
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("hpUsb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gmMgo = parcelRequire("gmMgo");

var $1e2E5 = parcelRequire("1e2E5");


var $ggbZE = parcelRequire("ggbZE");

var $1DWH0 = parcelRequire("1DWH0");


var $lgqac = parcelRequire("lgqac");





var $lAJUP = parcelRequire("lAJUP");


var $fBMbo = parcelRequire("fBMbo");


var $dQl1W = parcelRequire("dQl1W");


var $kKODE = parcelRequire("kKODE");


var $bIll3 = parcelRequire("bIll3");


var $ivUmx = parcelRequire("ivUmx");


var $5MkWK = parcelRequire("5MkWK");


var $9E8aG = parcelRequire("9E8aG");


var $l6tPN = parcelRequire("l6tPN");


var $5Tie7 = parcelRequire("5Tie7");


const $494a9ab126f82b16$export$a7690c318cd6a95e = /*#__PURE__*/ (0, $42omo.lazy)(()=>(0, $ivUmx.importWithRetry)(()=>(parcelRequire("iafpB"))));
function $494a9ab126f82b16$export$e00a7788e30dc998(props) {
    (0, $fBMbo.di)($494a9ab126f82b16$export$a7690c318cd6a95e);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [id] = (0, $42omo.useState)(()=>props.id ? props.id : (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))());
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        // ComponentWillUnmount
        return ()=>{
            (0, $l6tPN.clearMarks)(id);
            (0, $l6tPN.clearMeasures)(id);
        };
    }, [
        id
    ]);
    const { url: url, appearance: appearance, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, onClick: onClick, container: container, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, inheritDimensions: inheritDimensions, platform: platform, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, children: children, ui: ui, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, placeholder: placeholder, fallbackComponent: fallbackComponent, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, CompetitorPrompt: CompetitorPrompt, disablePreviewPanel: disablePreviewPanel } = props;
    const isFlexibleUi = (0, $9E8aG.isFlexibleUiCard)(children, ui);
    const analyticsContext = (0, $5MkWK.useSmartLinkAnalyticsContext)({
        display: isFlexibleUi ? 'flexible' : appearance,
        id: id,
        url: url ?? ''
    });
    const errorHandler = (0, $42omo.useCallback)((error, info)=>{
        const { componentStack: componentStack } = info;
        const errorInfo = {
            componentStack: componentStack
        };
        // NB: APIErrors are thrown in response to Object Resolver Service. We do not
        // fire an event for these, as they do not cover failed UI render events.
        // The rest of the errors caught here are unexpected, and correlate
        // to the reliability of the smart-card front-end components.
        // Likewise, chunk loading errors are not caused by a failure of smart-card rendering.
        if (error.name === 'ChunkLoadError') fireEvent('operational.smartLink.chunkLoadFailed', {
            ...analyticsContext?.attributes,
            display: appearance,
            error: error,
            errorInfo: errorInfo,
            definitionId: null
        });
        else if (error.name !== 'APIError') {
            (0, $bIll3.startUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $bIll3.failUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $bIll3.failUfoExperience)('smart-link-authenticated', id || 'NULL');
            fireEvent('ui.smartLink.renderFailed', {
                ...analyticsContext?.attributes,
                display: isFlexibleUi ? 'flexible' : appearance,
                id: id ?? null,
                error: error,
                errorInfo: errorInfo
            });
        }
        onError && onError({
            status: 'errored',
            url: url ?? '',
            err: error
        });
    }, [
        analyticsContext?.attributes,
        appearance,
        fireEvent,
        id,
        isFlexibleUi,
        onError,
        url
    ]);
    if (!url) throw new Error('@atlaskit/smart-card: url property is missing.');
    const defaultFallBackComponent = ()=>null;
    const FallbackComponent = fallbackComponent ?? defaultFallBackComponent;
    const ErrorFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(FallbackComponent, null);
    const cardWithUrlProps = {
        id: id,
        url: url,
        appearance: appearance,
        onClick: onClick,
        isSelected: isSelected,
        isHovered: isHovered,
        frameStyle: frameStyle,
        container: container,
        onResolve: onResolve,
        onError: onError,
        testId: testId,
        actionOptions: actionOptions,
        inheritDimensions: inheritDimensions,
        platform: platform,
        embedIframeRef: embedIframeRef,
        embedIframeUrlType: embedIframeUrlType,
        inlinePreloaderStyle: inlinePreloaderStyle,
        ui: ui,
        showHoverPreview: showHoverPreview,
        hoverPreviewOptions: hoverPreviewOptions,
        placeholder: placeholder,
        removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
        resolvingPlaceholder: resolvingPlaceholder,
        truncateInline: truncateInline,
        CompetitorPrompt: CompetitorPrompt,
        disablePreviewPanel: disablePreviewPanel
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
        FallbackComponent: ErrorFallback,
        onError: errorHandler
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Tie7.LoadingCardLink), cardWithUrlProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($494a9ab126f82b16$export$a7690c318cd6a95e, cardWithUrlProps, children)));
}


class $b7b2971f0774cd45$var$PlainCard extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $494a9ab126f82b16$export$e00a7788e30dc998), this.props);
        return this.props.intl ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1e2E5.default), {
            locale: "en"
        }, content);
    }
}
const $b7b2971f0774cd45$export$60332b2344f7fe41 = (0, $ggbZE.default)((0, $lgqac.context))((0, $1DWH0.default)()((0, $gmMgo.default)($b7b2971f0774cd45$var$PlainCard, {
    enforceContext: false
})));
module.exports["Card"] = $b7b2971f0774cd45$export$60332b2344f7fe41;

});

parcelRegister("ivUmx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4wH3g = parcelRequire("4wH3g");


var $dh538 = parcelRequire("dh538");


var $j6S25 = parcelRequire("j6S25");


var $5TXU5 = parcelRequire("5TXU5");


var $f6wMd = parcelRequire("f6wMd");

const $71dfdac77e49ff43$export$efca2c4705678489 = (evt)=>evt.isDefaultPrevented() && ($71dfdac77e49ff43$export$e6c5ffa684aac4d7() || $71dfdac77e49ff43$export$d8de0cd37d316fdf(evt) || $71dfdac77e49ff43$export$5b1771037ab7c451(evt));
const $71dfdac77e49ff43$export$e6c5ffa684aac4d7 = ()=>window.parent !== parent;
const $71dfdac77e49ff43$export$d8de0cd37d316fdf = (event)=>{
    return (0, $dh538.fg)('platform-smart-card-shift-key') ? event.metaKey || event.ctrlKey || event.shiftKey : event.metaKey || event.ctrlKey;
};
const $71dfdac77e49ff43$export$5b1771037ab7c451 = (event)=>event.button === 1;
const $71dfdac77e49ff43$export$4d685c85ebc7a1e3 = (fileMimeType)=>{
    if (!fileMimeType) return;
    let icon = $71dfdac77e49ff43$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "Zuvzb",
        name: "Icon",
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    }); // because we're using dynamic loading here, TS will not be able to infer the type
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        testId: "document-file-format-icon"
    });
};



























































































const $71dfdac77e49ff43$export$92d31eb5326761b6 = ()=>{
    return {
        [(0, $5TXU5.IconType).Document]: {
            default: ()=>Promise.resolve((parcelRequire("9SMct")))
        },
        [(0, $5TXU5.IconType).Blog]: {
            default: ()=>Promise.resolve((parcelRequire("7r4Rz")))
        },
        [(0, $5TXU5.IconType).Audio]: {
            default: ()=>(parcelRequire("kZQiE"))
        },
        [(0, $5TXU5.IconType).Code]: {
            default: ()=>(parcelRequire("P3MOH"))
        },
        [(0, $5TXU5.IconType).File]: {
            default: ()=>(parcelRequire("9xzZl"))
        },
        [(0, $5TXU5.IconType).Folder]: {
            default: ()=>(parcelRequire("kq8Ju"))
        },
        [(0, $5TXU5.IconType).Generic]: {
            default: ()=>(parcelRequire("9xzZl"))
        },
        [(0, $5TXU5.IconType).Image]: {
            default: ()=>(parcelRequire("aLmFo"))
        },
        [(0, $5TXU5.IconType).Presentation]: {
            default: ()=>(parcelRequire("deJjE"))
        },
        [(0, $5TXU5.IconType).Spreadsheet]: {
            default: ()=>(parcelRequire("lQr35"))
        },
        [(0, $5TXU5.IconType).Video]: {
            default: ()=>(parcelRequire("k6WNP"))
        },
        [(0, $5TXU5.IconType).Project]: {
            default: ()=>Promise.resolve((parcelRequire("lebfc")))
        },
        [(0, $5TXU5.IconType).Template]: {
            default: ()=>Promise.resolve((parcelRequire("chO1Z")))
        },
        [(0, $5TXU5.IconType).Forbidden]: {
            default: ()=>Promise.resolve((parcelRequire("9Q2dU")))
        },
        [(0, $5TXU5.IconType).Default]: {
            default: ()=>Promise.resolve((parcelRequire("1bY7o")))
        },
        [(0, $5TXU5.IconType).Error]: {
            default: ()=>Promise.resolve((parcelRequire("a3fRD")))
        },
        [(0, $5TXU5.IconType).Archive]: {
            default: ()=>(parcelRequire("5dAfr")),
            large: ()=>(parcelRequire("8Q8zP"))
        },
        [(0, $5TXU5.IconType).Executable]: {
            default: ()=>(parcelRequire("kX6XP")),
            large: ()=>(parcelRequire("aVlHH"))
        },
        [(0, $5TXU5.IconType).GIF]: {
            default: ()=>(parcelRequire("baHbT")),
            large: ()=>(parcelRequire("4Nc96"))
        },
        [(0, $5TXU5.IconType).GoogleDocs]: {
            default: ()=>(parcelRequire("c8ZoX")),
            large: ()=>(parcelRequire("fk3Vu"))
        },
        [(0, $5TXU5.IconType).GoogleForms]: {
            default: ()=>(parcelRequire("2PEWm")),
            large: ()=>(parcelRequire("cEx7i"))
        },
        [(0, $5TXU5.IconType).GoogleSheets]: {
            default: ()=>(parcelRequire("9wre1")),
            large: ()=>(parcelRequire("lGa5e"))
        },
        [(0, $5TXU5.IconType).GoogleSlides]: {
            default: ()=>(parcelRequire("htcSJ")),
            large: ()=>(parcelRequire("1DZBp"))
        },
        [(0, $5TXU5.IconType).MSExcel]: {
            default: ()=>(parcelRequire("516g5")),
            large: ()=>(parcelRequire("7X7LY"))
        },
        [(0, $5TXU5.IconType).MSPowerpoint]: {
            default: ()=>(parcelRequire("ffDhW")),
            large: ()=>(parcelRequire("gkryH"))
        },
        [(0, $5TXU5.IconType).MSWord]: {
            default: ()=>(parcelRequire("5lE6Q")),
            large: ()=>(parcelRequire("kjtlE"))
        },
        [(0, $5TXU5.IconType).PDF]: {
            default: ()=>(parcelRequire("7peNt")),
            large: ()=>(parcelRequire("9ZH0J"))
        },
        [(0, $5TXU5.IconType).Sketch]: {
            default: ()=>(parcelRequire("1ySEE")),
            large: ()=>(parcelRequire("kYpKU"))
        },
        // Bitbucket icons
        [(0, $5TXU5.IconType).Branch]: {
            default: ()=>Promise.resolve((parcelRequire("iNt9O"))),
            large: ()=>(parcelRequire("04az2"))
        },
        [(0, $5TXU5.IconType).Commit]: {
            default: ()=>Promise.resolve((parcelRequire("g3kRp"))),
            large: ()=>(parcelRequire("hmCaW"))
        },
        [(0, $5TXU5.IconType).PullRequest]: {
            default: ()=>Promise.resolve((parcelRequire("48jO6"))),
            large: ()=>(parcelRequire("i0wei"))
        },
        [(0, $5TXU5.IconType).Repo]: {
            default: ()=>Promise.resolve((parcelRequire("gP2jG"))),
            large: ()=>(parcelRequire("kNRLj"))
        },
        // Jira icons
        [(0, $5TXU5.IconType).Bug]: {
            default: ()=>Promise.resolve((parcelRequire("5pEhQ"))),
            large: ()=>(parcelRequire("2zIpi"))
        },
        [(0, $5TXU5.IconType).Change]: {
            default: ()=>Promise.resolve((parcelRequire("gyMYQ"))),
            large: ()=>(parcelRequire("gbdx8"))
        },
        [(0, $5TXU5.IconType).Epic]: {
            default: ()=>Promise.resolve((parcelRequire("g30aC"))),
            large: ()=>(parcelRequire("9oNn8"))
        },
        [(0, $5TXU5.IconType).Incident]: {
            default: ()=>Promise.resolve((parcelRequire("ieNZ0"))),
            large: ()=>(parcelRequire("9ESQg"))
        },
        [(0, $5TXU5.IconType).Problem]: {
            default: ()=>Promise.resolve((parcelRequire("736YY"))),
            large: ()=>(parcelRequire("4GcnP"))
        },
        [(0, $5TXU5.IconType).ServiceRequest]: {
            default: ()=>Promise.resolve((parcelRequire("GLxTx"))),
            large: ()=>(parcelRequire("48VyZ"))
        },
        [(0, $5TXU5.IconType).Story]: {
            default: ()=>Promise.resolve((parcelRequire("hrqJ0"))),
            large: ()=>(parcelRequire("dVkUF"))
        },
        [(0, $5TXU5.IconType).SubTask]: {
            default: ()=>Promise.resolve((parcelRequire("4V1hx"))),
            large: ()=>(parcelRequire("BQXGV"))
        },
        [(0, $5TXU5.IconType).Task]: {
            default: ()=>Promise.resolve((parcelRequire("9wTHj"))),
            large: ()=>(parcelRequire("bWncq"))
        },
        // Confluence icons
        [(0, $5TXU5.IconType).LiveDocument]: {
            default: ()=>Promise.resolve((parcelRequire("brDJd"))),
            large: ()=>Promise.resolve((parcelRequire("deok5")))
        },
        // Provider icons
        [(0, $5TXU5.IconType).Confluence]: {
            default: ()=>Promise.resolve((parcelRequire("4sZvs"))).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                        default: ConfluenceIcon
                    }))
        },
        [(0, $5TXU5.IconType).Jira]: {
            default: ()=>(parcelRequire("47MFw")).then(({ JiraIcon: JiraIcon })=>({
                        default: JiraIcon
                    }))
        },
        // Badge icons
        [(0, $5TXU5.IconType).Attachment]: {
            default: ()=>Promise.resolve((parcelRequire("9lz2c")))
        },
        [(0, $5TXU5.IconType).CheckItem]: {
            default: ()=>Promise.resolve((parcelRequire("dmbve")))
        },
        [(0, $5TXU5.IconType).Component]: {
            default: ()=>(parcelRequire("vFT5r"))
        },
        [(0, $5TXU5.IconType).Comment]: {
            default: ()=>Promise.resolve((parcelRequire("1yB28")))
        },
        [(0, $5TXU5.IconType).View]: {
            default: ()=>Promise.resolve((parcelRequire("8cjip")))
        },
        [(0, $5TXU5.IconType).React]: {
            default: ()=>Promise.resolve((parcelRequire("9FnLD")))
        },
        [(0, $5TXU5.IconType).Vote]: {
            default: ()=>Promise.resolve((parcelRequire("euUgw")))
        },
        [(0, $5TXU5.IconType).PriorityBlocker]: {
            default: ()=>(parcelRequire("c8YVf"))
        },
        [(0, $5TXU5.IconType).PriorityCritical]: {
            default: ()=>(parcelRequire("hsu2e"))
        },
        [(0, $5TXU5.IconType).PriorityHigh]: {
            default: ()=>(parcelRequire("lMyok"))
        },
        [(0, $5TXU5.IconType).PriorityHighest]: {
            default: ()=>(parcelRequire("gshmu"))
        },
        [(0, $5TXU5.IconType).PriorityLow]: {
            default: ()=>(parcelRequire("iUIo3"))
        },
        [(0, $5TXU5.IconType).PriorityLowest]: {
            default: ()=>(parcelRequire("lBWV7"))
        },
        [(0, $5TXU5.IconType).PriorityMajor]: {
            default: ()=>(parcelRequire("skC3o"))
        },
        [(0, $5TXU5.IconType).PriorityMedium]: {
            default: ()=>(parcelRequire("fNoyr"))
        },
        [(0, $5TXU5.IconType).PriorityMinor]: {
            default: ()=>(parcelRequire("eMurh"))
        },
        [(0, $5TXU5.IconType).PriorityTrivial]: {
            default: ()=>(parcelRequire("bQVou"))
        },
        [(0, $5TXU5.IconType).PriorityUndefined]: {
            default: ()=>Promise.resolve((parcelRequire("ci7Ox")))
        },
        [(0, $5TXU5.IconType).ProgrammingLanguage]: {
            default: ()=>Promise.resolve((parcelRequire("eIlE7")))
        },
        [(0, $5TXU5.IconType).Subscriber]: {
            default: ()=>Promise.resolve((parcelRequire("lebfc")))
        },
        [(0, $5TXU5.IconType).SubTasksProgress]: {
            default: ()=>Promise.resolve((parcelRequire("49GPt")))
        }
    };
};
const $71dfdac77e49ff43$var$getTypeToIconMap = (fileFormat)=>{
    const iconDescriptor = (0, $f6wMd.default)(fileFormat);
    if (!iconDescriptor?.icon) return null;
    const lazyIcons = $71dfdac77e49ff43$export$92d31eb5326761b6();
    return [
        lazyIcons[iconDescriptor.icon]?.default
    ];
};
const $71dfdac77e49ff43$export$9b7e6a102056a387 = (isTrusted)=>{
    if (isTrusted) return undefined;
    const sandboxPermissions = 'allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts';
    return sandboxPermissions;
};
const $71dfdac77e49ff43$export$ffccab2ae3d093ef = (handler)=>(e)=>{
        e.preventDefault();
        e.stopPropagation();
        handler();
    };
const $71dfdac77e49ff43$export$6c837641a9ab03cb = ()=>typeof IntersectionObserver !== 'undefined';
const $71dfdac77e49ff43$export$e772c8ff12451969 = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
const $71dfdac77e49ff43$export$aacbf48ace518c5a = async (importFn, retries = 2, interval = 500)=>{
    try {
        return await importFn();
    } catch (error) {
        if (error.name === 'ChunkLoadError' && retries > 0) {
            await $71dfdac77e49ff43$export$e772c8ff12451969(interval);
            return $71dfdac77e49ff43$export$aacbf48ace518c5a(importFn, retries - 1, interval);
        } else throw error;
    }
};
const $71dfdac77e49ff43$export$8a96edb1c96563f4 = async (url)=>{
    if (!url) return;
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    link.download = url;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const $71dfdac77e49ff43$export$a238cfe4a10e6279 = async (url)=>{
    if (!url) return;
    window.open(url, '_blank', 'noopener=yes');
};
const $71dfdac77e49ff43$export$4470f298c61a79da = (previewUrl, themeState)=>{
    try {
        const url = new URL(previewUrl);
        url.searchParams.append('themeState', (0, $j6S25.themeObjectToString)(themeState));
        return url.href;
    } catch  {
        return previewUrl;
    }
};
const $71dfdac77e49ff43$export$d2b8fb9e780e17e7 = (size)=>size && [
        (0, $5TXU5.SmartLinkSize).Large,
        (0, $5TXU5.SmartLinkSize).XLarge
    ].includes(size);
const $71dfdac77e49ff43$export$6a4545d6b336c401 = (type)=>!!(type && type.includes('Profile'));
module.exports["isSpecialEvent"] = $71dfdac77e49ff43$export$efca2c4705678489;
module.exports["isSpecialKey"] = $71dfdac77e49ff43$export$d8de0cd37d316fdf;
module.exports["isSpecialClick"] = $71dfdac77e49ff43$export$5b1771037ab7c451;
module.exports["getIconForFileType"] = $71dfdac77e49ff43$export$4d685c85ebc7a1e3;
module.exports["getLazyIcons"] = $71dfdac77e49ff43$export$92d31eb5326761b6;
module.exports["getIframeSandboxAttribute"] = $71dfdac77e49ff43$export$9b7e6a102056a387;
module.exports["handleOnClick"] = $71dfdac77e49ff43$export$ffccab2ae3d093ef;
module.exports["isIntersectionObserverSupported"] = $71dfdac77e49ff43$export$6c837641a9ab03cb;
module.exports["importWithRetry"] = $71dfdac77e49ff43$export$aacbf48ace518c5a;
module.exports["downloadUrl"] = $71dfdac77e49ff43$export$8a96edb1c96563f4;
module.exports["openUrl"] = $71dfdac77e49ff43$export$a238cfe4a10e6279;
module.exports["getPreviewUrlWithTheme"] = $71dfdac77e49ff43$export$4470f298c61a79da;
module.exports["isIconSizeLarge"] = $71dfdac77e49ff43$export$d2b8fb9e780e17e7;
module.exports["isProfileType"] = $71dfdac77e49ff43$export$6a4545d6b336c401;

});

parcelRegister("kZQiE", function(module, exports) {

let $f49212d1d8fc434a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f49212d1d8fc434a$var$load("6wr18"),
    $f49212d1d8fc434a$var$load("ffEVr"),
    $f49212d1d8fc434a$var$load("kO0mz")
]).then(()=>parcelRequire('kYM3c'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("P3MOH", function(module, exports) {

let $0997b36dc1b2237a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0997b36dc1b2237a$var$load("6wr18"),
    $0997b36dc1b2237a$var$load("ffEVr"),
    $0997b36dc1b2237a$var$load("gQLjx")
]).then(()=>parcelRequire('3OcEi'));

});

parcelRegister("9xzZl", function(module, exports) {

let $6f231cb2d25cdd39$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6f231cb2d25cdd39$var$load("6wr18"),
    $6f231cb2d25cdd39$var$load("ffEVr"),
    $6f231cb2d25cdd39$var$load("kDqHr")
]).then(()=>parcelRequire('9JsQ8'));

});

parcelRegister("kq8Ju", function(module, exports) {

let $eddd027915442b2c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $eddd027915442b2c$var$load("6wr18"),
    $eddd027915442b2c$var$load("ffEVr"),
    $eddd027915442b2c$var$load("5i5pX")
]).then(()=>parcelRequire('ltRMD'));

});

parcelRegister("aLmFo", function(module, exports) {

let $7d5fe04f793686ed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7d5fe04f793686ed$var$load("6wr18"),
    $7d5fe04f793686ed$var$load("ffEVr"),
    $7d5fe04f793686ed$var$load("eA5B3")
]).then(()=>parcelRequire('gcJKc'));

});

parcelRegister("deJjE", function(module, exports) {

let $9a2fbbf941f6c55c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9a2fbbf941f6c55c$var$load("6wr18"),
    $9a2fbbf941f6c55c$var$load("ffEVr"),
    $9a2fbbf941f6c55c$var$load("4HZlX")
]).then(()=>parcelRequire('1w5AW'));

});

parcelRegister("lQr35", function(module, exports) {

let $fe736f9e3b82275b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fe736f9e3b82275b$var$load("6wr18"),
    $fe736f9e3b82275b$var$load("ffEVr"),
    $fe736f9e3b82275b$var$load("7jSfd")
]).then(()=>parcelRequire('h45kr'));

});

parcelRegister("k6WNP", function(module, exports) {

let $ea41fb2b33a2b7d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ea41fb2b33a2b7d7$var$load("6wr18"),
    $ea41fb2b33a2b7d7$var$load("ffEVr"),
    $ea41fb2b33a2b7d7$var$load("7AsyI")
]).then(()=>parcelRequire('480Js'));

});

parcelRegister("5dAfr", function(module, exports) {

let $3cca48c73573eb39$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3cca48c73573eb39$var$load("2fk6g").then(()=>parcelRequire('dlbUV'));

});

parcelRegister("8Q8zP", function(module, exports) {

let $66f9d53b36a1c87f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $66f9d53b36a1c87f$var$load("2fk6g").then(()=>parcelRequire('fX9Sa'));

});

parcelRegister("kX6XP", function(module, exports) {

let $f40eb84301e8c025$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f40eb84301e8c025$var$load("huUvS").then(()=>parcelRequire('2ixko'));

});

parcelRegister("aVlHH", function(module, exports) {

let $7f401031ef3feb53$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7f401031ef3feb53$var$load("huUvS").then(()=>parcelRequire('4dLYc'));

});

parcelRegister("baHbT", function(module, exports) {

let $822221aaef5e7b27$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $822221aaef5e7b27$var$load("1oiJ6").then(()=>parcelRequire('d5BUD'));

});

parcelRegister("4Nc96", function(module, exports) {

let $37d528f5740ffa5e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $37d528f5740ffa5e$var$load("1oiJ6").then(()=>parcelRequire('b4DX7'));

});

parcelRegister("c8ZoX", function(module, exports) {

let $8d75dc799514e943$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8d75dc799514e943$var$load("lxiFd").then(()=>parcelRequire('4rkAw'));

});

parcelRegister("fk3Vu", function(module, exports) {

let $b27bc4f01f81a82c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b27bc4f01f81a82c$var$load("lxiFd").then(()=>parcelRequire('5W6v1'));

});

parcelRegister("2PEWm", function(module, exports) {

let $21001a16bfe99cf8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $21001a16bfe99cf8$var$load("eDqo1").then(()=>parcelRequire('jDMpf'));

});

parcelRegister("cEx7i", function(module, exports) {

let $9362e8bd33eaa9f5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9362e8bd33eaa9f5$var$load("eDqo1").then(()=>parcelRequire('av4P2'));

});

parcelRegister("9wre1", function(module, exports) {

let $6eec388d67832b92$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6eec388d67832b92$var$load("6HBYC").then(()=>parcelRequire('l59oX'));

});

parcelRegister("lGa5e", function(module, exports) {

let $fc8557957af59f74$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fc8557957af59f74$var$load("6HBYC").then(()=>parcelRequire('giYeH'));

});

parcelRegister("htcSJ", function(module, exports) {

let $cb7f232b5be92725$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cb7f232b5be92725$var$load("bYxCZ").then(()=>parcelRequire('jOGxt'));

});

parcelRegister("1DZBp", function(module, exports) {

let $132937e71aaf3ed1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $132937e71aaf3ed1$var$load("bYxCZ").then(()=>parcelRequire('eWLPt'));

});

parcelRegister("516g5", function(module, exports) {

let $3a71e68ec6145457$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3a71e68ec6145457$var$load("eTBsW").then(()=>parcelRequire('d8Kpd'));

});

parcelRegister("7X7LY", function(module, exports) {

let $5ca4129d5a883a9f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5ca4129d5a883a9f$var$load("eTBsW").then(()=>parcelRequire('gH8Rx'));

});

parcelRegister("ffDhW", function(module, exports) {

let $b1a6bb9a21a18a09$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b1a6bb9a21a18a09$var$load("020xd").then(()=>parcelRequire('hY1Uy'));

});

parcelRegister("gkryH", function(module, exports) {

let $be33e4276f6027a7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $be33e4276f6027a7$var$load("020xd").then(()=>parcelRequire('dfQbH'));

});

parcelRegister("5lE6Q", function(module, exports) {

let $3e4e06d4705f4ba7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3e4e06d4705f4ba7$var$load("ls0Um").then(()=>parcelRequire('90Icb'));

});

parcelRegister("kjtlE", function(module, exports) {

let $ec9c58f6e253e433$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ec9c58f6e253e433$var$load("ls0Um").then(()=>parcelRequire('lkBga'));

});

parcelRegister("7peNt", function(module, exports) {

let $5646588e31a854db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5646588e31a854db$var$load("eVYW1").then(()=>parcelRequire('11LZV'));

});

parcelRegister("9ZH0J", function(module, exports) {

let $746b2ca068d8f3b8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $746b2ca068d8f3b8$var$load("eVYW1").then(()=>parcelRequire('lzyQK'));

});

parcelRegister("1ySEE", function(module, exports) {

let $12335cac957a87bb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $12335cac957a87bb$var$load("f35QR").then(()=>parcelRequire('9W0IA'));

});

parcelRegister("kYpKU", function(module, exports) {

let $f44d63c955d1a80c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f44d63c955d1a80c$var$load("f35QR").then(()=>parcelRequire('9AnKp'));

});

parcelRegister("04az2", function(module, exports) {

let $00c891ace8db923d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $00c891ace8db923d$var$load("6wr18"),
    $00c891ace8db923d$var$load("ipYAC"),
    $00c891ace8db923d$var$load("ffEVr"),
    $00c891ace8db923d$var$load("4sSyn")
]).then(()=>parcelRequire('lU7yV'));

});

parcelRegister("hmCaW", function(module, exports) {

let $ca421a9240cf5658$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ca421a9240cf5658$var$load("6wr18"),
    $ca421a9240cf5658$var$load("hC2ak"),
    $ca421a9240cf5658$var$load("ffEVr"),
    $ca421a9240cf5658$var$load("dnrR3")
]).then(()=>parcelRequire('jB3l2'));

});

parcelRegister("i0wei", function(module, exports) {

let $d1c13a30c8652ac0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d1c13a30c8652ac0$var$load("6wr18"),
    $d1c13a30c8652ac0$var$load("5ouJ8"),
    $d1c13a30c8652ac0$var$load("ffEVr"),
    $d1c13a30c8652ac0$var$load("gxkp2")
]).then(()=>parcelRequire('8EuWv'));

});

parcelRegister("kNRLj", function(module, exports) {

let $f2521648bec1d68b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f2521648bec1d68b$var$load("6wr18"),
    $f2521648bec1d68b$var$load("7uF9z"),
    $f2521648bec1d68b$var$load("ffEVr"),
    $f2521648bec1d68b$var$load("hiqrg")
]).then(()=>parcelRequire('59qhj'));

});

parcelRegister("2zIpi", function(module, exports) {

let $1e014befa9315b8e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1e014befa9315b8e$var$load("6wr18"),
    $1e014befa9315b8e$var$load("2rQCX"),
    $1e014befa9315b8e$var$load("ffEVr"),
    $1e014befa9315b8e$var$load("490Jr")
]).then(()=>parcelRequire('go9q2'));

});

parcelRegister("gbdx8", function(module, exports) {

let $bc782be2554d7311$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bc782be2554d7311$var$load("6wr18"),
    $bc782be2554d7311$var$load("jYRUQ"),
    $bc782be2554d7311$var$load("ffEVr"),
    $bc782be2554d7311$var$load("ggkqU")
]).then(()=>parcelRequire('2hyOi'));

});

parcelRegister("9oNn8", function(module, exports) {

let $6d7ca7368aac072a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6d7ca7368aac072a$var$load("6wr18"),
    $6d7ca7368aac072a$var$load("8M9JG"),
    $6d7ca7368aac072a$var$load("ffEVr"),
    $6d7ca7368aac072a$var$load("65smn")
]).then(()=>parcelRequire('7MtzJ'));

});

parcelRegister("9ESQg", function(module, exports) {

let $708263f2e2acdf8a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $708263f2e2acdf8a$var$load("6wr18"),
    $708263f2e2acdf8a$var$load("2s7cH"),
    $708263f2e2acdf8a$var$load("ffEVr"),
    $708263f2e2acdf8a$var$load("1fh7t")
]).then(()=>parcelRequire('iyOJu'));

});

parcelRegister("4GcnP", function(module, exports) {

let $3684b0ba8efd849b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3684b0ba8efd849b$var$load("6wr18"),
    $3684b0ba8efd849b$var$load("2Hu3D"),
    $3684b0ba8efd849b$var$load("ffEVr"),
    $3684b0ba8efd849b$var$load("4mLGd")
]).then(()=>parcelRequire('75US5'));

});

parcelRegister("48VyZ", function(module, exports) {

let $30448fad52a83e8f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $30448fad52a83e8f$var$load("6wr18"),
    $30448fad52a83e8f$var$load("ffEVr"),
    $30448fad52a83e8f$var$load("cMlHc")
]).then(()=>parcelRequire('2v58P'));

});

parcelRegister("dVkUF", function(module, exports) {

let $a230d21afa0a05a7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a230d21afa0a05a7$var$load("6wr18"),
    $a230d21afa0a05a7$var$load("3ilaI"),
    $a230d21afa0a05a7$var$load("ffEVr"),
    $a230d21afa0a05a7$var$load("lSzlP")
]).then(()=>parcelRequire('guaI6'));

});

parcelRegister("BQXGV", function(module, exports) {

let $071c89eb5b58c850$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $071c89eb5b58c850$var$load("6wr18"),
    $071c89eb5b58c850$var$load("aM37p"),
    $071c89eb5b58c850$var$load("ffEVr"),
    $071c89eb5b58c850$var$load("5erPe")
]).then(()=>parcelRequire('ddr0p'));

});

parcelRegister("bWncq", function(module, exports) {

let $8b171b66c139b00e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8b171b66c139b00e$var$load("6wr18"),
    $8b171b66c139b00e$var$load("lVEhx"),
    $8b171b66c139b00e$var$load("ffEVr"),
    $8b171b66c139b00e$var$load("cXodu")
]).then(()=>parcelRequire('aH2D0'));

});

parcelRegister("47MFw", function(module, exports) {

let $300d9179ca856237$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $300d9179ca856237$var$load("87j6O").then(()=>parcelRequire('kAaAo'));

});

parcelRegister("vFT5r", function(module, exports) {

let $05f363595ee8bc16$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $05f363595ee8bc16$var$load("jNyUd").then(()=>parcelRequire('aUxi6'));

});

parcelRegister("c8YVf", function(module, exports) {

let $8d757d50e8354f4f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8d757d50e8354f4f$var$load("kmFmA").then(()=>parcelRequire('7MfGI'));

});

parcelRegister("hsu2e", function(module, exports) {

let $cb5c59857e5b21f5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cb5c59857e5b21f5$var$load("lFU9I").then(()=>parcelRequire('1IOoh'));

});

parcelRegister("lMyok", function(module, exports) {

let $fdb8c212cb480eaa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fdb8c212cb480eaa$var$load("7pBNO").then(()=>parcelRequire('ePjQq'));

});

parcelRegister("gshmu", function(module, exports) {

let $bfacba8707ec3bf5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bfacba8707ec3bf5$var$load("aBa4X").then(()=>parcelRequire('fVHnW'));

});

parcelRegister("iUIo3", function(module, exports) {

let $dc4fe347b3ef8cec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dc4fe347b3ef8cec$var$load("2svpA").then(()=>parcelRequire('dEXbZ'));

});

parcelRegister("lBWV7", function(module, exports) {

let $fbbac2056fc5deec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fbbac2056fc5deec$var$load("dGIKv").then(()=>parcelRequire('lqknn'));

});

parcelRegister("skC3o", function(module, exports) {

let $05529ae8009c2af6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $05529ae8009c2af6$var$load("gYLzA").then(()=>parcelRequire('9WB9k'));

});

parcelRegister("fNoyr", function(module, exports) {

let $b7fe7a9b86b6855e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b7fe7a9b86b6855e$var$load("56IhT").then(()=>parcelRequire('lhNyN'));

});

parcelRegister("eMurh", function(module, exports) {

let $ac2d28f104118a86$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ac2d28f104118a86$var$load("7OpXX").then(()=>parcelRequire('j5eSx'));

});

parcelRegister("bQVou", function(module, exports) {

let $8a11124df7898313$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8a11124df7898313$var$load("2bK0D").then(()=>parcelRequire('6GRhK'));

});

parcelRegister("9E8aG", function(module, exports) {

var $42omo = parcelRequire("42omo");



var $2c99834a6fa1d6ad$exports = {};
$parcel$export($2c99834a6fa1d6ad$exports, "FooterBlock", () => (parcelRequire("8NpDA")).default);
$parcel$export($2c99834a6fa1d6ad$exports, "MetadataBlock", () => (parcelRequire("1lLfV")).default);
$parcel$export($2c99834a6fa1d6ad$exports, "PreviewBlock", () => (parcelRequire("Y5kOr")).default);
$parcel$export($2c99834a6fa1d6ad$exports, "SnippetBlock", () => (parcelRequire("8zS2j")).default);
$parcel$export($2c99834a6fa1d6ad$exports, "TitleBlock", () => (parcelRequire("5znEc")).default);
$parcel$export($2c99834a6fa1d6ad$exports, "CustomBlock", () => (parcelRequire("2R1C4")).default);
$parcel$export($2c99834a6fa1d6ad$exports, "InternalFooterBlock", () => (parcelRequire("jsdg1")).default);
$parcel$export($2c99834a6fa1d6ad$exports, "AISummaryBlock", () => (parcelRequire("eqpYq")).default);
$parcel$export($2c99834a6fa1d6ad$exports, "AIFooterBlock", () => (parcelRequire("MlN47")).default);
$parcel$export($2c99834a6fa1d6ad$exports, "ActionBlock", () => (parcelRequire("f0wtW")).default);

var $8NpDA = parcelRequire("8NpDA");


var $1lLfV = parcelRequire("1lLfV");


var $Y5kOr = parcelRequire("Y5kOr");


var $8zS2j = parcelRequire("8zS2j");


var $5znEc = parcelRequire("5znEc");


var $2R1C4 = parcelRequire("2R1C4");


var $jsdg1 = parcelRequire("jsdg1");


var $eqpYq = parcelRequire("eqpYq");


var $MlN47 = parcelRequire("MlN47");


var $f0wtW = parcelRequire("f0wtW");




var $2gWqY = parcelRequire("2gWqY");

const $c224b37846f1c464$export$3c94e0f4719f5c2a = (children, ui)=>{
    if (ui?.removeBlockRestriction) return children && (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children)?.length > 0 ? true : false;
    if (children && (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children).some((child)=>$c224b37846f1c464$export$df0092b19156b140(child))) return true;
    return false;
};
const $c224b37846f1c464$export$14ff825bfe645006 = (node)=>{
    if (typeof node.type !== 'string' && node.type?.name === 'StyleCacheProvider' && node.props.children) return true;
    else if (typeof node.type !== 'string' && node.type?.name === 'CC' && node.props.children) return true;
    return false;
};
const $c224b37846f1c464$export$b56fc89cf6e7d1e9 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(node)) return false;
    if ($c224b37846f1c464$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $c224b37846f1c464$export$b56fc89cf6e7d1e9(child);
        });
        return isChildrenValid;
    }
    if (Object.values($2c99834a6fa1d6ad$exports).some((type)=>type === node.type)) return true;
    return false;
};
const $c224b37846f1c464$export$d7fc505bb0bd5756 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(node)) return false;
    if (Object.values($2gWqY).some((type)=>type === node.type)) return true;
    if ($c224b37846f1c464$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $c224b37846f1c464$export$d7fc505bb0bd5756(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $c224b37846f1c464$export$df0092b19156b140 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(node)) return false;
    if (node.type === (0, $5znEc.default)) return true;
    if ($c224b37846f1c464$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $c224b37846f1c464$export$df0092b19156b140(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $c224b37846f1c464$export$c0547b4405cae584 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(node)) return false;
    if (node.type === (0, $Y5kOr.default)) return true;
    if ($c224b37846f1c464$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $c224b37846f1c464$export$c0547b4405cae584(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $c224b37846f1c464$export$43edae7b55c79927 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(node) && node.type === (0, $8NpDA.default);
module.exports["isFlexibleUiCard"] = $c224b37846f1c464$export$3c94e0f4719f5c2a;
module.exports["isStyleCacheProvider"] = $c224b37846f1c464$export$14ff825bfe645006;
module.exports["isFlexibleUiBlock"] = $c224b37846f1c464$export$b56fc89cf6e7d1e9;
module.exports["isFlexibleUiElement"] = $c224b37846f1c464$export$d7fc505bb0bd5756;
module.exports["isFlexibleUiPreviewBlock"] = $c224b37846f1c464$export$c0547b4405cae584;

});

parcelRegister("8NpDA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $jsdg1 = parcelRequire("jsdg1");

/**
 * Represents a FooterBlock, designed to contain elements and actions that should appear
 * at the bottom of a link card.
 * @public
 * @param {FooterBlockProps} FooterBlockProps
 * @see Block
 */ const $64d13bf310395f75$var$FooterBlock = ({ testId: testId = 'smart-footer-block', alwaysShow: alwaysShow, ...props })=>{
    const cardContext = (0, $fUfR2.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $5TXU5.SmartLinkStatus).Resolved && !alwaysShow) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jsdg1.default), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId
    });
};
var $64d13bf310395f75$export$2e2bcd8739ae039 = $64d13bf310395f75$var$FooterBlock;
module.exports["default"] = $64d13bf310395f75$export$2e2bcd8739ae039;

});

parcelRegister("fUfR2", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6e7308c6380408ec$export$13dde4423ab71d62 = (0, $42omo.createContext)(undefined);
const $6e7308c6380408ec$export$a8c4167e4e9f26ab = ()=>(0, $42omo.useContext)($6e7308c6380408ec$export$13dde4423ab71d62);
const $6e7308c6380408ec$export$61d7957a243df7aa = ()=>$6e7308c6380408ec$export$a8c4167e4e9f26ab()?.data;
const $6e7308c6380408ec$export$e6b5ad18b56e8f51 = ()=>$6e7308c6380408ec$export$a8c4167e4e9f26ab()?.ui;
module.exports["FlexibleCardContext"] = $6e7308c6380408ec$export$13dde4423ab71d62;
module.exports["useFlexibleCardContext"] = $6e7308c6380408ec$export$a8c4167e4e9f26ab;
module.exports["useFlexibleUiContext"] = $6e7308c6380408ec$export$61d7957a243df7aa;
module.exports["useFlexibleUiOptionContext"] = $6e7308c6380408ec$export$e6b5ad18b56e8f51;

});

parcelRegister("jsdg1", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4P6U3 = parcelRequire("4P6U3");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $2ZgNz = parcelRequire("2ZgNz");


var $7d67T = parcelRequire("7d67T");


var $2R1C4 = parcelRequire("2R1C4");


var $1RvsP = parcelRequire("1RvsP");


var $l7DP7 = parcelRequire("l7DP7");

const $a5a88c936354623c$var$actionGroupStyles = null;
const $a5a88c936354623c$var$safariStyles = null;
const $a5a88c936354623c$var$FooterBlockResolvedView = (props)=>{
    const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, $5TXU5.SmartLinkSize).Medium, hideProvider: hideProvider } = props;
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const hasActions = (0, $42omo.useMemo)(()=>(0, $l7DP7.filterActionItems)(actions, context)?.length > 0, [
        actions,
        context
    ]); // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $42omo.useMemo)(()=>(0, $4P6U3.browser)(), []);
    const onDropdownOpenChange = (0, $42omo.useCallback)((isOpen)=>{
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    return /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        ...props,
        testId: `${testId}-resolved-view`
    }, !hideProvider && /*#__PURE__*/ $42omo.createElement((0, $2ZgNz.default), {
        appearance: "subtle",
        testId: `${testId}-provider`
    }), actions && hasActions ? /*#__PURE__*/ $42omo.createElement((0, $1RvsP.default), {
        testId: "smart-element-group-actions",
        align: (0, $5TXU5.SmartLinkAlignment).Right,
        direction: (0, $5TXU5.SmartLinkDirection).Horizontal,
        width: (0, $5TXU5.SmartLinkWidth).Flexible,
        className: (0, $gMc0m.default)([
            size === (0, $5TXU5.SmartLinkSize).XLarge && "_c71lxy5q",
            safari && "_4t3i1osq"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $7d67T.default), {
        onDropdownOpenChange: onDropdownOpenChange,
        items: actions,
        appearance: "default",
        size: size
    })) : null);
};
var $a5a88c936354623c$export$2e2bcd8739ae039 = $a5a88c936354623c$var$FooterBlockResolvedView;
module.exports["default"] = $a5a88c936354623c$export$2e2bcd8739ae039;

});

parcelRegister("2ZgNz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $33250de89c37863a$var$ProviderElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context?.provider ?? null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).Provider
    }) : null;
};
var $33250de89c37863a$export$2e2bcd8739ae039 = $33250de89c37863a$var$ProviderElement;
module.exports["default"] = $33250de89c37863a$export$2e2bcd8739ae039;

});

parcelRegister("7r4Rz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $hxQwS = parcelRequire("hxQwS");


var $bueVT = parcelRequire("bueVT");


var $7CgcZ = parcelRequire("7CgcZ");

const $a1b21c3b6fc75776$var$BlogIconWithColor = (0, $7CgcZ.renderIconPerSize)((0, $hxQwS.default), (0, $bueVT.default));
$a1b21c3b6fc75776$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $a1b21c3b6fc75776$export$2e2bcd8739ae039 = $a1b21c3b6fc75776$var$BlogIconWithColor;
module.exports["default"] = $a1b21c3b6fc75776$export$2e2bcd8739ae039;

});

parcelRegister("7CgcZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lE8sM = parcelRequire("lE8sM");


var $5TXU5 = parcelRequire("5TXU5");


var $ivUmx = parcelRequire("ivUmx");

const $6846287c8ee6bf50$export$3acc3fb10995f020 = (size)=>{
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
        case (0, $5TXU5.SmartLinkSize).Large:
            return '24';
        default:
            return '16';
    }
};
const $6846287c8ee6bf50$export$28dd5ad82647c000 = (IconSmall, IconLarge)=>{
    return ({ size: size, ...props })=>{
        if ((0, $ivUmx.isIconSizeLarge)(size)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(IconLarge, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(IconSmall, props);
    };
};
const $6846287c8ee6bf50$export$87c3646d0e299cfe = (Icon, appearance)=>{
    return ({ size: size, ...props })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lE8sM.default), {
            appearance: appearance,
            icon: Icon,
            size: $6846287c8ee6bf50$export$3acc3fb10995f020(size),
            ...props
        });
    };
};
module.exports["renderIconPerSize"] = $6846287c8ee6bf50$export$28dd5ad82647c000;
module.exports["renderIconTile"] = $6846287c8ee6bf50$export$87c3646d0e299cfe;

});

parcelRegister("GFtWS", function(module, exports) {

var $brDJd = parcelRequire("brDJd");


var $deok5 = parcelRequire("deok5");


var $7CgcZ = parcelRequire("7CgcZ");

const $fc75dd15b55d0661$var$LiveDocumentIconWithColor = (0, $7CgcZ.renderIconPerSize)((0, $brDJd.default), (0, $deok5.default));
$fc75dd15b55d0661$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $fc75dd15b55d0661$export$2e2bcd8739ae039 = $fc75dd15b55d0661$var$LiveDocumentIconWithColor;
module.exports["default"] = $fc75dd15b55d0661$export$2e2bcd8739ae039;

});

parcelRegister("9SMct", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8jHAi = parcelRequire("8jHAi");


var $7CgcZ = parcelRequire("7CgcZ");

const $3c9171fc16956912$var$PageIconWithColor = (0, $7CgcZ.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), 'blueBold');
$3c9171fc16956912$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $3c9171fc16956912$export$2e2bcd8739ae039 = $3c9171fc16956912$var$PageIconWithColor;
module.exports["default"] = $3c9171fc16956912$export$2e2bcd8739ae039;

});

parcelRegister("7d67T", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gtD4K = parcelRequire("gtD4K");


var $fBMbo = parcelRequire("fBMbo");


var $hArLp = parcelRequire("hArLp");


var $eEA8O = parcelRequire("eEA8O");


var $52EPl = parcelRequire("52EPl");


var $9VJDA = parcelRequire("9VJDA");


var $3gadb = parcelRequire("3gadb");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $hJgLA = parcelRequire("hJgLA");


var $l7DP7 = parcelRequire("l7DP7");





var $jlQ9A = parcelRequire("jlQ9A");

const $98cfef5f1319cffc$var$ActionGroupItem = ({ item: item, size: size, appearance: appearance, asDropDownItems: asDropDownItems, onActionItemClick: onActionItemClick })=>{
    const { name: name, hideContent: hideContent, hideIcon: hideIcon, onClick: onClick, isDisabled: isDisabled, ...props } = item;
    const handleOnClick = (0, $42omo.useCallback)(()=>{
        if (onActionItemClick) onActionItemClick();
        if (onClick) onClick();
    }, [
        onActionItemClick,
        onClick
    ]);
    const Action = name in $jlQ9A ? $jlQ9A[name] : undefined;
    if (!Action) return null;
    const actionProps = {
        ...props
    };
    if (hideContent && !asDropDownItems) actionProps.content = '';
    if (hideIcon) actionProps.icon = undefined;
    if (item?.entryPointWrapper) actionProps.wrapper = item.entryPointWrapper;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Action, {
        asDropDownItem: asDropDownItems,
        size: size,
        appearance: appearance,
        onClick: handleOnClick,
        isDisabled: isDisabled,
        ...actionProps
    });
};
var $98cfef5f1319cffc$export$2e2bcd8739ae039 = $98cfef5f1319cffc$var$ActionGroupItem;


const $56632f4bfc993cb1$var$styles = null;
const $56632f4bfc993cb1$var$renderActionItems = (items = [], size = (0, $5TXU5.SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>/*#__PURE__*/ $42omo.createElement((0, $98cfef5f1319cffc$export$2e2bcd8739ae039), {
            item: item,
            key: idx,
            size: size,
            appearance: appearance,
            asDropDownItems: asDropDownItems,
            onActionItemClick: onActionItemClick
        })); /**
                                                                                                                                                                                                                                                                                                                                                                                                            * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
                                                                                                                                                                                                                                                                                                                                                                                                            * preferences.
                                                                                                                                                                                                                                                                                                                                                                                                            * @internal
                                                                                                                                                                                                                                                                                                                                                                                                            * @param {ActionGroupProps} ActionGroupProps
                                                                                                                                                                                                                                                                                                                                                                                                            * @see Action
                                                                                                                                                                                                                                                                                                                                                                                                            */ 
const $56632f4bfc993cb1$var$ActionGroup = ({ items: items = [], size: size = (0, $5TXU5.SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange })=>{
    (0, $fBMbo.di)((0, $52EPl.default));
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const renderableActionItems = (0, $42omo.useMemo)(()=>(0, $l7DP7.filterActionItems)(items, context), [
        context,
        items
    ]);
    const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
    const onOpenChange = (0, $42omo.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
    }, [
        onDropdownOpenChange
    ]);
    const onActionItemClick = (0, $42omo.useCallback)(()=>{
        if (isOpen) onOpenChange({
            isOpen: false
        });
    }, [
        isOpen,
        onOpenChange
    ]);
    const actionButtons = (0, $42omo.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
        return $56632f4bfc993cb1$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
    }, [
        appearance,
        isMoreThenTwoItems,
        onActionItemClick,
        renderableActionItems,
        size,
        visibleButtonsNum
    ]);
    const moreActionDropdown = (0, $42omo.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
        if (actionItems.length > 0) {
            const spacing = (0, $hJgLA.sizeToButtonSpacing)[size];
            const moreIcon = /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                label: "more",
                color: "currentColor"
            });
            const formatMessage = /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), (0, $afp1H.messages).more_actions);
            return /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $3gadb.default), {
                        content: formatMessage,
                        hideTooltipOnClick: true,
                        testId: "action-group-more-button-tooltip",
                        tag: "span"
                    }, /*#__PURE__*/ $42omo.createElement((0, $eEA8O.default), {
                        ...props,
                        spacing: spacing,
                        testId: "action-group-more-button",
                        iconBefore: moreIcon,
                        ref: triggerRef
                    })),
                testId: "action-group-dropdown",
                zIndex: ui?.zIndex
            }, $56632f4bfc993cb1$var$renderActionItems(actionItems, size, appearance, true, onActionItemClick));
        }
        return null;
    }, [
        appearance,
        isMoreThenTwoItems,
        isOpen,
        onActionItemClick,
        onOpenChange,
        renderableActionItems,
        size,
        ui?.zIndex,
        visibleButtonsNum
    ]);
    return renderableActionItems.length > 0 ? /*#__PURE__*/ $42omo.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            "_1e0c116y _dzc21h6o _1ilq1i6y",
            "actions-button-group"
        ]),
        "data-action-open": isOpen
    }, /*#__PURE__*/ $42omo.createElement((0, $hArLp.default), null, actionButtons, moreActionDropdown)) : null;
};
var $56632f4bfc993cb1$export$2e2bcd8739ae039 = $56632f4bfc993cb1$var$ActionGroup;
module.exports["default"] = $56632f4bfc993cb1$export$2e2bcd8739ae039;

});

parcelRegister("l7DP7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $9E8aG = parcelRequire("9E8aG");


var $2gWqY = parcelRequire("2gWqY");


var $7d67T = parcelRequire("7d67T");


var $1RvsP = parcelRequire("1RvsP");

const $304e11160ef9ec7e$export$f942619ce67b1a41 = {
    [(0, $5TXU5.ElementName).AssignedTo]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).AssignedToGroup]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).AttachmentCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).AuthorGroup]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).AppliedToComponentsCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ChecklistProgress]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).CollaboratorGroup]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).CommentCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).CreatedBy]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).CreatedOn]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).DueOn]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).LatestCommit]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).LinkIcon]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).Location]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ModifiedBy]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ModifiedOn]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).OwnedBy]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).OwnedByGroup]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).Preview]: [
        'block'
    ],
    [(0, $5TXU5.ElementName).Priority]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ProgrammingLanguage]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).Provider]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ReactCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ReadTime]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).Snippet]: [
        'block'
    ],
    [(0, $5TXU5.ElementName).SourceBranch]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).SentOn]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).State]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).SubscriberCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).TeamMemberCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).SubTasksProgress]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).StoryPoints]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).TargetBranch]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).Title]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).UserAttributes]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ViewCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).VoteCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).HostName]: [
        'inline'
    ]
};
const $304e11160ef9ec7e$export$ff20be09ae01c52e = (size)=>{
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
            return 1.25;
        case (0, $5TXU5.SmartLinkSize).Large:
            return 1;
        case (0, $5TXU5.SmartLinkSize).Medium:
            return 0.5;
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return 0.25;
    }
};
const $304e11160ef9ec7e$var$isActionGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(node) && node.type === (0, $7d67T.default);
const $304e11160ef9ec7e$var$isElementDisplayValid = (name, display)=>{
    return $304e11160ef9ec7e$export$f942619ce67b1a41[name]?.includes(display) ?? false;
};
const $304e11160ef9ec7e$export$f2c7ad0961800b16 = (children)=>{
    return Boolean(children.type() === null);
};
const $304e11160ef9ec7e$var$isElementOrElementGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(node) && ((0, $9E8aG.isFlexibleUiElement)(node) || node.type === (0, $1RvsP.default));
const $304e11160ef9ec7e$export$adbd04236f07a7d8 = (items = [], context)=>{
    return items.filter((item)=>{
        switch(item.name){
            case (0, $5TXU5.ActionName).DeleteAction:
            case (0, $5TXU5.ActionName).EditAction:
            case (0, $5TXU5.ActionName).CustomAction:
                // Named and custom actions that user defines.
                return Boolean((0, $5TXU5.ActionName)[item.name]);
            default:
                // Action that require data from the data context to render.
                if (context?.actions === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
        }
    });
};
const $304e11160ef9ec7e$export$cd762ccf1a583d69 = (children, size)=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children, (child)=>{
        if ($304e11160ef9ec7e$var$isElementOrElementGroup(child) || $304e11160ef9ec7e$var$isActionGroup(child)) {
            const node = child;
            const { size: childSize } = node.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(node, {
                size: childSize || size
            });
        }
        return child;
    });
const $304e11160ef9ec7e$export$9678d3ca18bd7526 = (items = [], display = 'inline')=>{
    const elements = items.reduce((acc, curr, idx)=>{
        const { name: name, ...props } = curr;
        const Element = $2gWqY[name];
        const typedProps = props;
        if (Element && $304e11160ef9ec7e$var$isElementDisplayValid(name, display)) {
            const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Element, {
                key: idx,
                ...typedProps
            });
            if (!$304e11160ef9ec7e$export$f2c7ad0961800b16(element)) return [
                ...acc,
                element
            ];
        }
        return acc;
    }, []);
    if (elements.length) return elements;
};
module.exports["filterActionItems"] = $304e11160ef9ec7e$export$adbd04236f07a7d8;
module.exports["renderChildren"] = $304e11160ef9ec7e$export$cd762ccf1a583d69;
module.exports["renderElementItems"] = $304e11160ef9ec7e$export$9678d3ca18bd7526;

});

parcelRegister("6cbph", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $05796b2533bfe14f$var$AssignedToElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages).assigned_to, context.assignedTo) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).AssignedTo
    }) : null;
};
var $05796b2533bfe14f$export$2e2bcd8739ae039 = $05796b2533bfe14f$var$AssignedToElement;
module.exports["default"] = $05796b2533bfe14f$export$2e2bcd8739ae039;

});

parcelRegister("aIzVM", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $hJgLA = parcelRequire("hJgLA");

const $1ecffae6e6a717dc$var$baseStyle = null;
const $1ecffae6e6a717dc$var$fontOverrideStyleMap = {
    'font.body': "_11c8fhey",
    'font.body.large': "_11c81d4k",
    'font.body.small': "_11c8wadc",
    'font.body.UNSAFE_small': "_11c8rymc"
};
const $1ecffae6e6a717dc$export$79422073c7118b5b = ({ content: content, maxLines: maxLines = 1, message: message, name: name, className: className, testId: testId = 'smart-element-text', hideFormat: hideFormat = false, color: color, fontSize: fontSize })=>{
    if (!message && !content) return null;
    const dynamicCss = null;
    const formattedContent = hideFormat && content ? content : (0, $hJgLA.getFormattedMessage)(message) || content;
    return /*#__PURE__*/ $42omo.createElement("span", {
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-text": true,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_11c8wadc _1reo15vq _18m915vq _syazazsu _o5724jg8 _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _sudp1e54",
            fontSize !== undefined && $1ecffae6e6a717dc$var$fontOverrideStyleMap[fontSize],
            "_1yyjr31u _102k1dud",
            className
        ]),
        style: {
            color: color,
            "--_1erfju8": (0, $7sObp.default)(maxLines)
        }
    }, formattedContent);
};
var $1ecffae6e6a717dc$export$2e2bcd8739ae039 = $1ecffae6e6a717dc$export$79422073c7118b5b;
const $1ecffae6e6a717dc$export$b9738bf28fb14829 = (descriptor, context)=>{
    return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        },
        content: context
    } : undefined;
};
const $1ecffae6e6a717dc$export$f12aecc78be3c7bb = (content)=>{
    return content ? {
        content: content
    } : undefined;
};
module.exports["default"] = $1ecffae6e6a717dc$export$2e2bcd8739ae039;
module.exports["toFormattedTextProps"] = $1ecffae6e6a717dc$export$b9738bf28fb14829;
module.exports["toTextProps"] = $1ecffae6e6a717dc$export$f12aecc78be3c7bb;

});

parcelRegister("4wLtQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9mMJ0 = parcelRequire("9mMJ0");

const $e65535d36ac745c6$var$AssignedToGroupElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9mMJ0.toAvatarGroupProps)(context.assignedToGroup, true) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9mMJ0.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).AssignedToGroup
    }) : null;
};
var $e65535d36ac745c6$export$2e2bcd8739ae039 = $e65535d36ac745c6$var$AssignedToGroupElement;
module.exports["default"] = $e65535d36ac745c6$export$2e2bcd8739ae039;

});

parcelRegister("iNImz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $68f91cb1c2b70cc7$var$AttachmentCountElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.attachmentCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).Attachment,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).AttachmentCount
    }) : null;
};
var $68f91cb1c2b70cc7$export$2e2bcd8739ae039 = $68f91cb1c2b70cc7$var$AttachmentCountElement;
module.exports["default"] = $68f91cb1c2b70cc7$export$2e2bcd8739ae039;

});

parcelRegister("LrBxG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9mMJ0 = parcelRequire("9mMJ0");

const $5665fdfe0a3a6612$var$AuthorGroupElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9mMJ0.toAvatarGroupProps)(context.authorGroup, false) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9mMJ0.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).AuthorGroup
    }) : null;
};
var $5665fdfe0a3a6612$export$2e2bcd8739ae039 = $5665fdfe0a3a6612$var$AuthorGroupElement;
module.exports["default"] = $5665fdfe0a3a6612$export$2e2bcd8739ae039;

});

parcelRegister("bWsCB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $9683283e28315c04$var$ChecklistProgressElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.checklistProgress?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).CheckItem,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).ChecklistProgress
    }) : null;
};
var $9683283e28315c04$export$2e2bcd8739ae039 = $9683283e28315c04$var$ChecklistProgressElement;
module.exports["default"] = $9683283e28315c04$export$2e2bcd8739ae039;

});

parcelRegister("azCqP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9mMJ0 = parcelRequire("9mMJ0");

const $853fada055614992$var$CollaboratorGroupElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9mMJ0.toAvatarGroupProps)(context.collaboratorGroup, false) : undefined;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9mMJ0.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).CollaboratorGroup
    }) : null;
};
var $853fada055614992$export$2e2bcd8739ae039 = $853fada055614992$var$CollaboratorGroupElement;
module.exports["default"] = $853fada055614992$export$2e2bcd8739ae039;

});

parcelRegister("kexiH", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $0c173ce05ce57544$var$CommentCountElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.commentCount?.toString()) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $42omo.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).Comment,
        ...data,
        ...restProps,
        name: (0, $5TXU5.ElementName).CommentCount
    }) : null;
};
var $0c173ce05ce57544$export$2e2bcd8739ae039 = $0c173ce05ce57544$var$CommentCountElement;
module.exports["default"] = $0c173ce05ce57544$export$2e2bcd8739ae039;

});

parcelRegister("e8W8a", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $6wR2f = parcelRequire("6wR2f");

const $047203c23d0cd021$var$CreatedOnElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $6wR2f.toDateTimeProps)('created', context.createdOn) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6wR2f.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).CreatedOn
    }) : null;
};
var $047203c23d0cd021$export$2e2bcd8739ae039 = $047203c23d0cd021$var$CreatedOnElement;
module.exports["default"] = $047203c23d0cd021$export$2e2bcd8739ae039;

});

parcelRegister("3nul2", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $916e74797092cad1$var$CreatedByElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages).created_by, context.createdBy) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).CreatedBy
    }) : null;
};
var $916e74797092cad1$export$2e2bcd8739ae039 = $916e74797092cad1$var$CreatedByElement;
module.exports["default"] = $916e74797092cad1$export$2e2bcd8739ae039;

});

parcelRegister("jKoRo", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $7f92O = parcelRequire("7f92O");

const $d5c24538631868a6$var$DueOnElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $7f92O.toDateLozengeProps)(context.dueOn) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7f92O.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).DueOn
    }) : null;
};
var $d5c24538631868a6$export$2e2bcd8739ae039 = $d5c24538631868a6$var$DueOnElement;
module.exports["default"] = $d5c24538631868a6$export$2e2bcd8739ae039;

});

parcelRegister("4X6f2", function(module, exports) {
/**
 * The enum that describes Smart Link action types
 */ var $c5c90dd6b941df7e$export$6324b7946ad663e9 = /*#__PURE__*/ function(SmartLinkActionType) {
    SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
    SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
    SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
    SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
    return SmartLinkActionType;
}({});
class $c5c90dd6b941df7e$export$d4d72202bff63658 extends Error {
    constructor(message, errorCode){
        super(message);
        this.errorCode = void 0;
        this.errorCode = errorCode;
    }
}
module.exports["SmartLinkActionType"] = $c5c90dd6b941df7e$export$6324b7946ad663e9;
module.exports["InvokeError"] = $c5c90dd6b941df7e$export$d4d72202bff63658;

});

parcelRegister("bmx11", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $c95f1e4b0b62823d$var$LatestCommitElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.latestCommit?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).Commit,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).LatestCommit
    }) : null;
};
var $c95f1e4b0b62823d$export$2e2bcd8739ae039 = $c95f1e4b0b62823d$var$LatestCommitElement;
module.exports["default"] = $c95f1e4b0b62823d$export$2e2bcd8739ae039;

});

parcelRegister("jI5eg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $4NlKF = parcelRequire("4NlKF");

const $b061eed85b2a3300$var$LinkIconElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    if (!context) return null;
    const data = (0, $4NlKF.toLinkIconProps)(context?.linkIcon, context.type);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4NlKF.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).LinkIcon
    }) : null;
};
var $b061eed85b2a3300$export$2e2bcd8739ae039 = $b061eed85b2a3300$var$LinkIconElement;
module.exports["default"] = $b061eed85b2a3300$export$2e2bcd8739ae039;

});

parcelRegister("4NlKF", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1bY7o = parcelRequire("1bY7o");


var $gdv5Z = parcelRequire("gdv5Z");


var $i7jPX = parcelRequire("i7jPX");


var $5TXU5 = parcelRequire("5TXU5");


var $ivUmx = parcelRequire("ivUmx");


var $hX032 = parcelRequire("hX032");


var $iFRRf = parcelRequire("iFRRf");


var $kUxzQ = parcelRequire("kUxzQ");


var $hJgLA = parcelRequire("hJgLA");

const $5f41eba93c8538ef$var$styles = {
    container: "_1ul91ns9",
    iconWrapperStyle: "_1e0c1txw _4cvr1h6o _1bah1h6o"
};
const $5f41eba93c8538ef$var$positionStyleMap = {
    center: "_1wpz1h6o",
    top: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wpz1y6m"
};
const $5f41eba93c8538ef$var$customRenderStyleMap = {
    xlarge: "_1reo15vq _18m915vq _11c810sd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km1q9y _1xjx1osq _e2oo1osq _102kz42d",
    large: "_1reo15vq _18m915vq _11c810sd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km1q9y _1xjx1osq _e2oo1osq _102kz42d",
    medium: "_1reo15vq _18m915vq _11c81e3o _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km1q9y _1xjx1osq _e2oo1osq _102kptym",
    small: "_1reo15vq _18m915vq _11c81e3o _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km1q9y _1xjx1osq _e2oo1osq _102kptym"
};
const $5f41eba93c8538ef$var$renderAtlaskitIcon = (icon, testId, size = (0, $5TXU5.SmartLinkSize).Medium)=>{
    if (icon) return /*#__PURE__*/ $42omo.createElement((0, $iFRRf.default), {
        icon: icon,
        testId: `${testId}-icon`,
        "aria-hidden": "true",
        label: "",
        size: size
    });
};
const $5f41eba93c8538ef$var$renderDefaultIcon = (label, testId)=>/*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
        label: label,
        testId: `${testId}-default`,
        color: "currentColor"
    });
const $5f41eba93c8538ef$var$renderImageIcon = (defaultIcon, url, testId, size = (0, $5TXU5.SmartLinkSize).Medium, appearance, hideLoadingSkeleton)=>{
    const width = size === (0, $5TXU5.SmartLinkSize).Large ? "var(--ds-space-300, 24px)" : "var(--ds-space-200, 16px)";
    if (url) return /*#__PURE__*/ $42omo.createElement((0, $kUxzQ.default), {
        defaultIcon: defaultIcon,
        testId: testId,
        url: url,
        width: width,
        height: width,
        appearance: appearance,
        hideLoadingSkeleton: hideLoadingSkeleton
    });
}; /**
    * A base element that displays an Icon or favicon.
    * @internal
    * @param props - The props necessary for the Icon element.
    * @see LinkIcon
    */ 
const $5f41eba93c8538ef$var$IconElement = ({ icon: icon, overrideIcon: overrideIcon, label: label = 'Link', name: name, position: position = (0, $5TXU5.SmartLinkPosition).Top, className: className, render: render, size: size = (0, $5TXU5.SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url, appearance: appearance = 'square', hideLoadingSkeleton: hideLoadingSkeleton, isTiledIcon: isTiledIcon })=>{
    const element = (0, $42omo.useMemo)(()=>{
        const defaultIcon = $5f41eba93c8538ef$var$renderDefaultIcon(label, testId);
        return overrideIcon || render?.() || $5f41eba93c8538ef$var$renderImageIcon(defaultIcon, url, testId, size, appearance, hideLoadingSkeleton) || $5f41eba93c8538ef$var$renderAtlaskitIcon(icon, testId, size) || defaultIcon;
    }, [
        label,
        testId,
        overrideIcon,
        render,
        url,
        size,
        appearance,
        hideLoadingSkeleton,
        icon
    ]);
    const width = (0, $hJgLA.getIconWidth)(size);
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-smart-element": name,
        "data-smart-element-icon": true,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $5f41eba93c8538ef$var$styles.container,
            $5f41eba93c8538ef$var$positionStyleMap[position],
            render && $5f41eba93c8538ef$var$customRenderStyleMap[size],
            className
        ])
    }, isTiledIcon && (0, $hX032.isNewBlockcardUnauthorizedRefreshExperimentEnabled)() ? /*#__PURE__*/ $42omo.createElement((0, $i7jPX.default), {
        size: size,
        label: label
    }, element) : /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $5f41eba93c8538ef$var$styles.iconWrapperStyle,
        style: {
            width: width,
            height: width
        }
    }, element));
};
var $5f41eba93c8538ef$export$2e2bcd8739ae039 = $5f41eba93c8538ef$var$IconElement;
const $5f41eba93c8538ef$export$6d33abd591a3f700 = (data, type)=>{
    const isDataLinkIcon = (_data)=>{
        return typeof _data === 'object' && _data !== null && ('icon' in _data || 'url' in _data);
    };
    if (!isDataLinkIcon(data)) return typeof data === 'object' ? data : undefined;
    const isImageRound = (0, $ivUmx.isProfileType)(type);
    return {
        ...data,
        appearance: isImageRound ? 'round' : 'square'
    };
};
module.exports["default"] = $5f41eba93c8538ef$export$2e2bcd8739ae039;
module.exports["toLinkIconProps"] = $5f41eba93c8538ef$export$6d33abd591a3f700;

});

parcelRegister("hX032", function(module, exports) {

var $1oCLl = parcelRequire("1oCLl");


var $dZ8uq = parcelRequire("dZ8uq");

const $fa4a18d6fca5177d$export$5aaff24acd8d0e5d = (fireExperimentExposure = false)=>{
    if (fireExperimentExposure) return (0, $1oCLl.expValEquals)('platform_sl_3p_unauth_paste_as_block_card', 'cohort', 'card_by_default_and_new_design', 'control');
    else return (0, $dZ8uq.expValEqualsNoExposure)('platform_sl_3p_unauth_paste_as_block_card', 'cohort', 'card_by_default_and_new_design', 'control');
};
module.exports["isNewBlockcardUnauthorizedRefreshExperimentEnabled"] = $fa4a18d6fca5177d$export$5aaff24acd8d0e5d;

});

parcelRegister("8iOdP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $8bb8e = parcelRequire("8bb8e");

const $7078b0bbce341226$var$LocationElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context?.location ?? null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8bb8e.default), {
        theme: (0, $5TXU5.SmartLinkInternalTheme).Grey,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).Location
    }) : null;
};
var $7078b0bbce341226$export$2e2bcd8739ae039 = $7078b0bbce341226$var$LocationElement;
module.exports["default"] = $7078b0bbce341226$export$2e2bcd8739ae039;

});

parcelRegister("jW9GW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $7578031676e72aae$var$ModifiedByElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages).modified_by, context.modifiedBy) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).ModifiedBy
    }) : null;
};
var $7578031676e72aae$export$2e2bcd8739ae039 = $7578031676e72aae$var$ModifiedByElement;
module.exports["default"] = $7578031676e72aae$export$2e2bcd8739ae039;

});

parcelRegister("1WqHG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $6wR2f = parcelRequire("6wR2f");

const $eaad8a74af19aa38$var$ModifiedOnElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $6wR2f.toDateTimeProps)('modified', context.modifiedOn) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $42omo.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6wR2f.default), {
        ...data,
        ...restProps,
        name: (0, $5TXU5.ElementName).ModifiedOn
    }) : null;
};
var $eaad8a74af19aa38$export$2e2bcd8739ae039 = $eaad8a74af19aa38$var$ModifiedOnElement;
module.exports["default"] = $eaad8a74af19aa38$export$2e2bcd8739ae039;

});

parcelRegister("ful5o", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $42f47b467fa462a3$var$OwnedByElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const { onRender: onRender, textPrefix: textPrefix = 'owned_by', ...restProps } = props || {};
    const data = context ? (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages)[textPrefix], context?.ownedBy) : null;
    (0, $42omo.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
        ...data,
        ...restProps,
        name: (0, $5TXU5.ElementName).OwnedBy
    }) : null;
};
var $42f47b467fa462a3$export$2e2bcd8739ae039 = $42f47b467fa462a3$var$OwnedByElement;
module.exports["default"] = $42f47b467fa462a3$export$2e2bcd8739ae039;

});

parcelRegister("41AV3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9mMJ0 = parcelRequire("9mMJ0");

const $085ad7f5d3b72529$var$OwnedByGroupElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9mMJ0.toAvatarGroupProps)(context.ownedByGroup, false) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $42omo.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9mMJ0.default), {
        ...data,
        ...restProps,
        name: (0, $5TXU5.ElementName).OwnedByGroup
    }) : null;
};
var $085ad7f5d3b72529$export$2e2bcd8739ae039 = $085ad7f5d3b72529$var$OwnedByGroupElement;
module.exports["default"] = $085ad7f5d3b72529$export$2e2bcd8739ae039;

});

parcelRegister("ikM9T", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");





var $kUxzQ = parcelRequire("kUxzQ");

const $531c533c77a52797$var$styles = null;
const $531c533c77a52797$var$MediaElement = ({ name: name, className: className, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    if (!type || !url) return null;
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-smart-element": name,
        "data-smart-element-media": type,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_1h1tcq2i _1e0c1txw _1bsb1osq _4t3i1ns9 _jqez1osq _1lg71osq _6slq1osq _x1m21osq _1chb1osq _1usb1osq _5c331osq _l9z01osq _6o691dfr _vr2g1dfr _173baqso _1niwaqso _t0h9stnw _1ulbstnw _byj21ooe _3hvr1ooe _1c0s1ssb _15j31ssb _1npy1ssb _19he1ssb _n3vc1wug _1qj91wug _4fdy1wug _18cv1wug _1aoq15vq _1iqz15vq _6fioj63w _l0jmidpf _12zuh2mm",
            className
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $kUxzQ.default), {
        hideLoadingSkeleton: ui?.hideLoadingSkeleton,
        testId: `${testId}-image`,
        url: url,
        onError: onError,
        onLoad: onLoad,
        defaultIcon: null
    }));
};
var $531c533c77a52797$export$2e2bcd8739ae039 = $531c533c77a52797$var$MediaElement;


const $a98281f2c459b443$var$PreviewElement = (props)=>{
    const { overrideUrl: overrideUrl, ...rest } = props ?? {};
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = overrideUrl ? {
        url: overrideUrl,
        type: (0, $5TXU5.MediaType).Image
    } : context?.preview;
    if (!data) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $531c533c77a52797$export$2e2bcd8739ae039), {
        ...rest,
        ...data
    });
};
var $a98281f2c459b443$export$2e2bcd8739ae039 = $a98281f2c459b443$var$PreviewElement;
module.exports["default"] = $a98281f2c459b443$export$2e2bcd8739ae039;

});

parcelRegister("8YJtM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $ecf289c1a2ef6a7c$var$PriorityElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context?.priority ?? null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).Priority
    }) : null;
};
var $ecf289c1a2ef6a7c$export$2e2bcd8739ae039 = $ecf289c1a2ef6a7c$var$PriorityElement;
module.exports["default"] = $ecf289c1a2ef6a7c$export$2e2bcd8739ae039;

});

parcelRegister("6Ed8U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $3c7f8fc790c1b094$var$ProgrammingLanguageElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.programmingLanguage) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).ProgrammingLanguage,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).ProgrammingLanguage
    }) : null;
};
var $3c7f8fc790c1b094$export$2e2bcd8739ae039 = $3c7f8fc790c1b094$var$ProgrammingLanguageElement;
module.exports["default"] = $3c7f8fc790c1b094$export$2e2bcd8739ae039;

});

parcelRegister("iuEuh", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $5efcddd7e05f410f$var$ReactCountElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.reactCount?.toString()) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $42omo.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).React,
        ...data,
        ...restProps,
        name: (0, $5TXU5.ElementName).ReactCount
    }) : null;
};
var $5efcddd7e05f410f$export$2e2bcd8739ae039 = $5efcddd7e05f410f$var$ReactCountElement;
module.exports["default"] = $5efcddd7e05f410f$export$2e2bcd8739ae039;

});

parcelRegister("2GDee", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $2b374eebbbeae9d3$var$ReadTimeElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages).read_time, context.readTime) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).ReadTime
    }) : null;
};
var $2b374eebbbeae9d3$export$2e2bcd8739ae039 = $2b374eebbbeae9d3$var$ReadTimeElement;
module.exports["default"] = $2b374eebbbeae9d3$export$2e2bcd8739ae039;

});

parcelRegister("h2WFd", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $6wR2f = parcelRequire("6wR2f");

const $b4843e0ca575cd89$var$SentOnElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $6wR2f.toDateTimeProps)('sent', context.sentOn) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6wR2f.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).SentOn
    }) : null;
};
var $b4843e0ca575cd89$export$2e2bcd8739ae039 = $b4843e0ca575cd89$var$SentOnElement;
module.exports["default"] = $b4843e0ca575cd89$export$2e2bcd8739ae039;

});

parcelRegister("49WiA", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $4a2a6a0afaba68de$var$SNIPPET_DEFAULT_MAX_LINES = 3;
const $4a2a6a0afaba68de$var$snippetBaseStyle = null;
const $4a2a6a0afaba68de$var$SnippetElement = (props)=>{
    const { content: overrideContent, maxLines: maxLines = $4a2a6a0afaba68de$var$SNIPPET_DEFAULT_MAX_LINES, className: className, ...restOfProps } = props ?? {};
    const context = (0, $fUfR2.useFlexibleUiContext)();
    return /*#__PURE__*/ $42omo.createElement((0, $aIzVM.default), {
        content: overrideContent ?? context?.snippet,
        maxLines: maxLines,
        className: (0, $gMc0m.default)([
            "_syazi7uo _1ul9idpf _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        ...restOfProps
    });
};
var $4a2a6a0afaba68de$export$2e2bcd8739ae039 = $4a2a6a0afaba68de$var$SnippetElement;
module.exports["default"] = $4a2a6a0afaba68de$export$2e2bcd8739ae039;

});

parcelRegister("aGsNO", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $2b9dc14522cad497$var$SourceBranchElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $aIzVM.toTextProps)(context.sourceBranch) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).SourceBranch
    }) : null;
};
var $2b9dc14522cad497$export$2e2bcd8739ae039 = $2b9dc14522cad497$var$SourceBranchElement;
module.exports["default"] = $2b9dc14522cad497$export$2e2bcd8739ae039;

});

parcelRegister("emfmd", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $7f92O = parcelRequire("7f92O");

const $ba597065b544e1bf$var$StateElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context?.state ?? null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7f92O.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).State
    }) : null;
};
var $ba597065b544e1bf$export$2e2bcd8739ae039 = $ba597065b544e1bf$var$StateElement;
module.exports["default"] = $ba597065b544e1bf$export$2e2bcd8739ae039;

});

parcelRegister("a0Yyn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $9a2e44abfd20874f$var$SubscriberCountElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.subscriberCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).Subscriber,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).SubscriberCount
    }) : null;
};
var $9a2e44abfd20874f$export$2e2bcd8739ae039 = $9a2e44abfd20874f$var$SubscriberCountElement;
module.exports["default"] = $9a2e44abfd20874f$export$2e2bcd8739ae039;

});

parcelRegister("b8mrt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $a84eddedac7cbcb2$var$SubTasksProgressElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.subTasksProgress?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).SubTasksProgress,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).SubTasksProgress
    }) : null;
};
var $a84eddedac7cbcb2$export$2e2bcd8739ae039 = $a84eddedac7cbcb2$var$SubTasksProgressElement;
module.exports["default"] = $a84eddedac7cbcb2$export$2e2bcd8739ae039;

});

parcelRegister("jpKes", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");


var $c4sKh = parcelRequire("c4sKh");

const $26451f799052e0a3$var$badgeStyles = null; /**
                           * A base element that displays a visual indicator for a numeric value
                           * @internal
                           * @see StoryPoints
                           * */ 
const $26451f799052e0a3$var$BaseAtlaskitElementBadge = ({ value: value, name: name, className: className, testId: testId = 'smart-element-atlaskit-badge' })=>{
    if (!value) return null;
    return /*#__PURE__*/ $42omo.createElement("span", {
        "data-smart-element": name,
        "data-smart-element-atlaskit-badge": true,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_4cvr1h6o _1e0c116y _1ul91ns9",
            className
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $c4sKh.default), null, value));
};
var $26451f799052e0a3$export$2e2bcd8739ae039 = $26451f799052e0a3$var$BaseAtlaskitElementBadge;
const $26451f799052e0a3$export$731812b93bd90554 = (value)=>{
    return value ? {
        value: value
    } : undefined;
};


const $92f590de7cb9f9cd$var$StoryPointsElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $26451f799052e0a3$export$731812b93bd90554)(context.storyPoints) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $26451f799052e0a3$export$2e2bcd8739ae039), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).StoryPoints
    }) : null;
};
var $92f590de7cb9f9cd$export$2e2bcd8739ae039 = $92f590de7cb9f9cd$var$StoryPointsElement;
module.exports["default"] = $92f590de7cb9f9cd$export$2e2bcd8739ae039;

});

parcelRegister("hIbqn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $9a81c9be82c9d19d$var$TargetBranchElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $aIzVM.toTextProps)(context.targetBranch) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).TargetBranch
    }) : null;
};
var $9a81c9be82c9d19d$export$2e2bcd8739ae039 = $9a81c9be82c9d19d$var$TargetBranchElement;
module.exports["default"] = $9a81c9be82c9d19d$export$2e2bcd8739ae039;

});

parcelRegister("gHW9t", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $8bb8e = parcelRequire("8bb8e");

const $b6969367f8b7bc15$var$TitleElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? context?.linkTitle : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8bb8e.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).Title
    }) : null;
};
var $b6969367f8b7bc15$export$2e2bcd8739ae039 = $b6969367f8b7bc15$var$TitleElement;
module.exports["default"] = $b6969367f8b7bc15$export$2e2bcd8739ae039;

});

parcelRegister("zH0mb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $5c7b8fd91da848f0$var$ViewCountElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.viewCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).View,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).ViewCount
    }) : null;
};
var $5c7b8fd91da848f0$export$2e2bcd8739ae039 = $5c7b8fd91da848f0$var$ViewCountElement;
module.exports["default"] = $5c7b8fd91da848f0$export$2e2bcd8739ae039;

});

parcelRegister("6LJqp", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $1a9391f1b33e2cfa$var$VoteCountElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.voteCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).Vote,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).VoteCount
    }) : null;
};
var $1a9391f1b33e2cfa$export$2e2bcd8739ae039 = $1a9391f1b33e2cfa$var$VoteCountElement;
module.exports["default"] = $1a9391f1b33e2cfa$export$2e2bcd8739ae039;

});

parcelRegister("1RvsP", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $5TXU5 = parcelRequire("5TXU5");


var $l7DP7 = parcelRequire("l7DP7");

const $16630f477b2fdaf3$var$alignmentStyleMap = {
    right: "_1dthh9n0 _r291h9n0 _1bahesu3 _y3gnusic",
    left: "_1dthv2br _r291v2br _1bah1y6m _y3gn1e5h"
};
const $16630f477b2fdaf3$var$baseStyleBySize = {
    xlarge: "_zulpv47k _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    large: "_zulppxbi _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    medium: "_zulpu2gc _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    small: "_zulp1b66 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf"
};
const $16630f477b2fdaf3$var$baseStyleByDirection = {
    horizontal: "_2lx2vrvc _4cvr1h6o",
    vertical: "_2lx21bp4 _4cvr1y6m"
};
const $16630f477b2fdaf3$var$baseStyles = null;
const $16630f477b2fdaf3$var$widthStyle = {
    flexible: "_16jlkb7n _1o9z11wp _i0dlf1ug",
    'fit-to-content': ""
};
const $16630f477b2fdaf3$var$positionStyle = {
    top: "_1wpz1y6m",
    center: ""
};
const $16630f477b2fdaf3$var$horizontalStyleBase = null;
const $16630f477b2fdaf3$var$horizontalStyleByHeight = {
    xlarge: "_1e0ccj1k _102k125z",
    large: "_1e0ccj1k _102k125z",
    medium: "_1e0ccj1k _102kz42d",
    small: "_1e0ccj1k _102kz42d"
};
const $16630f477b2fdaf3$var$gapStylesLeft = {
    xlarge: "_7yhbv47k _m6ukidpf",
    large: "_7yhbpxbi _m6ukidpf",
    medium: "_7yhbu2gc _m6ukidpf",
    small: "_7yhb1b66 _m6ukidpf"
};
const $16630f477b2fdaf3$var$gapStylesRight = {
    xlarge: "_24rcv47k _3dveidpf",
    large: "_24rcpxbi _3dveidpf",
    medium: "_24rcu2gc _3dveidpf",
    small: "_24rc1b66 _3dveidpf"
};
const $16630f477b2fdaf3$var$minWidthStyle = null; /**
                             * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
                             * preferences.
                             * @internal
                             * @param {ActionGroupProps} ActionGroupProps
                             * @see Action
                             */ 
const $16630f477b2fdaf3$var$ElementGroup = ({ align: align = (0, $5TXU5.SmartLinkAlignment).Left, children: children, direction: direction = (0, $5TXU5.SmartLinkDirection).Horizontal, size: size = (0, $5TXU5.SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, $5TXU5.SmartLinkWidth).FitToContent, position: position = (0, $5TXU5.SmartLinkPosition).Center, className: className })=>{
    const isHorizontal = direction === (0, $5TXU5.SmartLinkDirection).Horizontal;
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-smart-element-group": true,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $16630f477b2fdaf3$var$baseStyleBySize[size],
            $16630f477b2fdaf3$var$baseStyleByDirection[direction],
            "_fiawglyw",
            $16630f477b2fdaf3$var$alignmentStyleMap[align],
            "_1ul99by0",
            $16630f477b2fdaf3$var$widthStyle[width],
            isHorizontal && "_1reo15vq _18m915vq _1e0c1ule _s7n4nkob _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _1aaynkob _15tynkob _1iu61nu9 _166k1nu9 _1div1nu9 _bmfb1nu9",
            isHorizontal && $16630f477b2fdaf3$var$horizontalStyleByHeight[size],
            isHorizontal && align === (0, $5TXU5.SmartLinkAlignment).Left && $16630f477b2fdaf3$var$gapStylesLeft[size],
            isHorizontal && align === (0, $5TXU5.SmartLinkAlignment).Right && $16630f477b2fdaf3$var$gapStylesRight[size],
            $16630f477b2fdaf3$var$positionStyle[position],
            className
        ])
    }, (0, $l7DP7.renderChildren)(children, size));
};
var $16630f477b2fdaf3$export$2e2bcd8739ae039 = $16630f477b2fdaf3$var$ElementGroup;
module.exports["default"] = $16630f477b2fdaf3$export$2e2bcd8739ae039;

});

parcelRegister("6FZ6a", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");





var $9YwaJ = parcelRequire("9YwaJ");


var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");

var $7p4As = parcelRequire("7p4As");

var $dE1p6 = parcelRequire("dE1p6");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $3gadb = parcelRequire("3gadb");





var $fUfR2 = parcelRequire("fUfR2");


var $1iDg7 = parcelRequire("1iDg7");


var $hJgLA = parcelRequire("hJgLA");

const $0c0e9865fe28e398$var$IconOnlyLarge = null;
const $0c0e9865fe28e398$var$SizeSmall = null;
const $0c0e9865fe28e398$var$SizeSmallIconOnly = null;
const $0c0e9865fe28e398$var$SizeSmallNotIconOnly = null;
const $0c0e9865fe28e398$var$IconButtonAppearanceMap = {
    default: 'default',
    danger: undefined,
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: undefined
};
const $0c0e9865fe28e398$var$ButtonAppearanceMap = {
    default: 'default',
    danger: 'danger',
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: 'warning'
};
const $0c0e9865fe28e398$var$tooltipOptions = {
    hideTooltipOnClick: true
};
const $0c0e9865fe28e398$var$ActionButtonRefresh = /*#__PURE__*/ (0, $42omo.forwardRef)(({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel }, ref)=>{
    const iconOnly = !content;
    const onButtonClick = (0, $42omo.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    const button = (0, $42omo.useMemo)(()=>{
        const isLinkButton = !!href;
        const spacing = size === (0, $5TXU5.SmartLinkSize).Large || size === (0, $5TXU5.SmartLinkSize).XLarge ? 'default' : 'compact';
        if ((0, $dh538.fg)('platform-button-icon-spacing-cleanup')) {
            const icon = iconBefore || iconAfter;
            const iconFn = icon ? ()=>icon : undefined;
            if (iconOnly && iconFn) {
                if (isLinkButton && iconFn) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dE1p6.default), {
                    appearance: $0c0e9865fe28e398$var$IconButtonAppearanceMap[appearance],
                    icon: iconFn,
                    href: href,
                    isDisabled: isDisabled,
                    isTooltipDisabled: false,
                    label: tooltipMessage,
                    onClick: onButtonClick(onClick),
                    spacing: spacing,
                    testId: testId,
                    tooltip: $0c0e9865fe28e398$var$tooltipOptions
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                    appearance: $0c0e9865fe28e398$var$IconButtonAppearanceMap[appearance],
                    icon: iconFn,
                    isDisabled: isDisabled,
                    isLoading: isLoading,
                    isTooltipDisabled: false,
                    label: tooltipMessage,
                    onClick: onButtonClick(onClick),
                    spacing: spacing,
                    testId: testId,
                    tooltip: $0c0e9865fe28e398$var$tooltipOptions
                });
            }
        } else if (iconOnly) {
            const icon = iconBefore || iconAfter;
            const iconFn = ()=>icon || null;
            if (isLinkButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dE1p6.default), {
                appearance: $0c0e9865fe28e398$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                href: href,
                isDisabled: isDisabled,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $0c0e9865fe28e398$var$tooltipOptions
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                appearance: $0c0e9865fe28e398$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $0c0e9865fe28e398$var$tooltipOptions
            });
        }
        if ((0, $dh538.fg)('platform-button-icon-spacing-cleanup')) {
            const iconBeforeFn = iconBefore ? ()=>iconBefore : undefined;
            const iconAfterFn = iconAfter ? ()=>iconAfter : undefined;
            if (isLinkButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                content: tooltipMessage,
                hideTooltipOnClick: true,
                testId: `${testId}-tooltip`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
                appearance: $0c0e9865fe28e398$var$ButtonAppearanceMap[appearance],
                "aria-label": ariaLabel,
                iconAfter: iconAfterFn,
                iconBefore: iconBeforeFn,
                isDisabled: isDisabled,
                href: href,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId
            }, content));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                content: tooltipMessage,
                hideTooltipOnClick: true,
                testId: `${testId}-tooltip`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                appearance: $0c0e9865fe28e398$var$ButtonAppearanceMap[appearance],
                "aria-label": ariaLabel,
                iconAfter: iconAfterFn,
                iconBefore: iconBeforeFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId
            }, content));
        } else {
            const iconBeforeFn = ()=>iconBefore || null;
            const iconAfterFn = ()=>iconAfter || null;
            if (isLinkButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                content: tooltipMessage,
                hideTooltipOnClick: true,
                testId: `${testId}-tooltip`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
                appearance: $0c0e9865fe28e398$var$ButtonAppearanceMap[appearance],
                "aria-label": ariaLabel,
                iconAfter: iconAfterFn,
                iconBefore: iconBeforeFn,
                isDisabled: isDisabled,
                href: href,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId
            }, content));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                content: tooltipMessage,
                hideTooltipOnClick: true,
                testId: `${testId}-tooltip`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                appearance: $0c0e9865fe28e398$var$ButtonAppearanceMap[appearance],
                "aria-label": ariaLabel,
                iconAfter: iconAfterFn,
                iconBefore: iconBeforeFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId
            }, content));
        }
    }, [
        appearance,
        ariaLabel,
        content,
        href,
        iconAfter,
        iconBefore,
        iconOnly,
        isDisabled,
        isLoading,
        onButtonClick,
        onClick,
        size,
        testId,
        tooltipMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        testId: `${testId}-button-wrapper`,
        ref: ref
    }, button);
});
const $0c0e9865fe28e398$var$ActionButtonRefreshWithOverrideCss = (0, $1iDg7.withOverrideCss)($0c0e9865fe28e398$var$ActionButtonRefresh);
const $0c0e9865fe28e398$var$ActionButtonNew = ({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, className: className })=>{
    const iconOnly = !content;
    const onButtonClick = (0, $42omo.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            size === (0, $5TXU5.SmartLinkSize).Large && iconOnly && "_1gflidpf _or3fidpf _1ddvidpf _1hhaidpf _yhjmidpf _1trnidpf _1fstidpf _1xceidpf _1gqnidpf _1qdmidpf _df2ridpf _j1twidpf _11lvidpf _192bidpf _vbn7idpf _wfu3idpf _1i3bidpf _13gwidpf _4wlcidpf _rehaidpf _mp2fidpf _ro8midpf _1l0qidpf _1bnaidpf _3kh9idpf _i2vxidpf _8pvjidpf _1e1oidpf _1vtwidpf _ijvwidpf _tpwpidpf _1ad8idpf",
            size === (0, $5TXU5.SmartLinkSize).Small && "_11c8wadc _k48p1wq8",
            size === (0, $5TXU5.SmartLinkSize).Small && iconOnly && "_1gflv77o _or3fv77o _1ddvv77o _1hhav77o _yhjmv77o _1trnv77o _1fstv77o _1xcev77o _1gqnv77o _1qdmv77o _df2rv77o _j1twv77o _11lvv77o _192bv77o _vbn7v77o _wfu3v77o",
            size === (0, $5TXU5.SmartLinkSize).Small && !iconOnly && "_11lv1b66 _192b1b66 _vbn71b66 _wfu31b66 _yhjm1b66 _1trn1b66 _1fst1b66 _1xce1b66",
            className
        ]),
        "data-testid": `${testId}-button-wrapper`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: tooltipMessage,
        hideTooltipOnClick: true,
        testId: `${testId}-tooltip`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9YwaJ.default), {
        appearance: appearance,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onButtonClick(onClick),
        spacing: (0, $hJgLA.sizeToButtonSpacing)[size],
        testId: testId,
        href: href,
        "aria-label": ariaLabel
    }, content)));
};
const $0c0e9865fe28e398$var$ActionButton = (props)=>{
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    if (ui?.hideLegacyButton || ui?.removeBlockRestriction) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c0e9865fe28e398$var$ActionButtonRefreshWithOverrideCss, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c0e9865fe28e398$var$ActionButtonNew, props);
};
var $0c0e9865fe28e398$export$2e2bcd8739ae039 = $0c0e9865fe28e398$var$ActionButton;






var $dAYOx = parcelRequire("dAYOx");


var $ivUmx = parcelRequire("ivUmx");

const $4e516599d84c6e93$var$ActionDropdownItem = ({ content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        elemAfter: iconAfter,
        elemBefore: iconBefore,
        isDisabled: isLoading,
        onClick: (0, $ivUmx.handleOnClick)(onClick),
        testId: testId
    }, content);
var $4e516599d84c6e93$export$2e2bcd8739ae039 = $4e516599d84c6e93$var$ActionDropdownItem;


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $cc9e773a3279151b$var$stackItemIconStylesCompiled = null;
const $cc9e773a3279151b$var$ActionIcon = ({ testId: testId, icon: icon })=>{
    return /*#__PURE__*/ $42omo.createElement("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l"
        ])
    }, icon);
};
var $cc9e773a3279151b$export$2e2bcd8739ae039 = $cc9e773a3279151b$var$ActionIcon;








/* action-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $1Whri = parcelRequire("1Whri");




var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");


var $9hlns = parcelRequire("9hlns");





const $cb337baea8f1bcdf$var$styles = {
    button: "_bfhksm61 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1bsb1osq _1ah31i6y _irr31dpa _1di6fcek",
    content: "_11c8wadc _syazi7uo"
};
const $cb337baea8f1bcdf$var$ActionButton = ({ content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, style: style })=>{
    const space = spaceOption ?? (0, $hJgLA.getPrimitivesInlineSpaceBySize)(size);
    const onClick = (0, $42omo.useCallback)(()=>{
        if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
    }, [
        isDisabled,
        isLoading,
        onClickCallback
    ]);
    const icon = iconOption && isLoading ? /*#__PURE__*/ $42omo.createElement((0, $cc9e773a3279151b$export$2e2bcd8739ae039), {
        icon: /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
            testId: `${testId}-loading`
        })
    }) : iconOption;
    return /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
        xcss: (0, $1Whri.cx)($cb337baea8f1bcdf$var$styles.button),
        ...tooltipProps,
        onClick: onClick,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style
    }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        alignBlock: "center",
        grow: "fill",
        space: space
    }, icon, /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($cb337baea8f1bcdf$var$styles.content)
    }, content)));
};
var $cb337baea8f1bcdf$export$2e2bcd8739ae039 = $cb337baea8f1bcdf$var$ActionButton;


const $e828a55eaf50791b$var$ActionStackItem = ({ content: content, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hideTooltip: hideTooltip, ...props })=>hideTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cb337baea8f1bcdf$export$2e2bcd8739ae039), {
        ...props,
        content: content
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: tooltipMessage || content,
        onHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cb337baea8f1bcdf$export$2e2bcd8739ae039), {
            ...props,
            content: content,
            tooltipProps: tooltipProps
        }));
var $e828a55eaf50791b$export$2e2bcd8739ae039 = $e828a55eaf50791b$var$ActionStackItem;


/**
 * A base action that can be triggered with an on click.
 * @internal
 * @param {ActionProps} ActionProps - The props necessary for the Action.
 */ const $1f726fde681f8fde$var$Action = ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, $5TXU5.SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, style: style, asDropDownItem: asDropDownItem, className: className, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
    if (!onClick) return null;
    const isStackItem = as === 'stack-item';
    const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
    const actionIcon = icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cc9e773a3279151b$export$2e2bcd8739ae039), {
        icon: icon,
        testId: testId
    }) : undefined;
    const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
    const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
    if (isStackItem) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e828a55eaf50791b$export$2e2bcd8739ae039), {
        content: content,
        icon: actionIcon,
        space: spaceInline,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        tooltipOnHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hideTooltip: hideTooltip
    });
    if (isDropdownItem) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4e516599d84c6e93$export$2e2bcd8739ae039), {
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        testId: testId
    });
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0c0e9865fe28e398$export$2e2bcd8739ae039), {
        appearance: appearance,
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        isDisabled: isDisabled,
        href: href,
        ariaLabel: ariaLabel
    });
    return Wrapper !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Wrapper, null, button) : button;
};
var $1f726fde681f8fde$export$2e2bcd8739ae039 = $1f726fde681f8fde$var$Action;
module.exports["default"] = $1f726fde681f8fde$export$2e2bcd8739ae039;

});

parcelRegister("cLh5D", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $9aGns = parcelRequire("9aGns");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $9oOnT = parcelRequire("9oOnT");


var $6FZ6a = parcelRequire("6FZ6a");

const $47aa84bed0904f6b$var$DownloadAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const invoke = (0, $9oOnT.default)({});
    const data = context?.actions?.[(0, $5TXU5.ActionName).DownloadAction];
    const onClick = (0, $42omo.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const label = isStackItem ? (0, $afp1H.messages).download_file : (0, $afp1H.messages).download;
    const tooltipMessage = isStackItem ? (0, $afp1H.messages).download_description : (0, $afp1H.messages).download;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), label),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9aGns))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Download"
        }),
        onClick: onClick,
        testId: "smart-action-download-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), tooltipMessage),
        ...data,
        ...props
    }) : null;
};
var $47aa84bed0904f6b$export$2e2bcd8739ae039 = $47aa84bed0904f6b$var$DownloadAction;
module.exports["default"] = $47aa84bed0904f6b$export$2e2bcd8739ae039;

});

parcelRegister("9l03X", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $c6GJD = parcelRequire("c6GJD");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $hJgLA = parcelRequire("hJgLA");





var $kKODE = parcelRequire("kKODE");


var $g98dH = parcelRequire("g98dH");


var $8i8ID = parcelRequire("8i8ID");


var $7DSoa = parcelRequire("7DSoa");

const $8421257f1cf5034c$var$createInvokeRequest = (request, payload)=>({
        action: {
            ...request.action,
            payload: payload
        },
        providerKey: request.providerKey
    });
var $8421257f1cf5034c$export$2e2bcd8739ae039 = $8421257f1cf5034c$var$createInvokeRequest;



var $6FZ6a = parcelRequire("6FZ6a");

const $a36d75dc0f2bdcbc$var$ServerAction = ({ action: action, onClick: onClick, onError: onErrorCallback, ...props })=>{
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const invoke = (0, $g98dH.default)();
    const reload = (0, $7DSoa.default)();
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const handleClick = (0, $42omo.useCallback)(async ()=>{
        if (action) {
            const smartLinkActionType = action.action?.actionType;
            try {
                setIsLoading(true);
                if (smartLinkActionType === 'FollowEntityAction' || smartLinkActionType === 'UnfollowEntityAction') fireEvent('ui.button.clicked.smartLinkFollowButton', {});
                else fireEvent(`ui.button.clicked.${smartLinkActionType}`, {});
                fireEvent('track.smartLinkQuickAction.started', {
                    smartLinkActionType: smartLinkActionType
                });
                const request = (0, $8421257f1cf5034c$export$2e2bcd8739ae039)(action);
                await invoke(request);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: smartLinkActionType
                });
                if (action.reload && action.reload.url) await reload(action.reload.url, true, undefined, action.reload.id);
                setIsLoading(false);
                if (onClick) onClick();
            } catch (err) {
                setIsLoading(false);
                fireEvent('track.smartLinkQuickAction.failed', {
                    smartLinkActionType: smartLinkActionType,
                    reason: (0, $8i8ID.getInvokeFailureReason)(err)
                });
                onErrorCallback?.();
            }
        }
    }, [
        action,
        invoke,
        onClick,
        onErrorCallback,
        reload,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        ...props,
        isLoading: isLoading,
        onClick: handleClick
    });
};
var $a36d75dc0f2bdcbc$export$2e2bcd8739ae039 = $a36d75dc0f2bdcbc$var$ServerAction;








const $3c347798ab285251$export$49248678d3914625 = (isProject = false, isFollow = false)=>{
    if (isProject && isFollow) return (0, $c6GJD.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $afp1H.messages).follow_project_errorGalaxia : (0, $afp1H.messages).follow_project_error;
    if (isProject && !isFollow) return (0, $c6GJD.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $afp1H.messages).unfollow_project_errorGalaxia : (0, $afp1H.messages).unfollow_project_error;
    if (!isProject && isFollow) return (0, $afp1H.messages).follow_goal_error;
    if (!isProject && !isFollow) return (0, $afp1H.messages).unfollow_goal_error;
    return (0, $afp1H.messages).generic_error_message;
};




const $fd35d1180b7d8d14$var$importIconMapper = {
    goal: ()=>(parcelRequire("bRnvt")).then(({ GoalIcon: GoalIcon })=>({
                default: GoalIcon
            })),
    projects: ()=>(parcelRequire("9RQQm")).then(({ ProjectsIcon: ProjectsIcon })=>({
                default: ProjectsIcon
            }))
};
const $fd35d1180b7d8d14$var$getIcon = (stackIconType)=>{
    const importFn = $fd35d1180b7d8d14$var$importIconMapper[stackIconType];
    if (!importFn) return null;
    return (0, $hJgLA.importIcon)(importFn);
};
const $fd35d1180b7d8d14$var$FollowAction = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5TXU5.ActionName).FollowAction];
    if (!context || !actionData) return null;
    const { value: value, isProject: isProject, ...data } = actionData;
    const isStackItem = props.as === 'stack-item';
    const message = value ? (0, $afp1H.messages).follow : (0, $afp1H.messages).unfollow;
    const projectMessage = value ? (0, $afp1H.messages).follow_project : (0, $afp1H.messages).unfollow_project;
    const goalMessage = value ? (0, $afp1H.messages).follow_goal : (0, $afp1H.messages).unfollow_goal;
    const stackMessage = isProject ? projectMessage : goalMessage;
    const label = isStackItem ? stackMessage : message;
    const projectTooltipMessage = value ? (0, $c6GJD.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $afp1H.messages).follow_project_descriptionGalaxia : (0, $afp1H.messages).follow_project_description : (0, $c6GJD.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $afp1H.messages).unfollow_project_descriptionGalaxia : (0, $afp1H.messages).unfollow_project_description;
    const goalTooltipMessage = value ? (0, $afp1H.messages).follow_goal_description : (0, $afp1H.messages).unfollow_goal_description;
    const stackTooltipMessage = isProject ? projectTooltipMessage : goalTooltipMessage;
    const tooltipMessage = isStackItem ? stackTooltipMessage : message;
    const stackIconType = isProject ? 'projects' : 'goal';
    const ImportedIcon = $fd35d1180b7d8d14$var$getIcon(stackIconType);
    const followIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ImportedIcon, {
        label: "Follow",
        testId: `smart-action-follow-action-${stackIconType}-icon`
    });
    const handleError = ()=>{
        const { onError: onErrorCallback } = props;
        const errorMessage = (0, $3c347798ab285251$export$49248678d3914625)(isProject, value);
        onErrorCallback?.({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), errorMessage),
            appearance: 'error'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a36d75dc0f2bdcbc$export$2e2bcd8739ae039), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), label),
        icon: followIcon,
        testId: "smart-action-follow-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), tooltipMessage),
        ...data,
        ...props,
        onError: handleError
    });
};
var $fd35d1180b7d8d14$export$2e2bcd8739ae039 = $fd35d1180b7d8d14$var$FollowAction;
module.exports["default"] = $fd35d1180b7d8d14$export$2e2bcd8739ae039;

});

parcelRegister("bRnvt", function(module, exports) {

let $8a26e0dc99c728f8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8a26e0dc99c728f8$var$load("6wr18"),
    $8a26e0dc99c728f8$var$load("ffEVr"),
    $8a26e0dc99c728f8$var$load("3wY4G")
]).then(()=>parcelRequire('7EiCp'));

});

parcelRegister("9RQQm", function(module, exports) {

let $72f20de99433ea06$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $72f20de99433ea06$var$load("6wr18"),
    $72f20de99433ea06$var$load("ffEVr"),
    $72f20de99433ea06$var$load("88r9N")
]).then(()=>parcelRequire('lwRK9'));

});

parcelRegister("2vLbR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $lOzEN = parcelRequire("lOzEN");


var $jypE9 = parcelRequire("jypE9");


var $1oCLl = parcelRequire("1oCLl");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $9oOnT = parcelRequire("9oOnT");


var $6FZ6a = parcelRequire("6FZ6a");

const $b8c6ed50ac412c77$var$PreviewAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const invoke = (0, $9oOnT.default)({});
    const data = context?.actions?.[(0, $5TXU5.ActionName).PreviewAction];
    const hasPreviewPanel = data?.hasPreviewPanel;
    const onClick = (0, $42omo.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const tooltipMessage = isStackItem ? (0, $afp1H.messages).preview_description : (0, $afp1H.messages).preview_improved;
    const actionIcon = (0, $42omo.useCallback)(()=>{
        // Only use panel icon if experiment is enabled and hasPreviewPanel is true
        if ((0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && hasPreviewPanel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jypE9))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Open preview panel"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lOzEN))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Open preview"
        });
    }, [
        hasPreviewPanel
    ]);
    const actionLabel = (0, $42omo.useCallback)(()=>{
        // Only use panel message if experiment is enabled and hasPreviewPanel is true
        if ((0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && hasPreviewPanel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $afp1H.messages).preview_panel);
        // Fall back to modal message if experiment is enabled, otherwise use original preview message
        if ((0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $afp1H.messages).preview_modal);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $afp1H.messages).preview_improved);
    }, [
        hasPreviewPanel
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        content: actionLabel(),
        icon: actionIcon(),
        onClick: onClick,
        testId: "smart-action-preview-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), tooltipMessage),
        hideTooltipOnMouseDown: true,
        ...data,
        ...props
    }) : null;
};
var $b8c6ed50ac412c77$export$2e2bcd8739ae039 = $b8c6ed50ac412c77$var$PreviewAction;
module.exports["default"] = $b8c6ed50ac412c77$export$2e2bcd8739ae039;

});

parcelRegister("apOlf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $1bY7o = parcelRequire("1bY7o");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $9oOnT = parcelRequire("9oOnT");


var $6FZ6a = parcelRequire("6FZ6a");

const $a91d440270dbacf8$var$CopyLinkAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const invoke = (0, $9oOnT.default)({});
    const data = context?.actions?.[(0, $5TXU5.ActionName).CopyLinkAction];
    const [tooltipMessage, setTooltipMessage] = (0, $42omo.useState)((0, $afp1H.messages).copy_url_to_clipboard);
    const onClick = (0, $42omo.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke({
                ...data.invokeAction,
                actionFn: async ()=>{
                    await data.invokeAction?.actionFn();
                    setTooltipMessage((0, $afp1H.messages).copied_url_to_clipboard);
                }
            });
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $afp1H.messages).copy_url_to_clipboard),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
            color: "currentColor",
            label: "copy url",
            spacing: "spacious"
        }),
        onClick: onClick,
        testId: "smart-action-copy-link-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), tooltipMessage),
        tooltipOnHide: ()=>setTooltipMessage((0, $afp1H.messages).copy_url_to_clipboard),
        ...data,
        ...props
    }) : null;
};
var $a91d440270dbacf8$export$2e2bcd8739ae039 = $a91d440270dbacf8$var$CopyLinkAction;
module.exports["default"] = $a91d440270dbacf8$export$2e2bcd8739ae039;

});

parcelRegister("lVA2Y", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

var $fVUfS = parcelRequire("fVUfS");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");

const $a1261186af9b2859$var$styles = {
    button: "_1e0c1bgi",
    padding: "_18zrutpp",
    message: "_1rjcze3t _18zrze3t"
};
const $a1261186af9b2859$var$UnresolvedAction = ({ testId: testId = 'unresolved-action', hasPadding: hasPadding = false })=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context?.actions?.[(0, $5TXU5.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const hasAction = onClick !== undefined;
    const message = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : undefined,
        xcss: (0, $1Whri.cx)($a1261186af9b2859$var$styles.message, hasPadding && $a1261186af9b2859$var$styles.padding)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...descriptor,
        values: values
    }));
    return hasAction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        onClick: data.onClick,
        style: {
            color: `inherit`,
            font: `inherit`,
            textAlign: `inherit`
        },
        xcss: $a1261186af9b2859$var$styles.button
    }, message) : message;
};
var $a1261186af9b2859$export$2e2bcd8739ae039 = $a1261186af9b2859$var$UnresolvedAction;
module.exports["default"] = $a1261186af9b2859$export$2e2bcd8739ae039;

});

parcelRegister("3eMTN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gdv5Z = parcelRequire("gdv5Z");

const $67004d95b34ee986$var$styles = {
    wrapper: "_c71lidpf _p12fidpf _kqswstnw"
};
const $67004d95b34ee986$export$3e100bc08448f36c = ({ children: children })=>{
    const onClick = (0, $42omo.useCallback)((e)=>{
        // Prevent click events from bubbling up
        e.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        role: "none",
        xcss: $67004d95b34ee986$var$styles.wrapper,
        onClick: onClick
    }, children);
};


const $a2cc1d898ee1f610$var$FALLBACK_API = {
    open: ()=>{},
    close: ()=>{}
};
const $a2cc1d898ee1f610$export$f4c0a0f23ba57f8c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($a2cc1d898ee1f610$var$FALLBACK_API);
const $a2cc1d898ee1f610$export$bb4eb02a83e1a0f8 = ({ children: children })=>{
    const [element, setElement] = (0, $42omo.useState)(null);
    const api = (0, $42omo.useMemo)(()=>({
            open: (modal)=>setElement(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
                    fallback: null
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67004d95b34ee986$export$3e100bc08448f36c), null, modal))),
            close: ()=>setElement(null)
        }), []);
    const fallbackRender = (0, $42omo.useCallback)(({ resetErrorBoundary: resetErrorBoundary })=>{
        resetErrorBoundary();
        return null;
    }, []);
    const onReset = (0, $42omo.useCallback)(()=>setElement(null), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a2cc1d898ee1f610$export$f4c0a0f23ba57f8c.Provider, {
        value: api
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
        fallbackRender: fallbackRender,
        onReset: onReset
    }, element));
};
const $a2cc1d898ee1f610$export$1fd7f5f21a6d6cb8 = ()=>(0, $42omo.useContext)($a2cc1d898ee1f610$export$f4c0a0f23ba57f8c);
module.exports["SmartLinkModalProvider"] = $a2cc1d898ee1f610$export$bb4eb02a83e1a0f8;
module.exports["useSmartLinkModal"] = $a2cc1d898ee1f610$export$1fd7f5f21a6d6cb8;

});

parcelRegister("guHsZ", function(module, exports) {

let $c0212a38e72a041f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c0212a38e72a041f$var$load("6wr18"),
    $c0212a38e72a041f$var$load("ffEVr"),
    $c0212a38e72a041f$var$load("Wowvf"),
    $c0212a38e72a041f$var$load("kHOMt"),
    $c0212a38e72a041f$var$load("hhss7"),
    $c0212a38e72a041f$var$load("7EorR"),
    $c0212a38e72a041f$var$load("h305A"),
    $c0212a38e72a041f$var$load("cqZpg")
]).then(()=>parcelRequire('iWqmE'));

});

parcelRegister("fFwgP", function(module, exports) {

let $b683b799784b2296$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b683b799784b2296$var$load("iVgrO"),
    $b683b799784b2296$var$load("hhss7"),
    $b683b799784b2296$var$load("aoU9B")
]).then(()=>parcelRequire('a6OFr'));

});

parcelRegister("2R1C4", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $5TXU5 = parcelRequire("5TXU5");


var $l7DP7 = parcelRequire("l7DP7");

const $1ab21bb04b9ccb77$var$baseBlockStyles = null;
const $1ab21bb04b9ccb77$var$highlightRemoveStyles = null;
const $1ab21bb04b9ccb77$var$gapStyles = {
    xlarge: "_zulpv47k _1ljqv47k",
    large: "_zulppxbi _1ljqpxbi",
    medium: "_zulpu2gc _1ljqu2gc",
    small: "_zulp1b66 _1ljq1b66"
};
const $1ab21bb04b9ccb77$var$directionStyles = {
    vertical: "_2lx21bp4 _4cvr1y6m",
    horizontal: "_2lx2vrvc _4cvr1h6o"
}; /**
    * A block represents a collection of elements and actions that are arranged
    * in a row. All elements and actions should be contained within a Block.
    * @internal
    * @param {ActionGroupProps} ActionGroupProps
    * @see Action
    */ 
const $1ab21bb04b9ccb77$var$Block = ({ children: children, direction: direction = (0, $5TXU5.SmartLinkDirection).Horizontal, size: size = (0, $5TXU5.SmartLinkSize).Medium, testId: testId = 'smart-block', className: className, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd, style: style, placeholderId: placeholderId })=>{
    (0, $42omo.useEffect)(()=>{
        onRender && onRender();
    }, [
        onRender
    ]);
    return /*#__PURE__*/ $42omo.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _1bah1y6m _fiawglyw _1uzp1mp2 _a6bx1l7x _e4i5bjq5 _1gu2dgkc _5b7tuxlv _17aedgkc",
            "_12ji1snc _1qu2agmp _12y310yn _12ji1kw7 _syaz1kw7 _18ql1j28 _1ifmglyw _181uglyw _1rkwglyw _te17glyw _uiztglyw",
            $1ab21bb04b9ccb77$var$directionStyles[direction],
            $1ab21bb04b9ccb77$var$gapStyles[size],
            className
        ]),
        "data-smart-block": true,
        "data-testid": testId,
        onTransitionEnd: onTransitionEnd,
        ref: blockRef,
        style: style,
        "data-ssr-placeholder": placeholderId,
        "data-ssr-placeholder-replace": placeholderId
    }, (0, $l7DP7.renderChildren)(children, size));
};
var $1ab21bb04b9ccb77$export$2e2bcd8739ae039 = $1ab21bb04b9ccb77$var$Block;
module.exports["default"] = $1ab21bb04b9ccb77$export$2e2bcd8739ae039;

});

parcelRegister("1lLfV", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $2R1C4 = parcelRequire("2R1C4");


var $1RvsP = parcelRequire("1RvsP");


var $l7DP7 = parcelRequire("l7DP7");

const $8e07cec8e3b2cb3b$var$DEFAULT_MAX_LINES = 2;
const $8e07cec8e3b2cb3b$var$MAXIMUM_MAX_LINES = 2;
const $8e07cec8e3b2cb3b$var$MINIMUM_MAX_LINES = 1;
const $8e07cec8e3b2cb3b$var$truncateStyles = {
    '1': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54",
    '2': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjcs5v _sudp1e54"
};
const $8e07cec8e3b2cb3b$var$sizeStyles = {
    xlarge: "_102k8vuz",
    large: "_102k8vuz",
    medium: "_102kckbl",
    small: "_102kckbl"
};
const $8e07cec8e3b2cb3b$var$getMaxLines = (maxLines)=>{
    if (maxLines > $8e07cec8e3b2cb3b$var$MAXIMUM_MAX_LINES) return $8e07cec8e3b2cb3b$var$DEFAULT_MAX_LINES;
    if (maxLines < $8e07cec8e3b2cb3b$var$MINIMUM_MAX_LINES) return $8e07cec8e3b2cb3b$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $8e07cec8e3b2cb3b$var$ElementItemRenderer = ({ align: align = (0, $5TXU5.SmartLinkAlignment).Left, items: items = [], display: display = 'inline', size: size = (0, $5TXU5.SmartLinkSize).Medium, maxLines: maxLines = $8e07cec8e3b2cb3b$var$DEFAULT_MAX_LINES })=>{
    const elements = (0, $l7DP7.renderElementItems)(items, display);
    return elements && /*#__PURE__*/ $42omo.createElement((0, $1RvsP.default), {
        align: align,
        direction: (0, $5TXU5.SmartLinkDirection).Horizontal,
        width: (0, $5TXU5.SmartLinkWidth).Flexible,
        size: size,
        className: (0, $gMc0m.default)([
            $8e07cec8e3b2cb3b$var$truncateStyles[maxLines],
            $8e07cec8e3b2cb3b$var$sizeStyles[size]
        ])
    }, elements);
}; /**
    * Represents a MetadataBlock, designed to contain groups of metadata in the form of elements.
    * Accepts an array of elements to be shown either primary (left hand side) or secondary (right hand side).
    * @public
    * @param {MetadataBlockProps} MetadataBlockProps
    * @see Block
    */ 
const $8e07cec8e3b2cb3b$var$MetadataBlock = ({ maxLines: maxLines = $8e07cec8e3b2cb3b$var$DEFAULT_MAX_LINES, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
    const cardContext = (0, $fUfR2.useFlexibleCardContext)();
    if (primary.length === 0 && secondary.length === 0 || cardContext?.status !== (0, $5TXU5.SmartLinkStatus).Resolved) return null;
    const size = blockProps?.size ?? cardContext?.ui?.size ?? (0, $5TXU5.SmartLinkSize).Medium;
    const maxLinesTotal = $8e07cec8e3b2cb3b$var$getMaxLines(maxLines);
    return /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        ...blockProps,
        size: size,
        testId: `${testId}-resolved-view`
    }, /*#__PURE__*/ $42omo.createElement($8e07cec8e3b2cb3b$var$ElementItemRenderer, {
        items: primary,
        size: size,
        maxLines: maxLinesTotal
    }), /*#__PURE__*/ $42omo.createElement($8e07cec8e3b2cb3b$var$ElementItemRenderer, {
        align: (0, $5TXU5.SmartLinkAlignment).Right,
        items: secondary,
        size: size,
        maxLines: maxLinesTotal
    }));
};
var $8e07cec8e3b2cb3b$export$2e2bcd8739ae039 = $8e07cec8e3b2cb3b$var$MetadataBlock;
module.exports["default"] = $8e07cec8e3b2cb3b$export$2e2bcd8739ae039;

});

parcelRegister("Y5kOr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fUfR2 = parcelRequire("fUfR2");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");


var $5TXU5 = parcelRequire("5TXU5");


var $ikM9T = parcelRequire("ikM9T");


var $2R1C4 = parcelRequire("2R1C4");

const $2fe31e0809d9677b$var$previewBlockStyleCommon = null;
const $2fe31e0809d9677b$var$ignoreContainerPaddingStyle = null; /**
                                           * Represents a resolved PreviewBlock, which typically contains media or other large format content.
                                           * @public
                                           * @param {PreviewBlock} PreviewBlock
                                           * @see Block
                                           */ 
const $2fe31e0809d9677b$var$PreviewBlockResolvedView = ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, placement: placement, testId: testId, overrideUrl: overrideUrl, style: style, className: className, ...blockProps })=>{
    const [dynamicStyles, setDynamicStyles] = (0, $42omo.useState)(style ?? {});
    const updateStyles = (0, $42omo.useCallback)(()=>{
        if (placement === (0, $5TXU5.MediaPlacement).Left || placement === (0, $5TXU5.MediaPlacement).Right) {
            const containerPadding = ignoreContainerPadding ? '0px' : 'var(--container-padding)';
            const newStyle = {
                ...style,
                position: 'absolute',
                top: containerPadding,
                bottom: containerPadding,
                width: `calc(var(--preview-block-width) - ${containerPadding})`,
                ...placement === (0, $5TXU5.MediaPlacement).Left ? {
                    left: containerPadding
                } : {},
                ...placement === (0, $5TXU5.MediaPlacement).Right ? {
                    right: containerPadding
                } : {}
            };
            setDynamicStyles(newStyle);
        } else if (ignoreContainerPadding) setDynamicStyles({
            ...style
        });
    }, [
        ignoreContainerPadding,
        placement,
        style
    ]); // Should be useLayoutEffect to avoid flicker.
    // Styles should be set before paint.
    (0, $42omo.useLayoutEffect)(()=>{
        updateStyles();
    }, [
        ignoreContainerPadding,
        placement,
        updateStyles,
        className
    ]);
    const handleOnLoad = (0, $42omo.useCallback)(()=>{
        updateStyles();
    }, [
        updateStyles
    ]);
    const handleOnError = (0, $42omo.useCallback)(()=>{
        if (onError) onError();
    }, [
        onError
    ]);
    return /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        style: dynamicStyles,
        className: (0, $gMc0m.default)([
            placement && "_1t26n7od _ze72n7od _10aa1osq _rjuj1osq _mr051dfr",
            !placement && ignoreContainerPadding && "_18u01ivi _2hwxc10g _e0oi1ya9 _dmhj1ya9",
            className
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $ikM9T.default), {
        onError: handleOnError,
        onLoad: handleOnLoad,
        overrideUrl: overrideUrl
    }));
};
var $2fe31e0809d9677b$export$2e2bcd8739ae039 = $2fe31e0809d9677b$var$PreviewBlockResolvedView;


/**
 * Represents a PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlockProps} PreviewBlock
 * @see Block
 */ const $3da662f4fc394f2e$var$PreviewBlock = ({ testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2fe31e0809d9677b$export$2e2bcd8739ae039), {
        ...blockProps,
        size: blockProps.size ?? ui?.size,
        testId: testId,
        overrideUrl: overrideUrl
    });
};
var $3da662f4fc394f2e$export$2e2bcd8739ae039 = $3da662f4fc394f2e$var$PreviewBlock;
module.exports["default"] = $3da662f4fc394f2e$export$2e2bcd8739ae039;

});

parcelRegister("8zS2j", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $4QzTV = parcelRequire("4QzTV");


var $49WiA = parcelRequire("49WiA");


var $hJgLA = parcelRequire("hJgLA");


var $2R1C4 = parcelRequire("2R1C4");

const $60c86a1fbc149797$var$DEFAULT_MAX_LINES = 3;
const $60c86a1fbc149797$var$MAXIMUM_MAX_LINES = 6;
const $60c86a1fbc149797$var$MINIMUM_MAX_LINES = 1;
/**
 * Represents a SnippetBlock, which is used to display longer form text content, like descriptions.
 * @public
 * @param {SnippetBlockProps} SnippetBlockProps
 * @see Block
 */ const $60c86a1fbc149797$var$SnippetBlock = ({ maxLines: maxLines = $60c86a1fbc149797$var$DEFAULT_MAX_LINES, testId: testId = 'smart-block-snippet', text: text, isHidden: isHidden = false, showFooter: showFooter = true, ...blockProps })=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const renderers = (0, $4QzTV.useSmartLinkRenderers)();
    const enableSnippetRenderer = (0, $fUfR2.useFlexibleUiOptionContext)()?.enableSnippetRenderer;
    const cardContext = (0, $fUfR2.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $5TXU5.SmartLinkStatus).Resolved && !text) return null;
    const snippetMaxLines = (0, $hJgLA.getMaxLines)(maxLines, $60c86a1fbc149797$var$DEFAULT_MAX_LINES, $60c86a1fbc149797$var$MAXIMUM_MAX_LINES, $60c86a1fbc149797$var$MINIMUM_MAX_LINES);
    const statusTestId = !text ? 'resolved' : 'non-resolved';
    const snippet = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $49WiA.default), {
        maxLines: snippetMaxLines,
        content: text
    });
    if (!enableSnippetRenderer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2R1C4.default), {
        ...blockProps,
        size: blockProps.size ?? cardContext?.ui?.size,
        testId: `${testId}-${statusTestId}-view`
    }, snippet);
    const SnippetReplacement = renderers?.snippet;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2R1C4.default), {
        ...blockProps,
        size: blockProps.size ?? cardContext?.ui?.size,
        testId: `${testId}-${statusTestId}-view`
    }, SnippetReplacement ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(SnippetReplacement, {
        fallbackText: (text || context?.snippet) ?? '',
        fallbackComponent: snippet,
        contentId: context?.meta?.objectId ?? '',
        contentType: context?.meta?.resourceType ?? '',
        cloudId: context?.meta?.tenantId ?? '',
        maxLines: snippetMaxLines,
        isHidden: isHidden,
        showFooter: showFooter
    }) : snippet);
};
var $60c86a1fbc149797$export$2e2bcd8739ae039 = $60c86a1fbc149797$var$SnippetBlock;
module.exports["default"] = $60c86a1fbc149797$export$2e2bcd8739ae039;

});

parcelRegister("4QzTV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eIleF = parcelRequire("eIleF");

const $69abf735cbcf4e67$export$c3514c024fefef57 = ()=>{
    const context = (0, $eIleF.useSmartLinkContext)();
    let renderers = context?.renderers;
    renderers = (0, $42omo.useMemo)(()=>renderers, [
        renderers
    ]);
    return renderers;
};
module.exports["useSmartLinkRenderers"] = $69abf735cbcf4e67$export$c3514c024fefef57;

});

parcelRegister("5znEc", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $5TXU5 = parcelRequire("5TXU5");


var $4gM1A = parcelRequire("4gM1A");


var $fUfR2 = parcelRequire("fUfR2");


var $gHW9t = parcelRequire("gHW9t");


var $7d67T = parcelRequire("7d67T");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gdv5Z = parcelRequire("gdv5Z");








var $lVA2Y = parcelRequire("lVA2Y");


var $jI5eg = parcelRequire("jI5eg");


var $2R1C4 = parcelRequire("2R1C4");


var $1RvsP = parcelRequire("1RvsP");

const $7f525c54e6e1b7b1$var$styles = {
    titleBoxCard: "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bsb1osq"
};
/**
 * Represents an Errored TitleBlock view.
 * This will render when a Smart Link did not successfully resolve.
 * This may be a result of a Smart Link not having the correct credentials,
 * or the backend response was errored or malformed.
 * @see TitleBlock
 */ const $7f525c54e6e1b7b1$var$TitleBlockErroredView = ({ actionGroup: actionGroup, hideRetry: hideRetry, retry: _retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, CompetitorPrompt: CompetitorPrompt, ...blockProps })=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const showRetry = !hideRetry && Boolean(context?.actions?.[(0, $5TXU5.InternalActionName).UnresolvedAction]);
    const competitorPrompt = CompetitorPrompt && context?.url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(CompetitorPrompt, {
        sourceUrl: context?.url,
        linkType: 'card'
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2R1C4.default), {
        ...blockProps,
        testId: `${testId}-errored-view`
    }, !hideIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jI5eg.default), {
        overrideIcon: icon,
        position: position
    }), competitorPrompt ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $7f525c54e6e1b7b1$var$styles.titleBoxCard
    }, title, competitorPrompt) : title, showRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1RvsP.default), {
        align: (0, $5TXU5.SmartLinkAlignment).Right
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lVA2Y.default), {
        testId: testId
    })), actionGroup);
};
var $7f525c54e6e1b7b1$export$2e2bcd8739ae039 = $7f525c54e6e1b7b1$var$TitleBlockErroredView;


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 





















var $l7DP7 = parcelRequire("l7DP7");

const $c1792527dfb9ef73$var$style = null;
const $c1792527dfb9ef73$var$styles = {
    titleBox: "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bsb1osq"
}; /**
    * This renders a fully resolved TitleBlock.
    * This should render when a Smart Link returns a valid response.
    * @see TitleBlock
    */ 
const $c1792527dfb9ef73$var$TitleBlockResolvedView = ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: _text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, CompetitorPrompt: CompetitorPrompt, url: url, hideIconLoadingSkeleton: hideIconLoadingSkeleton, ...blockProps })=>{
    const { size: size } = blockProps;
    const metadataElements = (0, $l7DP7.renderElementItems)(metadata);
    const subtitleElements = (0, $l7DP7.renderElementItems)(subtitle);
    return /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`
    }, !hideIcon && /*#__PURE__*/ $42omo.createElement((0, $jI5eg.default), {
        overrideIcon: icon,
        position: position,
        size: size,
        hideLoadingSkeleton: hideIconLoadingSkeleton
    }), /*#__PURE__*/ $42omo.createElement((0, $1RvsP.default), {
        direction: (0, $5TXU5.SmartLinkDirection).Vertical,
        width: (0, $5TXU5.SmartLinkWidth).Flexible,
        size: blockProps.size,
        className: (0, $gMc0m.default)([
            "_zulp1b66"
        ])
    }, CompetitorPrompt && url ? /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $c1792527dfb9ef73$var$styles.titleBox
    }, title, /*#__PURE__*/ $42omo.createElement(CompetitorPrompt, {
        sourceUrl: url,
        linkType: 'card'
    })) : title, subtitleElements && /*#__PURE__*/ $42omo.createElement((0, $1RvsP.default), {
        direction: (0, $5TXU5.SmartLinkDirection).Horizontal
    }, subtitleElements)), metadataElements && /*#__PURE__*/ $42omo.createElement((0, $1RvsP.default), {
        direction: (0, $5TXU5.SmartLinkDirection).Horizontal,
        align: (0, $5TXU5.SmartLinkAlignment).Right,
        position: metadataPosition ?? (0, $5TXU5.SmartLinkPosition).Center,
        size: blockProps.size
    }, metadataElements), actionGroup);
};
var $c1792527dfb9ef73$export$2e2bcd8739ae039 = $c1792527dfb9ef73$var$TitleBlockResolvedView;


/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 






var $hT8Jj = parcelRequire("hT8Jj");





var $hJgLA = parcelRequire("hJgLA");




/**
 * This represents a TitleBlock for a Smart Link that is currently waiting
 * for a request to finish.
 * This should render when a Smart Link has sent a request.
 * @see TitleBlock
 */ const $835b2d1437edfc5d$var$TitleBlockResolvingView = ({ actionGroup: actionGroup, icon: icon, position: position, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size = (0, $5TXU5.SmartLinkSize).Medium } = blockProps;
    const iconWidth = (0, $hJgLA.getIconWidth)(size);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2R1C4.default), {
        ...blockProps,
        testId: `${testId}-resolving-view`
    }, !hideIcon && icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jI5eg.default), {
        overrideIcon: icon,
        position: position,
        size: size,
        hideLoadingSkeleton: true
    }), !hideIcon && !icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        style: {
            width: iconWidth,
            height: iconWidth
        },
        "data-testid": `${testId}-icon`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hT8Jj.LoadingSkeleton), {
        width: iconWidth,
        height: iconWidth,
        testId: `${testId}-icon-loading`
    })), title, actionGroup);
};
var $835b2d1437edfc5d$export$2e2bcd8739ae039 = $835b2d1437edfc5d$var$TitleBlockResolvingView;


const $86a4ce57d2ec07f2$var$actionStyles = null;
const $86a4ce57d2ec07f2$var$getTitleBlockViewComponent = (status)=>{
    switch(status){
        case (0, $5TXU5.SmartLinkStatus).Pending:
        case (0, $5TXU5.SmartLinkStatus).Resolving:
            return 0, $835b2d1437edfc5d$export$2e2bcd8739ae039;
        case (0, $5TXU5.SmartLinkStatus).Resolved:
            return 0, $c1792527dfb9ef73$export$2e2bcd8739ae039;
        case (0, $5TXU5.SmartLinkStatus).Unauthorized:
        case (0, $5TXU5.SmartLinkStatus).Forbidden:
        case (0, $5TXU5.SmartLinkStatus).NotFound:
        case (0, $5TXU5.SmartLinkStatus).Errored:
        case (0, $5TXU5.SmartLinkStatus).Fallback:
        default:
            return 0, $7f525c54e6e1b7b1$export$2e2bcd8739ae039;
    }
};
/**
 * Represents a TitleBlock, which is the foundation of Flexible UI.
 * This contains an icon, the link, and any associated metadata and actions in one block.
 * The TitleBlock will also render differently given the state of the smart link.
 * This can be found in the corresponding Resolving, Resolved and Errored views.
 * @public
 * @param {TitleBlockProps} TitleBlockProps
 * @see Block
 * @see TitleBlockResolvingViewNew
 * @see TitleBlockResolvedViewNew
 * @see TitleBlockErroredViewNew
 */ const $86a4ce57d2ec07f2$var$TitleBlock = ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, className: className, anchorRef: anchorRef, CompetitorPrompt: CompetitorPrompt, url: url, hideIconLoadingSkeleton: hideIconLoadingSkeleton, ...props })=>{
    const cardContext = (0, $fUfR2.useFlexibleCardContext)();
    const { status: status = (0, $5TXU5.SmartLinkStatus).Fallback, ui: ui } = cardContext || {};
    const [actionDropdownOpen, setActionDropdownOpen] = (0, $42omo.useState)(false);
    const onDropdownOpenChange = (0, $42omo.useCallback)((isOpen)=>{
        setActionDropdownOpen(isOpen);
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    const actionGroup = actions.length > 0 && /*#__PURE__*/ $42omo.createElement((0, $7d67T.default), {
        items: actions,
        visibleButtonsNum: showActionOnHover ? 1 : 2,
        onDropdownOpenChange: onDropdownOpenChange
    });
    const overrideText = !!text ? {
        text: text
    } : {};
    const onMouseDown = (0, $4gM1A.useMouseDownEvent)();
    const title = /*#__PURE__*/ $42omo.createElement((0, $gHW9t.default), {
        hideTooltip: hideTitleTooltip,
        maxLines: maxLines,
        onMouseDown: onMouseDown,
        target: anchorTarget,
        theme: ui?.theme,
        anchorRef: anchorRef,
        ...overrideText
    });
    const Component = $86a4ce57d2ec07f2$var$getTitleBlockViewComponent(status);
    return /*#__PURE__*/ $42omo.createElement(Component, {
        ...props,
        actionGroup: actionGroup,
        className: (0, $gMc0m.default)([
            showActionOnHover && !actionDropdownOpen && "_1bfhidpf _wn5xkb7n _h157kb7n",
            className
        ]),
        testId: testId,
        title: title,
        metadataPosition: metadataPosition,
        hideIcon: hideIcon,
        hideRetry: hideRetry,
        icon: icon,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton,
        size: props.size ?? ui?.size,
        CompetitorPrompt: CompetitorPrompt,
        url: url
    });
};
var $86a4ce57d2ec07f2$export$2e2bcd8739ae039 = $86a4ce57d2ec07f2$var$TitleBlock;
module.exports["default"] = $86a4ce57d2ec07f2$export$2e2bcd8739ae039;

});

parcelRegister("5Tie7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1KuCI = parcelRequire("1KuCI");


var $9snKo = parcelRequire("9snKo");

const $eeea3d3a1c12cf78$export$1ca0544321134ad6 = ({ isSelected: isSelected, url: url, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1KuCI.CardLinkView), {
        key: 'lazy-render-key',
        testId: 'lazy-render-placeholder',
        "data-trello-do-not-use-override": "lazy-render-placeholder-trello",
        isSelected: isSelected,
        link: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9snKo.loadingPlaceholderClassName),
        placeholder: placeholder
    });
};
module.exports["LoadingCardLink"] = $eeea3d3a1c12cf78$export$1ca0544321134ad6;

});

parcelRegister("1KuCI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ioVck = parcelRequire("ioVck");

class $33c97c3cf1ea6f6c$export$ce508304ed2dd145 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ioVck.Frame), {
            withoutBackground: true,
            ...this.props
        }, this.props.placeholder || this.props.link);
    }
}
module.exports["CardLinkView"] = $33c97c3cf1ea6f6c$export$ce508304ed2dd145;

});

parcelRegister("ioVck", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4gM1A = parcelRequire("4gM1A");

/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");





var $dh538 = parcelRequire("dh538");

const $f88a24196e637c23$export$8b5c95e985c4ec9a = /*#__PURE__*/ (0, $42omo.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: _isInteractive, isSelected: isSelected, viewType: viewType, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        ref: ref,
        ...props,
        className: (0, $gMc0m.default)([
            "_1yt4x7n9 _2rko12b0 _v56415x0 _1e0c1nu9 _16d9qvcn _syaz13af _1rkwglyw _4cvx1w55",
            truncateInline && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            truncateInline && viewType === 'unauthorised' && "_syaz15cr",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19itia51 _bfhkhp5a _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
            isHovered && "_1h6d1w55",
            isHovered && !withoutBackground && "_4bfu1r31 _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qsw5lj _uiztglyw _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _bfw7ia51 _1nrm1r31 _c2waglyw _1iohnqa1" : "_uizt1kdv"
        ])
    }, props.children);
});
const $f88a24196e637c23$export$6e4bde711df5c2ab = /*#__PURE__*/ (0, $42omo.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, viewType: viewType, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
        href: href,
        ref: ref,
        ...props,
        className: (0, $gMc0m.default)([
            "_1yt4x7n9 _2rko12b0 _v56415x0 _1e0c1nu9 _16d9qvcn _syaz13af _1rkwglyw _4cvx1w55",
            truncateInline && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            truncateInline && viewType === 'unauthorised' && "_syaz15cr",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19itia51 _bfhkhp5a _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
            isHovered && "_1h6d1w55",
            isHovered && !withoutBackground && "_4bfu1r31 _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qsw5lj _uiztglyw _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _bfw7ia51 _1nrm1r31 _c2waglyw _1iohnqa1" : "_uizt1kdv",
            isInteractive && "_nt751r31 _49pcglyw _1hvw1o36 _1372tlke _7ehiw5lj _1j5pglyw _1di615s3",
            viewType === 'errored' && (0, $dh538.fg)('navx-2565-inline-card-error-state-underline') && "_4bfu1r31 _1hms8stv _ajmmnqa1 _9oik1r31 _1bnxglyw _jf4cnqa1"
        ])
    }, props.children);
});
const $f88a24196e637c23$var$baseWrapperStyles = null; // if the parent instruct the wrapper to be interactive, and the wrapper is in focus, apply selectedStyles
const $f88a24196e637c23$var$interactiveStyles = null;
const $f88a24196e637c23$var$hoveredStyles = null;
const $f88a24196e637c23$var$hoveredWithBackgroundStyles = null;
const $f88a24196e637c23$var$errorViewTypeStyles = null;
const $f88a24196e637c23$var$withoutBackgroundStyles = null;
const $f88a24196e637c23$var$withBackgroundStyles = null;
const $f88a24196e637c23$var$truncateStyles = null;
const $f88a24196e637c23$var$unauthorisedTruncateStyles = null;
const $f88a24196e637c23$var$notSelectedStyle = null;
const $f88a24196e637c23$var$selectedStyles = null;


const $0a9218124e4addff$export$b89a827e9254211a = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { isSelected: isSelected, children: children, onClick: onClick, link: link, viewType: viewType, withoutBackground: withoutBackground, testId: testId, className: className, isHovered: isHovered, truncateInline: truncateInline } = props;
    const handleClick = (0, $42omo.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, $42omo.useCallback)((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleMouseDown = (0, $4gM1A.useMouseDownEvent)();
    const isInteractive = Boolean(onClick);
    const isAnchor = Boolean(link || onClick);
    // Depending on whenever Frame was given onClick or link itself we display span or anchor elements
    const Wrapper = isAnchor ? (0, $f88a24196e637c23$export$6e4bde711df5c2ab) : (0, $f88a24196e637c23$export$8b5c95e985c4ec9a);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Wrapper, {
        href: link,
        withoutBackground: withoutBackground,
        isSelected: isSelected,
        isInteractive: isInteractive,
        tabIndex: isInteractive ? 0 : undefined,
        role: isInteractive ? 'button' : undefined,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onKeyPress: handleKeyPress,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ref: ref,
        isHovered: isHovered,
        truncateInline: truncateInline,
        viewType: viewType
    }, children);
});
module.exports["Frame"] = $0a9218124e4addff$export$b89a827e9254211a;

});

parcelRegister("9snKo", function(module, exports) {
const $20ef05bed4af1360$export$4b2b7d155f69aed4 = 'smart-link-loading-placeholder';
module.exports["loadingPlaceholderClassName"] = $20ef05bed4af1360$export$4b2b7d155f69aed4;

});

parcelRegister("iafpB", function(module, exports) {

let $d3951daa5c7fb328$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d3951daa5c7fb328$var$load("iVgrO"),
    $d3951daa5c7fb328$var$load("5ZwKh"),
    $d3951daa5c7fb328$var$load("ehFbl"),
    $d3951daa5c7fb328$var$load("gOP9E"),
    $d3951daa5c7fb328$var$load("Wowvf"),
    $d3951daa5c7fb328$var$load("36QeB"),
    $d3951daa5c7fb328$var$load("2euij"),
    $d3951daa5c7fb328$var$load("kZMnh"),
    $d3951daa5c7fb328$var$load("855o0"),
    $d3951daa5c7fb328$var$load("8MfZE"),
    $d3951daa5c7fb328$var$load("9aQIt"),
    $d3951daa5c7fb328$var$load("XZauT"),
    $d3951daa5c7fb328$var$load("4S1SF"),
    $d3951daa5c7fb328$var$load("jiFtb"),
    $d3951daa5c7fb328$var$load("lm9Lt"),
    $d3951daa5c7fb328$var$load("9wPDc"),
    $d3951daa5c7fb328$var$load("1MWOL"),
    $d3951daa5c7fb328$var$load("6fQco"),
    $d3951daa5c7fb328$var$load("aOY32"),
    $d3951daa5c7fb328$var$load("kjZZD"),
    $d3951daa5c7fb328$var$load("7jSfd"),
    $d3951daa5c7fb328$var$load("4HZlX"),
    $d3951daa5c7fb328$var$load("6wr18"),
    $d3951daa5c7fb328$var$load("kDqHr"),
    $d3951daa5c7fb328$var$load("ffEVr"),
    $d3951daa5c7fb328$var$load("hhss7"),
    $d3951daa5c7fb328$var$load("i4cia")
]).then(()=>parcelRequire('bAzak'));

});

parcelRegister("8k046", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eIleF = parcelRequire("eIleF");


var $dh538 = parcelRequire("dh538");


var $fwDOR = parcelRequire("fwDOR");


var $kKODE = parcelRequire("kKODE");


var $5TXU5 = parcelRequire("5TXU5");

const $6e579b1e6cb4cfe2$var$isValidPlaceholderData = (placeholderData)=>placeholderData?.data && 'url' in placeholderData.data && 'name' in placeholderData.data;
const $6e579b1e6cb4cfe2$export$684541b2632ffbbc = (placeholderData)=>{
    return $6e579b1e6cb4cfe2$var$isValidPlaceholderData(placeholderData) ? {
        status: 'resolved',
        metadataStatus: undefined,
        details: placeholderData
    } : undefined;
};



var $fUfR2 = parcelRequire("fUfR2");


var $i8IAc = parcelRequire("i8IAc");


var $7DSoa = parcelRequire("7DSoa");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");





var $fBMbo = parcelRequire("fBMbo");










const $bb043bc0c2a9f6db$export$783c1bf8fee63f80 = (context)=>Boolean(context && context.preview);



var $9E8aG = parcelRequire("9E8aG");


var $5znEc = parcelRequire("5znEc");








var $90Y9A = parcelRequire("90Y9A");

const $7470566bbae8322c$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY = 100;
const $7470566bbae8322c$var$HoverCardControl = ({ children: children, isHoverPreview: isHoverPreview, isAuthTooltip: isAuthTooltip, actionOptions: actionOptions, testId: testId, url: url, delay: delay = $7470566bbae8322c$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY, hoverPreviewOptions: hoverPreviewOptions })=>{
    const [canOpen, setCanOpen] = (0, $42omo.useState)(true);
    const mouseStopTimer = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        };
    }, []);
    const onMouseLeave = (0, $42omo.useCallback)(()=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
    }, []);
    const onMouseMove = (0, $42omo.useCallback)((e)=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        // Never show hover card on action or when action dropdown opens.
        // The code below can be simplified by using :is() and :has()
        // but the pseudo-class isn't support by Firefox yet.
        const action = // Any action button group (title/footer block)
        e.target.closest('.actions-button-group') || // When action dropdown list is opened on action button group or lozenge action
        e.target.closest('[data-smart-link-container]')?.querySelector('[data-action-open="true"]');
        const canOpenOnElement = isAuthTooltip && !action || // EDM-7060: For hover preview, also hide hover card on all elements
        // except title element (link title)
        isHoverPreview && !action && !e.target.closest(`[data-smart-element]:not([data-smart-element="${(0, $5TXU5.ElementName).Title}"])`);
        mouseStopTimer.current = setTimeout(()=>{
            if (canOpen !== canOpenOnElement) setCanOpen(Boolean(canOpenOnElement));
        }, delay);
    }, [
        isAuthTooltip,
        isHoverPreview,
        canOpen,
        delay
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $90Y9A.HoverCard), {
        allowEventPropagation: true,
        canOpen: canOpen,
        closeOnChildClick: true,
        actionOptions: actionOptions,
        url: url,
        hoverPreviewOptions: hoverPreviewOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: onMouseLeave,
        onMouseMove: onMouseMove,
        "data-testid": `${testId}-hover-card-wrapper`,
        role: 'presentation'
    }, children));
};
var $7470566bbae8322c$export$2e2bcd8739ae039 = $7470566bbae8322c$var$HoverCardControl;


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $4gM1A = parcelRequire("4gM1A");

const $079645fb666cbdaa$var$styles = null; /**
                      * An anchor component to cover the entire container creating a clickable area.
                      * @internal
                      * @see `clickableContainer`
                      */ 
const $079645fb666cbdaa$var$LayeredLink = ({ onClick: onClick, target: target, testId: testId, text: text, url: url })=>{
    const onMouseDown = (0, $4gM1A.useMouseDownEvent)();
    return /*#__PURE__*/ $42omo.createElement("a" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _154iidpf _1xi2idpf _94n5idpf _1ltvidpf _azhw1osq _o5721q9c _hboxstnw _obkmidpf _a52dkb7n",
            "layered-link"
        ]),
        "data-testid": `${testId}-layered-link`,
        href: url,
        onClick: onClick,
        onMouseDown: onMouseDown,
        target: target
    }, text);
};
var $079645fb666cbdaa$export$2e2bcd8739ae039 = $079645fb666cbdaa$var$LayeredLink;


const $a624e70f21d764cf$export$6f4e0540a2f2295a = (children, context)=>{
    let options = {};
    if ((0, $bb043bc0c2a9f6db$export$783c1bf8fee63f80)(context)) (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) {
            if ((0, $9E8aG.isFlexibleUiPreviewBlock)(child)) {
                const { placement: placement } = child.props;
                if (placement === (0, $5TXU5.MediaPlacement).Left) options.previewOnLeft = true;
                if (placement === (0, $5TXU5.MediaPlacement).Right) options.previewOnRight = true;
            }
        }
    });
    return options;
};
const $a624e70f21d764cf$var$filterChildren = (children, removeBlockRestriction)=>{
    if (removeBlockRestriction) return children;
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children, (child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child) && (0, $9E8aG.isFlexibleUiBlock)(child) ? child : undefined);
}; /**
    * Note: This function is only necessary for CompiledCSS within Jest tests due to the way it handles Styles.
    * CompiledCSS will inject a StyleCacheProvider around the component tree, which
    * causes the children to be wrapped in a StyleCacheProvider as well. This function recursively
    * searches for the first valid TitleBlock within the children of the StyleCacheProvider.
    */ 
const $a624e70f21d764cf$export$f6c7a950371733c8 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(node)) return undefined;
    if (node.type === (0, $5znEc.default)) return node;
    if ((0, $9E8aG.isStyleCacheProvider)(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid;
        (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(node.props.children, (child)=>{
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $a624e70f21d764cf$export$f6c7a950371733c8(child);
        });
        return isChildrenValid;
    }
    return undefined;
};
const $a624e70f21d764cf$var$getTitleBlockProps = (children)=>{
    const block = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children).map((child)=>$a624e70f21d764cf$export$f6c7a950371733c8(child)).filter((x)=>x !== undefined).at(0);
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(block)) return block.props;
};
const $a624e70f21d764cf$var$getLayeredLink = (testId, context, children, onClick)=>{
    const { linkTitle: linkTitle, url: url = '' } = context || {};
    const { anchorTarget: target, text: text } = $a624e70f21d764cf$var$getTitleBlockProps(children) || {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $079645fb666cbdaa$export$2e2bcd8739ae039), {
        onClick: onClick,
        target: target,
        testId: testId,
        text: text || linkTitle?.text,
        url: url
    });
};
const $a624e70f21d764cf$var$baseStyleCommon = null;
const $a624e70f21d764cf$var$backgroundStyles = null;
const $a624e70f21d764cf$var$elevationStyles = null;
const $a624e70f21d764cf$var$clickableContainerStyles = null;
const $a624e70f21d764cf$var$gapStyleMap = {
    xlarge: "_zulpr2fv",
    large: "_zulpzu5n",
    medium: "_zulp1bpf",
    small: "_zulpswc3"
}; /**
    * Get container padding based on smart link size
    * Equivalent version for DS primitives space token is getPrimitivesPaddingSpaceBySize()
    * at view/FlexibleCard/components/utils.tsx
    */ 
const $a624e70f21d764cf$var$getPadding = (size)=>{
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $5TXU5.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $5TXU5.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $a624e70f21d764cf$var$getGap = (size)=>{
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
            return "var(--ds-space-250, 20px)";
        case (0, $5TXU5.SmartLinkSize).Large:
            return "var(--ds-space-200, 16px)";
        case (0, $5TXU5.SmartLinkSize).Medium:
            return "var(--ds-space-100, 8px)";
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return "var(--ds-space-050, 4px)";
    }
};
const $a624e70f21d764cf$var$previewOnLeftStyleMap = {
    xlarge: "_19bver0k _y5vk1ejb",
    large: "_19bv16ru _y5vkv47k",
    medium: "_19bv1g7w _y5vk1eak",
    small: "_19bvlbes _y5vku2gc"
};
const $a624e70f21d764cf$var$previewOnRightStyleMap = {
    xlarge: "_u5f3er0k _1yob1ejb",
    large: "_u5f316ru _1yobv47k",
    medium: "_u5f31g7w _1yob1eak",
    small: "_u5f3lbes _1yobu2gc"
}; /**
    * A container is a hidden component that build the Flexible Smart Link.
    * All the Flexible UI components are wrapped inside the container.
    * It inherits the ui props from Card component and applies the custom styling
    * accordingly.
    * @internal
    * @see Block
    */ 
const $a624e70f21d764cf$var$Container = ({ children: children, clickableContainer: clickableContainer = false, hideBackground: hideBackground = false, hideElevation: hideElevation = false, hidePadding: hidePadding = false, onClick: onClick, retry: retry, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeBlockRestriction: removeBlockRestriction = false, size: size = (0, $5TXU5.SmartLinkSize).Medium, status: status, testId: testId = 'smart-links-container' })=>{
    (0, $fBMbo.di)((0, $7470566bbae8322c$export$2e2bcd8739ae039));
    const padding = hidePadding ? '0px' : $a624e70f21d764cf$var$getPadding(size);
    const gap = $a624e70f21d764cf$var$getGap(size);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const { previewOnLeft: previewOnLeft, previewOnRight: previewOnRight } = $a624e70f21d764cf$export$6f4e0540a2f2295a(children, context);
    const canShowHoverPreview = showHoverPreview && (status === 'resolved' || hoverPreviewOptions?.render !== undefined); // `retry` object contains action that can be performed on
    // unresolved link (unauthorized, forbidden, not found, etc.)
    const canShowAuthTooltip = showHoverPreview && status === 'unauthorized' && retry !== undefined;
    const isResolved = status === 'resolved';
    const isUnresolvedWithAuthFlow = status !== 'resolved' && retry !== undefined;
    const hasHoverCardOverride = hoverPreviewOptions?.render !== undefined;
    const canShowHoverCard = showHoverPreview && (isResolved || isUnresolvedWithAuthFlow || hasHoverCardOverride);
    const containerPaddingStyles = null;
    const container = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-smart-link-container": true,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _1ul9idpf _1reo15vq _kqswh2mm _1pcmkb7n _1v7y1i6y _ufn21i6y",
            $a624e70f21d764cf$var$gapStyleMap[size],
            !hideBackground && "_bfhkhp5a",
            "_1yt418y6 _jb7v18y6 _y5vk167t _1yob1wow _r37x1r5k",
            previewOnLeft && $a624e70f21d764cf$var$previewOnLeftStyleMap[size],
            previewOnRight && $a624e70f21d764cf$var$previewOnRightStyleMap[size],
            !hideElevation && "_19itia51 _2rkopb1k _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            clickableContainer && "_nqwih2mm _18ywh2mm _1nq3h2mm _1t4ckb7n _1nxdkb7n _xnbykb7n"
        ]),
        style: {
            "--_1xumd0e": (0, $7sObp.default)(padding),
            "--_73mooq": (0, $7sObp.default)(previewOnLeft ? gap : padding),
            "--_12k13bg": (0, $7sObp.default)(previewOnRight ? gap : padding)
        }
    }, clickableContainer ? $a624e70f21d764cf$var$getLayeredLink(testId, context, children, onClick) : null, $a624e70f21d764cf$var$filterChildren(children, removeBlockRestriction));
    if (context?.url && ((0, $dh538.fg)('navx-2478-sl-fix-hover-card-unresolved-view') ? canShowHoverCard : canShowHoverPreview || canShowAuthTooltip)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7470566bbae8322c$export$2e2bcd8739ae039), {
        isHoverPreview: (0, $dh538.fg)('navx-2478-sl-fix-hover-card-unresolved-view') ? isResolved || hasHoverCardOverride : canShowHoverPreview,
        isAuthTooltip: (0, $dh538.fg)('navx-2478-sl-fix-hover-card-unresolved-view') ? isUnresolvedWithAuthFlow : canShowAuthTooltip,
        actionOptions: actionOptions,
        testId: testId,
        url: context.url,
        hoverPreviewOptions: hoverPreviewOptions
    }, container);
    return container;
};
var $a624e70f21d764cf$export$2e2bcd8739ae039 = $a624e70f21d764cf$var$Container;



var $79vw2 = parcelRequire("79vw2");








var $7kN5H = parcelRequire("7kN5H");


var $4P3K9 = parcelRequire("4P3K9");



var $aliCf = parcelRequire("aliCf");


var $hX032 = parcelRequire("hX032");


var $lyclm = parcelRequire("lyclm");

const $89d55dabaa02345a$export$db5a8500f6b6286e = (jsonLd)=>{
    if (typeof jsonLd?.summary === 'string') {
        const summary = jsonLd.summary.trim();
        return Boolean(summary) ? summary : undefined;
    }
};
const $89d55dabaa02345a$export$8c6b9b49f358840 = (response)=>{
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntity)(response)?.description;
    return response?.data && $89d55dabaa02345a$export$db5a8500f6b6286e(response.data);
};






var $2LWAa = parcelRequire("2LWAa");


var $kbh18 = parcelRequire("kbh18");


var $hcMBV = parcelRequire("hcMBV");

const $e8673adc3e68b528$export$e7f7a50a8b8932df = (response, url, actionOptions, aiSummaryConfig)=>{
    if (!(0, $2LWAa.canShowAction)((0, $hcMBV.CardAction).AISummaryAction, actionOptions) || !(0, $kbh18.getIsAISummaryEnabled)(aiSummaryConfig?.isAdminHubAIEnabled, response) || !url) return;
    return {
        url: url
    };
};





const $b78ad704e0ae6105$export$f913cc6abf3ec084 = (response)=>{
    if (!response.data) return undefined;
    if (!response?.meta?.supportedFeature?.includes((0, $5TXU5.ActionName).AutomationAction)) return undefined;
    const data = response.data;
    const meta = response.meta;
    const { name: name, 'atlassian:ari': objectAri } = data;
    const { product: product, tenantId: tenantId, resourceType: resourceType } = meta;
    return {
        product: product,
        resourceType: resourceType,
        siteAri: `ari:cloud:${product}::site/${tenantId}`,
        objectName: name,
        objectAri: objectAri,
        // TODO: The admin experience will be a follow up
        canManageAutomation: false,
        baseAutomationUrl: '',
        analyticsSource: 'smartCardAutomationAction'
    };
};











var $226XV = parcelRequire("226XV");




const $fb7e4596bd230c75$export$5ec86886067a062d = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $2LWAa.canShowAction)((0, $hcMBV.CardAction).CopyLinkAction, actionOptions)) return;
    const url = (0, $79vw2.extractSmartLinkUrl)(response);
    if (!url) return;
    return {
        actionFn: async ()=>navigator.clipboard.writeText(url),
        actionSubjectId: 'copyLink',
        actionType: (0, $5TXU5.ActionName).CopyLinkAction,
        definitionId: (0, $226XV.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $226XV.getExtensionKey)(response),
        id: id,
        resourceType: (0, $226XV.getResourceType)(response)
    };
};


const $8c2f74fe1be4da73$export$31ddd5c40039ce53 = (param)=>{
    const invokeAction = (0, $fb7e4596bd230c75$export$5ec86886067a062d)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};



var $eB2Ls = parcelRequire("eB2Ls");

const $9de9c0ec786639a8$export$f6c386869a352b1f = (param)=>{
    const invokeAction = (0, $eB2Ls.extractInvokeDownloadAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};



var $l6lJr = parcelRequire("l6lJr");




var $4X6f2 = parcelRequire("4X6f2");










const $22e8dd570acdd9ca$var$extractServerAction = (data)=>{
    const actions = data?.['atlassian:serverAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) return [
        actions
    ];
    return actions;
};
var $22e8dd570acdd9ca$export$2e2bcd8739ae039 = $22e8dd570acdd9ca$var$extractServerAction;


const $e2c6b1a5cddedae9$var$extractFollowAction = (response, actionOptions, id)=>{
    if (!(0, $2LWAa.canShowAction)((0, $hcMBV.CardAction).FollowAction, actionOptions)) return;
    const extensionKey = (0, $226XV.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $22e8dd570acdd9ca$export$2e2bcd8739ae039)(data);
    const type = (0, $aliCf.extractType)(data);
    const isProject = type?.includes('atlassian:Project');
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>{
        if (item?.name === 'UpdateAction') {
            const actionName = item?.dataUpdateAction?.name;
            return actionName === (0, $4X6f2.SmartLinkActionType).FollowEntityAction || actionName === (0, $4X6f2.SmartLinkActionType).UnfollowEntityAction;
        }
        return false;
    });
    if (!action || !action.resourceIdentifiers) return;
    const url = (0, $l6lJr.extractLink)(data);
    const reload = url ? {
        id: id,
        url: url
    } : undefined;
    const actionType = action.dataUpdateAction?.name;
    return {
        action: {
            action: {
                actionType: actionType,
                resourceIdentifiers: action.resourceIdentifiers
            },
            providerKey: extensionKey,
            reload: reload
        },
        value: actionType === (0, $4X6f2.SmartLinkActionType).FollowEntityAction,
        isProject: isProject
    };
};
var $e2c6b1a5cddedae9$export$2e2bcd8739ae039 = $e2c6b1a5cddedae9$var$extractFollowAction;



var $4gOU2 = parcelRequire("4gOU2");

const $eeffcaf65b928966$export$9f0d9100b079448 = (param)=>{
    const result = (0, $4gOU2.extractInvokePreviewAction)(param);
    return result ? result : undefined;
};





const $2508fbc57d702d88$export$debae7424a0231b9 = (response)=>{
    if (!response?.meta?.supportedFeature?.includes('RelatedLinks')) return;
    const ari = (0, $79vw2.extractSmartLinkAri)(response);
    if (!ari) return;
    return {
        ari: ari
    };
};


const $97dbdd6e7a108abb$export$abe8d0ca1daa1755 = ({ actionOptions: actionOptions, aiSummaryConfig: aiSummaryConfig, appearance: appearance, fireEvent: fireEvent, id: id, origin: origin, response: response, url: url, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel })=>{
    const action = {
        [(0, $5TXU5.ActionName).CopyLinkAction]: (0, $8c2f74fe1be4da73$export$31ddd5c40039ce53)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $5TXU5.ActionName).DownloadAction]: (0, $9de9c0ec786639a8$export$f6c386869a352b1f)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $5TXU5.ActionName).FollowAction]: (0, $e2c6b1a5cddedae9$export$2e2bcd8739ae039)(response, actionOptions, id),
        [(0, $5TXU5.ActionName).PreviewAction]: (0, $eeffcaf65b928966$export$9f0d9100b079448)({
            actionOptions: actionOptions,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }),
        [(0, $5TXU5.ActionName).AutomationAction]: (0, $b78ad704e0ae6105$export$f913cc6abf3ec084)(response),
        [(0, $5TXU5.InternalActionName).AISummaryAction]: (0, $e8673adc3e68b528$export$e7f7a50a8b8932df)(response, url, actionOptions, aiSummaryConfig),
        [(0, $5TXU5.InternalActionName).ViewRelatedLinksAction]: (0, $2508fbc57d702d88$export$debae7424a0231b9)(response)
    };
    return Object.values(action).some((value)=>Boolean(value)) ? action : undefined;
};



var $kzSaQ = parcelRequire("kzSaQ");

const $335da40493fc9d85$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>(0, $kzSaQ.extractPersonFromJsonLd)(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = (0, $kzSaQ.extractPersonFromJsonLd)(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
    return undefined;
};




const $bb6eac6463daf31f$export$216e4f6aa7c169b8 = (jsonLd)=>{
    if (jsonLd['@type'] === 'atlassian:Project') {
        const members = (0, $335da40493fc9d85$export$6281d080d62a0719)(jsonLd);
        if (members && members.length !== 0) return members;
    }
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) {
        const extractedPersons = (0, $kzSaQ.extractPersonFromJsonLd)(updatedBy);
        return extractedPersons ? [
            extractedPersons
        ] : undefined;
    }
};








const $d9f3dbb8591ea96a$var$extractLinkTitle = (status, propUrl, response, onClick)=>{
    const responseUrl = (0, $79vw2.extractSmartLinkUrl)(response);
    const url = status === (0, $5TXU5.SmartLinkStatus).Resolved ? responseUrl ?? propUrl : propUrl;
    const name = (0, $79vw2.extractSmartLinkTitle)(response);
    const text = status === (0, $5TXU5.SmartLinkStatus).Resolved ? name ?? responseUrl ?? propUrl : propUrl;
    return {
        onClick: onClick,
        text: text,
        url: url
    };
};
var $d9f3dbb8591ea96a$export$2e2bcd8739ae039 = $d9f3dbb8591ea96a$var$extractLinkTitle;



var $5ctc0 = parcelRequire("5ctc0");


var $8hlRK = parcelRequire("8hlRK");




const $74fe51f061491681$var$priorityMapper = {
    blocker: (0, $5TXU5.IconType).PriorityBlocker,
    critical: (0, $5TXU5.IconType).PriorityCritical,
    high: (0, $5TXU5.IconType).PriorityHigh,
    highest: (0, $5TXU5.IconType).PriorityHighest,
    low: (0, $5TXU5.IconType).PriorityLow,
    lowest: (0, $5TXU5.IconType).PriorityLowest,
    major: (0, $5TXU5.IconType).PriorityMajor,
    medium: (0, $5TXU5.IconType).PriorityMedium,
    minor: (0, $5TXU5.IconType).PriorityMinor,
    trivial: (0, $5TXU5.IconType).PriorityTrivial,
    undefined: (0, $5TXU5.IconType).PriorityUndefined
};
const $74fe51f061491681$var$extractPriority = (data)=>{
    const priority = data['atlassian:priority'];
    if (priority) {
        if (typeof priority === 'string') {
            const icon = $74fe51f061491681$var$priorityMapper[priority.toLowerCase()];
            if (icon) return {
                icon: icon,
                label: priority
            };
        } else if (priority['@type'] === 'Object') return {
            label: priority.name,
            url: priority.icon && (0, $8hlRK.extractUrlFromIconJsonLd)(priority.icon)
        };
    }
};
var $74fe51f061491681$export$2e2bcd8739ae039 = $74fe51f061491681$var$extractPriority;


















var $dKrmg = parcelRequire("dKrmg");


const $a4bf3e45dcc07f8b$var$toInvokeRequest = (extensionKey, resourceIdentifiers, actionType, details)=>{
    if (!actionType) return;
    return {
        action: {
            actionType: actionType,
            resourceIdentifiers: resourceIdentifiers
        },
        providerKey: extensionKey,
        details: details
    };
};
const $a4bf3e45dcc07f8b$var$extractAction = (response, id, actionOptions, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel)=>{
    const extensionKey = (0, $226XV.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $22e8dd570acdd9ca$export$2e2bcd8739ae039)(data);
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>item?.name === 'UpdateAction' && item?.refField === 'tag');
    if (!action || !action.resourceIdentifiers) return;
    const read = $a4bf3e45dcc07f8b$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataRetrievalAction?.name);
    const url = (0, $l6lJr.extractLink)(data);
    const invokePreviewAction = response ? (0, $4gOU2.extractInvokePreviewAction)({
        actionOptions: actionOptions,
        appearance: appearance,
        fireEvent: fireEvent,
        id: id,
        onClose: resolve ? ()=>url && resolve(url, true) : undefined,
        origin: origin,
        response: response,
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        openPreviewPanel: openPreviewPanel
    })?.invokeAction : undefined;
    const details = {
        id: id,
        url: url,
        invokePreviewAction: invokePreviewAction
    };
    const update = $a4bf3e45dcc07f8b$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataUpdateAction?.name, details);
    return read || update ? {
        read: read,
        update: update
    } : undefined;
};
const $a4bf3e45dcc07f8b$var$extractState = (response, actionOptions, id, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel)=>{
    if (!response || !response.data) return;
    const lozenge = (0, $dKrmg.extractLozenge)(response?.data);
    if (!lozenge) return;
    if (!(0, $2LWAa.canShowAction)((0, $hcMBV.CardAction).ChangeStatusAction, actionOptions)) return lozenge;
    const action = $a4bf3e45dcc07f8b$var$extractAction(response, id, actionOptions, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel);
    return {
        ...lozenge,
        action: action
    };
};
var $a4bf3e45dcc07f8b$export$2e2bcd8739ae039 = $a4bf3e45dcc07f8b$var$extractState;



var $575f6 = parcelRequire("575f6");


var $kX2ZH = parcelRequire("kX2ZH");

const $6850aa7564532ebc$export$f222392162cff0d8 = (jsonLd)=>{
    const latestCommit = jsonLd['atlassian:latestCommit'];
    if (typeof latestCommit === 'string') return latestCommit;
    if (latestCommit) //todo: change the properties to latestCommit.hash when BE is ready
    return latestCommit ? latestCommit.name : undefined;
};



var $imb12 = parcelRequire("imb12");

const $cc6e2a82dcbb4550$var$extractFlexibleUiContext = ({ appearance: appearance, fireEvent: fireEvent, id: id, onClick: onClick, origin: origin, resolve: resolve, actionOptions: actionOptions, response: response, status: status, aiSummaryConfig: aiSummaryConfig, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel, ...props } = {})=>{
    if (!response) return undefined;
    const data = response.data;
    const meta = response.meta;
    const url = (0, $79vw2.extractSmartLinkUrl)(response);
    return {
        actions: (0, $97dbdd6e7a108abb$export$abe8d0ca1daa1755)({
            actionOptions: actionOptions,
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response,
            url: props.url,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }),
        appliedToComponentsCount: (0, $imb12.extractAppliedToComponentsCount)(data),
        assignedToGroup: (0, $imb12.extractPersonAssignedToAsArray)(data),
        attachmentCount: (0, $imb12.extractAttachmentCount)(data),
        authorGroup: (0, $79vw2.extractSmartLinkAuthorGroup)(response),
        ownedByGroup: (0, $4P3K9.extractPersonOwnedBy)(data),
        collaboratorGroup: (0, $bb6eac6463daf31f$export$216e4f6aa7c169b8)(data),
        commentCount: (0, $imb12.extractSmartLinkCommentCount)(response),
        viewCount: (0, $imb12.extractViewCount)(data),
        reactCount: (0, $imb12.extractSmartLinkReactCount)(response),
        voteCount: (0, $imb12.extractVoteCount)(data),
        checklistProgress: (0, $imb12.extractChecklistProgress)(data),
        createdBy: (0, $79vw2.extractSmartLinkCreatedBy)(response),
        ownedBy: (0, $imb12.extractOwnedBy)(data),
        assignedTo: (0, $imb12.extractAssignedTo)(data),
        createdOn: (0, $79vw2.extractSmartLinkCreatedOn)(response),
        dueOn: (0, $imb12.extractDueOn)(data),
        latestCommit: (0, $6850aa7564532ebc$export$f222392162cff0d8)(data),
        linkIcon: (0, $575f6.extractSmartLinkIcon)(response),
        linkTitle: (0, $d9f3dbb8591ea96a$export$2e2bcd8739ae039)(status, props.url, response, onClick),
        location: (0, $imb12.extractLocation)(data),
        modifiedBy: (0, $79vw2.extractSmartLinkModifiedBy)(response),
        modifiedOn: (0, $79vw2.extractSmartLinkModifiedOn)(response),
        preview: (0, $5ctc0.extractSmartLinkPreviewImage)(response),
        priority: (0, $74fe51f061491681$export$2e2bcd8739ae039)(data),
        provider: (0, $kX2ZH.extractSmartLinkProviderIcon)(response),
        programmingLanguage: (0, $imb12.extractProgrammingLanguage)(data),
        readTime: (0, $imb12.extractReadTime)(data),
        sentOn: (0, $imb12.extractSmartLinkSentOn)(response),
        snippet: (0, $89d55dabaa02345a$export$8c6b9b49f358840)(response) || undefined,
        sourceBranch: (0, $imb12.extractSourceBranch)(data),
        state: (0, $a4bf3e45dcc07f8b$export$2e2bcd8739ae039)(response, actionOptions, id, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel),
        subscriberCount: (0, $imb12.extractSubscriberCount)(data),
        subTasksProgress: (0, $imb12.extractSubTasksProgress)(data),
        storyPoints: (0, $imb12.extractStoryPoints)(data),
        targetBranch: (0, $imb12.extractTargetBranch)(data),
        userAttributes: (0, $imb12.extractUserAttributes)(data),
        teamMemberCount: (0, $imb12.extractTeamMemberCount)(data),
        url: url,
        ari: (0, $79vw2.extractSmartLinkAri)(response),
        type: (0, $aliCf.extractType)(data),
        meta: {
            objectId: (0, $imb12.extractMetaObjectId)(meta),
            resourceType: (0, $imb12.extractMetaResourceType)(meta),
            tenantId: (0, $imb12.extractMetaTenantId)(meta)
        },
        ...(0, $hX032.isNewBlockcardUnauthorizedRefreshExperimentEnabled)() && {
            hostName: (0, $imb12.extractHostName)(response)
        }
    };
};
var $cc6e2a82dcbb4550$export$2e2bcd8739ae039 = $cc6e2a82dcbb4550$var$extractFlexibleUiContext;
















var $afp1H = parcelRequire("afp1H");


var $ivUmx = parcelRequire("ivUmx");





var $4ibS1 = parcelRequire("4ibS1");

const $bce69080918b9451$export$e68aec76e359e401 = (params)=>{
    const { onClick: onClick, response: response, status: status, url: url } = params ?? {};
    switch(status){
        case (0, $5TXU5.SmartLinkStatus).Pending:
        case (0, $5TXU5.SmartLinkStatus).Resolving:
            return {
                linkTitle: (0, $d9f3dbb8591ea96a$export$2e2bcd8739ae039)(status, url, response, onClick),
                url: url
            };
        case (0, $5TXU5.SmartLinkStatus).Resolved:
            return (0, $cc6e2a82dcbb4550$export$2e2bcd8739ae039)(params);
        case (0, $5TXU5.SmartLinkStatus).Unauthorized:
        case (0, $5TXU5.SmartLinkStatus).Forbidden:
        case (0, $5TXU5.SmartLinkStatus).NotFound:
        case (0, $5TXU5.SmartLinkStatus).Errored:
        case (0, $5TXU5.SmartLinkStatus).Fallback:
        default:
            return {
                url: url,
                linkIcon: (0, $575f6.extractErrorIcon)(response, status),
                linkTitle: (0, $d9f3dbb8591ea96a$export$2e2bcd8739ae039)(status, url, response, onClick),
                preview: (0, $5ctc0.extractSmartLinkPreviewImage)(response),
                provider: (0, $kX2ZH.extractSmartLinkProviderIcon)(response),
                actions: {
                    [(0, $5TXU5.InternalActionName).UnresolvedAction]: $bce69080918b9451$export$f3d3482baaff4bf6(url, status, response, params.onAuthorize)
                },
                meta: {
                    accessType: response?.meta?.requestAccess?.accessType
                },
                ...(0, $hX032.isNewBlockcardUnauthorizedRefreshExperimentEnabled)() && {
                    hostName: (0, $imb12.extractHostName)(response)
                }
            };
    }
};
const $bce69080918b9451$var$getForbiddenMessageKey = (meta)=>{
    const accessType = meta?.requestAccess?.accessType;
    switch(accessType){
        case 'DIRECT_ACCESS':
            return (0, $dh538.fg)('confluence-issue-terminology-refresh') ? 'join_to_viewIssueTermRefresh' : 'join_to_view';
        case 'REQUEST_ACCESS':
            return (0, $dh538.fg)('confluence-issue-terminology-refresh') ? 'request_access_to_viewIssueTermRefresh' : 'request_access_to_view';
        case 'PENDING_REQUEST_EXISTS':
            return 'pending_request';
        case 'FORBIDDEN':
            return 'forbidden_access';
        case 'DENIED_REQUEST_EXISTS':
            return 'request_denied';
        default:
            return 'restricted_link';
    }
};
const $bce69080918b9451$export$f3d3482baaff4bf6 = (url, status, response, onAuthorize)=>{
    const provider = (0, $79vw2.extractSmartLinkProvider)(response);
    const context = provider?.text;
    const values = context ? {
        context: context
    } : undefined;
    switch(status){
        case (0, $5TXU5.SmartLinkStatus).Forbidden:
            const meta = response?.meta ?? (0, $4ibS1.getForbiddenJsonLd)().meta;
            const access = (0, $7kN5H.extractRequestAccessContextImproved)({
                jsonLd: meta,
                url: url,
                product: context ?? ''
            });
            const messageKey = $bce69080918b9451$var$getForbiddenMessageKey(meta);
            const descriptor = (0, $afp1H.messages)[messageKey];
            const retry = onAuthorize || access?.action?.promise;
            const onClick = retry && !(access?.buttonDisabled ?? false) ? (0, $ivUmx.handleOnClick)(retry) : undefined;
            return {
                descriptor: descriptor,
                onClick: onClick,
                values: values
            };
        case (0, $5TXU5.SmartLinkStatus).Unauthorized:
            return onAuthorize ? {
                descriptor: (0, $afp1H.messages).connect_link_account_card_name,
                onClick: (0, $ivUmx.handleOnClick)(onAuthorize),
                values: values
            } : undefined;
        case (0, $5TXU5.SmartLinkStatus).NotFound:
            return {
                descriptor: (0, $afp1H.messages).cannot_find_link
            };
    }
};


const $b18298ec40df52db$var$PENDING_LINK_STATUSES = [
    (0, $5TXU5.SmartLinkStatus).Pending,
    (0, $5TXU5.SmartLinkStatus).Resolving
];
/**
 * This represents a Flexible Card: a link represented by a card with metadata.
 * This is the container in which all Flexible UI Blocks and Elements exist.
 * Note: TitleBlock is mandatory for a Flexible Card to render.
 * @see Container
 */ const $b18298ec40df52db$var$FlexibleCard = ({ appearance: appearance = 'flexible', cardState: cardState, children: children, id: id, onAuthorize: onAuthorize, onClick: onClick, onError: onError, onResolve: onResolve, origin: origin, placeholderData: placeholderData, renderers: renderers, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, testId: testId, ui: ui, url: url })=>{
    const aiSummaryConfig = (0, $i8IAc.useAISummaryConfig)();
    const resolve = (0, $7DSoa.default)();
    const { isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $eIleF.useSmartLinkContext)();
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const { status: cardType, details: details } = cardState;
    const status = cardType;
    // if we have placeholder state it means we can internally use it
    // as temporary resolved data until the actual data comes back as one of the final statuses
    const placeholderCardState = (0, $42omo.useMemo)(()=>$b18298ec40df52db$var$PENDING_LINK_STATUSES.includes(status) && placeholderData && (0, $6e579b1e6cb4cfe2$export$684541b2632ffbbc)(placeholderData), [
        placeholderData,
        status
    ]);
    const placeHolderStatus = placeholderCardState ? placeholderCardState.status : undefined;
    const context = (0, $42omo.useMemo)(()=>(0, $bce69080918b9451$export$e68aec76e359e401)({
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            response: placeholderCardState ? placeholderCardState.details : details,
            id: id,
            onAuthorize: onAuthorize,
            onClick: onClick,
            origin: origin,
            renderers: renderers,
            resolve: resolve,
            actionOptions: actionOptions,
            status: placeholderCardState ? placeHolderStatus : status,
            url: url,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }), [
        aiSummaryConfig,
        appearance,
        actionOptions,
        details,
        id,
        isPreviewPanelAvailable,
        onAuthorize,
        onClick,
        openPreviewPanel,
        origin,
        placeholderCardState,
        placeHolderStatus,
        renderers,
        resolve,
        status,
        url,
        fireEvent
    ]);
    const flexibleCardContext = (0, $42omo.useMemo)(()=>({
            data: context,
            status: placeHolderStatus ?? status,
            ui: ui
        }), [
        context,
        placeHolderStatus,
        status,
        ui
    ]);
    const { linkTitle: linkTitle } = context || {};
    const title = linkTitle?.text;
    (0, $42omo.useEffect)(()=>{
        switch(status){
            case (0, $5TXU5.SmartLinkStatus).Resolved:
                if (onResolve) onResolve({
                    title: title,
                    url: url,
                    ...(0, $dh538.fg)('expose-product-details-from-smart-card') && {
                        extensionKey: details?.meta?.key
                    }
                });
                break;
            case (0, $5TXU5.SmartLinkStatus).Errored:
            case (0, $5TXU5.SmartLinkStatus).Fallback:
            case (0, $5TXU5.SmartLinkStatus).Forbidden:
            case (0, $5TXU5.SmartLinkStatus).NotFound:
            case (0, $5TXU5.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        title,
        url,
        details?.meta?.key
    ]);
    const retry = flexibleCardContext.data?.actions?.[(0, $5TXU5.InternalActionName).UnresolvedAction];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fUfR2.FlexibleCardContext).Provider, {
        value: flexibleCardContext
    }, $b18298ec40df52db$var$PENDING_LINK_STATUSES.includes(status) && !Boolean(placeholderCardState) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
        name: "smart-card-flexible-card"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a624e70f21d764cf$export$2e2bcd8739ae039), {
        testId: testId,
        ...ui,
        onClick: onClick,
        showHoverPreview: showHoverPreview,
        hoverPreviewOptions: hoverPreviewOptions,
        actionOptions: actionOptions,
        status: status,
        retry: retry
    }, children));
};
var $b18298ec40df52db$export$2e2bcd8739ae039 = $b18298ec40df52db$var$FlexibleCard;
module.exports["default"] = $b18298ec40df52db$export$2e2bcd8739ae039;

});

parcelRegister("90Y9A", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $fBMbo = parcelRequire("fBMbo");


var $1DWH0 = parcelRequire("1DWH0");


var $kKODE = parcelRequire("kKODE");


var $5TXU5 = parcelRequire("5TXU5");


var $bIll3 = parcelRequire("bIll3");


var $3eMTN = parcelRequire("3eMTN");


var $5MkWK = parcelRequire("5MkWK");





var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $iu6m9 = parcelRequire("iu6m9");





var $a43ao = parcelRequire("a43ao");


var $4QzTV = parcelRequire("4QzTV");


var $lz9QA = parcelRequire("lz9QA");







/**
 * The purpose of this component is to hide the default Popup border.
 * HoverCard border implementation is in ContentContainer where it can
 * change between the default border and prism border during runtime.
 */ const $52ec9dab657c3c9f$var$CustomPopupContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ children: children, shouldFitContainer: _, shouldRenderToParent: __, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ...props,
        ref: ref
    }, children));
const $52ec9dab657c3c9f$export$c98f335200f1c8df = (zIndex)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ children: children, shouldFitContainer: _, shouldRenderToParent: __, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ...props,
            ref: ref,
            ...zIndex !== undefined && {
                style: {
                    ...props.style,
                    zIndex: zIndex
                }
            }
        }, children));
};
var $52ec9dab657c3c9f$export$2e2bcd8739ae039 = $52ec9dab657c3c9f$var$CustomPopupContainer;






var $inPa6 = parcelRequire("inPa6");


var $eIleF = parcelRequire("eIleF");











var $226XV = parcelRequire("226XV");





var $ivUmx = parcelRequire("ivUmx");


var $kbh18 = parcelRequire("kbh18");


var $6wQZE = parcelRequire("6wQZE");


var $dTk3A = parcelRequire("dTk3A");




const $695b1b58e53b929b$export$8245b0eaabf3440c = (0, $dTk3A.layers).modal();
const $695b1b58e53b929b$export$8e022b7269e8199a = {
    hideBackground: true,
    hideElevation: true,
    hideLegacyButton: true,
    removeBlockRestriction: true,
    size: (0, $5TXU5.SmartLinkSize).Medium,
    zIndex: $695b1b58e53b929b$export$8245b0eaabf3440c + 1
};
const $695b1b58e53b929b$export$a0a37c997fbcd678 = 24;
const $695b1b58e53b929b$export$e7cae8c75d768024 = 10; // gap between mouse cursor and hover card



var $aliCf = parcelRequire("aliCf");





var $imb12 = parcelRequire("imb12");

const $11f68d60f03aaf1c$var$getSimulatedBetterMetadata = (extensionKey, data)=>{
    const types = data ? (0, $aliCf.extractType)(data) : undefined;
    const defaultMetadata = {
        primary: [
            (0, $5TXU5.ElementName).AuthorGroup,
            (0, $5TXU5.ElementName).ModifiedOn
        ]
    };
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            if (types?.includes('atlassian:SourceCodePullRequest')) return {
                primary: [
                    (0, $5TXU5.ElementName).AuthorGroup,
                    (0, $5TXU5.ElementName).ModifiedOn,
                    (0, $5TXU5.ElementName).SubscriberCount,
                    (0, $5TXU5.ElementName).State
                ],
                subtitle: [
                    (0, $5TXU5.ElementName).SourceBranch,
                    (0, $5TXU5.ElementName).TargetBranch
                ]
            };
            if (types?.includes('schema:DigitalDocument')) return {
                primary: [
                    (0, $5TXU5.ElementName).LatestCommit,
                    (0, $5TXU5.ElementName).CollaboratorGroup,
                    (0, $5TXU5.ElementName).ModifiedOn
                ]
            };
            return {
                primary: [
                    (0, $5TXU5.ElementName).AuthorGroup,
                    (0, $5TXU5.ElementName).ModifiedOn
                ]
            };
        case 'confluence-object-provider':
            const primaryAttribution = data && (0, $imb12.extractOwnedBy)(data) ? (0, $5TXU5.ElementName).OwnedByGroup : (0, $5TXU5.ElementName).AuthorGroup;
            return {
                primary: [
                    primaryAttribution,
                    (0, $5TXU5.ElementName).ModifiedOn
                ],
                tertiary: [
                    (0, $5TXU5.ElementName).ReactCount,
                    (0, $5TXU5.ElementName).CommentCount,
                    (0, $5TXU5.ElementName).ViewCount
                ]
            };
        case 'jira-object-provider':
            const isJiraTask = data?.['@type']?.includes('atlassian:Task') ?? false;
            return {
                ...defaultMetadata,
                ...isJiraTask && {
                    primary: [
                        (0, $5TXU5.ElementName).AssignedToGroup,
                        (0, $5TXU5.ElementName).State,
                        (0, $5TXU5.ElementName).StoryPoints,
                        (0, $5TXU5.ElementName).Priority
                    ]
                }
            };
        case 'trello-object-provider':
            return {
                primary: [
                    (0, $5TXU5.ElementName).CollaboratorGroup,
                    (0, $5TXU5.ElementName).State,
                    (0, $5TXU5.ElementName).DueOn
                ],
                secondary: [
                    (0, $5TXU5.ElementName).ReactCount,
                    (0, $5TXU5.ElementName).CommentCount,
                    (0, $5TXU5.ElementName).AttachmentCount,
                    (0, $5TXU5.ElementName).ChecklistProgress
                ],
                subtitle: [
                    (0, $5TXU5.ElementName).Location
                ]
            };
        case 'watermelon-object-provider':
            if (types?.includes('atlassian:Project')) return {
                primary: [
                    (0, $5TXU5.ElementName).AuthorGroup,
                    (0, $5TXU5.ElementName).ModifiedOn,
                    (0, $5TXU5.ElementName).State,
                    (0, $5TXU5.ElementName).DueOn
                ]
            };
            return {
                primary: [
                    (0, $5TXU5.ElementName).AuthorGroup,
                    (0, $5TXU5.ElementName).State,
                    (0, $5TXU5.ElementName).DueOn
                ]
            };
        case 'slack-object-provider':
            return {
                primary: [
                    (0, $5TXU5.ElementName).AuthorGroup,
                    (0, $5TXU5.ElementName).SentOn
                ],
                tertiary: [
                    (0, $5TXU5.ElementName).ReactCount,
                    (0, $5TXU5.ElementName).CommentCount
                ]
            };
        case 'google-object-provider':
        case 'figma-object-provider':
            return {
                primary: [
                    (0, $5TXU5.ElementName).AuthorGroup,
                    (0, $5TXU5.ElementName).ModifiedOn
                ]
            };
        default:
            return defaultMetadata;
    }
};
const $11f68d60f03aaf1c$var$AvatarGroupsWithNamePrefix = [
    (0, $5TXU5.ElementName).AssignedToGroup,
    (0, $5TXU5.ElementName).OwnedByGroup,
    (0, $5TXU5.ElementName).AuthorGroup
];
const $11f68d60f03aaf1c$var$toElementItem = (name)=>{
    const showNamePrefix = $11f68d60f03aaf1c$var$AvatarGroupsWithNamePrefix.indexOf(name) !== -1 ? true : undefined;
    const testId = `${name.toLowerCase()}-metadata-element`;
    return {
        name: name,
        showNamePrefix: showNamePrefix,
        testId: testId
    };
};
const $11f68d60f03aaf1c$var$toElementItems = (elementNames)=>{
    if (!elementNames?.length) return;
    return elementNames.filter((name)=>name in (0, $5TXU5.ElementName)).map($11f68d60f03aaf1c$var$toElementItem);
};
const $11f68d60f03aaf1c$export$8548546c0aa631e6 = (extensionKey, data)=>{
    const metadata = $11f68d60f03aaf1c$var$getSimulatedBetterMetadata(extensionKey, data);
    const primary = [].concat(metadata.primary, metadata.tertiary);
    return {
        subtitle: $11f68d60f03aaf1c$var$toElementItems(metadata.subtitle),
        primary: $11f68d60f03aaf1c$var$toElementItems(primary),
        secondary: $11f68d60f03aaf1c$var$toElementItems(metadata.secondary)
    };
};


/* ContentContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");





var $6KV13 = parcelRequire("6KV13");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $cOrQJ = parcelRequire("cOrQJ");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 





/* animated-svg-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 





let $79bc72179a51708e$var$namespaceUUID = 0;
const $79bc72179a51708e$var$svgStyles = null;
const $79bc72179a51708e$var$blurredStyles = null;
const $79bc72179a51708e$var$notBlurredStyles = null; /**
                                * The bulk of this file is originally from
                                * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
                                * with modifications.
                                */ 
const $79bc72179a51708e$var$AnimatedSvgContainer = ({ palette: palette, isMoving: isMoving, isGlowing: isGlowing, className: className })=>{
    const svgRef = (0, $42omo.useRef)(null);
    const namespaceId = (0, $42omo.useRef)();
    if (namespaceId.current === undefined) {
        namespaceId.current = $79bc72179a51708e$var$namespaceUUID;
        $79bc72179a51708e$var$namespaceUUID += 1;
    }
    (0, $42omo.useEffect)(()=>{
        if (isMoving) {
            const svg = svgRef.current; // Schedule animation to begin before next browser paint
            const beginReq = requestAnimationFrame(()=>{
                svg?.querySelectorAll('animate').forEach((node)=>node.beginElement());
            });
            return ()=>{
                // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
                // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
                cancelAnimationFrame(beginReq);
                requestAnimationFrame(()=>{
                    svg?.querySelectorAll('animate').forEach((node)=>node.endElement());
                });
            };
        }
        return undefined;
    }, [
        isMoving
    ]);
    return /*#__PURE__*/ $42omo.createElement("svg" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            "_2rko19bv _kqswstnw",
            isGlowing ? "_1bsb1wgc _4t3i1wgc _154i1b66 _1ltv1b66 _kdam1rfl _w6ng15vq _t9ec161g" : "_1ltvidpf _154iidpf _1bsb1osq _4t3i1osq",
            className
        ]),
        ref: svgRef,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "none"
    }, /*#__PURE__*/ $42omo.createElement("defs", null, /*#__PURE__*/ $42omo.createElement("linearGradient", {
        id: `${namespaceId.current}_lg1`,
        gradientUnits: "userSpaceOnUse",
        x1: "0%",
        y1: "0",
        x2: "400%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ $42omo.createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "0%",
        to: "400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $42omo.createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "400%",
        to: "800%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "1",
        stopColor: palette.blue
    })), /*#__PURE__*/ $42omo.createElement("linearGradient", {
        id: `${namespaceId.current}_lg2`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "-100%",
        x2: "0",
        y2: "300%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ $42omo.createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "-100%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $42omo.createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "300%",
        to: "700%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "1",
        stopColor: palette.blue
    })), /*#__PURE__*/ $42omo.createElement("linearGradient", {
        id: `${namespaceId.current}_lg3`,
        gradientUnits: "userSpaceOnUse",
        x1: "300%",
        y1: "0",
        x2: "700%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ $42omo.createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "300%",
        to: "-100%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $42omo.createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "700%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "1",
        stopColor: palette.blue
    })), /*#__PURE__*/ $42omo.createElement("linearGradient", {
        id: `${namespaceId.current}_lg4`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "0",
        x2: "0",
        y2: "400%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ $42omo.createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "0%",
        to: "-400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $42omo.createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "400%",
        to: "0%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "1",
        stopColor: palette.blue
    }))), /*#__PURE__*/ $42omo.createElement("g", {
        strokeWidth: "8"
    }, /*#__PURE__*/ $42omo.createElement("path", {
        stroke: `url(#${namespaceId.current}_lg1)`,
        d: "M0 0h24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        stroke: `url(#${namespaceId.current}_lg2)`,
        d: "M24 0v24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        stroke: `url(#${namespaceId.current}_lg3)`,
        d: "M24 24H0",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        stroke: `url(#${namespaceId.current}_lg4)`,
        d: "M0 24V0",
        vectorEffect: "non-scaling-stroke"
    })));
};
var $79bc72179a51708e$export$2e2bcd8739ae039 = $79bc72179a51708e$var$AnimatedSvgContainer;


const $0807ece58a794f3e$var$borderContainerStyles = null;
const $0807ece58a794f3e$var$borderContentStyles = null; /**
                                   * The bulk of this file is originally from
                                   * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
                                   * with modifications.
                                   */ 
const $0807ece58a794f3e$var$AIGlowingBorder = ({ children: children, palette: palette, isMoving: isMoving = true, isGlowing: isGlowing, testId: testId, className: className })=>/*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _kqswh2mm _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _1bsb1ns9"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $79bc72179a51708e$export$2e2bcd8739ae039), {
        palette: palette,
        isMoving: isMoving,
        className: className
    }), isGlowing && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ $42omo.createElement((0, $79bc72179a51708e$export$2e2bcd8739ae039), {
        palette: palette,
        isMoving: isMoving,
        isGlowing: true,
        className: className
    }), /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_2rko1mok _16jlkb7n _1pbykb7n"
        ])
    }, children, " "));
var $0807ece58a794f3e$export$2e2bcd8739ae039 = $0807ece58a794f3e$var$AIGlowingBorder;


const $24cc1de367735950$export$3088ed82e2905d1e = {
    blueUniqueGradientLight: '#00ACF8',
    blueUniqueGradientDark: '#008BD2',
    blue1000: '#092957',
    blue800: '#0055CC',
    blue700: '#0C66E4',
    blue600: '#1D7AFC',
    blue500: '#388BFF',
    blue300: '#85B8FF',
    blue200: '#CCE0FF',
    blue100: '#E9F2FF',
    teal500: '#37B4C3',
    teal300: '#8BDBE5',
    yellow500: '#CF9F02',
    yellow200: '#F8E6A0',
    red800: '#AE2A19',
    red600: '#E34935',
    orange500: '#F18D13',
    orange300: '#FEC57B'
};
const $24cc1de367735950$export$23b7b83c7063ccfe = {
    dark: {
        blue: $24cc1de367735950$export$3088ed82e2905d1e.blue800,
        teal: $24cc1de367735950$export$3088ed82e2905d1e.teal500,
        yellow: $24cc1de367735950$export$3088ed82e2905d1e.yellow500
    },
    light: {
        blue: $24cc1de367735950$export$3088ed82e2905d1e.blue600,
        teal: $24cc1de367735950$export$3088ed82e2905d1e.teal300,
        yellow: $24cc1de367735950$export$3088ed82e2905d1e.yellow200
    }
};


const $211707d69efe87d9$var$contentStyles = null;
const $211707d69efe87d9$var$contentStylesPrismVisible = null;
const $211707d69efe87d9$var$animatedSvgContainerStyles = {
    true: "_v564fs5d _tzy4kb7n",
    false: "_v564fs5d _tzy4idpf"
};
const $211707d69efe87d9$var$popupContainerStyles = null;
const $211707d69efe87d9$var$AIPrism = ({ children: children, isGlowing: isGlowing = true, isMoving: isMoving = true, isVisible: isVisible, testId: testId })=>{
    const { colorMode: colorMode = 'light' } = (0, $cOrQJ.default)();
    return /*#__PURE__*/ $42omo.createElement((0, $0807ece58a794f3e$export$2e2bcd8739ae039), {
        palette: (0, $24cc1de367735950$export$23b7b83c7063ccfe)[colorMode] ?? (0, $24cc1de367735950$export$23b7b83c7063ccfe).light,
        isGlowing: isGlowing,
        isMoving: isMoving,
        testId: testId,
        className: (0, $gMc0m.default)([
            $211707d69efe87d9$var$animatedSvgContainerStyles[isVisible ? 'true' : 'false']
        ])
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_2rko1mok _bfhk1bhr _16qs130s",
            "_v5649spz",
            isVisible && "_16qs1aef"
        ])
    }, children));
};
var $211707d69efe87d9$export$2e2bcd8739ae039 = $211707d69efe87d9$var$AIPrism;



const $b39273305bd9d567$var$NEW_CARD_WIDTH_REM = 25;
const $b39273305bd9d567$var$HoverCardContainerStyle = null;
const $b39273305bd9d567$var$popupContainerStyles = null;
const $b39273305bd9d567$var$ConnectedAIPrismContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>{
    (0, $fBMbo.di)((0, $6KV13.default), (0, $211707d69efe87d9$export$2e2bcd8739ae039));
    const { state: { status: status } } = (0, $6KV13.default)(url);
    const [showPrism, setShowPrism] = (0, $42omo.useState)(status === 'loading');
    (0, $42omo.useEffect)(()=>{
        setShowPrism(status === 'loading');
    }, [
        status
    ]);
    const container = /*#__PURE__*/ $42omo.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            "_11q7glyw _189eidpf _vchhusvi _1bsb1f23 _9spsglyw",
            !isAIEnabled && "_2rko1mok _bfhk1bhr _16qs130s",
            (0, $44ed84e93427a03a$export$34883cbaea18402d)
        ]),
        "data-testid": testId,
        ...props
    }, children);
    return isAIEnabled ? /*#__PURE__*/ $42omo.createElement((0, $211707d69efe87d9$export$2e2bcd8739ae039), {
        isVisible: showPrism,
        testId: `${testId}-prism`
    }, container) : container;
};
const $b39273305bd9d567$var$ContentContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>/*#__PURE__*/ $42omo.createElement($b39273305bd9d567$var$ConnectedAIPrismContainer, {
        isAIEnabled: isAIEnabled,
        url: url,
        testId: testId,
        ...props
    }, children);
var $b39273305bd9d567$export$2e2bcd8739ae039 = $b39273305bd9d567$var$ContentContainer;


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gtD4K = parcelRequire("gtD4K");





var $ccHMk = parcelRequire("ccHMk");


var $79vw2 = parcelRequire("79vw2");


var $7kN5H = parcelRequire("7kN5H");


var $hiPTU = parcelRequire("hiPTU");


var $afp1H = parcelRequire("afp1H");


var $8k046 = parcelRequire("8k046");


var $2R1C4 = parcelRequire("2R1C4");

var $Y5kOr = parcelRequire("Y5kOr");

const $7cef7844f9674345$var$titleBlockStyles = null;
const $7cef7844f9674345$var$mainTextStyles = null;
const $7cef7844f9674345$var$connectButtonStyles = null;
const $7cef7844f9674345$var$basePreviewStyles = null;
const $7cef7844f9674345$var$HoverCardForbiddenView = ({ flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-forbidden-view' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cardState: cardState, url: url } = flexibleCardProps;
    const meta = cardState.details?.meta;
    const product = (0, $79vw2.extractSmartLinkProvider)(cardState.details)?.text ?? '';
    const hostname = /*#__PURE__*/ $42omo.createElement("b", null, (0, $hiPTU.default)(url));
    const { action: action, descriptiveMessageKey: descriptiveMessageKey, titleMessageKey: titleMessageKey, buttonDisabled: buttonDisabled } = (0, $7kN5H.extractRequestAccessContextImproved)({
        jsonLd: meta,
        url: url,
        product: product,
        createAnalyticsEvent: createAnalyticsEvent
    }) ?? {};
    if (!titleMessageKey || !descriptiveMessageKey) return null;
    return /*#__PURE__*/ $42omo.createElement((0, $8k046.default), {
        ...flexibleCardProps,
        testId: testId
    }, /*#__PURE__*/ $42omo.createElement((0, $Y5kOr.default), {
        ignoreContainerPadding: true,
        testId: testId,
        className: (0, $gMc0m.default)([
            "_13li1mok _qrwq1mok _otyru2gc"
        ])
    }), /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        testId: `${testId}-title`,
        className: (0, $gMc0m.default)([
            "_1bah1h6o _k48p1pd9 _19pku2gc"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), {
        ...(0, $afp1H.messages)[titleMessageKey],
        values: {
            product: product
        }
    })), /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        testId: `${testId}-content`,
        className: (0, $gMc0m.default)([
            "_11c8rymc _1e0c1nu9 _1bah1h6o _19pkze3t _y3gn1h6o"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), {
        ...(0, $afp1H.messages)[descriptiveMessageKey],
        values: {
            product: product,
            hostname: hostname
        }
    })), action && /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        className: (0, $gMc0m.default)([
            "_1bah1h6o _19pku2gc"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
        testId: `${testId}-button`,
        onClick: action?.promise,
        appearance: "primary",
        isDisabled: buttonDisabled
    }, action?.text)));
};
var $7cef7844f9674345$export$2e2bcd8739ae039 = $7cef7844f9674345$var$HoverCardForbiddenView;


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


























const $cc85c7b3ba72e34b$var$useRovoConfig = ()=>{
    const { rovoOptions: rovoOptions } = (0, $eIleF.useSmartLinkContext)();
    return (0, $42omo.useMemo)(()=>rovoOptions, [
        rovoOptions
    ]);
};
var $cc85c7b3ba72e34b$export$2e2bcd8739ae039 = $cc85c7b3ba72e34b$var$useRovoConfig;






var $f0wtW = parcelRequire("f0wtW");

var $MlN47 = parcelRequire("MlN47");

var $eqpYq = parcelRequire("eqpYq");

var $1lLfV = parcelRequire("1lLfV");

var $8zS2j = parcelRequire("8zS2j");

var $5znEc = parcelRequire("5znEc");









var $5ctc0 = parcelRequire("5ctc0");




const $57f598b4bbab12f1$var$ImagePreview = ({ fallbackElementHeight: fallbackElementHeight, response: response })=>{
    const transitionStarted = (0, $42omo.useRef)(false);
    const previewBlockRef = (0, $42omo.useRef)(null);
    const [showPreview, setShowPreview] = (0, $42omo.useState)(true);
    const [dynamicStyles, setDynamicStyles] = (0, $42omo.useState)({});
    // Set Preview to a fixed height to enable transitions
    const onPreviewRender = (0, $42omo.useCallback)(()=>{
        if (previewBlockRef.current) {
            const previewHeight = previewBlockRef.current?.getBoundingClientRect().height;
            setDynamicStyles({
                borderTopLeftRadius: "var(--ds-radius-large, 8px)",
                borderTopRightRadius: "var(--ds-radius-large, 8px)",
                ...previewHeight ? {
                    height: `${previewHeight}px`
                } : {}
            });
        }
    }, []);
    // On error set Preview to Fallback height with transition
    const onPreviewError = (0, $42omo.useCallback)(()=>{
        if (transitionStarted.current === false) {
            setDynamicStyles({
                transition: 'height 300ms ease-in-out',
                height: `${fallbackElementHeight}px`
            });
            transitionStarted.current = true;
        }
    }, [
        fallbackElementHeight
    ]);
    const onPreviewTransitionEnd = (0, $42omo.useCallback)(()=>{
        setShowPreview(false);
    }, []);
    return showPreview && (0, $5ctc0.extractSmartLinkPreviewImage)(response) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $Y5kOr.default), {
        onError: onPreviewError,
        ignoreContainerPadding: true,
        onTransitionEnd: onPreviewTransitionEnd,
        blockRef: previewBlockRef,
        onRender: onPreviewRender,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles
    }) : null;
};
var $57f598b4bbab12f1$export$2e2bcd8739ae039 = $57f598b4bbab12f1$var$ImagePreview;


const $800f2bff5149f1e1$var$hiddenSnippetStyles = null;
const $800f2bff5149f1e1$var$titleBlockStyles = null;
const $800f2bff5149f1e1$var$snippetBlockCss = null;
const $800f2bff5149f1e1$var$actionBlockCss = null;
const $800f2bff5149f1e1$var$HoverCardResolvedView = ({ cardState: cardState, extensionKey: extensionKey, flexibleCardProps: flexibleCardProps, isAISummaryEnabled: isAISummaryEnabled, onActionClick: onActionClick, titleBlockProps: titleBlockProps, id: id, url: url })=>{
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const rovoConfig = (0, $cc85c7b3ba72e34b$export$2e2bcd8739ae039)();
    (0, $42omo.useEffect)(()=>{
        // Since this hover view is only rendered on resolved status,
        // there is no need to check for statuses.
        (0, $bIll3.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
            extensionKey: extensionKey,
            display: (0, $5TXU5.CardDisplay).HoverCardPreview
        }); // UFO will disregard this if authentication experience has not yet been started
        (0, $bIll3.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
            display: (0, $5TXU5.CardDisplay).HoverCardPreview
        });
        fireEvent('ui.smartLink.renderSuccess', {
            display: (0, $5TXU5.CardDisplay).HoverCardPreview
        });
    }, [
        extensionKey,
        fireEvent,
        id
    ]);
    const data = cardState.details?.data;
    const { primary: primary, secondary: secondary } = (0, $42omo.useMemo)(()=>{
        return (0, $11f68d60f03aaf1c$export$8548546c0aa631e6)(extensionKey, data);
    }, [
        data,
        extensionKey
    ]);
    const snippetHeight = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(0);
    const snippetBlockRef = (0, $42omo.useRef)(null);
    const onSnippetRender = (0, $42omo.useCallback)(()=>{
        snippetHeight.current = snippetBlockRef.current?.getBoundingClientRect().height ?? 0;
    }, []);
    const imagePreview = (0, $57f598b4bbab12f1$export$2e2bcd8739ae039)({
        fallbackElementHeight: snippetHeight.current,
        response: cardState.details
    });
    const snippet = imagePreview ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8zS2j.default), {
        className: (0, $gMc0m.default)([
            "_ca0q1b66"
        ])
    });
    const aiSummaryMinHeight = snippet ? snippetHeight.current : 0;
    const isRovoSummaryEnabled = rovoConfig?.isRovoEnabled && extensionKey === 'google-object-provider' && (0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch');
    const aiSummaryProps = (0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $6KV13.default)(url) : undefined;
    const hasSummarised = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if ((0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch')) {
            if (aiSummaryProps?.state.status !== 'ready' || hasSummarised.current) return;
            hasSummarised.current = true;
            aiSummaryProps?.summariseUrl();
        }
    }, [
        aiSummaryProps,
        isRovoSummaryEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8k046.default), flexibleCardProps, imagePreview, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5znEc.default), {
        ...titleBlockProps,
        metadataPosition: (0, $5TXU5.SmartLinkPosition).Top,
        className: (0, $gMc0m.default)([
            "_zulpu2gc _quenze3t _oebj1txw _13mh1pd9"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lLfV.default), {
        primary: primary,
        secondary: secondary,
        maxLines: 1,
        size: (0, $5TXU5.SmartLinkSize).Medium
    }), isRovoSummaryEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eqpYq.RovoSummaryBlock), {
        aiSummaryMinHeight: aiSummaryMinHeight,
        placeholder: snippet,
        url: url
    }) : isAISummaryEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eqpYq.default), {
        aiSummaryMinHeight: aiSummaryMinHeight,
        placeholder: snippet
    }) : snippet, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8zS2j.default), {
        testId: "hidden-snippet",
        onRender: onSnippetRender,
        blockRef: snippetBlockRef,
        isHidden: true,
        className: (0, $gMc0m.default)([
            "_3um015vq _kqswstnw"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f0wtW.default), {
        onClick: onActionClick,
        spaceInline: "space.100",
        hideAISummaryAction: isRovoSummaryEnabled,
        className: (0, $gMc0m.default)([
            "_n3td1b66"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $MlN47.default), null));
};
var $800f2bff5149f1e1$export$2e2bcd8739ae039 = $800f2bff5149f1e1$var$HoverCardResolvedView;


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $7d67T = parcelRequire("7d67T");


var $hT8Jj = parcelRequire("hT8Jj");


var $4NlKF = parcelRequire("4NlKF");


const $9431eb578da6d4e9$var$loadingViewContainer = null;
const $9431eb578da6d4e9$var$skeletonContainer = null;
const $9431eb578da6d4e9$var$titleStyle = null;
const $9431eb578da6d4e9$var$titleBlockStyles = null;
const $9431eb578da6d4e9$var$HoverCardLoadingView = ({ titleBlockProps: titleBlockProps })=>{
    const testId = 'hover-card-loading-view';
    const lineHeightRem = 1.25;
    const skeletonWidth = (0, $695b1b58e53b929b$export$a0a37c997fbcd678) - 2;
    const { size: size, actions: actions } = titleBlockProps;
    const actionGroup = actions?.length && actions?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d67T.default), {
        items: actions,
        visibleButtonsNum: 2
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_zulpud5o _1e0c1txw _2lx21bp4 _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2R1C4.default), {
        ...titleBlockProps,
        testId: `${testId}-title-block`,
        className: (0, $gMc0m.default)([
            "_zulpu2gc _1bsb1osq"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4NlKF.default), {
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hT8Jj.LoadingSkeleton), null),
        size: size
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": `${testId}-title`,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug _4t3i1k92 _e2oo1osq"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hT8Jj.LoadingSkeleton), {
        height: `${lineHeightRem}rem`
    })), actionGroup), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hT8Jj.LoadingSkeleton), {
        width: `${skeletonWidth}rem`,
        height: `${lineHeightRem}rem`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hT8Jj.LoadingSkeleton), {
        width: `${skeletonWidth}rem`,
        height: `${lineHeightRem * 3}rem`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hT8Jj.LoadingSkeleton), {
        width: `${skeletonWidth}rem`,
        height: `${lineHeightRem}rem`
    }))));
};
var $9431eb578da6d4e9$export$2e2bcd8739ae039 = $9431eb578da6d4e9$var$HoverCardLoadingView;


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



























var $86rMt = parcelRequire("86rMt");











var $jI5eg = parcelRequire("jI5eg");

const $aa8b3375130275dc$var$connectButtonStyles = null;
const $aa8b3375130275dc$var$titleBlockStyles = null;
const $aa8b3375130275dc$var$mainTextStyles = null;
const $aa8b3375130275dc$var$HoverCardUnauthorisedView = ({ id: id = '', flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-unauthorised-view', url: url })=>{
    const { cardState: cardState } = flexibleCardProps;
    const providerName = (0, $79vw2.extractSmartLinkProvider)(cardState.details)?.text;
    const isProductIntegrationSupported = (0, $226XV.hasAuthScopeOverrides)(cardState.details);
    const { authorize: authorize } = (0, $a43ao.useSmartCardActions)(id, url);
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const handleAuthorize = (0, $42omo.useCallback)(()=>{
        if (authorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            authorize((0, $5TXU5.CardDisplay).HoverCardPreview);
        }
    }, [
        authorize,
        fireEvent
    ]);
    const actions = (0, $42omo.useMemo)(()=>[
            {
                name: (0, $5TXU5.ActionName).CustomAction,
                content: /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), {
                    ...(0, $afp1H.messages).connect_unauthorised_account_action,
                    values: {
                        context: providerName
                    }
                }),
                onClick: handleAuthorize
            }
        ], [
        handleAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ $42omo.createElement((0, $8k046.default), {
        ...flexibleCardProps,
        testId: testId
    }, /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        testId: `${testId}-title`,
        className: (0, $gMc0m.default)([
            "_zulpu2gc _13mh1pd9"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $jI5eg.default), null), /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), {
        ...(0, $afp1H.messages).connect_link_account_card_name,
        values: {
            context: providerName
        }
    })), /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        testId: `${testId}-content`,
        className: (0, $gMc0m.default)([
            "_11c8rymc _19pku2gc"
        ])
    }, /*#__PURE__*/ $42omo.createElement("div", null, /*#__PURE__*/ $42omo.createElement((0, $86rMt.default), {
        providerName: providerName,
        isProductIntegrationSupported: isProductIntegrationSupported
    }))), /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        testId: `${testId}-button`,
        className: (0, $gMc0m.default)([
            "_1bahesu3 _19pku2gc"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $7d67T.default), {
        items: actions,
        appearance: "primary"
    })));
};
var $aa8b3375130275dc$export$2e2bcd8739ae039 = $aa8b3375130275dc$var$HoverCardUnauthorisedView;


const $44ed84e93427a03a$export$34883cbaea18402d = 'smart-links-hover-preview';
const $44ed84e93427a03a$var$HoverCardContent = ({ id: id = '', cardState: cardState, onActionClick: onActionClick, onResolve: onResolve, renderers: renderers, url: url, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, actionOptions: actionOptions, hoverPreviewOptions: hoverPreviewOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const extensionKey = (0, $42omo.useMemo)(()=>(0, $226XV.getExtensionKey)(cardState.details), [
        cardState.details
    ]);
    const linkState = (0, $lz9QA.useSmartCardState)(url);
    const linkStatus = linkState.status ?? 'pending';
    const definitionId = (0, $42omo.useMemo)(()=>(0, $226XV.getDefinitionId)(cardState.details), [
        cardState.details
    ]);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, product: product } = (0, $eIleF.useSmartLinkContext)();
    const isAISummaryEnabled = (0, $kbh18.getIsAISummaryEnabled)(isAdminHubAIEnabled, cardState.details);
    const services = (0, $226XV.getServices)(linkState.details);
    const statusRef = (0, $42omo.useRef)(linkStatus);
    const fireEventRef = (0, $42omo.useRef)(fireEvent);
    const definitionIdRef = (0, $42omo.useRef)(definitionId);
    (0, $42omo.useEffect)(()=>{
        /**
		 * Must access object value via ref because its not stable
		 * and it can trigger useEffect to re-run below
		 */ if (statusRef.current !== linkStatus) statusRef.current = linkStatus;
        if (fireEventRef.current !== fireEvent) fireEventRef.current = fireEvent;
        if (definitionIdRef.current !== definitionId) definitionIdRef.current = definitionId;
    }, [
        linkStatus,
        fireEvent,
        definitionId
    ]);
    (0, $42omo.useEffect)(()=>{
        const previewDisplay = 'card';
        const previewInvokeMethod = 'mouse_hover';
        const cardOpenTime = Date.now();
        const fireEventCurrent = fireEventRef.current;
        fireEventCurrent('ui.hoverCard.viewed', {
            previewDisplay: previewDisplay,
            previewInvokeMethod: previewInvokeMethod,
            definitionId: definitionIdRef.current ?? null
        });
        return ()=>{
            const hoverTime = Date.now() - cardOpenTime;
            fireEventCurrent('ui.hoverCard.dismissed', {
                previewDisplay: previewDisplay,
                previewInvokeMethod: previewInvokeMethod,
                hoverTime: hoverTime,
                definitionId: definitionIdRef.current ?? null
            });
        };
    }, []);
    const onClick = (0, $42omo.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $ivUmx.isSpecialEvent)(event);
        fireEvent('ui.smartLink.clicked.titleGoToLink', {
            id: id,
            display: (0, $5TXU5.CardDisplay).HoverCardPreview,
            isModifierKeyPressed: isModifierKeyPressed,
            definitionId: definitionId ?? null
        });
        (0, $6wQZE.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        createAnalyticsEvent,
        id,
        fireEvent,
        definitionId
    ]);
    const data = cardState.details?.data;
    const { subtitle: subtitle } = (0, $11f68d60f03aaf1c$export$8548546c0aa631e6)(extensionKey, data);
    const titleMaxLines = subtitle && subtitle.length > 0 ? 1 : 2;
    // Platform apps (Home, Goals, Projects, and Teams) should by default open in the same tab when the FF is enabled.
    const isSameTabAlignmentEnabled = (0, $dh538.fg)('townsquare-same-tab-alignment-gcko-849');
    const anchorTarget = product === 'ATLAS' && isSameTabAlignmentEnabled ? '_self' : undefined;
    const titleBlockProps = {
        maxLines: titleMaxLines,
        size: (0, $5TXU5.SmartLinkSize).Large,
        position: (0, $5TXU5.SmartLinkPosition).Center,
        subtitle: subtitle,
        ...isSameTabAlignmentEnabled ? {
            anchorTarget: anchorTarget
        } : undefined
    };
    const uiOptions = (0, $695b1b58e53b929b$export$8e022b7269e8199a);
    uiOptions.enableSnippetRenderer = true;
    const flexibleCardProps = {
        appearance: (0, $5TXU5.CardDisplay).HoverCardPreview,
        cardState: cardState,
        onClick: onClick,
        onResolve: onResolve,
        origin: 'smartLinkPreviewHoverCard',
        renderers: renderers,
        actionOptions: actionOptions,
        ui: uiOptions,
        url: url,
        children: null
    };
    const onClickStopPropagation = (0, $42omo.useCallback)((e)=>e.stopPropagation(), []);
    const getCardView = (cardState)=>{
        const overrideView = hoverPreviewOptions?.render?.();
        if (overrideView) return overrideView;
        if (cardState.status === 'errored' && (0, $dh538.fg)('navx-2478-sl-fix-hover-card-unresolved-view')) return null;
        if ((0, $dh538.fg)('navx-2478-sl-fix-hover-card-unresolved-view') ? cardState.status === 'resolving' || cardState.metadataStatus === 'pending' : cardState.metadataStatus === 'pending') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9431eb578da6d4e9$export$2e2bcd8739ae039), {
            flexibleCardProps: flexibleCardProps,
            titleBlockProps: titleBlockProps
        });
        if (cardState.status === 'unauthorized' && services?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aa8b3375130275dc$export$2e2bcd8739ae039), {
            extensionKey: extensionKey,
            id: id,
            flexibleCardProps: flexibleCardProps,
            url: url
        });
        if (cardState.status === 'forbidden' || cardState.status === 'not_found') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7cef7844f9674345$export$2e2bcd8739ae039), {
            flexibleCardProps: flexibleCardProps
        });
        if (cardState.status === 'resolved') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $800f2bff5149f1e1$export$2e2bcd8739ae039), {
            cardState: cardState,
            extensionKey: extensionKey,
            flexibleCardProps: flexibleCardProps,
            isAISummaryEnabled: isAISummaryEnabled,
            onActionClick: onActionClick,
            titleBlockProps: titleBlockProps,
            url: url
        });
        return null;
    };
    const cardView = getCardView(cardState);
    return cardView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b39273305bd9d567$export$2e2bcd8739ae039), {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onClickStopPropagation,
        isAIEnabled: isAISummaryEnabled,
        url: url
    }, cardView) : null;
};
var $44ed84e93427a03a$export$2e2bcd8739ae039 = $44ed84e93427a03a$var$HoverCardContent;



const $4bda3cea16c08f4a$export$421dbc3834daf261 = 'smartLinkPreviewHoverCard';
const $4bda3cea16c08f4a$var$HOVER_CARD_TRIGGER_WRAPPER = 'hover-card-trigger-wrapper';
const $4bda3cea16c08f4a$var$FADE_IN_DELAY = 500;
const $4bda3cea16c08f4a$var$FADE_OUT_DELAY = 300;
const $4bda3cea16c08f4a$var$RESOLVE_DELAY = 100;
const $4bda3cea16c08f4a$export$e2173dafa6a751bb = ({ children: children, url: url, id: id = '', canOpen: canOpen = true, closeOnChildClick: closeOnChildClick = false, actionOptions: actionOptions, allowEventPropagation: allowEventPropagation = false, zIndex: zIndex = (0, $695b1b58e53b929b$export$8245b0eaabf3440c), noFadeDelay: noFadeDelay = false, hoverPreviewOptions: hoverPreviewOptions, role: role, shouldRenderToParent: shouldRenderToParent = false, label: label, titleId: titleId, onVisibilityChange: onVisibilityChange })=>{
    const fadeInDelay = hoverPreviewOptions?.fadeInDelay ?? $4bda3cea16c08f4a$var$FADE_IN_DELAY;
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const fadeOutTimeoutId = (0, $42omo.useRef)();
    const fadeInTimeoutId = (0, $42omo.useRef)();
    const resolveTimeOutId = (0, $42omo.useRef)();
    const mousePos = (0, $42omo.useRef)();
    const popupOffset = (0, $42omo.useRef)();
    const parentSpan = (0, $42omo.useRef)(null);
    const renderers = (0, $4QzTV.useSmartLinkRenderers)();
    const linkState = (0, $lz9QA.useSmartCardState)(url);
    const handleSetIsOpen = (0, $42omo.useCallback)((isOpen)=>{
        setIsOpen(isOpen);
        onVisibilityChange?.(isOpen);
    }, [
        onVisibilityChange
    ]);
    const { loadMetadata: loadMetadata, register: register } = (0, $a43ao.useSmartCardActions)(id, url);
    const setMousePosition = (0, $42omo.useCallback)((event)=>{
        if (isOpen && canOpen) return;
        mousePos.current = {
            x: event.clientX,
            y: event.clientY
        };
        //If these are undefined then popupOffset is undefined and we fallback to default bottom-start placement
        if ((!isOpen || !canOpen) && parentSpan.current && mousePos.current) {
            const { bottom: bottom, left: left } = parentSpan.current.getBoundingClientRect();
            popupOffset.current = [
                mousePos.current.x - left + (0, $695b1b58e53b929b$export$e7cae8c75d768024),
                mousePos.current.y - bottom + (0, $695b1b58e53b929b$export$e7cae8c75d768024)
            ];
        }
    }, [
        canOpen,
        isOpen
    ]);
    const hideCard = (0, $42omo.useCallback)(()=>{
        if (handleSetIsOpen) handleSetIsOpen(false);
        else setIsOpen(false);
    }, [
        handleSetIsOpen
    ]);
    const initHideCard = (0, $42omo.useCallback)(()=>{
        if (fadeInTimeoutId.current) {
            clearTimeout(fadeInTimeoutId.current);
            // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress fade in event
            fadeInTimeoutId.current = undefined;
        }
        if (resolveTimeOutId.current) {
            clearTimeout(resolveTimeOutId.current);
            // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress resolve event
            resolveTimeOutId.current = undefined;
        }
        if (noFadeDelay) hideCard();
        else fadeOutTimeoutId.current = setTimeout(()=>hideCard(), $4bda3cea16c08f4a$var$FADE_OUT_DELAY);
    }, [
        hideCard,
        noFadeDelay
    ]);
    // clearing out the timeouts in order to avoid memory leaks
    // in case the component unmounts before they execute
    (0, $42omo.useEffect)(()=>()=>{
            if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
            if (fadeInTimeoutId.current) {
                clearTimeout(fadeInTimeoutId.current);
                // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress fade in event
                fadeInTimeoutId.current = undefined;
            }
            if (resolveTimeOutId.current) {
                clearTimeout(resolveTimeOutId.current);
                // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress resolve event
                resolveTimeOutId.current = undefined;
            }
        }, []);
    // we want to initiate resolve a bit earlier for standalone cards
    // to minimize the loading state
    const initResolve = (0, $42omo.useCallback)(()=>{
        // this check covers both non-SSR (status) & SSR case (metadataStatus)
        const isLinkUnresolved = linkState.status === 'pending' || !linkState.metadataStatus;
        if (!resolveTimeOutId.current && isLinkUnresolved) resolveTimeOutId.current = setTimeout(()=>{
            if ((0, $dh538.fg)('navx-2478-sl-fix-hover-card-unresolved-view')) {
                if (linkState.status === 'pending') // Link hasn't been registered yet. Register and resolve link.
                register();
                else // Link has been already been partially resolved. Load metadata.
                loadMetadata();
            } else loadMetadata();
        }, $4bda3cea16c08f4a$var$RESOLVE_DELAY);
    }, [
        linkState.metadataStatus,
        linkState.status,
        loadMetadata,
        register
    ]);
    const initShowCard = (0, $42omo.useCallback)((event)=>{
        // clearing out fadeOutTimeoutId in case it's already counting down to hide the card
        if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
        // starting to resolve the hover card if the store doesn't have data about the link yet
        initResolve();
        //Set mouse position in the case it's not already set by onMouseMove, as in the case of scrolling
        setMousePosition(event);
        if (!isOpen && !fadeInTimeoutId.current) {
            // setting a timeout to show a Hover Card after delay runs out
            if (noFadeDelay) {
                if (handleSetIsOpen) handleSetIsOpen(true);
                else setIsOpen(true);
            } else fadeInTimeoutId.current = setTimeout(()=>{
                if (handleSetIsOpen) handleSetIsOpen(true);
                else setIsOpen(true);
            }, fadeInDelay);
        }
    }, [
        initResolve,
        isOpen,
        setMousePosition,
        noFadeDelay,
        fadeInDelay,
        handleSetIsOpen
    ]);
    const onActionClick = (0, $42omo.useCallback)((actionId)=>{
        if (actionId === (0, $5TXU5.ActionName).PreviewAction || actionId === (0, $5TXU5.ActionName).AutomationAction) hideCard();
    }, [
        hideCard
    ]);
    // Stop hover preview content to propagate event to parent.
    const handleChildClick = (0, $42omo.useCallback)((e, closeOnClick)=>{
        if (!allowEventPropagation) e.stopPropagation();
        if (closeOnClick) hideCard();
    }, [
        allowEventPropagation,
        hideCard
    ]);
    const onContextMenuClick = (0, $42omo.useCallback)((e)=>handleChildClick(e, true), [
        handleChildClick
    ]);
    const onChildClick = (0, $42omo.useCallback)((e)=>handleChildClick(e, closeOnChildClick), [
        closeOnChildClick,
        handleChildClick
    ]);
    const content = (0, $42omo.useCallback)(({ update: update })=>{
        const hoverCardContentProps = {
            onMouseEnter: initShowCard,
            onMouseLeave: initHideCard,
            cardState: linkState,
            onActionClick: onActionClick,
            onResolve: update,
            renderers: renderers,
            actionOptions: actionOptions,
            url: url,
            id: id,
            hoverPreviewOptions: hoverPreviewOptions
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5MkWK.SmartLinkAnalyticsContext), {
            url: url,
            display: (0, $5TXU5.CardDisplay).HoverCardPreview,
            id: id,
            source: $4bda3cea16c08f4a$export$421dbc3834daf261
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $44ed84e93427a03a$export$2e2bcd8739ae039), hoverCardContentProps));
    }, [
        initShowCard,
        initHideCard,
        linkState,
        onActionClick,
        renderers,
        actionOptions,
        url,
        id,
        hoverPreviewOptions
    ]);
    const trigger = (0, $42omo.useCallback)(({ 'aria-haspopup': _ariaHasPopup, 'aria-expanded': _ariaExpanded, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            ref: parentSpan
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            ...triggerProps,
            // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
            onMouseOver: initShowCard,
            // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
            onMouseLeave: initHideCard,
            onMouseMove: setMousePosition,
            onClick: onChildClick,
            onContextMenu: onContextMenuClick,
            "data-testid": $4bda3cea16c08f4a$var$HOVER_CARD_TRIGGER_WRAPPER,
            ...(0, $iu6m9.editorExperiment)('platform_editor_preview_panel_linking_exp', true) ? {
                className: $4bda3cea16c08f4a$var$HOVER_CARD_TRIGGER_WRAPPER
            } : {}
        }, children)), [
        children,
        initHideCard,
        initShowCard,
        onChildClick,
        onContextMenuClick,
        setMousePosition
    ]);
    const popupComponent = (0, $42omo.useMemo)(// Within the Popup component, if shouldRenderToParent, the zIndex prop is ignored
    // as it is assumed that the custom popup container has the desired styles
    ()=>(0, $52ec9dab657c3c9f$export$c98f335200f1c8df)(shouldRenderToParent ? zIndex : undefined), [
        zIndex,
        shouldRenderToParent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        testId: "hover-card",
        isOpen: isOpen && canOpen,
        onClose: hideCard,
        placement: "bottom-start",
        offset: popupOffset.current,
        autoFocus: false,
        content: content,
        trigger: trigger,
        zIndex: zIndex,
        role: role,
        titleId: titleId,
        label: label,
        shouldRenderToParent: shouldRenderToParent,
        // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
        popupComponent: popupComponent
    });
};


const $1ecced62c01f09fc$var$HoverCardWithErrorBoundary = (props)=>{
    (0, $fBMbo.di)((0, $4bda3cea16c08f4a$export$e2173dafa6a751bb));
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const { url: url, id: id, children: children } = props;
    const analyticsContext = (0, $5MkWK.useSmartLinkAnalyticsContext)({
        display: (0, $5TXU5.CardDisplay).HoverCardPreview,
        id: id,
        source: (0, $4bda3cea16c08f4a$export$421dbc3834daf261),
        url: url
    });
    const onError = (0, $42omo.useCallback)((error, info)=>{
        (0, $bIll3.startUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $bIll3.failUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $bIll3.failUfoExperience)('smart-link-authenticated', id || 'NULL');
        fireEvent('ui.smartLink.renderFailed', {
            ...analyticsContext?.attributes,
            display: (0, $5TXU5.CardDisplay).HoverCardPreview,
            id: id ?? null,
            error: error,
            errorInfo: info
        });
    }, [
        analyticsContext,
        id,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
        fallback: children,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eMTN.SmartLinkModalProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4bda3cea16c08f4a$export$e2173dafa6a751bb), props, children)));
};
const $1ecced62c01f09fc$var$HoverCardWithoutAnalyticsContext = (0, $1DWH0.default)()($1ecced62c01f09fc$var$HoverCardWithErrorBoundary);
const $1ecced62c01f09fc$export$57a077cc9fbe653e = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1ecced62c01f09fc$var$HoverCardWithoutAnalyticsContext, props);
};
const $1ecced62c01f09fc$export$f1f63acbe6ed8fb0 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1ecced62c01f09fc$export$57a077cc9fbe653e, props);
module.exports["HoverCard"] = $1ecced62c01f09fc$export$57a077cc9fbe653e;
module.exports["StandaloneHoverCard"] = $1ecced62c01f09fc$export$f1f63acbe6ed8fb0;

});

parcelRegister("imb12", function(module, exports) {

var $lyclm = parcelRequire("lyclm");

var $kzSaQ = parcelRequire("kzSaQ");

const $338f0872276e6db6$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd['atlassian:assignedTo'];
    if (assignedTo) return (0, $kzSaQ.extractPersonFromJsonLd)(assignedTo);
    return undefined;
};


var $9WUug = parcelRequire("9WUug");

var $4P3K9 = parcelRequire("4P3K9");

var $4sK6R = parcelRequire("4sK6R");

var $79vw2 = parcelRequire("79vw2");

const $4af8820ea221ff5f$var$extractLinkName = (link)=>{
    if (link && typeof link === 'object' && link['@type'] === 'Link') return link.name;
};
const $4af8820ea221ff5f$var$extractValue = (data, key)=>{
    return data?.[key];
};
const $4af8820ea221ff5f$export$b68822b76d5d51d5 = (data)=>$4af8820ea221ff5f$var$extractValue(data, 'schema:commentCount');
const $4af8820ea221ff5f$export$fb0960a89fb9c17b = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $lyclm.isEntityPresent)(response)) {
        const entity = (0, $lyclm.extractEntity)(response);
        return entity && 'commentCount' in entity && typeof entity.commentCount === 'number' ? entity?.commentCount : undefined;
    }
    return response?.data && $4af8820ea221ff5f$export$b68822b76d5d51d5(response?.data);
};
const $4af8820ea221ff5f$export$4356c594f5c138d6 = (data)=>$4af8820ea221ff5f$var$extractValue(data, 'atlassian:appliedToComponentsCount');
const $4af8820ea221ff5f$export$ac56bd7a37249b48 = (data)=>$4af8820ea221ff5f$var$extractValue(data, 'endTime');
const $4af8820ea221ff5f$export$e57334ce4738e29d = (data)=>$4af8820ea221ff5f$var$extractValue(data, 'atlassian:viewCount');
const $4af8820ea221ff5f$export$44130aa92252501 = (data)=>$4af8820ea221ff5f$var$extractValue(data, 'atlassian:reactCount');
const $4af8820ea221ff5f$export$bb52c21c67a309ca = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $lyclm.isEntityPresent)(response)) {
        const entity = (0, $lyclm.extractEntity)(response);
        const reactions = entity && 'reactions' in entity && Array.isArray(entity.reactions) ? entity.reactions : undefined;
        return reactions?.reduce((total, reaction)=>total + reaction?.total, 0);
    }
    return response?.data && $4af8820ea221ff5f$export$44130aa92252501(response?.data);
};
const $4af8820ea221ff5f$export$c8bef3d5e550a3a = (data)=>$4af8820ea221ff5f$var$extractValue(data, 'atlassian:voteCount');
const $4af8820ea221ff5f$export$75b4b5a156f48ff3 = (data)=>{
    const persons = (0, $4P3K9.extractPersonOwnedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $4af8820ea221ff5f$export$5546969a505305 = (data)=>{
    const person = (0, $338f0872276e6db6$export$38a0979ebf273662)(data);
    if (person) return person.name;
};
const $4af8820ea221ff5f$export$edb8a7a44b91274e = (data)=>{
    const person = (0, $338f0872276e6db6$export$38a0979ebf273662)(data);
    return person ? [
        person
    ] : undefined;
};
const $4af8820ea221ff5f$export$69b10d653f96288b = (data)=>{
    const persons = (0, $9WUug.extractPersonCreatedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $4af8820ea221ff5f$export$bcb193c84c865ec9 = (data)=>{
    const person = (0, $4sK6R.extractPersonUpdatedBy)(data);
    if (person) return person.name;
};
const $4af8820ea221ff5f$export$43e54589935a1ff = (data)=>$4af8820ea221ff5f$var$extractValue(data, 'schema:programmingLanguage');
const $4af8820ea221ff5f$export$949ac6a8325b3fdb = (data)=>$4af8820ea221ff5f$var$extractLinkName(data['atlassian:mergeSource']);
const $4af8820ea221ff5f$export$8bd03a7beb5badf1 = (data)=>$4af8820ea221ff5f$var$extractValue(data, 'atlassian:subscriberCount');
const $4af8820ea221ff5f$export$9fc8706c6cb5343a = (data)=>{
    const val = data?.attributedTo ? Array.isArray(data?.attributedTo) ? data?.attributedTo.length : 0 : 0;
    return val;
};
const $4af8820ea221ff5f$export$65362ff78a97fd8 = (data)=>$4af8820ea221ff5f$var$extractValue(data, 'atlassian:attachmentCount');
const $4af8820ea221ff5f$export$29b0ac5d2f9890cf = (data)=>$4af8820ea221ff5f$var$extractLinkName(data['atlassian:mergeDestination']);
const $4af8820ea221ff5f$export$dd980f9881b65d9c = (data)=>{
    const checkItemsObj = $4af8820ea221ff5f$var$extractValue(data, 'atlassian:checkItems');
    return checkItemsObj ? `${checkItemsObj.checkedItems}/${checkItemsObj.totalItems}` : undefined;
};
const $4af8820ea221ff5f$export$9df94c77b0746c3c = (data)=>{
    const { url: url, name: name } = $4af8820ea221ff5f$var$extractValue(data, 'location') || {};
    if (url && name && typeof url === 'string') return {
        text: name,
        url: url
    };
};
const $4af8820ea221ff5f$export$744e3a2674114c1d = (data)=>{
    const subTasksObject = $4af8820ea221ff5f$var$extractValue(data, 'atlassian:subTasks');
    return subTasksObject && subTasksObject.totalCount ? `${subTasksObject.resolvedCount}/${subTasksObject.totalCount}` : undefined;
};
const $4af8820ea221ff5f$export$6052f26bb463e370 = (data)=>{
    return data?.userAttributes;
};
const $4af8820ea221ff5f$export$cc4028b2878d0675 = (data)=>{
    return $4af8820ea221ff5f$var$extractValue(data, 'atlassian:readTimeInMinutes');
};
const $4af8820ea221ff5f$export$b592ddecae70b61d = (data)=>{
    return $4af8820ea221ff5f$var$extractValue(data, 'dateSent');
};
const $4af8820ea221ff5f$export$5c05c5b7ca37e36e = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntity)(response)?.createdAt;
    return response?.data && $4af8820ea221ff5f$export$b592ddecae70b61d(response?.data);
};
const $4af8820ea221ff5f$export$bdcea84d1550eb9d = (data)=>{
    return $4af8820ea221ff5f$var$extractValue(data, 'atlassian:storyPoints');
};
const $4af8820ea221ff5f$export$bec1443e3e33b166 = (meta)=>meta.objectId;
const $4af8820ea221ff5f$export$11d1314ebbee594e = (meta)=>meta.resourceType;
const $4af8820ea221ff5f$export$92037aea7f27bf7f = (meta)=>meta.tenantId;
const $4af8820ea221ff5f$export$f222ff3355b608d8 = (response)=>{
    try {
        const url = (0, $79vw2.extractSmartLinkUrl)(response);
        const hostName = url ? new URL(url).hostname : undefined;
        return hostName;
    } catch  {
        return undefined;
    }
};
module.exports["extractSmartLinkCommentCount"] = $4af8820ea221ff5f$export$fb0960a89fb9c17b;
module.exports["extractAppliedToComponentsCount"] = $4af8820ea221ff5f$export$4356c594f5c138d6;
module.exports["extractDueOn"] = $4af8820ea221ff5f$export$ac56bd7a37249b48;
module.exports["extractViewCount"] = $4af8820ea221ff5f$export$e57334ce4738e29d;
module.exports["extractSmartLinkReactCount"] = $4af8820ea221ff5f$export$bb52c21c67a309ca;
module.exports["extractVoteCount"] = $4af8820ea221ff5f$export$c8bef3d5e550a3a;
module.exports["extractOwnedBy"] = $4af8820ea221ff5f$export$75b4b5a156f48ff3;
module.exports["extractAssignedTo"] = $4af8820ea221ff5f$export$5546969a505305;
module.exports["extractPersonAssignedToAsArray"] = $4af8820ea221ff5f$export$edb8a7a44b91274e;
module.exports["extractProgrammingLanguage"] = $4af8820ea221ff5f$export$43e54589935a1ff;
module.exports["extractSourceBranch"] = $4af8820ea221ff5f$export$949ac6a8325b3fdb;
module.exports["extractSubscriberCount"] = $4af8820ea221ff5f$export$8bd03a7beb5badf1;
module.exports["extractTeamMemberCount"] = $4af8820ea221ff5f$export$9fc8706c6cb5343a;
module.exports["extractAttachmentCount"] = $4af8820ea221ff5f$export$65362ff78a97fd8;
module.exports["extractTargetBranch"] = $4af8820ea221ff5f$export$29b0ac5d2f9890cf;
module.exports["extractChecklistProgress"] = $4af8820ea221ff5f$export$dd980f9881b65d9c;
module.exports["extractLocation"] = $4af8820ea221ff5f$export$9df94c77b0746c3c;
module.exports["extractSubTasksProgress"] = $4af8820ea221ff5f$export$744e3a2674114c1d;
module.exports["extractUserAttributes"] = $4af8820ea221ff5f$export$6052f26bb463e370;
module.exports["extractReadTime"] = $4af8820ea221ff5f$export$cc4028b2878d0675;
module.exports["extractSmartLinkSentOn"] = $4af8820ea221ff5f$export$5c05c5b7ca37e36e;
module.exports["extractStoryPoints"] = $4af8820ea221ff5f$export$bdcea84d1550eb9d;
module.exports["extractMetaObjectId"] = $4af8820ea221ff5f$export$bec1443e3e33b166;
module.exports["extractMetaResourceType"] = $4af8820ea221ff5f$export$11d1314ebbee594e;
module.exports["extractMetaTenantId"] = $4af8820ea221ff5f$export$92037aea7f27bf7f;
module.exports["extractHostName"] = $4af8820ea221ff5f$export$f222ff3355b608d8;

});

parcelRegister("7kN5H", function(module, exports) {

var $afp1H = parcelRequire("afp1H");


var $lgqac = parcelRequire("lgqac");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");




const $8a01ffa8e2b5674f$export$59f8830fb5467e35 = (handler, id = 'connect-other-account', message = (0, $afp1H.messages).try_another_account, values = {})=>({
        id: id,
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...message,
            values: values
        }),
        promise: ()=>new Promise((resolve)=>resolve(handler())),
        buttonAppearance: 'default'
    });



var $hiPTU = parcelRequire("hiPTU");

const $b560bbfc29780324$export$846c1540a86749e6 = ({ jsonLd: jsonLd, url: url, product: product, createAnalyticsEvent: createAnalyticsEvent })=>{
    const requestAccess = jsonLd?.requestAccess ? {
        ...jsonLd?.requestAccess,
        hostname: (0, $hiPTU.default)(url)
    } : undefined;
    switch(jsonLd?.requestAccess?.accessType){
        case 'DIRECT_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'direct_access_title',
                descriptiveMessageKey: 'direct_access_description',
                callToActionMessageKey: 'direct_access',
                action: (0, $8a01ffa8e2b5674f$export$59f8830fb5467e35)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'crossJoin',
                        eventType: 'ui'
                    }).fire((0, $lgqac.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'direct_access', (0, $afp1H.messages).direct_access, {
                    product: product
                })
            };
        case 'REQUEST_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'default_no_access_title',
                descriptiveMessageKey: 'request_access_description',
                callToActionMessageKey: 'request_access',
                action: (0, $8a01ffa8e2b5674f$export$59f8830fb5467e35)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $lgqac.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'request_access', (0, $afp1H.messages).request_access)
            };
        case 'PENDING_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'request_access_pending_title',
                descriptiveMessageKey: 'request_access_pending_description',
                callToActionMessageKey: 'request_access_pending',
                action: (0, $8a01ffa8e2b5674f$export$59f8830fb5467e35)(()=>window.open(url), 'request_access_pending', (0, $afp1H.messages).request_access_pending),
                buttonDisabled: true
            };
        case 'DENIED_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'request_denied_description'
            };
        case 'ACCESS_EXISTS':
            if (jsonLd?.visibility === 'not_found') return {
                ...requestAccess,
                titleMessageKey: 'not_found_title',
                descriptiveMessageKey: 'not_found_description'
            };
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'access_exists_description',
                callToActionMessageKey: 'request_access',
                action: (0, $8a01ffa8e2b5674f$export$59f8830fb5467e35)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $lgqac.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'access_exists', (0, $afp1H.messages).request_access)
            };
        case 'FORBIDDEN':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'forbidden_description'
            };
        default:
            return requestAccess;
    }
};
module.exports["extractRequestAccessContextImproved"] = $b560bbfc29780324$export$846c1540a86749e6;

});

parcelRegister("hiPTU", function(module, exports) {
const $31b64bf218ef2796$var$extractHostname = (url)=>{
    try {
        return new URL(url).hostname;
    } catch  {
        return url;
    }
};
var $31b64bf218ef2796$export$2e2bcd8739ae039 = $31b64bf218ef2796$var$extractHostname;
module.exports["default"] = $31b64bf218ef2796$export$2e2bcd8739ae039;

});

parcelRegister("iFI9k", function(module, exports) {

var $kzBLz = parcelRequire("kzBLz");

const $09d93d7349277f66$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $kzBLz.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $kzBLz.extractUrlFromLinkJsonLd)(image.url);
        }
    }
    return undefined;
};
module.exports["extractImage"] = $09d93d7349277f66$export$4c753a1297cb9805;

});

parcelRegister("86rMt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");


var $kKODE = parcelRequire("kKODE");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $hX032 = parcelRequire("hX032");

/**
 * This component is used in unauthorized views of a smart link.
 * It represents the main text that provides a user with information on how to connect their account
 */ const $4a1690bb7ffa863c$var$UnauthorisedViewContent = ({ providerName: providerName, isProductIntegrationSupported: isProductIntegrationSupported, testId: testId = 'unauthorised-view-content' })=>{
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const handleLearnMoreClick = (0, $42omo.useCallback)(()=>{
        fireEvent('ui.button.clicked.learnMore', {});
    }, [
        fireEvent
    ]);
    const learnMoreMessage = isProductIntegrationSupported ? (0, $dh538.fg)('product-terminology-refresh') ? (0, $afp1H.messages).learn_more_about_connecting_account_appify : (0, $afp1H.messages).learn_more_about_connecting_account : (0, $afp1H.messages).learn_more_about_smart_links;
    const unauthorizedAccountDescriptionMessage = (0, $hX032.isNewBlockcardUnauthorizedRefreshExperimentEnabled)() ? (0, $afp1H.messages).learn_more_about_connecting_account_experiment_shorter : (0, $dh538.fg)('product-terminology-refresh') ? (0, $afp1H.messages).connect_unauthorised_account_description_appify : (0, $afp1H.messages).connect_unauthorised_account_description;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, providerName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...unauthorizedAccountDescriptionMessage,
        values: {
            context: providerName
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $dh538.fg)('product-terminology-refresh') ? (0, $afp1H.messages).connect_unauthorised_account_description_no_provider_appify : (0, $afp1H.messages).connect_unauthorised_account_description_no_provider), (0, $hX032.isNewBlockcardUnauthorizedRefreshExperimentEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null) : ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
        href: isProductIntegrationSupported ? (0, $5TXU5.CONTENT_URL_3P_ACCOUNT_AUTH) : (0, $5TXU5.CONTENT_URL_SECURITY_AND_PERMISSIONS),
        target: "_blank",
        testId: `${testId}-learn-more`,
        onClick: handleLearnMoreClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), learnMoreMessage)));
};
var $4a1690bb7ffa863c$export$2e2bcd8739ae039 = $4a1690bb7ffa863c$var$UnauthorisedViewContent;
module.exports["default"] = $4a1690bb7ffa863c$export$2e2bcd8739ae039;

});

parcelRegister("eB2Ls", function(module, exports) {

var $79vw2 = parcelRequire("79vw2");


var $5TXU5 = parcelRequire("5TXU5");

var $hcMBV = parcelRequire("hcMBV");


var $226XV = parcelRequire("226XV");


var $ivUmx = parcelRequire("ivUmx");


var $2LWAa = parcelRequire("2LWAa");


var $fcTJU = parcelRequire("fcTJU");

const $dd9cc1ea5f7a02ad$export$ea97cd34c2ca86de = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $2LWAa.canShowAction)((0, $hcMBV.CardAction).DownloadAction, actionOptions)) return;
    const data = response.data;
    const downloadActionExists = (0, $fcTJU.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'DownloadAction');
    if (downloadActionExists) {
        const downloadUrl = (0, $79vw2.extractSmartLinkDownloadUrl)(response);
        return {
            actionFn: async ()=>(0, $ivUmx.downloadUrl)(downloadUrl),
            actionSubjectId: 'downloadDocument',
            actionType: (0, $5TXU5.ActionName).DownloadAction,
            definitionId: (0, $226XV.getDefinitionId)(response),
            display: appearance,
            extensionKey: (0, $226XV.getExtensionKey)(response),
            id: id,
            resourceType: (0, $226XV.getResourceType)(response)
        };
    }
};
module.exports["extractInvokeDownloadAction"] = $dd9cc1ea5f7a02ad$export$ea97cd34c2ca86de;

});

parcelRegister("4gOU2", function(module, exports) {

var $9JHBV = parcelRequire("9JHBV");

var $79vw2 = parcelRequire("79vw2");


var $7ee1w = parcelRequire("7ee1w");


var $1oCLl = parcelRequire("1oCLl");


var $5TXU5 = parcelRequire("5TXU5");

var $hcMBV = parcelRequire("hcMBV");


var $226XV = parcelRequire("226XV");


var $2LWAa = parcelRequire("2LWAa");


var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $1e2E5 = parcelRequire("1e2E5");

const $76698d8a364f0519$var$IFRAME_NAME = 'twp-editor-preview-iframe';
const $76698d8a364f0519$var$POPUP_MOUNT_POINT_ID = 'twp-editor-preview-iframe';

async function $76698d8a364f0519$export$7859f96cd8cff034({ onClose: onClose = ()=>{}, ...props } = {}) {
    let popupMountPoint;
    popupMountPoint = document.getElementById($76698d8a364f0519$var$POPUP_MOUNT_POINT_ID);
    if (!popupMountPoint) {
        popupMountPoint = document.createElement('div');
        popupMountPoint.id = $76698d8a364f0519$var$POPUP_MOUNT_POINT_ID;
        popupMountPoint.setAttribute('data-testid', 'preview-modal');
        document.body.appendChild(popupMountPoint);
    }
    let Modal = await (parcelRequire("7FkPA"));
    (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1e2E5.default), {
        locale: "en"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal.default, {
        ...props,
        iframeName: $76698d8a364f0519$var$IFRAME_NAME,
        onClose: (_context)=>{
            if (popupMountPoint) (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).unmountComponentAtNode(popupMountPoint);
            if (onClose) onClose(_context);
        },
        showModal: true
    })), popupMountPoint);
}



var $fHhRu = parcelRequire("fHhRu");


var $cUjGA = parcelRequire("cUjGA");


var $575f6 = parcelRequire("575f6");


var $eB2Ls = parcelRequire("eB2Ls");


var $dOvUN = parcelRequire("dOvUN");

const $0216c8d70d641474$export$caf83f49e52ac0bb = (param)=>{
    const { actionOptions: actionOptions, appearance: display, fireEvent: fireEvent, onClose: onClose, id: id, origin: origin, response: response, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = param;
    const ari = (0, $79vw2.extractSmartLinkAri)(response);
    const url = (0, $79vw2.extractSmartLinkUrl)(response);
    const name = (0, $79vw2.extractSmartLinkTitle)(response);
    const hasPreviewPanelParams = Boolean((0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && isPreviewPanelAvailable && openPreviewPanel && ari && url && name);
    const hasPreviewPanel = hasPreviewPanelParams && isPreviewPanelAvailable({
        ari: ari
    });
    const isInPreviewPanel = (0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && (0, $7ee1w.isWithinPreviewPanelIFrame)();
    const data = response.data;
    const meta = response.meta;
    if (!(0, $2LWAa.canShowAction)((0, $hcMBV.CardAction).PreviewAction, actionOptions)) return;
    /* Analytics UI event for preview action created to support tracking of preview actions as the experiment rolls out */ const firePreviewActionUIEvent = ({ previewType: previewType })=>{
        if (!(0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') || origin !== 'smartLinkPreviewHoverCard' || !fireEvent) return;
        fireEvent('ui.smartLink.clicked.previewHoverCard', {
            id: id || '',
            display: 'hoverCardPreview',
            previewType: previewType
        });
    };
    const src = (0, $9JHBV.extractPreview)(data, 'web')?.src;
    // disallow preview modals within preview panels
    if (!hasPreviewPanel && isInPreviewPanel) return;
    if (src) {
        const extensionKey = (0, $226XV.getExtensionKey)(response);
        return {
            hasPreviewPanel: hasPreviewPanel,
            invokeAction: {
                actionFn: async ()=>{
                    if (hasPreviewPanel) {
                        let resolvedUrl = url;
                        if ((0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test')) {
                            const responseUrl = response.data && 'url' in response.data ? response.data.url : undefined;
                            resolvedUrl = responseUrl || url;
                        }
                        openPreviewPanel({
                            ari: ari,
                            url: resolvedUrl,
                            name: name,
                            iconUrl: undefined,
                            panelData: {
                                embedUrl: (0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') ? (0, $79vw2.extractSmartLinkEmbed)(response)?.src : undefined
                            }
                        });
                        (0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && firePreviewActionUIEvent({
                            previewType: 'panel'
                        });
                    } else {
                        await (0, $76698d8a364f0519$export$7859f96cd8cff034)({
                            fireEvent: fireEvent,
                            extensionKey: extensionKey,
                            id: id,
                            invokeDownloadAction: (0, $eB2Ls.extractInvokeDownloadAction)(param),
                            invokeViewAction: (0, $dOvUN.extractInvokeViewAction)(param, true),
                            isSupportTheming: (0, $fHhRu.extractIsSupportTheming)(meta),
                            isTrusted: (0, $cUjGA.extractIsTrusted)(meta),
                            linkIcon: (0, $575f6.extractLinkIcon)(response),
                            providerName: (0, $79vw2.extractSmartLinkProvider)(response)?.text,
                            onClose: onClose,
                            origin: origin,
                            src: (0, $79vw2.extractSmartLinkEmbed)(response)?.src,
                            title: (0, $79vw2.extractSmartLinkTitle)(response),
                            url: url,
                            size: actionOptions?.previewAction?.size,
                            isBlanketHidden: actionOptions?.previewAction?.hideBlanket,
                            ...(0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && {
                                isInPreviewPanel: isInPreviewPanel
                            }
                        });
                        (0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && firePreviewActionUIEvent({
                            previewType: 'modal'
                        });
                    }
                },
                actionSubjectId: 'invokePreviewScreen',
                actionType: (0, $5TXU5.ActionName).PreviewAction,
                display: display,
                extensionKey: extensionKey,
                id: id
            }
        };
    }
};
module.exports["extractInvokePreviewAction"] = $0216c8d70d641474$export$caf83f49e52ac0bb;

});

parcelRegister("7ee1w", function(module, exports) {
/**
 * Utility functions for detecting iframe and preview panel contexts.
 * These utilities help components determine if they're running inside an iframe
 * or within a preview panel context.
 */ const $0342f45c1f755179$var$PREVIEW_PANEL_INDICATORS = {
    EMBEDDED_SOURCE: 'embeddedConfluenceSource',
    PREVIEW_PANELS: 'previewPanels',
    CONFLUENCE_PAGE_PREVIEW: 'confluence-page-preview-panel'
};
const $0342f45c1f755179$var$getUrlSearchParams = (url)=>{
    try {
        return new URLSearchParams(url);
    } catch  {
        return null;
    }
};
const $0342f45c1f755179$var$hasPreviewPanelIndicators = (searchParams)=>{
    return searchParams.has($0342f45c1f755179$var$PREVIEW_PANEL_INDICATORS.PREVIEW_PANELS) || searchParams.get($0342f45c1f755179$var$PREVIEW_PANEL_INDICATORS.EMBEDDED_SOURCE) === $0342f45c1f755179$var$PREVIEW_PANEL_INDICATORS.CONFLUENCE_PAGE_PREVIEW;
};
const $0342f45c1f755179$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
const $0342f45c1f755179$export$f274fcef361fe59d = ()=>{
    try {
        const currentSearch = window.location.search;
        if (currentSearch) {
            const currentParams = $0342f45c1f755179$var$getUrlSearchParams(currentSearch);
            if (currentParams && $0342f45c1f755179$var$hasPreviewPanelIndicators(currentParams)) return true;
        }
        return false;
    } catch  {
        return false;
    }
};
const $0342f45c1f755179$export$24def1b22639c691 = ()=>{
    return $0342f45c1f755179$export$9f140ed41af5108c() && $0342f45c1f755179$export$f274fcef361fe59d();
};
module.exports["isWithinPreviewPanelIFrame"] = $0342f45c1f755179$export$24def1b22639c691;

});

parcelRegister("7FkPA", function(module, exports) {

let $594c855bdd9c865d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $594c855bdd9c865d$var$load("iVgrO"),
    $594c855bdd9c865d$var$load("ehFbl"),
    $594c855bdd9c865d$var$load("gOP9E"),
    $594c855bdd9c865d$var$load("6wr18"),
    $594c855bdd9c865d$var$load("bFS2f"),
    $594c855bdd9c865d$var$load("ffEVr"),
    $594c855bdd9c865d$var$load("Wowvf"),
    $594c855bdd9c865d$var$load("36QeB"),
    $594c855bdd9c865d$var$load("2euij"),
    $594c855bdd9c865d$var$load("kZMnh"),
    $594c855bdd9c865d$var$load("hhss7"),
    $594c855bdd9c865d$var$load("kDLrp")
]).then(()=>parcelRequire('6as51'));

});

parcelRegister("fHhRu", function(module, exports) {

var $15w8R = parcelRequire("15w8R");

const $0f61633c27d66d37$export$38d755f52cdf4acb = (meta)=>{
    return Boolean(meta?.key && (0, $15w8R.PROVIDER_KEYS_WITH_THEMING).includes(meta.key));
};
module.exports["extractIsSupportTheming"] = $0f61633c27d66d37$export$38d755f52cdf4acb;

});

parcelRegister("15w8R", function(module, exports) {
const $c903d02fdad660aa$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $c903d02fdad660aa$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $c903d02fdad660aa$export$84a73a0383f58180 = 'JiraTask';
const $c903d02fdad660aa$export$c6c83963a9378a67 = 'JiraSubTask';
const $c903d02fdad660aa$export$58af3c426c111a6d = 'JiraStory';
const $c903d02fdad660aa$export$ac9898a63417219e = 'JiraBug';
const $c903d02fdad660aa$export$54db5e3fb12e39cd = 'JiraEpic';
const $c903d02fdad660aa$export$2f54a5a217202c85 = 'JiraIncident';
const $c903d02fdad660aa$export$d097371052bfc411 = 'JiraServiceRequest';
const $c903d02fdad660aa$export$efd9452ad16c6676 = 'JiraChange';
const $c903d02fdad660aa$export$2e7e70abb5d81f67 = 'JiraProblem';
const $c903d02fdad660aa$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
const $c903d02fdad660aa$export$fe44ce30fd8d131b = [
    'jira-object-provider',
    'confluence-object-provider',
    'watermelon-object-provider',
    'legion-object-provider',
    'avpviz-object-provider'
];
module.exports["CONFLUENCE_GENERATOR_ID"] = $c903d02fdad660aa$export$cee224b5de4d6d66;
module.exports["JIRA_GENERATOR_ID"] = $c903d02fdad660aa$export$f654d825189934a7;
module.exports["JIRA_TASK"] = $c903d02fdad660aa$export$84a73a0383f58180;
module.exports["JIRA_SUB_TASK"] = $c903d02fdad660aa$export$c6c83963a9378a67;
module.exports["JIRA_STORY"] = $c903d02fdad660aa$export$58af3c426c111a6d;
module.exports["JIRA_BUG"] = $c903d02fdad660aa$export$ac9898a63417219e;
module.exports["JIRA_EPIC"] = $c903d02fdad660aa$export$54db5e3fb12e39cd;
module.exports["JIRA_INCIDENT"] = $c903d02fdad660aa$export$2f54a5a217202c85;
module.exports["JIRA_SERVICE_REQUEST"] = $c903d02fdad660aa$export$d097371052bfc411;
module.exports["JIRA_CHANGE"] = $c903d02fdad660aa$export$efd9452ad16c6676;
module.exports["JIRA_PROBLEM"] = $c903d02fdad660aa$export$2e7e70abb5d81f67;
module.exports["JIRA_CUSTOM_TASK_TYPE"] = $c903d02fdad660aa$export$ce25cfc40b280dbc;
module.exports["PROVIDER_KEYS_WITH_THEMING"] = $c903d02fdad660aa$export$fe44ce30fd8d131b;

});

parcelRegister("cUjGA", function(module, exports) {
const $b09d72911e8b5283$export$4f3ffbb500daac5a = (meta)=>{
    return Boolean(meta?.key && meta.key !== 'iframely-object-provider');
};
module.exports["extractIsTrusted"] = $b09d72911e8b5283$export$4f3ffbb500daac5a;

});

parcelRegister("7hXqf", function(module, exports) {
/**
 * Options required to prioritise which icon to show
 */ function $776748d0c66c7fba$export$65e47eb22a387a86({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon }) {
    return urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
}
module.exports["prioritiseIcon"] = $776748d0c66c7fba$export$65e47eb22a387a86;

});

parcelRegister("uAXxz", function(module, exports) {
const $2e2993a3a04453b8$export$e0deaeb4a2dfe2b4 = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};
module.exports["extractorPriorityMap"] = $2e2993a3a04453b8$export$e0deaeb4a2dfe2b4;

});

parcelRegister("8sXiv", function(module, exports) {

var $8hlRK = parcelRequire("8hlRK");

const $50b1c4035dc2416d$export$ed3fd59180514d27 = (jsonLd)=>{
    // TODO: Remove once Jira migrate to the correct type.
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $8hlRK.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};
module.exports["extractTaskType"] = $50b1c4035dc2416d$export$ed3fd59180514d27;

});

parcelRegister("dOvUN", function(module, exports) {

var $l6lJr = parcelRequire("l6lJr");


var $hcMBV = parcelRequire("hcMBV");


var $226XV = parcelRequire("226XV");


var $ivUmx = parcelRequire("ivUmx");


var $2LWAa = parcelRequire("2LWAa");


var $fcTJU = parcelRequire("fcTJU");

const $7b2d7b35c23c90ae$export$88c5813cfbbe4e4c = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response }, force)=>{
    if (!(0, $2LWAa.canShowAction)((0, $hcMBV.CardAction).ViewAction, actionOptions)) return;
    const data = response.data;
    if (!data) return;
    const url = (0, $l6lJr.extractLink)(data);
    const viewActionExists = (0, $fcTJU.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'ViewAction');
    if (url && (viewActionExists || force)) return {
        actionFn: async ()=>(0, $ivUmx.openUrl)(url),
        actionSubjectId: 'shortcutGoToLink',
        actionType: 'ViewAction',
        definitionId: (0, $226XV.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $226XV.getExtensionKey)(response),
        id: id,
        resourceType: (0, $226XV.getResourceType)(response)
    };
};
module.exports["extractInvokeViewAction"] = $7b2d7b35c23c90ae$export$88c5813cfbbe4e4c;

});

parcelRegister("dKrmg", function(module, exports) {

var $aliCf = parcelRequire("aliCf");

const $62de36893d312d67$var$VALID_APPEARANCES = [
    'default',
    'success',
    'removed',
    'inprogress',
    'new',
    'moved'
];
const $62de36893d312d67$export$ce6b5b303f8e3c99 = (appearance)=>{
    return $62de36893d312d67$var$VALID_APPEARANCES.indexOf(appearance) !== -1;
};
const $62de36893d312d67$export$7b1deaaad25d1dc1 = {
    open: 'inprogress',
    merged: 'success',
    declined: 'removed',
    closed: 'success',
    draft: 'inprogress',
    archived: 'default',
    'queued to merge': 'moved'
};
const $62de36893d312d67$export$772610da74ddbc07 = [
    'current'
];


// Maps accent color short names to their corresponding background and text colors
const $2218d42ba61dc0c3$var$lozengeAccentStyles = {
    blue: {
        backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        color: "var(--ds-text-accent-blue, #0055CC)"
    },
    gray: {
        backgroundColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        color: "var(--ds-text-accent-gray, #44546F)"
    },
    green: {
        backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        color: "var(--ds-text-accent-green, #216E4E)"
    },
    lime: {
        backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        color: "var(--ds-text-accent-lime, #4C6B1F)"
    },
    magenta: {
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        color: "var(--ds-text-accent-magenta, #943D73)"
    },
    orange: {
        backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
        color: "var(--ds-text-accent-orange, #A54800)"
    },
    purple: {
        backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        color: "var(--ds-text-accent-purple, #5E4DB2)"
    },
    red: {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    teal: {
        backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        color: "var(--ds-text-accent-teal, #206A83)"
    },
    yellow: {
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        color: "var(--ds-text-accent-yellow, #7F5F01)"
    }
};
const $2218d42ba61dc0c3$export$5e4074cbce6574c7 = (jsonLd)=>{
    const state = jsonLd['atlassian:state'];
    if (state) {
        if (typeof state === 'string') {
            const linkState = state.toLowerCase();
            if (!(0, $62de36893d312d67$export$772610da74ddbc07).includes(linkState)) return {
                text: linkState,
                appearance: (0, $62de36893d312d67$export$7b1deaaad25d1dc1)[linkState] || 'default'
            };
        } else if (state['@type'] === 'Link' || state['@type'] === 'Object') {
            if (state.name) {
                const accent = state.accent;
                return {
                    text: state.name,
                    appearance: state.appearance || 'default',
                    style: accent ? $2218d42ba61dc0c3$var$lozengeAccentStyles[accent] : undefined
                };
            }
        }
    }
};



const $107358540664e913$export$962a8da34cf78a4f = (jsonLd)=>{
    const tag = jsonLd.tag;
    if (tag) {
        if (typeof tag === 'string') return {
            text: tag,
            appearance: 'default'
        };
        else if (Array.isArray(tag)) {
            const tags = tag.map($107358540664e913$var$extractTagItem).filter((item)=>!!item);
            if (tags.length > 0) return tags.shift();
        } else return $107358540664e913$var$extractTagItem(tag);
    }
};
const $107358540664e913$var$extractTagItem = (tag)=>{
    if (typeof tag === 'string') return {
        text: tag,
        appearance: 'default'
    };
    else if (tag['@type'] === 'Link') {
        if (tag.name) return {
            text: tag.name,
            appearance: 'default'
        };
    } else if (tag.name) {
        const appearance = tag.appearance;
        return {
            text: tag.name,
            // Jira currently uses tag.appearance to set the lozenge color. Remove this
            // once we migrate them away from using this old spec.
            appearance: (0, $62de36893d312d67$export$ce6b5b303f8e3c99)(appearance) && appearance || 'default'
        };
    }
};


const $361da8e075cf72f7$export$7698df1946deda72 = (jsonLd)=>{
    const taskStatus = jsonLd['atlassian:taskStatus'];
    if (taskStatus && taskStatus.name) return {
        text: taskStatus.name,
        appearance: 'success'
    };
};



var $8sXiv = parcelRequire("8sXiv");

const $35ed8229f3b3cbd6$export$e5da155556a77bca = (jsonLd)=>{
    const type = (0, $aliCf.extractType)(jsonLd);
    if (type) {
        if (type.includes('atlassian:Task')) {
            const jsonLdTask = jsonLd;
            const lozengeFromTag = (0, $107358540664e913$export$962a8da34cf78a4f)(jsonLdTask);
            const lozengeFromStatus = (0, $361da8e075cf72f7$export$7698df1946deda72)(jsonLdTask);
            const lozengeFromTaskType = $35ed8229f3b3cbd6$var$extractLozengeFromTaskType(jsonLdTask);
            return lozengeFromTag || lozengeFromStatus || lozengeFromTaskType;
        }
        if (type.includes('atlassian:UndefinedLink')) return {
            text: 'UNDEFINED',
            appearance: 'inprogress'
        };
        // casting it because `extractState` can safely handle missing properties
        return (0, $2218d42ba61dc0c3$export$5e4074cbce6574c7)(jsonLd);
    }
};
const $35ed8229f3b3cbd6$var$extractLozengeFromTaskType = (jsonLdTask)=>{
    const taskType = (0, $8sXiv.extractTaskType)(jsonLdTask);
    if (taskType && taskType.name) return {
        text: taskType.name,
        appearance: 'success'
    };
};
module.exports["extractLozenge"] = $35ed8229f3b3cbd6$export$e5da155556a77bca;

});

parcelRegister("iWvOt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $I1nNR = parcelRequire("I1nNR");

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $0e428a1b86b9241f$export$2e2bcd8739ae039 = {
    'my.test.no-translate': 'My Test'
};


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $45dca5869897ff09$export$2e2bcd8739ae039 = {
    'my.test.no-translate': 'My Test'
};


const $eae070da32ac21dd$var$fetchTranslations = async (locale)=>{
    switch(locale){
        case 'en-GB':
            return 0, $0e428a1b86b9241f$export$2e2bcd8739ae039;
        case 'en-US':
        default:
            return 0, $45dca5869897ff09$export$2e2bcd8739ae039;
    }
};
var $eae070da32ac21dd$export$2e2bcd8739ae039 = $eae070da32ac21dd$var$fetchTranslations;





parcelRequire("42omo");


var $7k8Uw = parcelRequire("7k8Uw");


var $8C5kA = parcelRequire("8C5kA");




parcelRequire("42omo");








parcelRequire("42omo");


var $aI44c = parcelRequire("aI44c");




const $216b1f3eb7fd7629$export$767e3006bdbb424a = (props)=>{
    const { locale: locale } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $aI44c.ViewPage), {
        locale: locale,
        ...props
    });
};


const $6d62a53500c7e32b$export$767e3006bdbb424a = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $I1nNR.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $eae070da32ac21dd$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $216b1f3eb7fd7629$export$767e3006bdbb424a), {
            ...props
        })
    });





parcelRequire("42omo");








parcelRequire("42omo");


var $aiCKw = parcelRequire("aiCKw");




const $015976cb7cb7475e$export$1fea75498367c4ac = (props)=>{
    const { locale: locale } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $aiCKw.EditPage), {
        locale: locale,
        ...props
    });
};


const $8690a9fa0f1ae334$export$1fea75498367c4ac = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $I1nNR.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $eae070da32ac21dd$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $015976cb7cb7475e$export$1fea75498367c4ac), {
            ...props
        })
    });


const $172be5db228fd17c$var$ViewComponent = (props)=>{
    const { locale: locale } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6d62a53500c7e32b$export$767e3006bdbb424a), {
        locale: locale,
        ...props
    });
};
const $172be5db228fd17c$var$EditComponent = (props)=>{
    const { locale: locale } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8690a9fa0f1ae334$export$1fea75498367c4ac), {
        locale: locale,
        ...props
    });
};
const $172be5db228fd17c$export$6955bcca4cd3539f = (props)=>{
    const { locale: locale } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7k8Uw.Page), {
        locale: locale,
        ...props,
        viewComponent: $172be5db228fd17c$var$ViewComponent,
        editComponent: $172be5db228fd17c$var$EditComponent
    });
};


const $7e20740578e340e4$export$6955bcca4cd3539f = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $I1nNR.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $eae070da32ac21dd$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $172be5db228fd17c$export$6955bcca4cd3539f), {
            ...props
        })
    });



var $dh538 = parcelRequire("dh538");








var $bRSdj = parcelRequire("bRSdj");

var $j6S25 = parcelRequire("j6S25");

var $7e0969c4e751a56a$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $7e0969c4e751a56a$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
var $7e0969c4e751a56a$export$dc091dbfc779121b = /*#__PURE__*/ function(CONFLUENCE_EXTENSION_KEYS) {
    CONFLUENCE_EXTENSION_KEYS["PAGE"] = "integration-confluence-object-provider";
    CONFLUENCE_EXTENSION_KEYS["CANVAS"] = "canvas-native-object-provider";
    return CONFLUENCE_EXTENSION_KEYS;
}({});
const $7e0969c4e751a56a$export$10fb2803bc7b79fc = (url, extensionKey)=>{
    const parsedData = (0, $42omo.useMemo)(()=>{
        if (!(0, $dh538.fg)('platform_deprecate_lp_cc_embed')) return undefined;
        if (!url || typeof url !== 'string' || !url.startsWith('http://') && !url.startsWith('https://') || !extensionKey || !Object.values($7e0969c4e751a56a$export$dc091dbfc779121b).find((key)=>key === extensionKey)) return undefined;
        let urlObj;
        try {
            urlObj = new URL(url);
        } catch  {
            return undefined;
        }
        const { searchParams: searchParams, hash: hash } = urlObj;
        const hostname = searchParams?.get('hostname') || '';
        const contentId = searchParams?.get('contentId') || '';
        const spaceKey = searchParams?.get('spaceKey') || '';
        // Early return for invalid URLs
        if (!contentId || !hostname) return undefined;
        const themeState = searchParams?.get('themeState') || '';
        const themeMode = searchParams?.get('themeMode');
        const enableInlineComments = searchParams?.get('enableInlineComments') === 'true';
        const enablePageComments = searchParams?.get('enablePageComments') === 'true';
        const userId = searchParams?.get('userId') || '';
        const userIdType = searchParams?.get('userInfo') || undefined;
        const parentProduct = searchParams?.get('parentProduct') || '';
        const inlineComments = enableInlineComments ? [
            'inline-comments'
        ] : [];
        const pageComments = enablePageComments ? [
            'page-comments'
        ] : [];
        // Calculate theme state object here
        let calculatedThemeStateObject;
        if (themeState) calculatedThemeStateObject = (0, $j6S25.themeStringToObject)(decodeURIComponent(themeState));
        else if (themeMode) calculatedThemeStateObject = {
            colorMode: themeMode
        };
        const calculatedUserInfo = userId && userIdType ? {
            userId: userId,
            userIdType: userIdType
        } : undefined;
        return {
            hostname: hostname,
            spaceKey: spaceKey,
            contentId: contentId,
            parentProduct: parentProduct,
            userInfo: calculatedUserInfo,
            hash: hash || '',
            enableInlineComments: enableInlineComments,
            enablePageComments: enablePageComments,
            themeStateObject: calculatedThemeStateObject,
            allowedFeatures: {
                edit: [
                    'delete-draft'
                ],
                view: [
                    'byline-contributors',
                    'byline-extensions',
                    'page-reactions',
                    ...pageComments,
                    ...inlineComments
                ]
            },
            mode: "view",
            locale: 'en'
        };
    }, [
        url,
        extensionKey
    ]);
    // Handle theme side effect - only when theme object changes
    (0, $42omo.useEffect)(()=>{
        if (parsedData?.themeStateObject) (0, $bRSdj.default)(parsedData.themeStateObject);
    }, [
        parsedData?.themeStateObject
    ]);
    return parsedData;
};


const $f9f9ad585f1b3a08$export$b32b5f1ee4493319 = ({ childRef: childRef, className: className, extensionKey: extensionKey, ...props })=>{
    const confluencePageData = (0, $dh538.fg)('platform_deprecate_lp_cc_embed') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $7e0969c4e751a56a$export$10fb2803bc7b79fc)(props.src || '', extensionKey || '') : undefined;
    // Conditional rendering: Page component for lp-cc-embed URLs, iframe for everything else
    return confluencePageData && (0, $dh538.fg)('platform_deprecate_lp_cc_embed') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7e20740578e340e4$export$6955bcca4cd3539f), {
        hostname: confluencePageData.hostname,
        spaceKey: confluencePageData.spaceKey,
        contentId: confluencePageData.contentId,
        parentProduct: confluencePageData.parentProduct,
        hash: confluencePageData.hash,
        mode: confluencePageData.mode,
        locale: confluencePageData.locale,
        iframeRef: childRef,
        onLoad: props.onLoad,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        sandbox: props.sandbox,
        allowedFeatures: confluencePageData.allowedFeatures,
        themeState: confluencePageData.themeStateObject,
        userInfo: confluencePageData.userInfo
    }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("iframe", {
        className: className,
        ...props,
        ref: childRef,
        title: props.title
    });
};
module.exports["IFrame"] = $f9f9ad585f1b3a08$export$b32b5f1ee4493319;

});

parcelRegister("7k8Uw", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");





var $42omo = parcelRequire("42omo");


var $jJf3a = parcelRequire("jJf3a");


var $hwNSM = parcelRequire("hwNSM");


var $iudHJ = parcelRequire("iudHJ");


var $kFwgS = parcelRequire("kFwgS");


var $8C5kA = parcelRequire("8C5kA");


var $dh538 = parcelRequire("dh538");

const $186cb535f1e2b2f1$var$EDIT_PAGE_CLOSE = 'edit-page/close';
const $186cb535f1e2b2f1$var$EDIT_PAGE_PUBLISH = 'edit-page/publish';
const $186cb535f1e2b2f1$export$6955bcca4cd3539f = (props)=>{
    const { viewComponent: ViewComponent, editComponent: EditComponent } = props;
    const { mode: mode, allowedFeatures: allowedFeatures, draftShareId: draftShareId, navigationPolicy: navigationPolicy, spaceKey: spaceKey, showFooter: showFooter, ...passThroughProps } = (0, $hwNSM.parsePageProps)(props);
    const { onModeChange: onModeChange } = props;
    const [currentMode, setCurrentMode] = (0, $42omo.useState)(mode);
    (0, $42omo.useEffect)(()=>{
        setCurrentMode(mode);
    }, [
        mode
    ]);
    const [currentSpaceKey, setCurrentSpaceKey] = (0, $42omo.useState)(spaceKey);
    const switchToViewPage = (0, $42omo.useCallback)(()=>{
        setCurrentMode((0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE);
    }, [
        setCurrentMode
    ]);
    const pageNavigationPolicy = (0, $42omo.useMemo)(()=>({
            navigate (url, modifiers, defaultNavigate) {
                /**
       * Below is for switching from View to Edit and we assume parent product doesn't have this situation in their navigationPolicy.
       */ if (currentMode === (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE && (modifiers.routeName === 'EDIT_PAGE_EMBED' || url?.includes('/edit-embed/') && passThroughProps.contentId === modifiers.contentId) && ((0, $dh538.fg)('platform_deprecate_lp_cc_embed') ? passThroughProps.contentId === modifiers.contentId : true)) {
                    setCurrentMode((0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
                    onModeChange?.((0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
                    return;
                }
                return navigationPolicy?.navigate ? navigationPolicy.navigate(url, modifiers, defaultNavigate) : defaultNavigate(url, modifiers);
            },
            shimUrl: navigationPolicy?.shimUrl,
            domainNamesToReplace: navigationPolicy?.domainNamesToReplace,
            spaceKeyFilter: navigationPolicy?.spaceKeyFilter
        }), [
        currentMode,
        passThroughProps.contentId,
        navigationPolicy,
        onModeChange
    ]);
    const experienceTracker = (0, $iudHJ.useExperienceTracker)();
    (0, $42omo.useEffect)(()=>experienceTracker.subscribe((event)=>{
            const { name: name, action: action, attributes: attributes } = event;
            /**
     * Using experienceTracker, we can switch from Edit to View page.
     * 1. When the user clicks the Publish button and task success, it can switch to the View page.
     *    a. If the `publish-modal` is added to the allowedFeatures, the Publish Modal may be used to
     *          change the spaceKey during publish.
     *          In that case, a new spaceKey will be added to the success event and tracked here.
     * 2. If the page is not unpublished draft, when the user clicks Close button and task success, it can switch to the View page.
     */ const isClosingPublishedEditPage = !draftShareId && name === $186cb535f1e2b2f1$var$EDIT_PAGE_CLOSE;
            const isPublishingDraft = name === $186cb535f1e2b2f1$var$EDIT_PAGE_PUBLISH;
            if (action === 'taskSuccess' && (isClosingPublishedEditPage || isPublishingDraft)) {
                if (allowedFeatures.edit?.includes('publish-modal')) {
                    const newSpaceKey = attributes?.newSpaceKey;
                    setCurrentSpaceKey(newSpaceKey || spaceKey);
                }
                switchToViewPage();
            }
        }), [
        draftShareId,
        experienceTracker,
        switchToViewPage,
        allowedFeatures.edit,
        spaceKey
    ]);
    const { locale: locale } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jJf3a.ExperienceTrackerContext).Provider, {
        value: experienceTracker,
        children: currentMode === (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE ? /*#__PURE__*/ (0, $l998X.jsx)(ViewComponent, {
            navigationPolicy: pageNavigationPolicy,
            allowedFeatures: allowedFeatures.view,
            locale: locale,
            spaceKey: currentSpaceKey,
            showFooter: showFooter,
            ...passThroughProps
        }) : currentMode === (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE ? /*#__PURE__*/ (0, $l998X.jsx)(EditComponent, {
            navigationPolicy: pageNavigationPolicy,
            allowedFeatures: allowedFeatures.edit,
            draftShareId: draftShareId,
            locale: locale,
            spaceKey: currentSpaceKey,
            ...passThroughProps
        }) : null
    });
};



var $elkSx = parcelRequire("elkSx");


var $I1nNR = parcelRequire("I1nNR");


var $gt5FF = parcelRequire("gt5FF");

const $9ced22d459d44e84$export$6955bcca4cd3539f = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $I1nNR.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $gt5FF.default),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
            fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $elkSx.PageNotFoundEmptyState), {}),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $186cb535f1e2b2f1$export$6955bcca4cd3539f), {
                ...props
            })
        })
    });
module.exports["Page"] = $9ced22d459d44e84$export$6955bcca4cd3539f;

});

parcelRegister("aI44c", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");

/* ViewPage.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");





var $7pThu = parcelRequire("7pThu");


var $9tQM5 = parcelRequire("9tQM5");

var $kFwgS = parcelRequire("kFwgS");

var $44JTv = parcelRequire("44JTv");


var $1oYQ9 = parcelRequire("1oYQ9");


var $6wQcp = parcelRequire("6wQcp");


var $cGc86 = parcelRequire("cGc86");

const $f3c4af92b1079227$var$embeddedPageContainerSytles = null;
const $f3c4af92b1079227$var$StyledEmbeddedPageContainer = ({ children: children, containerHeight: containerHeight })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testId": "styled-embedded-page-container-id",
        style: {
            height: containerHeight
        },
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4"
        ]),
        children: children
    });
};
const $f3c4af92b1079227$export$767e3006bdbb424a = (props)=>{
    const { hasFooterLogo: shouldShowFooter, isHeightSetFromContent: isHeightSetFromContent, showFooter: showFooter = true } = props;
    const { uniqueKey: uniqueKey } = (0, $cGc86.useUniqueKey)();
    const { height: height } = (0, $44JTv.useContentSize)(uniqueKey);
    (0, $6wQcp.useGetCurrentScrollPosition)(isHeightSetFromContent);
    const contentConfiguration = (0, $42omo.useMemo)(()=>({
            experiences: {
                experience: (0, $7pThu.ExperienceNames).VIEW_PAGE,
                ccExperience: (0, $7pThu.ExperienceNames).CC_VIEW_PAGE
            },
            getWrapperElement: (children)=>/*#__PURE__*/ (0, $l998X.jsx)($f3c4af92b1079227$var$StyledEmbeddedPageContainer, {
                    containerHeight: isHeightSetFromContent ? `${height}px` : '100%',
                    children: children
                }),
            hasFooter: showFooter
        }), [
        isHeightSetFromContent,
        height,
        showFooter
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1oYQ9.Content), {
        ...props,
        contentType: (0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE,
        mode: (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        contentConfiguration: contentConfiguration,
        isHeightSetFromContent: isHeightSetFromContent,
        shouldShowFooter: shouldShowFooter
    });
};



var $elkSx = parcelRequire("elkSx");


var $I1nNR = parcelRequire("I1nNR");


var $gt5FF = parcelRequire("gt5FF");


var $kudeD = parcelRequire("kudeD");




const $d51843cacb6b0e00$export$767e3006bdbb424a = (props)=>{
    const { markIframeLoadMetrics: markIframeLoadMetrics } = (0, $kudeD.usePerformanceMetrics)();
    (0, $42omo.useLayoutEffect)(()=>{
        markIframeLoadMetrics('lazy-load-end');
        markIframeLoadMetrics('common-load-start');
    }, [
        markIframeLoadMetrics
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $I1nNR.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $gt5FF.default),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cGc86.UniqueKeyProvider), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
                fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $elkSx.PageNotFoundEmptyState), {}),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $f3c4af92b1079227$export$767e3006bdbb424a), {
                    ...props
                })
            })
        })
    });
};
module.exports["ViewPage"] = $d51843cacb6b0e00$export$767e3006bdbb424a;

});

parcelRegister("aiCKw", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");








var $7pThu = parcelRequire("7pThu");


var $9tQM5 = parcelRequire("9tQM5");

var $kFwgS = parcelRequire("kFwgS");


var $1oYQ9 = parcelRequire("1oYQ9");


var $cezNv = parcelRequire("cezNv");

const $7677bd876355e476$var$IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED = 'auto_closed';
const $7677bd876355e476$export$1fea75498367c4ac = (props)=>{
    const { allowedFeatures: allowedFeatures } = props;
    const contentConfiguration = (0, $42omo.useMemo)(()=>{
        const isTemplateBrowserEnabled = (0, $cezNv.isInEditorTemplatesPanelEnabled)(allowedFeatures);
        const queryParams = isTemplateBrowserEnabled ? {
            inEditorTemplatesPanel: $7677bd876355e476$var$IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED
        } : undefined;
        return {
            experiences: {
                experience: (0, $7pThu.ExperienceNames).EDIT_PAGE,
                ccExperience: (0, $7pThu.ExperienceNames).CC_EDIT_PAGE_EMBED
            },
            queryParams: queryParams
        };
    }, [
        allowedFeatures
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1oYQ9.Content), {
        ...props,
        contentType: (0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE,
        mode: (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE,
        contentConfiguration: contentConfiguration
    });
};



var $elkSx = parcelRequire("elkSx");


var $I1nNR = parcelRequire("I1nNR");


var $gt5FF = parcelRequire("gt5FF");


var $kudeD = parcelRequire("kudeD");


var $cGc86 = parcelRequire("cGc86");

const $9310c72c080a483b$export$1fea75498367c4ac = (props)=>{
    const { markIframeLoadMetrics: markIframeLoadMetrics } = (0, $kudeD.usePerformanceMetrics)();
    (0, $42omo.useLayoutEffect)(()=>{
        markIframeLoadMetrics('lazy-load-end');
        markIframeLoadMetrics('common-load-start');
    }, [
        markIframeLoadMetrics
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $I1nNR.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $gt5FF.default),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cGc86.UniqueKeyProvider), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
                fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $elkSx.PageNotFoundEmptyState), {}),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7677bd876355e476$export$1fea75498367c4ac), {
                    ...props
                })
            })
        })
    });
};
module.exports["EditPage"] = $9310c72c080a483b$export$1fea75498367c4ac;

});

parcelRegister("4vCA9", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $a879f42abb981ca6$var$placeholderShimmer = null;
const $a879f42abb981ca6$var$appearanceValues = {
    darkGray: {
        animation: "var(--ds-background-accent-gray-subtle, #8C8F97)"
    },
    gray: {
        animation: "var(--ds-skeleton, #0515240F)"
    },
    blue: {
        animation: "var(--ds-background-information-hovered, #CFE1FD)"
    }
};
const $a879f42abb981ca6$var$spanSkeletonStyles = null;
const $a879f42abb981ca6$var$spanSkeletonBackgroundStyleMap = {
    gray: "_bfhkysee",
    blue: "_bfhk1s93",
    darkGray: "_bfhk7qp0"
};
const $a879f42abb981ca6$export$85d5658002cae6ce = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$a879f42abb981ca6$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $gMc0m.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $a879f42abb981ca6$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
const $a879f42abb981ca6$export$8f31e4c4a37b8e9c = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$a879f42abb981ca6$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $gMc0m.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $a879f42abb981ca6$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
var $a879f42abb981ca6$export$2e2bcd8739ae039 = $a879f42abb981ca6$export$8f31e4c4a37b8e9c;
module.exports["SpanSkeleton"] = $a879f42abb981ca6$export$85d5658002cae6ce;
module.exports["Skeleton"] = $a879f42abb981ca6$export$8f31e4c4a37b8e9c;

});

parcelRegister("eqpYq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");


var $gtD4K = parcelRequire("gtD4K");


var $fBMbo = parcelRequire("fBMbo");


var $lAFHW = parcelRequire("lAFHW");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");





var $afp1H = parcelRequire("afp1H");


var $6KV13 = parcelRequire("6KV13");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $e6pbP = parcelRequire("e6pbP");


var $dh538 = parcelRequire("dh538");

/* ulist.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $bd7359d17942e8a2$var$listStyles = null;
const $bd7359d17942e8a2$var$UList = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul", {
        ...props,
        className: (0, $gMc0m.default)([
            "_19bvv47k _bozgv47k"
        ])
    }, children);
var $bd7359d17942e8a2$export$2e2bcd8739ae039 = $bd7359d17942e8a2$var$UList;


const $9338d7fc86a81ff5$var$baseStyle = null;
const $9338d7fc86a81ff5$var$textStyleNew = null;
const $9338d7fc86a81ff5$var$textStyleOld = null; /**
                            * A component to render a response from AI in markdown text.
                            * @internal
                            * @param {AISummaryProps} AISummaryProps
                            */ 
const $9338d7fc86a81ff5$var$AISummary = ({ content: content = '', className: className, testId: testId = 'ai-summary', minHeight: minHeight = 0 })=>{
    if (!content && minHeight === 0) return null;
    return /*#__PURE__*/ $42omo.createElement((0, $e6pbP.default), {
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_11c8wadc _slp31hna _1nmz1hna _o5724jg8 _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            (0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch') ? "_syazi7uo" : "_syazazsu",
            className
        ]),
        children: content,
        options: {
            forceWrapper: true,
            overrides: {
                ul: (0, $bd7359d17942e8a2$export$2e2bcd8739ae039)
            }
        },
        style: {
            minHeight: minHeight
        }
    });
};
var $9338d7fc86a81ff5$export$2e2bcd8739ae039 = $9338d7fc86a81ff5$var$AISummary;


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $8tSmd = parcelRequire("8tSmd");


var $2Nwuj = parcelRequire("2Nwuj");









const $ba3699740c57099b$var$styles = {
    aiFooterWrapper: "_ca0q1b66"
};
const $ba3699740c57099b$var$AIFooter = ()=>/*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.050",
        xcss: $ba3699740c57099b$var$styles.aiFooterWrapper
    }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tSmd))), {
        label: "",
        color: "var(--ds-text-subtle, #505258)",
        size: "small"
    }), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        size: "small"
    }, /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
        href: "https://www.atlassian.com/trust/atlassian-intelligence",
        appearance: "subtle",
        target: "_blank"
    }, /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), (0, $afp1H.messages).ai_disclaimer))));
var $ba3699740c57099b$export$2e2bcd8739ae039 = $ba3699740c57099b$var$AIFooter;



var $6bBFP = parcelRequire("6bBFP");


var $2R1C4 = parcelRequire("2R1C4");





var $kKODE = parcelRequire("kKODE");

const $f7f9db9fca31c767$var$AIEventSummaryViewed = ({ fromCache: fromCache = null })=>{
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        fireEvent('ui.summary.viewed', {
            fromCache: fromCache
        });
        if (fromCache) fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 1,
            userGeneratedAI: 0
        });
    }, [
        fireEvent,
        fromCache
    ]);
    return null;
};
var $f7f9db9fca31c767$export$2e2bcd8739ae039 = $f7f9db9fca31c767$var$AIEventSummaryViewed;


/* ellipses.tsx generated by @compiled/babel-plugin v0.36.1 */ // Copied from platform/packages/ai-mate/rovo-platform-ui-components/src/ui/primitives/ellipses-animation/EllipsesAnimation.tsx






const $2a4b4233e8981c08$var$animation = null;
const $2a4b4233e8981c08$var$animation1 = null;
const $2a4b4233e8981c08$var$animation2 = null;
const $2a4b4233e8981c08$var$dot1 = null;
const $2a4b4233e8981c08$var$dot2 = null;
const $2a4b4233e8981c08$var$dot3 = null;
const $2a4b4233e8981c08$var$animatedOpacity = null;
const $2a4b4233e8981c08$export$c0e6915bcce7d1d0 = ({ isAnimated: isAnimated = true })=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: "10",
        height: "2",
        viewBox: "0 0 10 2",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $42omo.createElement("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            isAnimated && "",
            isAnimated && "_y44v1gpk",
            isAnimated && $2a4b4233e8981c08$var$animatedOpacity
        ]),
        d: "M0.0800781 2V0.414062H1.67969V2H0.0800781Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ $42omo.createElement("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            isAnimated && "",
            isAnimated && "_y44v18gg",
            isAnimated && $2a4b4233e8981c08$var$animatedOpacity
        ]),
        d: "M3.83984 2V0.414062H5.43945V2H3.83984Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ $42omo.createElement("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            isAnimated && "",
            isAnimated && "_y44voqx9",
            isAnimated && $2a4b4233e8981c08$var$animatedOpacity
        ]),
        d: "M7.59961 2V0.414062H9.19922V2H7.59961Z",
        fill: "#FCA700"
    }));
};


const $6916bf0a97d23595$var$styles = null;
const $6916bf0a97d23595$var$newStyles = {
    iconWrapper: "_19bv1b66 _u5f3utpp _1e0c1txw _4cvr1h6o",
    placeholderWrapper: "_1e0c1txw _4cvr1h6o",
    summaryWrapper: "_ca0q1b66 _1e0c1txw",
    ellipsesContainer: "_19bv1b66"
};
const $6916bf0a97d23595$var$AISummaryBlockResolvedView = (props)=>{
    (0, $fBMbo.di)((0, $6KV13.default), (0, $9338d7fc86a81ff5$export$2e2bcd8739ae039));
    const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
    const { state: { content: content, status: status } } = (0, $6KV13.default)(url);
    const showAISummary = status === 'done' || // We want to display the AI Summary component only when there is content available during the loading process.
    status === 'loading' && !!content;
    const isSummarisedOnMountRef = (0, $42omo.useRef)(status === 'done');
    const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    if (!showAISummary) return /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, placeholder);
    return /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        ...props,
        direction: (0, $5TXU5.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl"
        ])
    }, status === 'done' && /*#__PURE__*/ $42omo.createElement((0, $f7f9db9fca31c767$export$2e2bcd8739ae039), {
        fromCache: isSummarisedOnMountRef.current
    }), /*#__PURE__*/ $42omo.createElement((0, $6bBFP.default), {
        minHeight: minHeight,
        show: showAISummary,
        showTransition: !isSummarisedOnMountRef.current
    }, /*#__PURE__*/ $42omo.createElement((0, $9338d7fc86a81ff5$export$2e2bcd8739ae039), {
        testId: `${testId}-ai-summary`,
        minHeight: minHeight,
        content: content
    })));
};
const $6916bf0a97d23595$export$3570243fee4941c9 = (props)=>{
    (0, $fBMbo.di)((0, $6KV13.default), (0, $9338d7fc86a81ff5$export$2e2bcd8739ae039));
    const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, url: url } = props;
    const { state: { content: content, status: status } } = (0, $6KV13.default)(url);
    const showAISummary = status === 'done' || // We want to display the AI Summary component only when there is content available during the loading process.
    status === 'loading' && !!content;
    const isSummarisedOnMountRef = (0, $42omo.useRef)(status === 'done');
    const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    if (!showAISummary) return /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        xcss: $6916bf0a97d23595$var$newStyles.placeholderWrapper
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $6916bf0a97d23595$var$newStyles.iconWrapper
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $lAFHW.RovoIcon), {
        shouldUseHexLogo: true,
        size: 'xxsmall'
    })), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        size: "small",
        color: "color.text"
    }, /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), (0, $afp1H.messages).rovo_summary_loading)), /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $6916bf0a97d23595$var$newStyles.ellipsesContainer
    }, /*#__PURE__*/ $42omo.createElement((0, $2a4b4233e8981c08$export$c0e6915bcce7d1d0), {
        isAnimated: true
    })));
    return /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        ...props,
        direction: (0, $5TXU5.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        xcss: $6916bf0a97d23595$var$newStyles.summaryWrapper
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $6916bf0a97d23595$var$newStyles.iconWrapper
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $lAFHW.RovoIcon), {
        shouldUseHexLogo: true,
        size: 'xxsmall'
    })), status === 'done' && /*#__PURE__*/ $42omo.createElement((0, $f7f9db9fca31c767$export$2e2bcd8739ae039), {
        fromCache: isSummarisedOnMountRef.current
    }), /*#__PURE__*/ $42omo.createElement((0, $6bBFP.default), {
        minHeight: minHeight,
        show: showAISummary,
        showTransition: !isSummarisedOnMountRef.current
    }, /*#__PURE__*/ $42omo.createElement((0, $9338d7fc86a81ff5$export$2e2bcd8739ae039), {
        testId: `${testId}-ai-summary`,
        minHeight: minHeight,
        content: content
    }), status === 'done' && /*#__PURE__*/ $42omo.createElement((0, $ba3699740c57099b$export$2e2bcd8739ae039), null))));
};
var $6916bf0a97d23595$export$2e2bcd8739ae039 = $6916bf0a97d23595$var$AISummaryBlockResolvedView;


/**
 * Represents an AISummaryBlock, designed to summarising link resource
 * content using AI.
 * @public
 * @param {AISummaryBlockProps} AISummaryBlock
 * @see Block
 */ const $3d73a30329f2f2d2$var$AISummaryBlock = ({ testId: testId = 'smart-ai-summary-block', ...props })=>{
    const cardContext = (0, $fUfR2.useFlexibleCardContext)();
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5TXU5.InternalActionName).AISummaryAction];
    if (cardContext?.status !== (0, $5TXU5.SmartLinkStatus).Resolved) return null;
    if (!actionData?.url) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6916bf0a97d23595$export$2e2bcd8739ae039), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId,
        url: actionData.url
    });
};
const $3d73a30329f2f2d2$export$f1cbf411a572c4a5 = ({ testId: testId = 'smart-ai-summary-block', url: url, ...props })=>{
    const cardContext = (0, $fUfR2.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $5TXU5.SmartLinkStatus).Resolved) return null;
    if (!url) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6916bf0a97d23595$export$3570243fee4941c9), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId,
        url: url
    });
};
var $3d73a30329f2f2d2$export$2e2bcd8739ae039 = $3d73a30329f2f2d2$var$AISummaryBlock;
module.exports["RovoSummaryBlock"] = $3d73a30329f2f2d2$export$f1cbf411a572c4a5;
module.exports["default"] = $3d73a30329f2f2d2$export$2e2bcd8739ae039;

});

parcelRegister("MlN47", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");











var $2ZgNz = parcelRequire("2ZgNz");


var $2R1C4 = parcelRequire("2R1C4");





var $gtD4K = parcelRequire("gtD4K");


var $fBMbo = parcelRequire("fBMbo");


var $3Mg7y = parcelRequire("3Mg7y");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $3gadb = parcelRequire("3gadb");


var $afp1H = parcelRequire("afp1H");


var $6KV13 = parcelRequire("6KV13");





var $eXmBZ = parcelRequire("eXmBZ");

const $b60461a0f2dc3b3a$export$2957fc44b3d2481 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
        color: props.color || 'currentColor',
        ...props
    });


const $b7fbd07145f71993$export$175228cc2c92b3b6 = ({ testId: testId, url: url })=>{
    (0, $fBMbo.di)((0, $6KV13.default));
    const { state: { status: status } } = (0, $6KV13.default)(url);
    if (status !== 'done') return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        testId: testId,
        alignInline: "end",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $afp1H.messages).ai_summarized_info_short),
        position: "bottom"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b60461a0f2dc3b3a$export$2957fc44b3d2481), {
            label: "Information",
            color: "var(--ds-icon-subtle, #505258)"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))), {
        label: "AI",
        color: "var(--ds-icon-subtle, #505258)"
    }));
};


const $92f251934aee2626$var$AIFooterBlockResolvedView = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5TXU5.InternalActionName).AISummaryAction];
    const { testId: testId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2R1C4.default), {
        ...props,
        testId: `${testId}-resolved-view`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2ZgNz.default), {
        appearance: "subtle",
        testId: `${testId}-provider`
    }), actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b7fbd07145f71993$export$175228cc2c92b3b6), {
        ...actionData,
        testId: `${testId}-ai-metadata`
    }) : null);
};
var $92f251934aee2626$export$2e2bcd8739ae039 = $92f251934aee2626$var$AIFooterBlockResolvedView;


/**
 * Represents a AIFooterBlock, designed to show provider metadata in
 * addition to AI tooltip icons if AI is enabled
 * @param {AIFooterBlockProps} AIFooterBlockProps
 * @see Block
 */ const $38aa18aa215cb0bb$var$AIFooterBlock = ({ testId: testId = 'smart-ai-footer-block', ...props })=>{
    const cardContext = (0, $fUfR2.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $5TXU5.SmartLinkStatus).Resolved) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $92f251934aee2626$export$2e2bcd8739ae039), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId
    });
};
var $38aa18aa215cb0bb$export$2e2bcd8739ae039 = $38aa18aa215cb0bb$var$AIFooterBlock;
module.exports["default"] = $38aa18aa215cb0bb$export$2e2bcd8739ae039;

});

parcelRegister("f0wtW", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $fBMbo = parcelRequire("fBMbo");


var $dh538 = parcelRequire("dh538");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $jlQ9A = parcelRequire("jlQ9A");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $a3fRD = parcelRequire("a3fRD");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $6bBFP = parcelRequire("6bBFP");

const $dfe1275874cc34dc$var$styles = {
    containerStyles: "_kkk2n7od _2rko12b0 _1rjc12x7 _18zru2gc _19pku2gc _2hwxu2gc _otyrze3t _18u0u2gc _1bsb1osq _fiawglyw",
    errorContentStyles: "_bozgv77o",
    titleStyles: "_11c8rymc _syazazsu"
};
const $dfe1275874cc34dc$var$getIcon = (appearance)=>{
    switch(appearance){
        case 'error':
            return /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "compact",
                label: "Error",
                testId: "action-error-icon",
                size: "small"
            });
        default:
            return null;
    }
};
const $dfe1275874cc34dc$export$2d2b754ac238f9aa = ({ message: message, testId: testId })=>{
    if (!message) return null;
    return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        backgroundColor: message.appearance === 'error' ? 'color.background.danger' : undefined,
        testId: `${testId}-footer`,
        style: {
            width: `calc(100% - var(--container-padding-left) - var(--container-padding-right))`
        },
        xcss: $dfe1275874cc34dc$var$styles.containerStyles
    }, /*#__PURE__*/ $42omo.createElement((0, $6bBFP.default), {
        isFadeIn: true,
        show: true,
        showTransition: true
    }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        alignBlock: "start",
        grow: "fill",
        space: "space.075",
        xcss: $dfe1275874cc34dc$var$styles.errorContentStyles
    }, message.icon || $dfe1275874cc34dc$var$getIcon(message.appearance), /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $dfe1275874cc34dc$var$styles.titleStyles
    }, message.title))));
};


const $018f38f6aa2eb81b$var$ignoreContainerPaddingStyles = null;
const $018f38f6aa2eb81b$var$DEFAULT_SORT_ORDER = [
    'PreviewAction',
    'CopyLinkAction',
    'AISummaryAction'
];
const $018f38f6aa2eb81b$var$sort = (a, b)=>{
    let idxA = $018f38f6aa2eb81b$var$DEFAULT_SORT_ORDER.indexOf(a);
    let idxB = $018f38f6aa2eb81b$var$DEFAULT_SORT_ORDER.indexOf(b);
    if (idxA === -1) idxA = $018f38f6aa2eb81b$var$DEFAULT_SORT_ORDER.length;
    if (idxB === -1) idxB = $018f38f6aa2eb81b$var$DEFAULT_SORT_ORDER.length;
    return idxA - idxB;
}; /**
    * Get container padding based on smart link size
    * To replace container/index.tsx getPadding() with space token for primitives
    */ 
const $018f38f6aa2eb81b$export$1af10e3728e3a644 = (size)=>{
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $5TXU5.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $5TXU5.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $018f38f6aa2eb81b$var$ActionBlock = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, className: className, testId: testId = 'smart-block-action', hideAISummaryAction: hideAISummaryAction })=>{
    (0, $fBMbo.di)((0, $dfe1275874cc34dc$export$2d2b754ac238f9aa));
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    const [message, setMessage] = (0, $42omo.useState)();
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const onLoadingChange = (0, $42omo.useCallback)((isLoading)=>{
        setIsLoading(isLoading);
    }, [
        setIsLoading
    ]);
    const padding = !ui?.hidePadding ? $018f38f6aa2eb81b$export$1af10e3728e3a644(ui?.size || (0, $5TXU5.SmartLinkSize).Medium) : undefined;
    const onClick = (0, $42omo.useCallback)((name)=>{
        setMessage(undefined);
        onClickCallback?.(name);
    }, [
        onClickCallback
    ]);
    const onError = (0, $42omo.useCallback)((error)=>{
        setMessage(error);
    }, []);
    const actions = (0, $42omo.useMemo)(()=>{
        if (!context?.actions) return;
        let arr = Object.keys(context.actions);
        if (hideAISummaryAction && (0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch')) arr = arr.filter((name)=>name !== 'AISummaryAction');
        arr.sort($018f38f6aa2eb81b$var$sort);
        return arr.map((name)=>{
            const Action = name in $jlQ9A ? $jlQ9A[name] : undefined;
            return Action ? /*#__PURE__*/ $42omo.createElement(Action, {
                as: "stack-item",
                spaceInline: spaceInline,
                key: name,
                onClick: ()=>onClick(name),
                onError: onError,
                onLoadingChange: onLoadingChange,
                size: size || ui?.size,
                style: padding && {
                    paddingInline: padding
                },
                hideTooltip: isLoading
            }) : null;
        });
    }, [
        context?.actions,
        spaceInline,
        onError,
        onLoadingChange,
        size,
        ui?.size,
        padding,
        isLoading,
        onClick,
        hideAISummaryAction
    ]);
    return actions ? /*#__PURE__*/ $42omo.createElement("div", {
        ref: blockRef,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _vchhusvi _16jlkb7n _1bsb129b _18u01ivi _2hwxc10g",
            className
        ])
    }, actions, /*#__PURE__*/ $42omo.createElement((0, $dfe1275874cc34dc$export$2d2b754ac238f9aa), {
        message: message,
        testId: testId
    })) : null;
};
var $018f38f6aa2eb81b$export$2e2bcd8739ae039 = $018f38f6aa2eb81b$var$ActionBlock;
module.exports["default"] = $018f38f6aa2eb81b$export$2e2bcd8739ae039;

});

parcelRegister("b16ZX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $5b6166ad5dd66d6f$var$MAX_TEAM_MEMBER_LIMIT = 50;
const $5b6166ad5dd66d6f$var$TeamMemberCountElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    if (!context?.teamMemberCount) return null;
    const count = context?.teamMemberCount && context?.teamMemberCount > $5b6166ad5dd66d6f$var$MAX_TEAM_MEMBER_LIMIT ? `${$5b6166ad5dd66d6f$var$MAX_TEAM_MEMBER_LIMIT}+` : context?.teamMemberCount?.toString();
    const data = count ? (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages).team_members_count, count) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).TeamMemberCount
    }) : null;
};
var $5b6166ad5dd66d6f$export$2e2bcd8739ae039 = $5b6166ad5dd66d6f$var$TeamMemberCountElement;
module.exports["default"] = $5b6166ad5dd66d6f$export$2e2bcd8739ae039;

});

parcelRegister("bG0uM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $abfd64423c5a2d62$var$UserAttributesElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const renderUserAttributes = (userAttributes)=>{
        if (!userAttributes) return null;
        const attributeKeys = [
            'pronouns',
            'role',
            'department',
            'location'
        ];
        const attributes = [];
        attributeKeys.forEach((key)=>{
            if (userAttributes[key]) {
                const data = (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages).user_attributes, userAttributes[key]);
                if (data) attributes.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
                    key: key,
                    ...data,
                    testId: `smart-element-text-${key}`,
                    ...props,
                    name: (0, $5TXU5.ElementName).UserAttributes
                }));
            }
        });
        return attributes.length > 0 ? attributes : null;
    };
    const elements = context ? renderUserAttributes(context.userAttributes) : null;
    return elements ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, elements) : null;
};
var $abfd64423c5a2d62$export$2e2bcd8739ae039 = $abfd64423c5a2d62$var$UserAttributesElement;
module.exports["default"] = $abfd64423c5a2d62$export$2e2bcd8739ae039;

});

parcelRegister("8OVDp", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $34076fdcb2e684ce$var$HostNameElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleCardContext)();
    const hostName = context?.data?.hostName;
    return hostName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
        content: hostName,
        ...props,
        name: (0, $5TXU5.ElementName).HostName
    }) : null;
};
var $34076fdcb2e684ce$export$2e2bcd8739ae039 = $34076fdcb2e684ce$var$HostNameElement;
module.exports["default"] = $34076fdcb2e684ce$export$2e2bcd8739ae039;

});

parcelRegister("e4NSt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $97e7d5657b08cc85$var$AppliedToComponentsCountElement = (props)=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const context = (0, $fUfR2.useFlexibleUiContext)();
    if (// Check for null and undefined, render if it's 0.
    context?.appliedToComponentsCount === null || context?.appliedToComponentsCount === undefined) return null;
    const label = formatMessage((0, $afp1H.messages).compass_applied_components_count, {
        numberOfComponents: context.appliedToComponentsCount
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).Component,
        label: label,
        ...props
    });
};
var $97e7d5657b08cc85$export$2e2bcd8739ae039 = $97e7d5657b08cc85$var$AppliedToComponentsCountElement;
module.exports["default"] = $97e7d5657b08cc85$export$2e2bcd8739ae039;

});

parcelRegister("4SEPT", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $1dfde747276dc37b$var$baseStyle = null;
const $1dfde747276dc37b$var$isMessageDescriptor = (x)=>!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(x);
const $1dfde747276dc37b$var$fontOverrideStyleMap = {
    'font.body': "_11c8fhey",
    'font.body.large': "_11c81d4k",
    'font.body.small': "_11c8wadc",
    'font.body.UNSAFE_small': "_11c8rymc"
};
const $1dfde747276dc37b$var$maxLinesCss = null;
const $1dfde747276dc37b$var$CustomElementByAccessType = ({ className: className, testId: testId = 'custom-by-access-type-element', ...props })=>{
    const context = (0, $fUfR2.useFlexibleCardContext)();
    const accessType = context?.data?.meta?.accessType;
    const contentForAccessType = props[accessType] ?? props.fallback;
    if (!contentForAccessType) return null;
    const values = context?.data?.actions?.[(0, $5TXU5.InternalActionName).UnresolvedAction]?.values;
    if ($1dfde747276dc37b$var$isMessageDescriptor(contentForAccessType)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
        ...props,
        message: {
            descriptor: contentForAccessType,
            values: values
        },
        className: className,
        testId: testId,
        hideFormat: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        style: {
            color: props.color
        },
        "data-separator": true,
        "data-smart-element-text": true,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_11c8wadc _1reo15vq _18m915vq _syazazsu _o5724jg8 _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _sudp1e54",
            props.fontSize !== undefined && $1dfde747276dc37b$var$fontOverrideStyleMap[props.fontSize],
            "_1yyjkb7n _102k1j6v",
            className
        ])
    }, contentForAccessType);
};
var $1dfde747276dc37b$export$2e2bcd8739ae039 = $1dfde747276dc37b$var$CustomElementByAccessType;
module.exports["default"] = $1dfde747276dc37b$export$2e2bcd8739ae039;

});

parcelRegister("lOpcG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fUfR2 = parcelRequire("fUfR2");

const $0ea0c23a597f730f$var$CustomByStatusElement = ({ className: className, testId: testId = 'custom-by-status-element', ...props })=>{
    const context = (0, $fUfR2.useFlexibleCardContext)();
    const status = context?.status;
    if (!status) return null;
    const component = props[status];
    if (!component) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-separator": true,
        "data-smart-element": "custom-element",
        "data-smart-element-text": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className
    }, component);
};
var $0ea0c23a597f730f$export$2e2bcd8739ae039 = $0ea0c23a597f730f$var$CustomByStatusElement;
module.exports["default"] = $0ea0c23a597f730f$export$2e2bcd8739ae039;

});

parcelRegister("hJgLA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $4wH3g = parcelRequire("4wH3g");


var $5TXU5 = parcelRequire("5TXU5");

const $ecdac2a9be051ad6$export$9d642f65a919fb93 = {
    [(0, $5TXU5.SmartLinkSize).Small]: 'none',
    [(0, $5TXU5.SmartLinkSize).Medium]: 'compact',
    [(0, $5TXU5.SmartLinkSize).Large]: 'compact',
    [(0, $5TXU5.SmartLinkSize).XLarge]: 'default'
};
const $ecdac2a9be051ad6$export$f1aa79f2218fb713 = (message)=>{
    if (message) {
        const { descriptor: descriptor, values: values } = message;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...descriptor,
            values: values
        });
    }
};
const $ecdac2a9be051ad6$export$66ecb50a9dd1768 = (intl, message, context)=>{
    const { formatMessage: formatMessage } = intl;
    return message ? formatMessage(message, {
        context: context
    }) : '';
};
const $ecdac2a9be051ad6$export$fb10bc5609c6347e = (size)=>{
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
        case (0, $5TXU5.SmartLinkSize).Large:
            return "var(--ds-space-300, 24px)";
        case (0, $5TXU5.SmartLinkSize).Medium:
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return "var(--ds-space-200, 16px)";
    }
};
const $ecdac2a9be051ad6$export$6dc831e1a0a7a851 = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "tmnOu",
        name: "importIcon",
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $ecdac2a9be051ad6$export$a681bd062fee88a5 = (size)=>{
    // The maximum line height based on all elements in specific size.
    // These heights belongs to AvatarGroup.
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
        case (0, $5TXU5.SmartLinkSize).Large:
            return 1.75;
        case (0, $5TXU5.SmartLinkSize).Medium:
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return 1.5;
    }
};
const $ecdac2a9be051ad6$export$c2293adf1794c09 = (value, defaultValue, max, min)=>{
    if (value > max) return defaultValue;
    if (value < min) return min;
    return value;
};
const $ecdac2a9be051ad6$export$475c391af8171fec = (size)=>{
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
            return 'space.250';
        case (0, $5TXU5.SmartLinkSize).Large:
            return 'space.200';
        case (0, $5TXU5.SmartLinkSize).Medium:
            return 'space.100';
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return 'space.050';
    }
};
const $ecdac2a9be051ad6$export$619e376a425cb759 = (str)=>{
    return str.search(/\s/) >= 0;
};
module.exports["sizeToButtonSpacing"] = $ecdac2a9be051ad6$export$9d642f65a919fb93;
module.exports["getFormattedMessage"] = $ecdac2a9be051ad6$export$f1aa79f2218fb713;
module.exports["getFormattedMessageAsString"] = $ecdac2a9be051ad6$export$66ecb50a9dd1768;
module.exports["getIconWidth"] = $ecdac2a9be051ad6$export$fb10bc5609c6347e;
module.exports["importIcon"] = $ecdac2a9be051ad6$export$6dc831e1a0a7a851;
module.exports["getMaxLines"] = $ecdac2a9be051ad6$export$c2293adf1794c09;
module.exports["getPrimitivesInlineSpaceBySize"] = $ecdac2a9be051ad6$export$475c391af8171fec;
module.exports["hasWhiteSpace"] = $ecdac2a9be051ad6$export$619e376a425cb759;

});

parcelRegister("jLXEH", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $hmuev = parcelRequire("hmuev");


var $afp1H = parcelRequire("afp1H");


var $6FZ6a = parcelRequire("6FZ6a");

const $f415990ae4e7261e$var$DeleteAction = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $afp1H.messages).delete),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Delete"
        }),
        testId: "smart-action-delete-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $afp1H.messages).delete),
        ...props
    });
var $f415990ae4e7261e$export$2e2bcd8739ae039 = $f415990ae4e7261e$var$DeleteAction;
module.exports["default"] = $f415990ae4e7261e$export$2e2bcd8739ae039;

});

parcelRegister("dVBHR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $1Zr9M = parcelRequire("1Zr9M");


var $afp1H = parcelRequire("afp1H");


var $6FZ6a = parcelRequire("6FZ6a");

const $a74c68e5cf0852d5$var$EditAction = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $afp1H.messages).edit),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Edit"
        }),
        testId: "smart-action-edit-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $afp1H.messages).edit),
        ...props
    });
var $a74c68e5cf0852d5$export$2e2bcd8739ae039 = $a74c68e5cf0852d5$var$EditAction;
module.exports["default"] = $a74c68e5cf0852d5$export$2e2bcd8739ae039;

});

parcelRegister("fl0WE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");





var $fBMbo = parcelRequire("fBMbo");


var $6KV13 = parcelRequire("6KV13");





var $gtD4K = parcelRequire("gtD4K");


var $3Mg7y = parcelRequire("3Mg7y");


var $kKODE = parcelRequire("kKODE");


var $afp1H = parcelRequire("afp1H");


var $6FZ6a = parcelRequire("6FZ6a");








var $kbh18 = parcelRequire("kbh18");







const $9dd168d53d6086c0$var$AIEventErrorViewed = ({ reason: reason })=>{
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        fireEvent('ui.error.viewed.aiSummary', {
            reason: reason
        });
    }, [
        fireEvent,
        reason
    ]);
    return null;
};
var $9dd168d53d6086c0$export$2e2bcd8739ae039 = $9dd168d53d6086c0$var$AIEventErrorViewed;






var $2Nwuj = parcelRequire("2Nwuj");




const $287ebec1fdd40e02$var$AILearnMoreAnchor = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        href: (0, $5TXU5.CONTENT_URL_AI),
        target: "_blank",
        rel: "noopener noreferrer",
        ...props
    }, children);
var $287ebec1fdd40e02$export$2e2bcd8739ae039 = $287ebec1fdd40e02$var$AILearnMoreAnchor;


const $b750d65dda1a4c8d$export$82f46aa4e6535a45 = (error)=>{
    const { message: message, url: url } = (0, $kbh18.getAISummaryErrorMessage)(error);
    return {
        appearance: 'error',
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9dd168d53d6086c0$export$2e2bcd8739ae039), {
            reason: error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...message,
            values: {
                a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $287ebec1fdd40e02$export$2e2bcd8739ae039), {
                        href: url
                    }, chunks)
            }
        }))
    };
};


function $276cdae1a40ee2d2$export$75a19de44af58722({ onClick: onClickCallback, onError: onErrorCallback, testId: testId, status: status, summariseUrl: summariseUrl, ...props }) {
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const onCompleted = (0, $42omo.useCallback)((state)=>{
        if (state?.status === 'error') onErrorCallback?.((0, $b750d65dda1a4c8d$export$82f46aa4e6535a45)(state.error));
    }, [
        onErrorCallback
    ]);
    const handleActionClick = (0, $42omo.useCallback)(()=>{
        fireEvent('ui.button.clicked.aiSummary', {});
        fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1
        });
        summariseUrl()?.then(onCompleted, onCompleted);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        onCompleted,
        summariseUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $afp1H.messages).ai_summary_action),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Summarise with AI"
        }),
        onClick: handleActionClick,
        testId: `${testId}-summarise-action`,
        isLoading: status === 'loading',
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $afp1H.messages).ai_summary_action_description),
        ...props
    });
}









var $2MuFw = parcelRequire("2MuFw");










function $8b66580330514e65$export$cfa1d3eed9a61059({ url: url, onClick: onClickCallback, testId: testId, content: content, ...props }) {
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $42omo.useState)((0, $afp1H.messages).copy_summary_action_description);
    const handleCopySummaryClick = (0, $42omo.useCallback)(async ()=>{
        fireEvent('ui.button.clicked.copySummary', {});
        await navigator.clipboard.writeText(content ?? '');
        setTooltipMessage((0, $afp1H.messages).copied_summary_action_description);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        content
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $afp1H.messages).copy_summary_action),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Copy Summary"
        }),
        onClick: handleCopySummaryClick,
        testId: `${testId}-copy-summary-action`,
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), tooltipMessage),
        tooltipOnHide: ()=>setTooltipMessage((0, $afp1H.messages).copy_summary_action_description),
        ...props
    });
}


const $b80129153fa85400$export$8eed96bc6d982595 = (props)=>{
    (0, $fBMbo.di)((0, $6KV13.default));
    const { url: url, onLoadingChange: onLoadingChange, testId: testId = 'smart-action-ai-summary-action' } = props;
    const { state: { status: status, content: content }, summariseUrl: summariseUrl } = (0, $6KV13.default)(url);
    (0, $42omo.useEffect)(()=>{
        onLoadingChange?.(status === 'loading');
    }, [
        onLoadingChange,
        status
    ]);
    return status === 'done' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8b66580330514e65$export$cfa1d3eed9a61059), {
        ...props,
        testId: testId,
        content: content
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $276cdae1a40ee2d2$export$75a19de44af58722), {
        ...props,
        testId: testId,
        summariseUrl: summariseUrl,
        status: status
    });
};


const $773427e96b58aed9$var$AISummaryAction = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5TXU5.InternalActionName).AISummaryAction];
    return actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b80129153fa85400$export$8eed96bc6d982595), {
        ...actionData,
        ...props
    }) : null;
};
var $773427e96b58aed9$export$2e2bcd8739ae039 = $773427e96b58aed9$var$AISummaryAction;
module.exports["default"] = $773427e96b58aed9$export$2e2bcd8739ae039;

});

parcelRegister("loGLq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $fxBfz = parcelRequire("fxBfz");


var $iXCQx = parcelRequire("iXCQx");


var $kKODE = parcelRequire("kKODE");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $3eMTN = parcelRequire("3eMTN");


var $6FZ6a = parcelRequire("6FZ6a");




const $916427ca86a2c806$export$93e707b363eaf5c8 = (product, resourceType)=>{
    const modalContentMap = {
        confluence: {
            page: {
                modalTitle: (0, $afp1H.messages).automation_action_confluence_page_modal_title,
                modalDescription: (0, $afp1H.messages).automation_action_confluence_page_modal_description
            }
        }
    };
    return modalContentMap?.[product]?.[resourceType];
};



const $12d115b9ed847307$var$AutomationModal = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("guHsZ")));
const $12d115b9ed847307$var$AutomationAction = (props)=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const modal = (0, $3eMTN.useSmartLinkModal)();
    const { onClick: onClickCallback } = props;
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const automationActionData = context?.actions?.[(0, $5TXU5.ActionName).AutomationAction];
    const automationActionOnClick = (0, $42omo.useCallback)((automationActionData)=>{
        const { product: product, resourceType: resourceType, baseAutomationUrl: baseAutomationUrl, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, objectName: objectName } = automationActionData;
        fireEvent('ui.button.clicked.automationAction', {});
        const { modalTitle: modalTitle, modalDescription: modalDescription } = (0, $916427ca86a2c806$export$93e707b363eaf5c8)(product, resourceType) || {};
        const automationModalTitle = modalTitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), modalTitle) : undefined;
        const automationModalDescription = modalDescription ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...modalDescription,
            values: {
                name: objectName,
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                        as: "strong"
                    }, chunks),
                br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null)
            }
        }) : undefined;
        modal.open(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($12d115b9ed847307$var$AutomationModal, {
            baseAutomationUrl: baseAutomationUrl,
            objectAri: objectAri,
            siteAri: siteAri,
            canManageAutomation: canManageAutomation,
            analyticsSource: analyticsSource,
            modalTitle: automationModalTitle,
            modalDescription: automationModalDescription,
            onClose: ()=>modal.close()
        }));
        onClickCallback?.();
    }, [
        modal,
        onClickCallback,
        fireEvent
    ]);
    if (!automationActionData) return null;
    const automationActionTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $afp1H.messages).automation_action_title);
    const automationActionTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $afp1H.messages).automation_action_tooltip);
    const automationActionIconLabel = formatMessage((0, $afp1H.messages).automation_action_icon_label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        content: automationActionTitle,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fxBfz))), {
            spacing: "spacious",
            color: "currentColor",
            label: automationActionIconLabel
        }),
        testId: "smart-action-automation-action",
        tooltipMessage: automationActionTooltip,
        ...props,
        onClick: ()=>automationActionOnClick(automationActionData)
    }));
};
var $12d115b9ed847307$export$2e2bcd8739ae039 = $12d115b9ed847307$var$AutomationAction;
module.exports["default"] = $12d115b9ed847307$export$2e2bcd8739ae039;

});

parcelRegister("9Gqdx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $kKODE = parcelRequire("kKODE");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $3eMTN = parcelRequire("3eMTN");


var $6FZ6a = parcelRequire("6FZ6a");





var $kevJM = parcelRequire("kevJM");

const $c0b0240da4db21c1$var$RelatedLinksActionIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
        color: "currentColor",
        spacing: "spacious",
        label: "View related links..."
    });
var $c0b0240da4db21c1$export$2e2bcd8739ae039 = $c0b0240da4db21c1$var$RelatedLinksActionIcon;



const $c0c15e76cd694fe8$var$RelatedLinksModal = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fFwgP")));
const $c0c15e76cd694fe8$var$ViewRelatedLinksAction = ({ onClick: onClickCallback, ...props })=>{
    const modal = (0, $3eMTN.useSmartLinkModal)();
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const actionData = context?.actions?.ViewRelatedLinksAction;
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const onClick = (0, $42omo.useCallback)(()=>{
        const ari = actionData?.ari;
        if (ari) modal.open(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c0c15e76cd694fe8$var$RelatedLinksModal, {
            ari: ari,
            showModal: true,
            onClose: ()=>modal.close()
        }));
        fireEvent('ui.button.clicked.relatedLinks', {});
        onClickCallback?.();
    }, [
        actionData?.ari,
        fireEvent,
        modal,
        onClickCallback
    ]);
    return actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $afp1H.messages).related_links_view_related_links),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c0b0240da4db21c1$export$2e2bcd8739ae039), null),
        onClick: onClick,
        testId: "smart-action-view-related-links-action",
        ariaLabel: "View most recent pages or content types coming from or found on this link",
        ...props
    }) : null;
};
var $c0c15e76cd694fe8$export$2e2bcd8739ae039 = $c0c15e76cd694fe8$var$ViewRelatedLinksAction;
module.exports["default"] = $c0c15e76cd694fe8$export$2e2bcd8739ae039;

});

parcelRegister("j5Rp4", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $gdv5Z = parcelRequire("gdv5Z");

var $fVUfS = parcelRequire("fVUfS");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");

const $fd2ed04371a16208$var$styles = {
    button: "_1e0c1bgi",
    message: "_1rjcze3t _18zrze3t"
};
const $fd2ed04371a16208$var$validErrorStatuses = [
    (0, $5TXU5.SmartLinkStatus).Forbidden,
    (0, $5TXU5.SmartLinkStatus).Unauthorized
];
const $fd2ed04371a16208$var$validateErrorStatus = (status)=>{
    return status !== undefined && $fd2ed04371a16208$var$validErrorStatuses.includes(status);
};
const $fd2ed04371a16208$var$getMessageDescriptor = (status, accessType, props)=>{
    if (!$fd2ed04371a16208$var$validateErrorStatus(status)) return undefined;
    const message = props?.[status]?.[accessType ?? 'FALLBACK'];
    return message;
};
const $fd2ed04371a16208$var$CustomUnresolvedAction = ({ testId: testId = 'custom-unresolved-action', onlyShowIfAction: onlyShowIfAction = false, Container: Container, ...props })=>{
    const context = (0, $fUfR2.useFlexibleCardContext)();
    const data = context?.data?.actions?.[(0, $5TXU5.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const { status: status } = context;
    const accessType = context?.data?.meta?.accessType;
    const hasAction = onClick !== undefined;
    if (onlyShowIfAction && !hasAction) return null;
    const messageDescriptor = $fd2ed04371a16208$var$getMessageDescriptor(status, accessType, props) ?? descriptor;
    if (!messageDescriptor) return null;
    const message = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : undefined,
        xcss: $fd2ed04371a16208$var$styles.message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...messageDescriptor,
        values: values
    }));
    const component = hasAction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        onClick: data.onClick,
        style: {
            color: `inherit`,
            font: `inherit`,
            textAlign: `inherit`
        },
        xcss: $fd2ed04371a16208$var$styles.button
    }, message) : message;
    return Container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Container, null, component) : component;
};
var $fd2ed04371a16208$export$2e2bcd8739ae039 = $fd2ed04371a16208$var$CustomUnresolvedAction;
module.exports["default"] = $fd2ed04371a16208$export$2e2bcd8739ae039;

});

parcelRegister("2gWqY", function(module, exports) {
$parcel$export(module.exports, "AssignedTo", () => (parcelRequire("6cbph")).default);
$parcel$export(module.exports, "AssignedToGroup", () => (parcelRequire("4wLtQ")).default);
$parcel$export(module.exports, "AttachmentCount", () => (parcelRequire("iNImz")).default);
$parcel$export(module.exports, "AuthorGroup", () => (parcelRequire("LrBxG")).default);
$parcel$export(module.exports, "ChecklistProgress", () => (parcelRequire("bWsCB")).default);
$parcel$export(module.exports, "CollaboratorGroup", () => (parcelRequire("azCqP")).default);
$parcel$export(module.exports, "CommentCount", () => (parcelRequire("kexiH")).default);
$parcel$export(module.exports, "CreatedOn", () => (parcelRequire("e8W8a")).default);
$parcel$export(module.exports, "CreatedBy", () => (parcelRequire("3nul2")).default);
$parcel$export(module.exports, "DueOn", () => (parcelRequire("jKoRo")).default);
$parcel$export(module.exports, "LatestCommit", () => (parcelRequire("bmx11")).default);
$parcel$export(module.exports, "LinkIcon", () => (parcelRequire("jI5eg")).default);
$parcel$export(module.exports, "Location", () => (parcelRequire("8iOdP")).default);
$parcel$export(module.exports, "ModifiedBy", () => (parcelRequire("jW9GW")).default);
$parcel$export(module.exports, "ModifiedOn", () => (parcelRequire("1WqHG")).default);
$parcel$export(module.exports, "OwnedBy", () => (parcelRequire("ful5o")).default);
$parcel$export(module.exports, "OwnedByGroup", () => (parcelRequire("41AV3")).default);
$parcel$export(module.exports, "Preview", () => (parcelRequire("ikM9T")).default);
$parcel$export(module.exports, "Priority", () => (parcelRequire("8YJtM")).default);
$parcel$export(module.exports, "ProgrammingLanguage", () => (parcelRequire("6Ed8U")).default);
$parcel$export(module.exports, "Provider", () => (parcelRequire("2ZgNz")).default);
$parcel$export(module.exports, "ReactCount", () => (parcelRequire("iuEuh")).default);
$parcel$export(module.exports, "ReadTime", () => (parcelRequire("2GDee")).default);
$parcel$export(module.exports, "SentOn", () => (parcelRequire("h2WFd")).default);
$parcel$export(module.exports, "Snippet", () => (parcelRequire("49WiA")).default);
$parcel$export(module.exports, "SourceBranch", () => (parcelRequire("aGsNO")).default);
$parcel$export(module.exports, "State", () => (parcelRequire("emfmd")).default);
$parcel$export(module.exports, "SubscriberCount", () => (parcelRequire("a0Yyn")).default);
$parcel$export(module.exports, "SubTasksProgress", () => (parcelRequire("b8mrt")).default);
$parcel$export(module.exports, "StoryPoints", () => (parcelRequire("jpKes")).default);
$parcel$export(module.exports, "TargetBranch", () => (parcelRequire("hIbqn")).default);
$parcel$export(module.exports, "TeamMemberCount", () => (parcelRequire("b16ZX")).default);
$parcel$export(module.exports, "Title", () => (parcelRequire("gHW9t")).default);
$parcel$export(module.exports, "UserAttributes", () => (parcelRequire("bG0uM")).default);
$parcel$export(module.exports, "HostName", () => (parcelRequire("8OVDp")).default);
$parcel$export(module.exports, "ViewCount", () => (parcelRequire("zH0mb")).default);
$parcel$export(module.exports, "VoteCount", () => (parcelRequire("6LJqp")).default);
$parcel$export(module.exports, "AppliedToComponentsCount", () => (parcelRequire("e4NSt")).default);
$parcel$export(module.exports, "CustomByAccessTypeElement", () => (parcelRequire("4SEPT")).default);
$parcel$export(module.exports, "CustomByStatusElement", () => (parcelRequire("lOpcG")).default);

var $6cbph = parcelRequire("6cbph");


var $4wLtQ = parcelRequire("4wLtQ");


var $iNImz = parcelRequire("iNImz");


var $LrBxG = parcelRequire("LrBxG");


var $bWsCB = parcelRequire("bWsCB");


var $azCqP = parcelRequire("azCqP");


var $kexiH = parcelRequire("kexiH");


var $e8W8a = parcelRequire("e8W8a");


var $3nul2 = parcelRequire("3nul2");


var $jKoRo = parcelRequire("jKoRo");


var $bmx11 = parcelRequire("bmx11");


var $jI5eg = parcelRequire("jI5eg");


var $8iOdP = parcelRequire("8iOdP");


var $jW9GW = parcelRequire("jW9GW");


var $1WqHG = parcelRequire("1WqHG");


var $ful5o = parcelRequire("ful5o");


var $41AV3 = parcelRequire("41AV3");


var $ikM9T = parcelRequire("ikM9T");


var $8YJtM = parcelRequire("8YJtM");


var $6Ed8U = parcelRequire("6Ed8U");


var $2ZgNz = parcelRequire("2ZgNz");


var $iuEuh = parcelRequire("iuEuh");


var $2GDee = parcelRequire("2GDee");


var $h2WFd = parcelRequire("h2WFd");


var $49WiA = parcelRequire("49WiA");


var $aGsNO = parcelRequire("aGsNO");


var $emfmd = parcelRequire("emfmd");


var $a0Yyn = parcelRequire("a0Yyn");


var $b8mrt = parcelRequire("b8mrt");


var $jpKes = parcelRequire("jpKes");


var $hIbqn = parcelRequire("hIbqn");


var $b16ZX = parcelRequire("b16ZX");


var $gHW9t = parcelRequire("gHW9t");


var $bG0uM = parcelRequire("bG0uM");


var $8OVDp = parcelRequire("8OVDp");


var $zH0mb = parcelRequire("zH0mb");


var $6LJqp = parcelRequire("6LJqp");


var $e4NSt = parcelRequire("e4NSt");


var $4SEPT = parcelRequire("4SEPT");


var $lOpcG = parcelRequire("lOpcG");


});

parcelRegister("9AUBM", function(module, exports) {
$parcel$export(module.exports, "default", () => $951dc084d4c33fc9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $iFRRf = parcelRequire("iFRRf");


var $kUxzQ = parcelRequire("kUxzQ");


var $1iDg7 = parcelRequire("1iDg7");


var $hJgLA = parcelRequire("hJgLA");

const $951dc084d4c33fc9$var$styles = {
    container: "_zulp1b66 _1e0c116y _4cvr1h6o _1ul91ns9",
    icon: "_1e0c116y _v4pn116y _1b94116y _1ii7116y _4t3i7vkz _bna77vkz _1xjx7vkz _17527vkz _ca0qze3t _14bqze3t _1oh2ze3t _i2i3ze3t _u5f3ze3t _3tceze3t _99ztze3t _uhasze3t _n3tdze3t _1ym6ze3t _1m2uze3t _5jw9ze3t _19bvze3t _1xr1ze3t _9n9oze3t _7wy9ze3t _1bsb7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _s7n4nkob _rtqbnkob _e4kmnkob _z239nkob",
    text: "_11c8wadc"
};
const $951dc084d4c33fc9$var$colorMap = {
    subtle: "_syaz1rpy",
    default: "_syazazsu"
};
const $951dc084d4c33fc9$var$messageMapper = {
    [(0, $5TXU5.IconType).PriorityBlocker]: (0, $afp1H.messages).priority_blocker,
    [(0, $5TXU5.IconType).PriorityCritical]: (0, $afp1H.messages).priority_critical,
    [(0, $5TXU5.IconType).PriorityHigh]: (0, $afp1H.messages).priority_high,
    [(0, $5TXU5.IconType).PriorityHighest]: (0, $afp1H.messages).priority_highest,
    [(0, $5TXU5.IconType).PriorityLow]: (0, $afp1H.messages).priority_low,
    [(0, $5TXU5.IconType).PriorityLowest]: (0, $afp1H.messages).priority_lowest,
    [(0, $5TXU5.IconType).PriorityMajor]: (0, $afp1H.messages).priority_major,
    [(0, $5TXU5.IconType).PriorityMedium]: (0, $afp1H.messages).priority_medium,
    [(0, $5TXU5.IconType).PriorityMinor]: (0, $afp1H.messages).priority_minor,
    [(0, $5TXU5.IconType).PriorityTrivial]: (0, $afp1H.messages).priority_trivial,
    [(0, $5TXU5.IconType).PriorityUndefined]: (0, $afp1H.messages).priority_undefined
};
const $951dc084d4c33fc9$var$getFormattedMessageFromIcon = (icon)=>{
    if (icon) {
        const descriptor = $951dc084d4c33fc9$var$messageMapper[icon];
        if (descriptor) return (0, $hJgLA.getFormattedMessage)({
            descriptor: descriptor
        });
    }
};
const $951dc084d4c33fc9$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iFRRf.default), {
        icon: icon,
        label: icon,
        testId: `${testId}-icon`
    });
};
const $951dc084d4c33fc9$var$renderImageIcon = (url, testId, hideLoadingSkeleton)=>{
    if (url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kUxzQ.default), {
        testId: testId,
        url: url,
        hideLoadingSkeleton: hideLoadingSkeleton
    });
};
const $951dc084d4c33fc9$var$BaseBadgeRefreshNew = /*#__PURE__*/ (0, $42omo.forwardRef)(({ appearance: appearance = 'default', hideIcon: hideIcon = false, icon: icon, label: label, name: name, testId: testId = 'smart-element-badge', url: url, color: color }, ref)=>{
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    const formattedMessageOrLabel = $951dc084d4c33fc9$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $951dc084d4c33fc9$var$renderAtlaskitIcon(icon, testId) || $951dc084d4c33fc9$var$renderImageIcon(url, testId, ui?.hideLoadingSkeleton);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId,
        ref: ref,
        style: {
            color: color
        },
        className: (0, $gMc0m.default)([
            $951dc084d4c33fc9$var$styles.container,
            $951dc084d4c33fc9$var$colorMap[appearance]
        ])
    }, !hideIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $951dc084d4c33fc9$var$styles.icon
    }, badgeIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        testId: `${testId}-label`,
        xcss: $951dc084d4c33fc9$var$styles.text
    }, formattedMessageOrLabel));
});
var $951dc084d4c33fc9$export$2e2bcd8739ae039 = (0, $1iDg7.withOverrideCss)($951dc084d4c33fc9$var$BaseBadgeRefreshNew);
const $951dc084d4c33fc9$export$a2fb457791942ba4 = (label)=>{
    // Don't render the element if its 0
    return label !== '0' && label ? {
        label: label
    } : undefined;
};
module.exports["toBadgeProps"] = $951dc084d4c33fc9$export$a2fb457791942ba4;

});

parcelRegister("9mMJ0", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8C5kA = parcelRequire("8C5kA");


var $2Pg7f = parcelRequire("2Pg7f");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $hJgLA = parcelRequire("hJgLA");

const $9a89fd087e8e9b91$var$styles = null;
const $9a89fd087e8e9b91$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
    switch(elementName){
        case (0, $5TXU5.ElementName).AssignedToGroup:
            return (0, $hJgLA.getFormattedMessageAsString)(intl, (0, $afp1H.messages).assigned_to, personName);
        case (0, $5TXU5.ElementName).OwnedByGroup:
            return (0, $hJgLA.getFormattedMessageAsString)(intl, (0, $afp1H.messages).owned_by, personName);
        case (0, $5TXU5.ElementName).AuthorGroup:
            return (0, $hJgLA.getFormattedMessageAsString)(intl, (0, $afp1H.messages).created_by, personName);
        default:
            return personName;
    }
};
const $9a89fd087e8e9b91$var$BaseAvatarGroup = ({ items: items = [], maxCount: maxCount = 4, name: name, className: className, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
    const intl = (0, $8C5kA.default)();
    const data = (0, $42omo.useMemo)(()=>{
        if (!items.length && showFallbackAvatar) switch(name){
            case (0, $5TXU5.ElementName).AssignedToGroup:
                return [
                    {
                        name: (0, $hJgLA.getFormattedMessageAsString)(intl, (0, $afp1H.messages).unassigned)
                    }
                ];
            default:
                return [];
        }
         //show a name prefix if there is one Avatar in a group only
        if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
            return {
                ...person,
                name: $9a89fd087e8e9b91$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
            };
        });
        return items;
    }, [
        name,
        items,
        showNamePrefix,
        showFallbackAvatar,
        intl
    ]);
    if (!data.length) return null;
    return /*#__PURE__*/ $42omo.createElement("span" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    , {
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-avatar-group": true,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_1ul91ns9 _1e0c116y _1kvxu2gc _102oidpf",
            className
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $2Pg7f.default), {
        maxCount: maxCount,
        appearance: "stack",
        size: "small",
        data: data,
        testId: testId
    }));
};
var $9a89fd087e8e9b91$export$2e2bcd8739ae039 = $9a89fd087e8e9b91$var$BaseAvatarGroup;
const $9a89fd087e8e9b91$export$91ba8651475968bd = (items, showFallbackAvatar)=>{
    return items ? {
        items: items
    } : showFallbackAvatar ? {
        items: []
    } : undefined;
};
module.exports["default"] = $9a89fd087e8e9b91$export$2e2bcd8739ae039;
module.exports["toAvatarGroupProps"] = $9a89fd087e8e9b91$export$91ba8651475968bd;

});

parcelRegister("iFRRf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4wH3g = parcelRequire("4wH3g");


var $lAFHW = parcelRequire("lAFHW");


var $dh538 = parcelRequire("dh538");


var $7r4Rz = parcelRequire("7r4Rz");


var $GFtWS = parcelRequire("GFtWS");


var $9SMct = parcelRequire("9SMct");


var $5TXU5 = parcelRequire("5TXU5");


var $ivUmx = parcelRequire("ivUmx");

const $536366acab81aece$var$getIconImportFn = (icon, size)=>{
    const item = (0, $ivUmx.getLazyIcons)()[icon];
    if ((0, $ivUmx.isIconSizeLarge)(size) && item?.large) return item.large;
    return item?.default;
};
const $536366acab81aece$var$importIcon = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "rynap",
        name: "importIcon",
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $536366acab81aece$var$AtlaskitIcon = ({ icon: icon, label: label, testId: testId, size: size = (0, $5TXU5.SmartLinkSize).Medium })=>{
    // Check for synchonously loaded icons first for SSR purposes
    switch(icon){
        case (0, $5TXU5.IconType).Document:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9SMct.default), {
                label: label ?? 'document',
                testId: testId,
                size: size
            });
        case (0, $5TXU5.IconType).Blog:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7r4Rz.default), {
                label: label ?? 'blog',
                testId: testId,
                size: size
            });
        case (0, $5TXU5.IconType).LiveDocument:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $GFtWS.default), {
                label: label ?? 'live-doc',
                testId: testId,
                size: size
            });
    }
    const importFn = $536366acab81aece$var$getIconImportFn(icon, size);
    if (!importFn) return null;
    const ImportedIcon = $536366acab81aece$var$importIcon(importFn);
    switch(icon){
        case (0, $5TXU5.IconType).Confluence:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.ConfluenceIcon), {
                appearance: "brand",
                testId: testId,
                size: size === (0, $5TXU5.SmartLinkSize).Large || size === (0, $5TXU5.SmartLinkSize).XLarge ? 'small' : 'xxsmall',
                ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined
            });
        case (0, $5TXU5.IconType).Jira:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.JiraIcon), {
                appearance: "brand",
                testId: testId,
                size: size === (0, $5TXU5.SmartLinkSize).Large || size === (0, $5TXU5.SmartLinkSize).XLarge ? 'small' : 'xxsmall',
                ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined
            });
        case (0, $5TXU5.IconType).Error:
        case (0, $5TXU5.IconType).Forbidden:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ImportedIcon, {
                label: label,
                testId: testId,
                color: "var(--ds-icon-danger, #C9372C)"
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ImportedIcon, {
                label: label,
                testId: testId,
                size: size
            });
    }
};
var $536366acab81aece$export$2e2bcd8739ae039 = $536366acab81aece$var$AtlaskitIcon;
module.exports["default"] = $536366acab81aece$export$2e2bcd8739ae039;

});

parcelRegister("kUxzQ", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $6Eovk = parcelRequire("6Eovk");


var $hT8Jj = parcelRequire("hT8Jj");

const $4091fe284214d9a3$var$styles = {
    roundImg: "_2rko1rr0"
};
const $4091fe284214d9a3$var$messages = (0, $cgtv4.defineMessages)({
    imageAltText: {
        id: "smart-link.image-icon.altText",
        defaultMessage: "Link Icon"
    }
});
const $4091fe284214d9a3$var$ImageIcon = ({ defaultIcon: defaultIcon, testId: testId, url: url, width: width, height: height, appearance: appearance = 'square', onError: onError, onLoad: onLoad, hideLoadingSkeleton: hideLoadingSkeleton = false })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)(); // If url changes, reset state
    (0, $42omo.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        url
    ]);
    if (hasImageErrored) return defaultIcon;
    if (hideLoadingSkeleton) return /*#__PURE__*/ $42omo.createElement("img", {
        src: url,
        "data-testid": `${testId}-image`,
        alt: "",
        style: {
            width: width,
            height: height
        },
        onError: ()=>setHasImageErrored(true),
        className: (0, $gMc0m.default)([
            appearance === 'round' && $4091fe284214d9a3$var$styles.roundImg
        ])
    });
    else return /*#__PURE__*/ $42omo.createElement((0, $6Eovk.default), {
        src: url,
        loading: /*#__PURE__*/ $42omo.createElement((0, $hT8Jj.LoadingSkeleton), {
            testId: `${testId}-loading`,
            width: width,
            height: height
        }),
        loaded: /*#__PURE__*/ $42omo.createElement("img", {
            src: url,
            "data-testid": `${testId}-image`,
            alt: formatMessage($4091fe284214d9a3$var$messages.imageAltText),
            style: {
                width: width,
                height: height
            },
            className: (0, $gMc0m.default)([
                appearance === 'round' && $4091fe284214d9a3$var$styles.roundImg
            ])
        }),
        errored: defaultIcon,
        onError: onError,
        onLoad: onLoad
    });
};
var $4091fe284214d9a3$export$2e2bcd8739ae039 = $4091fe284214d9a3$var$ImageIcon;
module.exports["default"] = $4091fe284214d9a3$export$2e2bcd8739ae039;

});

parcelRegister("6wR2f", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4ULqR = parcelRequire("4ULqR");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $afp1H = parcelRequire("afp1H");

const $bbe6fa3f8ea6e4e4$var$styles = null;
const $bbe6fa3f8ea6e4e4$var$typeToDescriptorMap = {
    created: {
        relative: (0, $afp1H.messages).created_on_relative,
        absolute: (0, $afp1H.messages).created_on_absolute
    },
    modified: {
        relative: (0, $afp1H.messages).modified_on_relative,
        absolute: (0, $afp1H.messages).modified_on_absolute
    },
    sent: {
        relative: (0, $afp1H.messages).sent_on_relative,
        absolute: (0, $afp1H.messages).sent_on_absolute
    }
};
const $bbe6fa3f8ea6e4e4$var$fontOverrideStyleMap = {
    'font.body': "_11c8fhey",
    'font.body.large': "_11c81d4k",
    'font.body.small': "_11c8wadc",
    'font.body.UNSAFE_small': "_11c8rymc"
};
const $bbe6fa3f8ea6e4e4$var$BaseDateTimeElement = ({ date: date, name: name, className: className, type: type, testId: testId = 'smart-element-date-time', text: text, hideDatePrefix: hideDatePrefix = false, color: color, fontSize: fontSize })=>{
    const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, $8C5kA.default)();
    if (!type || !date) return null;
    const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
    let context;
    let typeVariant;
    if (isLongerThenWeek) {
        typeVariant = 'absolute';
        context = formatDate(date, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    } else {
        const { value: value, unit: unit } = (0, $4ULqR.selectUnit)(date, Date.now());
        typeVariant = 'relative';
        context = formatRelativeTime(value, unit, {
            numeric: 'auto'
        });
    }
    let content;
    if (hideDatePrefix) content = context;
    else if (text) content = `${text} ${context}`;
    else content = /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), {
        ...$bbe6fa3f8ea6e4e4$var$typeToDescriptorMap[type][typeVariant],
        values: {
            context: context
        }
    });
    return /*#__PURE__*/ $42omo.createElement("span", {
        style: {
            color: color
        },
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-date-time": true,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_11c8wadc _1reo15vq _18m915vq _syazazsu _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _102k7vkz",
            fontSize !== undefined && $bbe6fa3f8ea6e4e4$var$fontOverrideStyleMap[fontSize],
            className
        ])
    }, content);
};
var $bbe6fa3f8ea6e4e4$export$2e2bcd8739ae039 = $bbe6fa3f8ea6e4e4$var$BaseDateTimeElement;
const $bbe6fa3f8ea6e4e4$export$2d4384e6b150cbe3 = (type, dateString)=>{
    return dateString ? {
        date: new Date(dateString),
        type: type
    } : undefined;
};
module.exports["default"] = $bbe6fa3f8ea6e4e4$export$2e2bcd8739ae039;
module.exports["toDateTimeProps"] = $bbe6fa3f8ea6e4e4$export$2d4384e6b150cbe3;

});

parcelRegister("7f92O", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cgtv4 = parcelRequire("cgtv4");


var $5nBzc = parcelRequire("5nBzc");


var $dh538 = parcelRequire("dh538");


var $fUfR2 = parcelRequire("fUfR2");


var $cS65x = parcelRequire("cS65x");

const $7edf4af2ffda473e$var$styles = null;
/**
 * A base element that displays a Lozenge.
 * @internal
 * @param {BaseLozengeElementProps} BaseLozengeElementProps - The props necessary for the Lozenge element.
 * @see State
 */ const $7edf4af2ffda473e$var$BaseLozengeElement = ({ action: action, appearance: appearance = 'default', className: className, maxWidth: maxWidth, name: name, onAfterChanged: onAfterChanged, style: style, text: text, testId: testId = 'smart-element-lozenge' })=>{
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    if (!text) return null;
    const lozenge = action ? /*#__PURE__*/ $42omo.createElement((0, $cS65x.default), {
        action: action,
        appearance: appearance,
        ...(0, $dh538.fg)('platform_navx_sl_lozenge_max_width') ? {
            maxWidth: maxWidth
        } : undefined,
        testId: testId,
        text: text,
        zIndex: ui?.zIndex,
        onAfterChanged: onAfterChanged
    }) : /*#__PURE__*/ $42omo.createElement((0, $5nBzc.default), {
        appearance: appearance,
        ...(0, $dh538.fg)('platform-component-visual-refresh') ? {
            isBold: true
        } : undefined,
        ...(0, $dh538.fg)('platform_navx_sl_lozenge_max_width') ? {
            maxWidth: maxWidth
        } : undefined,
        style: style,
        testId: `${testId}-lozenge`
    }, text);
    return /*#__PURE__*/ $42omo.createElement("span", {
        "data-smart-element": name,
        "data-smart-element-lozenge": true,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_1e0c116y _1ul91ns9",
            className
        ])
    }, lozenge);
};
var $7edf4af2ffda473e$export$2e2bcd8739ae039 = $7edf4af2ffda473e$var$BaseLozengeElement;
const $7edf4af2ffda473e$export$8f9f58f7bac50fbe = (dateString)=>{
    if (dateString) {
        const text = Date.parse(dateString) ? /*#__PURE__*/ $42omo.createElement((0, $cgtv4.FormattedDate), {
            value: new Date(dateString),
            year: "numeric",
            month: "short",
            day: "numeric",
            formatMatcher: "best fit"
        }) : dateString;
        return {
            text: text
        };
    }
};
module.exports["default"] = $7edf4af2ffda473e$export$2e2bcd8739ae039;
module.exports["toDateLozengeProps"] = $7edf4af2ffda473e$export$8f9f58f7bac50fbe;

});

parcelRegister("8bb8e", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $3gadb = parcelRequire("3gadb");


var $5TXU5 = parcelRequire("5TXU5");


var $4gM1A = parcelRequire("4gM1A");


var $hX032 = parcelRequire("hX032");


var $hJgLA = parcelRequire("hJgLA");

const $eb4f16a03665d341$var$DEFAULT_MAX_LINES = 2;
const $eb4f16a03665d341$var$MAXIMUM_MAX_LINES = 2;
const $eb4f16a03665d341$var$MINIMUM_MAX_LINES = 1;
const $eb4f16a03665d341$var$containerStyles = null;
const $eb4f16a03665d341$var$getMaxLines = (maxLines)=>{
    if (maxLines > $eb4f16a03665d341$var$MAXIMUM_MAX_LINES) return $eb4f16a03665d341$var$DEFAULT_MAX_LINES;
    if (maxLines < $eb4f16a03665d341$var$MINIMUM_MAX_LINES) return $eb4f16a03665d341$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $eb4f16a03665d341$var$withTooltip = (trigger, content, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: content,
        testId: `${testId}-tooltip`,
        tag: "span"
    }, trigger);
const $eb4f16a03665d341$var$linkStyleSizeMap = {
    xlarge: "_11c81af2 _k48pi7a9 _vwz41k8s",
    large: "_11c8fhey _k48pi7a9 _vwz41j6v",
    medium: "_11c8fhey _k48pi7a9 _vwz41j6v",
    small: "_11c8rymc _k48pi7a9 _vwz41j6v"
};
const $eb4f16a03665d341$var$baseAnchorStyle = null;
const $eb4f16a03665d341$var$workBreakStyleMap = {
    true: "_1nmz1hna",
    false: "_1nmz9jpi"
};
const $eb4f16a03665d341$var$anchorConstantsStyles = null;
const $eb4f16a03665d341$var$anchorLineClampMap = {
    1: "_1yyjkb7n",
    2: "_1yyjcs5v"
};
const $eb4f16a03665d341$var$anchorLinkLineHeight1Map = {
    xlarge: "_102k1k8s",
    large: "_102k1j6v",
    medium: "_102k1j6v",
    small: "_102k1j6v"
};
const $eb4f16a03665d341$var$anchorLinkLineHeight2Map = {
    xlarge: "_102k1wto",
    large: "_102kviql",
    medium: "_102kviql",
    small: "_102kviql"
};
const $eb4f16a03665d341$var$themeStyleMap = {
    grey: "_fjv61r31 _93u91r31 _g2lk1r31 _pnzf1r31 _hlwq8stv _1e2m8stv _1l4b8stv _ue8d8stv _yni7nqa1 _1bianqa1 _93jhnqa1 _64n6nqa1 _1ray1rpy _dlb71rpy _rnxt1rpy _1h4d1rpy _10uerymc _ye101rpy",
    black: "_syazazsu _1nrm1r31 _1a3b1r31 _9oik1r31 _1ydc1r31 _c2wa8stv _4fpr8stv _1bnx8stv _1x288stv _1iohnqa1 _5goinqa1 _jf4cnqa1 _1726nqa1 _9h8hazsu _f8pjazsu _30l3azsu _1053azsu",
    link: "_syaz13af _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _9h8h12zz"
};
const $eb4f16a03665d341$var$BaseLinkElement = ({ hideTooltip: hideTooltip, maxLines: maxLines = $eb4f16a03665d341$var$DEFAULT_MAX_LINES, name: name, className: className, size: size = (0, $5TXU5.SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, $5TXU5.SmartLinkTheme).Link, url: url, onClick: onClick, target: target = '_blank', anchorRef: anchorRef })=>{
    const onMouseDown = (0, $4gM1A.useMouseDownEvent)();
    const hasSpace = (0, $42omo.useMemo)(()=>text ? (0, $hJgLA.hasWhiteSpace)(text) : false, [
        text
    ]);
    const anchor = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
        "data-smart-element": name,
        "data-smart-element-link": true,
        "data-testid": testId,
        onClick: onClick,
        onMouseDown: onMouseDown,
        href: url,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug",
            $eb4f16a03665d341$var$linkStyleSizeMap[size],
            $eb4f16a03665d341$var$anchorLineClampMap[$eb4f16a03665d341$var$getMaxLines(maxLines)],
            "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _sudp1e54",
            $eb4f16a03665d341$var$workBreakStyleMap[hasSpace ? 'true' : 'false'],
            $eb4f16a03665d341$var$getMaxLines(maxLines) === 1 && $eb4f16a03665d341$var$anchorLinkLineHeight1Map[size],
            $eb4f16a03665d341$var$getMaxLines(maxLines) === 2 && $eb4f16a03665d341$var$anchorLinkLineHeight2Map[size],
            $eb4f16a03665d341$var$themeStyleMap[theme],
            className
        ]),
        ...target !== '_self' && {
            target: target
        },
        ref: anchorRef
    }, text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug"
        ])
    }, hideTooltip || text === undefined ? anchor : $eb4f16a03665d341$var$withTooltip(anchor, url?.includes(text) && (0, $hX032.isNewBlockcardUnauthorizedRefreshExperimentEnabled)() ? url : text, testId));
};
var $eb4f16a03665d341$export$2e2bcd8739ae039 = $eb4f16a03665d341$var$BaseLinkElement;
const $eb4f16a03665d341$export$d58e465a9e5297f4 = (text, url)=>{
    return text ? {
        text: text,
        url: url
    } : undefined;
};
module.exports["default"] = $eb4f16a03665d341$export$2e2bcd8739ae039;

});

parcelRegister("1iDg7", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $8ddce3b50e63e6e3$export$e0bdcacb944f1da6(Component) {
    return (props)=>{
        const ref = (0, $42omo.useRef)(null);
        (0, $42omo.useEffect)(()=>{
            if (props?.className && ref.current) ref.current.className = `${ref.current.className} ${props.className}`;
        }, [
            props?.className
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            ...props,
            ref: ref
        });
    };
}
module.exports["withOverrideCss"] = $8ddce3b50e63e6e3$export$e0bdcacb944f1da6;

});

parcelRegister("g98dH", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $htjmD = parcelRequire("htjmD");


var $eIleF = parcelRequire("eIleF");

const $b01bbbcb1713fd75$var$useInvoke = ()=>{
    const { connections: connections } = (0, $eIleF.useSmartLinkContext)();
    const clientExt = (0, $htjmD.useSmartLinkClientExtension)(connections.client);
    return (0, $42omo.useCallback)(async (req, cb)=>{
        const response = await clientExt.invoke(req);
        return cb ? cb(response) : response;
    }, [
        clientExt
    ]);
};
var $b01bbbcb1713fd75$export$2e2bcd8739ae039 = $b01bbbcb1713fd75$var$useInvoke;
module.exports["default"] = $b01bbbcb1713fd75$export$2e2bcd8739ae039;

});

parcelRegister("8i8ID", function(module, exports) {

var $lgqac = parcelRequire("lgqac");

const $e9aefac4b34acc2c$export$65b3f792dff0bd60 = (err)=>{
    if (!$e9aefac4b34acc2c$export$1694272377fa07d8(err)) return (0, $lgqac.TrackQuickActionFailureReason).UnknownError;
    switch(err?.errorCode){
        case 403:
            return (0, $lgqac.TrackQuickActionFailureReason).PermissionError;
        default:
            return (0, $lgqac.TrackQuickActionFailureReason).UnknownError;
    }
};
const $e9aefac4b34acc2c$export$1694272377fa07d8 = (err)=>err?.message !== undefined && err?.errorCode !== undefined;
module.exports["getInvokeFailureReason"] = $e9aefac4b34acc2c$export$65b3f792dff0bd60;
module.exports["isInvokeCustomError"] = $e9aefac4b34acc2c$export$1694272377fa07d8;

});

parcelRegister("hT8Jj", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $0ee6375a3337d738$var$animationNameStyles = null;
const $0ee6375a3337d738$var$loadingSkeletonStyle = null;
const $0ee6375a3337d738$export$44c18d210d5de37b = ({ testId: testId, width: width, height: height })=>{
    return /*#__PURE__*/ $42omo.createElement("span", {
        "data-testid": testId,
        style: {
            width: width,
            height: height
        },
        className: (0, $gMc0m.default)([
            "_2rkolb4i _uiztglyw _bfhkvkf5 _1itkfj9x _12vemgnk _1lrw6rms _1e0c1o8l _5sag9cwz _1o51q7pw _tip812c5 _j7hqqkar _1pglp3kn"
        ])
    });
};
module.exports["LoadingSkeleton"] = $0ee6375a3337d738$export$44c18d210d5de37b;

});

parcelRegister("f6wMd", function(module, exports) {

var $5TXU5 = parcelRequire("5TXU5");

const $8700f5e69c6738e7$var$extractFileFormatIcon = (fileFormat)=>{
    switch(fileFormat){
        // Generic documents
        case 'folder':
            return {
                icon: (0, $5TXU5.IconType).Folder
            };
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return {
                icon: (0, $5TXU5.IconType).Document
            };
        case 'application/pdf':
            return {
                icon: (0, $5TXU5.IconType).PDF
            };
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return {
                icon: (0, $5TXU5.IconType).Presentation
            };
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return {
                icon: (0, $5TXU5.IconType).Spreadsheet
            };
        // Google Drive
        case 'application/vnd.google-apps.document':
            return {
                icon: (0, $5TXU5.IconType).GoogleDocs
            };
        case 'application/vnd.google-apps.form':
            return {
                icon: (0, $5TXU5.IconType).GoogleForms
            };
        case 'application/vnd.google-apps.spreadsheet':
            return {
                icon: (0, $5TXU5.IconType).GoogleSheets
            };
        case 'application/vnd.google-apps.presentation':
            return {
                icon: (0, $5TXU5.IconType).GoogleSlides
            };
        // Microsoft
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return {
                icon: (0, $5TXU5.IconType).MSExcel
            };
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return {
                icon: (0, $5TXU5.IconType).MSPowerpoint
            };
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return {
                icon: (0, $5TXU5.IconType).MSWord
            };
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return {
                icon: (0, $5TXU5.IconType).Image
            };
        case 'image/gif':
            return {
                icon: (0, $5TXU5.IconType).GIF
            };
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return {
                icon: (0, $5TXU5.IconType).Audio
            };
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return {
                icon: (0, $5TXU5.IconType).Video
            };
        // Others
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return {
                icon: (0, $5TXU5.IconType).Code
            };
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return {
                icon: (0, $5TXU5.IconType).Archive
            };
        case 'application/dmg':
            return {
                icon: (0, $5TXU5.IconType).Executable
            };
        case 'application/sketch':
            return {
                icon: (0, $5TXU5.IconType).Sketch
            };
        case 'application/octet-stream':
            return {
                icon: (0, $5TXU5.IconType).Generic
            };
        case 'application/invision.prototype':
            return {
                icon: (0, $5TXU5.IconType).Generic
            };
        default:
            return undefined;
    }
};
var $8700f5e69c6738e7$export$2e2bcd8739ae039 = $8700f5e69c6738e7$var$extractFileFormatIcon;
module.exports["default"] = $8700f5e69c6738e7$export$2e2bcd8739ae039;

});

parcelRegister("kbh18", function(module, exports) {

var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");

const $681e47ebaeddecd0$export$d439c74cb206ff29 = (isAdminHubAIEnabled = false, response)=>Boolean(isAdminHubAIEnabled && response?.meta?.supportedFeature?.includes('AISummary'));
const $681e47ebaeddecd0$export$cd2e891d7f87074d = (error)=>{
    switch(error){
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                message: (0, $afp1H.messages).ai_summary_error_acceptable_use_violation,
                url: (0, $5TXU5.CONTENT_URL_ACCEPTABLE_USE_POLICY)
            };
        case 'HIPAA_CONTENT_DETECTED':
            return {
                message: (0, $afp1H.messages).ai_summary_error_hipaa_content_detected
            };
        case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
            return {
                message: (0, $afp1H.messages).ai_summary_error_exceeding_context_length_error
            };
        default:
            return {
                message: (0, $afp1H.messages).ai_summary_error_generic,
                url: (0, $5TXU5.CONTENT_URL_AI_TROUBLESHOOTING)
            };
    }
};
module.exports["getIsAISummaryEnabled"] = $681e47ebaeddecd0$export$d439c74cb206ff29;
module.exports["getAISummaryErrorMessage"] = $681e47ebaeddecd0$export$cd2e891d7f87074d;

});

parcelRegister("i8IAc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eIleF = parcelRequire("eIleF");

const $524481383d1e73c2$export$4480af2c00aa7ebe = ()=>{
    const { connections: connections, product: product, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $eIleF.useSmartLinkContext)();
    return (0, $42omo.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        isAdminHubAIEnabled
    ]);
};
module.exports["useAISummaryConfig"] = $524481383d1e73c2$export$4480af2c00aa7ebe;

});

parcelRegister("5ctc0", function(module, exports) {

var $lyclm = parcelRequire("lyclm");

var $iFI9k = parcelRequire("iFI9k");


var $5TXU5 = parcelRequire("5TXU5");

const $0f22550e7379302c$var$extractPreview = (data)=>{
    if (!data) return undefined;
    const url = (0, $iFI9k.extractImage)(data);
    return url ? {
        type: (0, $5TXU5.MediaType).Image,
        url: url
    } : undefined;
};
var $0f22550e7379302c$export$2e2bcd8739ae039 = $0f22550e7379302c$var$extractPreview;
const $0f22550e7379302c$export$a79836076066b8b6 = (response)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $lyclm.isEntityPresent)(response)) {
        const entity = (0, $lyclm.extractEntity)(response);
        let url = entity?.thumbnail?.externalUrl;
        return url ? {
            type: (0, $5TXU5.MediaType).Image,
            url: url
        } : undefined;
    }
    return $0f22550e7379302c$var$extractPreview(response.data);
};
module.exports["extractSmartLinkPreviewImage"] = $0f22550e7379302c$export$a79836076066b8b6;

});

parcelRegister("4P3K9", function(module, exports) {

var $kzSaQ = parcelRequire("kzSaQ");

const $4fbbebc17c1a2887$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map((0, $kzSaQ.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $kzSaQ.extractPersonFromJsonLd)(ownedBy);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
module.exports["extractPersonOwnedBy"] = $4fbbebc17c1a2887$export$19ee667f3f7a6ec3;

});

parcelRegister("2LWAa", function(module, exports) {
const $c909c594c41baf78$export$2487b058456cca75 = (action, actionOptions)=>{
    if (typeof actionOptions === 'undefined') return true;
    if (actionOptions.hide || actionOptions.exclude?.includes(action)) return false;
    return true;
};
module.exports["canShowAction"] = $c909c594c41baf78$export$2487b058456cca75;

});

parcelRegister("575f6", function(module, exports) {

var $lyclm = parcelRequire("lyclm");


var $5TXU5 = parcelRequire("5TXU5");


var $2CpuW = parcelRequire("2CpuW");


var $kn2iQ = parcelRequire("kn2iQ");


var $kX2ZH = parcelRequire("kX2ZH");

const $48fd38a3919fb96d$export$43612bed147eae48 = (response, renderers)=>{
    const data = response.data;
    const render = (0, $2CpuW.default)(data, renderers);
    return {
        ...(0, $kn2iQ.default)(data),
        render: render
    };
};
const $48fd38a3919fb96d$export$bdd29be9b0395931 = (response, status)=>{
    // Try to get provider icon first.
    if (response) {
        const data = response.data;
        const { icon: icon, url: url } = (0, $kX2ZH.default)(data) || {};
        if (icon || url) return {
            icon: icon,
            url: url
        };
    }
    // Otherwise, use fallback icon for each status.
    switch(status){
        case (0, $5TXU5.SmartLinkStatus).Forbidden:
        case (0, $5TXU5.SmartLinkStatus).Unauthorized:
            return {
                icon: (0, $5TXU5.IconType).Forbidden
            };
        case (0, $5TXU5.SmartLinkStatus).NotFound:
            return {
                icon: (0, $5TXU5.IconType).Error
            };
        case (0, $5TXU5.SmartLinkStatus).Errored:
        case (0, $5TXU5.SmartLinkStatus).Fallback:
        default:
            return {
                icon: (0, $5TXU5.IconType).Default
            };
    }
};
const $48fd38a3919fb96d$export$35040aed9264b11c = (response, renderers)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntityIcon)(response);
    return $48fd38a3919fb96d$export$43612bed147eae48(response, renderers);
};
module.exports["extractLinkIcon"] = $48fd38a3919fb96d$export$43612bed147eae48;
module.exports["extractErrorIcon"] = $48fd38a3919fb96d$export$bdd29be9b0395931;
module.exports["extractSmartLinkIcon"] = $48fd38a3919fb96d$export$35040aed9264b11c;

});

parcelRegister("fcTJU", function(module, exports) {
const $bcab3e29f50fe6bc$export$8f031784a3a03b23 = (jsonLd)=>{
    let actions = jsonLd && jsonLd['schema:potentialAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) actions = [
        actions
    ];
    return actions;
};
module.exports["getActionsFromJsonLd"] = $bcab3e29f50fe6bc$export$8f031784a3a03b23;

});

parcelRegister("6KV13", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $99WQy = parcelRequire("99WQy");

var $l6lJr = parcelRequire("l6lJr");


var $kKODE = parcelRequire("kKODE");


var $bIll3 = parcelRequire("bIll3");


var $lz9QA = parcelRequire("lz9QA");


var $8Bm55 = parcelRequire("8Bm55");


var $i8IAc = parcelRequire("i8IAc");

const $c75904359bba5163$var$EXPERIENCE_NAME = 'smart-link-ai-summary';
const $c75904359bba5163$var$useAISummaryAction = (url)=>{
    const { baseUrl: baseUrl, envKey: envKey, product: product } = (0, $i8IAc.useAISummaryConfig)();
    const cardState = (0, $lz9QA.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const data = cardState.details?.data;
    const ari = data && (0, $99WQy.extractAri)(data);
    const dataUrl = data && (0, $l6lJr.extractLink)(data) || '';
    const onStart = (0, $42omo.useCallback)((id)=>{
        (0, $bIll3.startUfoExperience)($c75904359bba5163$var$EXPERIENCE_NAME, id);
    }, []);
    const onSuccess = (0, $42omo.useCallback)((id)=>{
        fireEvent('operational.summary.success', {});
        (0, $bIll3.succeedUfoExperience)($c75904359bba5163$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    const onError = (0, $42omo.useCallback)((id, reason)=>{
        /**
			 * Errors should only be counted to the SLO if they are not due to acceptable use violations
			 * HIPAA content detected or exceeding context length.
			 */ const isSloError = reason === undefined ? true : ![
            'ACCEPTABLE_USE_VIOLATIONS',
            'HIPAA_CONTENT_DETECTED',
            'EXCEEDING_CONTEXT_LENGTH_ERROR'
        ].includes(reason);
        fireEvent('operational.summary.failed', {
            reason: reason || null,
            isSloError: isSloError
        });
        (0, $bIll3.failUfoExperience)($c75904359bba5163$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    return (0, $8Bm55.useAISummary)({
        url: dataUrl,
        ari: ari,
        product: product,
        envKey: envKey,
        baseUrl: baseUrl,
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
var $c75904359bba5163$export$2e2bcd8739ae039 = $c75904359bba5163$var$useAISummaryAction;
module.exports["default"] = $c75904359bba5163$export$2e2bcd8739ae039;

});

parcelRegister("jlQ9A", function(module, exports) {
$parcel$export(module.exports, "CustomAction", () => (parcelRequire("6FZ6a")).default);
$parcel$export(module.exports, "DeleteAction", () => (parcelRequire("jLXEH")).default);
$parcel$export(module.exports, "EditAction", () => (parcelRequire("dVBHR")).default);
$parcel$export(module.exports, "DownloadAction", () => (parcelRequire("cLh5D")).default);
$parcel$export(module.exports, "FollowAction", () => (parcelRequire("9l03X")).default);
$parcel$export(module.exports, "PreviewAction", () => (parcelRequire("2vLbR")).default);
$parcel$export(module.exports, "CopyLinkAction", () => (parcelRequire("apOlf")).default);
$parcel$export(module.exports, "UnresolvedAction", () => (parcelRequire("lVA2Y")).default);
$parcel$export(module.exports, "AISummaryAction", () => (parcelRequire("fl0WE")).default);
$parcel$export(module.exports, "AutomationAction", () => (parcelRequire("loGLq")).default);
$parcel$export(module.exports, "ViewRelatedLinksAction", () => (parcelRequire("9Gqdx")).default);
$parcel$export(module.exports, "CustomUnresolvedAction", () => (parcelRequire("j5Rp4")).default);

var $6FZ6a = parcelRequire("6FZ6a");


var $jLXEH = parcelRequire("jLXEH");


var $dVBHR = parcelRequire("dVBHR");


var $cLh5D = parcelRequire("cLh5D");


var $9l03X = parcelRequire("9l03X");


var $2vLbR = parcelRequire("2vLbR");


var $apOlf = parcelRequire("apOlf");


var $lVA2Y = parcelRequire("lVA2Y");


var $fl0WE = parcelRequire("fl0WE");


var $loGLq = parcelRequire("loGLq");


var $9Gqdx = parcelRequire("9Gqdx");


var $j5Rp4 = parcelRequire("j5Rp4");


});

parcelRegister("6bBFP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $c30cfb4c0c886f9b$export$6118ed0013927eb2 = ({ children: children, isFadeIn: isFadeIn = false, minHeight: minHeight = 0, show: show, showTransition: showTransition = false })=>{
    const [height, setHeight] = (0, $42omo.useState)(0);
    const ref = (0, $42omo.useRef)(null);
    const transition = isFadeIn ? 'height, opacity' : 'height';
    (0, $42omo.useEffect)(()=>{
        if (show && ref.current) // set the height of the error message container explicitly to the height
        // of its contents (including anything hidden due to overflow) so that we
        // can animate the height of the container
        setHeight(ref.current.scrollHeight);
        else setHeight(0);
    }, [
        children,
        show
    ]);
    return show ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        style: {
            height: height,
            minHeight: minHeight,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
            lineHeight: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // a fit for purpose state variable to control when the 'visible' styles should be appled
            opacity: height > 0 ? 1 : 0,
            // we only want to transition opacity and height when the error message is initially shown
            // not if its to be shown on mount
            transitionProperty: showTransition ? transition : 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            transitionDuration: '0.3s'
        },
        ref: ref
    }, children) : null;
};
var $c30cfb4c0c886f9b$export$2e2bcd8739ae039 = $c30cfb4c0c886f9b$export$6118ed0013927eb2;
module.exports["default"] = $c30cfb4c0c886f9b$export$2e2bcd8739ae039;

});

parcelRegister("4ULqR", function(module, exports) {
var $39412f7225a31c87$var$__assign = undefined && undefined.__assign || function() {
    $39412f7225a31c87$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $39412f7225a31c87$var$__assign.apply(this, arguments);
};
var $39412f7225a31c87$var$MS_PER_SECOND = 1e3;
var $39412f7225a31c87$var$SECS_PER_MIN = 60;
var $39412f7225a31c87$var$SECS_PER_HOUR = $39412f7225a31c87$var$SECS_PER_MIN * 60;
var $39412f7225a31c87$var$SECS_PER_DAY = $39412f7225a31c87$var$SECS_PER_HOUR * 24;
var $39412f7225a31c87$var$SECS_PER_WEEK = $39412f7225a31c87$var$SECS_PER_DAY * 7;
function $39412f7225a31c87$export$b8f7189986dd5395(from, to, thresholds) {
    if (to === void 0) to = Date.now();
    if (thresholds === void 0) thresholds = {};
    var resolvedThresholds = $39412f7225a31c87$var$__assign($39412f7225a31c87$var$__assign({}, $39412f7225a31c87$export$f4fd60e41371f80d), thresholds || {});
    var secs = (+from - +to) / $39412f7225a31c87$var$MS_PER_SECOND;
    if (Math.abs(secs) < resolvedThresholds.second) return {
        value: Math.round(secs),
        unit: 'second'
    };
    var mins = secs / $39412f7225a31c87$var$SECS_PER_MIN;
    if (Math.abs(mins) < resolvedThresholds.minute) return {
        value: Math.round(mins),
        unit: 'minute'
    };
    var hours = secs / $39412f7225a31c87$var$SECS_PER_HOUR;
    if (Math.abs(hours) < resolvedThresholds.hour) return {
        value: Math.round(hours),
        unit: 'hour'
    };
    var days = secs / $39412f7225a31c87$var$SECS_PER_DAY;
    if (Math.abs(days) < resolvedThresholds.day) return {
        value: Math.round(days),
        unit: 'day'
    };
    var fromDate = new Date(from);
    var toDate = new Date(to);
    var years = fromDate.getFullYear() - toDate.getFullYear();
    if (Math.round(Math.abs(years)) > 0) return {
        value: Math.round(years),
        unit: 'year'
    };
    var months = years * 12 + fromDate.getMonth() - toDate.getMonth();
    if (Math.round(Math.abs(months)) > 0) return {
        value: Math.round(months),
        unit: 'month'
    };
    var weeks = secs / $39412f7225a31c87$var$SECS_PER_WEEK;
    return {
        value: Math.round(weeks),
        unit: 'week'
    };
}
var $39412f7225a31c87$export$f4fd60e41371f80d = {
    second: 45,
    minute: 45,
    hour: 22,
    day: 5
};
module.exports["selectUnit"] = $39412f7225a31c87$export$b8f7189986dd5395;

});

parcelRegister("cS65x", function(module, exports) {
$parcel$export(module.exports, "default", () => $7fab12f071167d36$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $52EPl = parcelRequire("52EPl");


var $dh538 = parcelRequire("dh538");


var $kKODE = parcelRequire("kKODE");


var $eJ92v = parcelRequire("eJ92v");


var $g98dH = parcelRequire("g98dH");


var $8i8ID = parcelRequire("8i8ID");


var $7DSoa = parcelRequire("7DSoa");


var $cOlaT = parcelRequire("cOlaT");


var $lgqac = parcelRequire("lgqac");


var $b7GIg = parcelRequire("b7GIg");


var $667Mo = parcelRequire("667Mo");


var $7uUCV = parcelRequire("7uUCV");


var $bTJCs = parcelRequire("bTJCs");


var $58trk = parcelRequire("58trk");


var $dXPIV = parcelRequire("dXPIV");

const $7fab12f071167d36$var$validateItems = (items = [], text)=>{
    return items.filter((item)=>item.text !== text);
};
const $7fab12f071167d36$var$LozengeAction = ({ action: action, appearance: appearance, maxWidth: maxWidth, testId: testId = 'smart-element-lozenge-action', text: text, zIndex: zIndex, onAfterChanged: onAfterChanged, shouldRenderToParent: shouldRenderToParent = false })=>{
    const [selected, setSelected] = (0, $42omo.useState)({
        appearance: appearance,
        text: text
    });
    const [isLoaded, setIsLoaded] = (0, $42omo.useState)(false);
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const [items, setItems] = (0, $42omo.useState)();
    const [errorMessage, setErrorMessage] = (0, $42omo.useState)();
    const reload = (0, $7DSoa.default)();
    const invoke = (0, $g98dH.default)();
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        setSelected({
            text: text,
            appearance: appearance
        });
    }, [
        text,
        appearance
    ]);
    const { url: url, id: linkId, invokePreviewAction: invokePreviewAction } = action?.update?.details || {};
    const handleOpenChange = (0, $42omo.useCallback)(async (args)=>{
        setIsOpen(args.isOpen);
        if (args.isOpen) {
            fireEvent('ui.button.clicked.smartLinkStatusLozenge', {});
            fireEvent('track.smartLinkQuickAction.started', {
                smartLinkActionType: (0, $lgqac.TrackQuickActionType).StatusUpdate
            });
            if (!isLoaded && action?.read) try {
                setIsLoading(true);
                const responseItems = await invoke(action.read, (0, $eJ92v.default));
                const validItems = typeof text === 'string' ? $7fab12f071167d36$var$validateItems(responseItems, text) : responseItems;
                setItems(validItems);
                setIsLoaded(true);
                if (validItems?.length === 0) {
                    fireEvent('track.smartLinkQuickAction.failed', (0, $667Mo.permissionLoadErrorAnalyticsPayload));
                    setErrorMessage((0, $dh538.fg)('confluence-issue-terminology-refresh') ? (0, $bTJCs.LozengeActionErrorMessages).noDataIssueTermRefresh : (0, $bTJCs.LozengeActionErrorMessages).noData);
                    setIsLoaded(false);
                }
            } catch  {
                setErrorMessage((0, $bTJCs.LozengeActionErrorMessages).unknown);
                setIsLoaded(false);
                fireEvent('track.smartLinkQuickAction.failed', (0, $667Mo.unknownLoadErrorAnalyticsPayload));
            } finally{
                setIsLoading(false);
            }
        }
        if (!args.isOpen) setErrorMessage(undefined);
    }, [
        action.read,
        invoke,
        isLoaded,
        text,
        fireEvent
    ]);
    const trigger = (0, $42omo.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dXPIV.default), {
            ...props,
            appearance: selected.appearance,
            isOpen: isOpen,
            ...(0, $dh538.fg)('platform_navx_sl_lozenge_max_width') ? {
                maxWidth: maxWidth
            } : undefined,
            testId: testId,
            text: selected.text
        }), [
        selected.appearance,
        selected.text,
        isOpen,
        maxWidth,
        testId
    ]);
    const handleItemClick = (0, $42omo.useCallback)(async (id, text, appearance)=>{
        try {
            fireEvent('ui.button.clicked.smartLinkStatusListItem', {});
            const updateAction = action?.update;
            if (updateAction && id) {
                setIsLoading(true);
                const request = (0, $cOlaT.default)(updateAction, id);
                await invoke(request);
                onAfterChanged?.();
                setSelected({
                    appearance: appearance,
                    text: text
                });
                setIsLoading(false);
                setIsLoaded(false);
                setIsOpen(false);
                setItems([]);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: (0, $lgqac.TrackQuickActionType).StatusUpdate
                });
                if (url) await reload(url, true, undefined, linkId);
            }
        } catch (err) {
            setIsLoading(false);
            if ((0, $8i8ID.isInvokeCustomError)(err)) {
                setErrorMessage(err.message);
                fireEvent('track.smartLinkQuickAction.failed', (0, $667Mo.validationUpdateErrorAnalyticsPayload));
            } else {
                setErrorMessage((0, $bTJCs.LozengeActionErrorMessages).updateFailed);
                fireEvent('track.smartLinkQuickAction.failed', (0, $667Mo.unknownUpdateErrorAnalyticsPayload));
            }
        }
    }, [
        action?.update,
        invoke,
        linkId,
        reload,
        url,
        fireEvent,
        onAfterChanged
    ]);
    const dropdownItemGroup = (0, $42omo.useMemo)(()=>{
        if (errorMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7uUCV.default), {
            errorMessage: errorMessage,
            testId: testId,
            url: url,
            invokePreviewAction: invokePreviewAction
        });
        if (items && items.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $58trk.default), {
            testId: testId,
            items: items,
            onClick: handleItemClick
        });
    }, [
        errorMessage,
        handleItemClick,
        items,
        invokePreviewAction,
        testId,
        url
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: handleOpenChange,
        testId: testId,
        trigger: trigger,
        zIndex: zIndex,
        shouldRenderToParent: shouldRenderToParent
    }, dropdownItemGroup);
};
var $7fab12f071167d36$export$2e2bcd8739ae039 = (0, $b7GIg.default)($7fab12f071167d36$var$LozengeAction);

});

parcelRegister("htjmD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gmi3X = parcelRequire("gmi3X");


var $4X6f2 = parcelRequire("4X6f2");


var $1Okf1 = parcelRequire("1Okf1");

const $6bb10922c4ae303f$export$303ede4eed148855 = (cardClient)=>{
    const resolverUrl = (0, $1Okf1.useResolverUrl)(cardClient);
    const invoke = (0, $42omo.useCallback)(async (data)=>{
        try {
            return await (0, $gmi3X.request)('post', `${resolverUrl}/invoke`, data, undefined, [
                200,
                201,
                202,
                203,
                204
            ]);
        } catch (err) {
            // checking if the error is a Response type
            // since we already had a few HOTs caused by comparing with instanceOf',
            // we're verifying the type by the contents
            if (err && err.json && typeof err.json === 'function') {
                const errorBody = await err.json();
                if (errorBody) throw new (0, $4X6f2.InvokeError)(errorBody?.error.message, errorBody?.error.status);
            }
            throw err;
        }
    }, [
        resolverUrl
    ]);
    return (0, $42omo.useMemo)(()=>({
            invoke: invoke
        }), [
        invoke
    ]);
};
module.exports["useSmartLinkClientExtension"] = $6bb10922c4ae303f$export$303ede4eed148855;

});

parcelRegister("2CpuW", function(module, exports) {
const $ecff103eb394f1ce$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $ecff103eb394f1ce$var$extractIconRenderer = (data, renderers)=>{
    const prefix = data['atlassian:titlePrefix'];
    if (prefix?.['@type'] === 'atlassian:Emoji') {
        const emojiId = $ecff103eb394f1ce$var$sanitizeEmojiValue(prefix['text']);
        const emojiRenderer = renderers?.emoji;
        if (emojiId && emojiRenderer) return ()=>emojiRenderer(emojiId);
    }
};
var $ecff103eb394f1ce$export$2e2bcd8739ae039 = $ecff103eb394f1ce$var$extractIconRenderer;
module.exports["default"] = $ecff103eb394f1ce$export$2e2bcd8739ae039;

});

parcelRegister("kn2iQ", function(module, exports) {

var $hUifo = parcelRequire("hUifo");


var $5TXU5 = parcelRequire("5TXU5");


var $7hXqf = parcelRequire("7hXqf");


var $uAXxz = parcelRequire("uAXxz");


var $8sXiv = parcelRequire("8sXiv");


var $15w8R = parcelRequire("15w8R");


var $2OB54 = parcelRequire("2OB54");


var $f6wMd = parcelRequire("f6wMd");


var $8fQ4N = parcelRequire("8fQ4N");


var $kX2ZH = parcelRequire("kX2ZH");


var $dVnIN = parcelRequire("dVnIN");

const $db64d56f9a1152ff$var$extractTask = (data, label)=>{
    const { id: id, icon: url } = (0, $8sXiv.extractTaskType)(data) || {};
    const taskType = id?.split('#').pop();
    const taskIcon = url ? {
        label: label,
        url: url
    } : undefined;
    return {
        taskType: taskType,
        taskIcon: taskIcon
    };
};
const $db64d56f9a1152ff$var$extractType = (jsonLd)=>{
    const type = jsonLd['@type'];
    return Array.isArray(type) ? type.sort((a, b)=>(0, $uAXxz.extractorPriorityMap)[b] - (0, $uAXxz.extractorPriorityMap)[a])[0] : type;
};
const $db64d56f9a1152ff$var$isJiraProvider = (provider)=>provider === (0, $15w8R.JIRA_GENERATOR_ID);
function $db64d56f9a1152ff$var$chooseIcon({ urlIcon: urlIcon, type: type, label: label, data: data, providerIcon: providerIcon }) {
    const providerId = data.generator?.['@id'];
    const fileFormat = data?.['schema:fileFormat'];
    const fileFormatIcon = (0, $f6wMd.default)(fileFormat);
    const documentTypeIcon = $db64d56f9a1152ff$var$typeToIconDescriptor({
        type: type,
        label: label,
        providerId: providerId,
        data: data
    }) || (0, $2OB54.default)(type, label, providerId);
    return (0, $7hXqf.prioritiseIcon)({
        fileFormatIcon: fileFormatIcon,
        documentTypeIcon: documentTypeIcon,
        urlIcon: urlIcon,
        providerIcon: providerIcon
    });
}
function $db64d56f9a1152ff$var$typeToIconDescriptor({ type: type, label: label, providerId: providerId, data: data }) {
    switch(type){
        case 'atlassian:Goal':
            return {
                icon: (0, $5TXU5.IconType).Task,
                label: label
            };
        case 'atlassian:Project':
            return {
                icon: (0, $5TXU5.IconType).Project,
                label: label
            };
        case 'atlassian:SourceCodeCommit':
            return {
                icon: (0, $5TXU5.IconType).Commit,
                label: label
            };
        case 'atlassian:SourceCodePullRequest':
            return {
                icon: (0, $5TXU5.IconType).PullRequest,
                label: label
            };
        case 'atlassian:SourceCodeReference':
            return {
                icon: (0, $5TXU5.IconType).Branch,
                label: label
            };
        case 'atlassian:SourceCodeRepository':
            return {
                icon: (0, $5TXU5.IconType).Repo,
                label: label
            };
        case 'atlassian:Task':
            const taskLabel = label || 'Task';
            const taskIconDescriptor = {
                icon: (0, $5TXU5.IconType).Task,
                label: taskLabel
            };
            if ($db64d56f9a1152ff$var$isJiraProvider(providerId)) {
                const { taskType: taskType, taskIcon: taskIcon } = $db64d56f9a1152ff$var$extractTask(data);
                return taskType === 'JiraCustomTaskType' ? taskIcon || taskIconDescriptor : (0, $8fQ4N.default)(taskType, taskLabel);
            }
            return taskIconDescriptor;
        default:
            return undefined;
    }
}
/**
 * Return the icon object given a JSON-LD data object.
 */ const $db64d56f9a1152ff$var$extractJsonldDataIcon = (data)=>{
    const label = (0, $hUifo.extractTitle)(data);
    const type = $db64d56f9a1152ff$var$extractType(data);
    const urlIcon = (0, $dVnIN.default)(data.icon, label);
    const providerIcon = (0, $kX2ZH.default)(data);
    return $db64d56f9a1152ff$var$chooseIcon({
        urlIcon: urlIcon,
        providerIcon: providerIcon,
        type: type,
        label: label,
        data: data
    });
};
var $db64d56f9a1152ff$export$2e2bcd8739ae039 = $db64d56f9a1152ff$var$extractJsonldDataIcon;
module.exports["default"] = $db64d56f9a1152ff$export$2e2bcd8739ae039;

});

parcelRegister("kX2ZH", function(module, exports) {

var $lyclm = parcelRequire("lyclm");

var $hUifo = parcelRequire("hUifo");


var $5TXU5 = parcelRequire("5TXU5");


var $15w8R = parcelRequire("15w8R");


var $dVnIN = parcelRequire("dVnIN");

/**
 * Extracts the provider icon and label from the given JSON-LD data.
 *
 * If the data is from Confluence, the icon will be the Confluence icon and the label will be 'Confluence'.
 * If the data is from Jira, the icon will be the Jira icon and the label will be 'Jira'.
 * If the data is from another provider, the icon and label will be extracted from the generator object.
 *
 * @param data - The JSON-LD data to extract the provider icon and label from.
 * @returns IconDescriptor with optional icon string name, url and label, or `undefined` if the data is not provided.
 */ const $65f5e55fe221e038$var$extractProviderIcon = (data)=>{
    if (!data) return undefined;
    const generator = data.generator;
    const provider = generator?.['@id'];
    const icon = generator?.icon;
    const label = generator?.name || (0, $hUifo.extractTitle)(data);
    if (provider === (0, $15w8R.CONFLUENCE_GENERATOR_ID)) return {
        icon: (0, $5TXU5.IconType).Confluence,
        label: label || 'Confluence'
    };
    if (provider === (0, $15w8R.JIRA_GENERATOR_ID)) return {
        icon: (0, $5TXU5.IconType).Jira,
        label: label || 'Jira'
    };
    return (0, $dVnIN.default)(icon, label);
};
var $65f5e55fe221e038$export$2e2bcd8739ae039 = $65f5e55fe221e038$var$extractProviderIcon;
const $65f5e55fe221e038$export$5def189f04eea025 = (response)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $lyclm.isEntityPresent)(response)) {
        const provider = (0, $lyclm.extractEntityProvider)(response);
        if (!provider) return undefined;
        switch(provider.id){
            case 0, $15w8R.CONFLUENCE_GENERATOR_ID:
                return {
                    icon: (0, $5TXU5.IconType).Confluence,
                    label: provider.text || 'Confluence'
                };
            case 0, $15w8R.JIRA_GENERATOR_ID:
                return {
                    icon: (0, $5TXU5.IconType).Jira,
                    label: provider.text || 'Jira'
                };
            default:
                const { generator: generator } = response.meta;
                if (!generator) return undefined;
                return {
                    label: generator.name || (0, $lyclm.extractEntity)(response)?.displayName,
                    url: generator.icon?.url
                };
        }
    }
    return $65f5e55fe221e038$var$extractProviderIcon(response.data);
};
module.exports["default"] = $65f5e55fe221e038$export$2e2bcd8739ae039;
module.exports["extractSmartLinkProviderIcon"] = $65f5e55fe221e038$export$5def189f04eea025;

});

parcelRegister("8Bm55", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $cbl6V = parcelRequire("cbl6V");


var $geR8p = parcelRequire("geR8p");

const $78ebc629fd62f804$export$becd8f2eba1bbd96 = (props)=>{
    const { url: url, baseUrl: baseUrl, product: product, ari: ari, envKey: envKey, onError: onError, onStart: onStart, onSuccess: onSuccess } = props;
    const [state, setState] = (0, $42omo.useState)((0, $geR8p.AISummariesStore).get(url)?.state || {
        status: 'ready',
        content: ''
    });
    const { locale: locale } = (0, $8C5kA.default)();
    (0, $42omo.useEffect)(()=>{
        //do not create a service for the empty URL string when the link data is not yet available,
        //or the service has already been created and cached.
        if (url && !(0, $geR8p.AISummariesStore).get(url)) (0, $geR8p.AISummariesStore).set(url, new (0, $cbl6V.AISummaryService)({
            url: url,
            ari: ari,
            baseUrl: baseUrl,
            product: product,
            envKey: envKey,
            locale: locale,
            onError: onError,
            onStart: onStart,
            onSuccess: onSuccess
        }));
        //returns function that calls unsubscribe method
        return (0, $geR8p.AISummariesStore).get(url)?.subscribe(setState);
    }, [
        url,
        baseUrl,
        onError,
        onStart,
        onSuccess,
        product,
        ari,
        envKey,
        locale
    ]);
    const summariseUrl = ()=>{
        return (0, $geR8p.AISummariesStore).get(url)?.summariseUrl();
    };
    return {
        summariseUrl: summariseUrl,
        state: state
    };
};
module.exports["useAISummary"] = $78ebc629fd62f804$export$becd8f2eba1bbd96;

});

parcelRegister("eJ92v", function(module, exports) {
const $de46c47a4ecd1eb4$var$extractLozengeActionItems = (response)=>{
    const items = response?.transitions?.map(({ appearance: appearance, id: id, name: name })=>({
            appearance: appearance ?? 'default',
            id: id,
            text: name
        })) ?? [];
    return items.sort((a, b)=>a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text));
};
var $de46c47a4ecd1eb4$export$2e2bcd8739ae039 = $de46c47a4ecd1eb4$var$extractLozengeActionItems;
module.exports["default"] = $de46c47a4ecd1eb4$export$2e2bcd8739ae039;

});

parcelRegister("cOlaT", function(module, exports) {
const $fa24a5eb3eb20317$var$createStatusUpdateRequest = (request, id)=>({
        providerKey: request.providerKey,
        action: {
            ...request.action,
            payload: {
                newStatusId: id
            }
        }
    });
var $fa24a5eb3eb20317$export$2e2bcd8739ae039 = $fa24a5eb3eb20317$var$createStatusUpdateRequest;
module.exports["default"] = $fa24a5eb3eb20317$export$2e2bcd8739ae039;

});

parcelRegister("b7GIg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $5nBzc = parcelRequire("5nBzc");


var $dh538 = parcelRequire("dh538");

const $d9e0a5eb52a0a8a6$var$withErrorBoundary = (Component)=>(props)=>{
        const fallback = (0, $42omo.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
                appearance: props?.appearance,
                ...(0, $dh538.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                testId: `${props?.testId ?? 'smart-element-lozenge-action'}-fallback`
            }, props?.text), [
            props?.appearance,
            props?.testId,
            props?.text
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props));
    };
var $d9e0a5eb52a0a8a6$export$2e2bcd8739ae039 = $d9e0a5eb52a0a8a6$var$withErrorBoundary;
module.exports["default"] = $d9e0a5eb52a0a8a6$export$2e2bcd8739ae039;

});

parcelRegister("667Mo", function(module, exports) {
const $e47eb447ef32ebf8$export$2a568ff99500df53 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'load'
};
const $e47eb447ef32ebf8$export$2de2d0ccc17b915f = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'PermissionError',
    step: 'load'
};
const $e47eb447ef32ebf8$export$c1c05f9d51f7c467 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'update'
};
const $e47eb447ef32ebf8$export$618660b8f2aa87e2 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'ValidationError',
    step: 'update'
};
module.exports["unknownLoadErrorAnalyticsPayload"] = $e47eb447ef32ebf8$export$2a568ff99500df53;
module.exports["permissionLoadErrorAnalyticsPayload"] = $e47eb447ef32ebf8$export$2de2d0ccc17b915f;
module.exports["unknownUpdateErrorAnalyticsPayload"] = $e47eb447ef32ebf8$export$c1c05f9d51f7c467;
module.exports["validationUpdateErrorAnalyticsPayload"] = $e47eb447ef32ebf8$export$618660b8f2aa87e2;

});

parcelRegister("7uUCV", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $gtD4K = parcelRequire("gtD4K");


var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $a3fRD = parcelRequire("a3fRD");


var $dh538 = parcelRequire("dh538");


var $fVUfS = parcelRequire("fVUfS");


var $kKODE = parcelRequire("kKODE");


var $afp1H = parcelRequire("afp1H");


var $9oOnT = parcelRequire("9oOnT");


var $hJgLA = parcelRequire("hJgLA");

const $86481dd22f22993b$var$MAX_LINE_NUMBER = 8;
const $86481dd22f22993b$var$styles = {
    contentStyles: "_zulpu2gc _11c81d4k _1reo15vq _18m915vq _1e0c1txw _1ul9idpf _2lx2vrvc _19pkv77o _4cvr1y6m _pqmefhey _102efhey _ngc0i7uo _1t4pi7uo",
    linkStyles: "_zulpu2gc _1reo15vq _18m915vq _11c8fhey _1e0c1txw _1ul9idpf _2lx2vrvc _4cvr1h6o _80omtlke _19pku2gc _18u0xy5q _otyrv77o",
    textStylesBase: "_11c81d4k _1reo15vq _18m915vq _o5724jg8 _1e0ccj1k _1bto1l2s _1nmz1hna _sudp1e54",
    dropdownItemGroupStyles: "_14hp1wdt _6pup1kw7 _1eo073ad",
    openIssueInJiraStyles: "_11c8fhey _bfhk1j28 _1bah1e5h _1e0c1kw7 _syaz13af _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik1r31 _1bnx8stv _jf4cnqa1 _30l312zz"
};
const $86481dd22f22993b$var$LozengeActionError = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $86481dd22f22993b$var$MAX_LINE_NUMBER, invokePreviewAction: invokePreviewAction })=>{
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const invoke = (0, $9oOnT.default)({});
    const isPreviewAvailable = invokePreviewAction !== undefined;
    const handlePreviewOpen = (0, $42omo.useCallback)(()=>{
        if (isPreviewAvailable) {
            fireEvent('ui.button.clicked.smartLinkStatusOpenPreview', {});
            if (invokePreviewAction) invoke(invokePreviewAction);
        }
    }, [
        isPreviewAvailable,
        invoke,
        invokePreviewAction,
        fireEvent
    ]);
    const dynamicCss = null;
    const content = (0, $42omo.useMemo)(()=>{
        return /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, /*#__PURE__*/ $42omo.createElement("div", {
            className: (0, $gMc0m.default)([
                $86481dd22f22993b$var$styles.contentStyles
            ])
        }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
            testId: `${testId}-icon`,
            color: "var(--ds-icon-danger, #C9372C)",
            label: 'error',
            spacing: "spacious"
        }), /*#__PURE__*/ $42omo.createElement("span", {
            "data-testid": `${testId}-error-message`,
            className: (0, $gMc0m.default)([
                $86481dd22f22993b$var$styles.textStylesBase,
                "_1yyj1n6p _102k16q4"
            ]),
            style: {
                "--_t4prqe": (0, $7sObp.default)(maxLineNumber)
            }
        }, typeof errorMessage === 'string' ? errorMessage : (0, $hJgLA.getFormattedMessage)(errorMessage))), isPreviewAvailable ? /*#__PURE__*/ $42omo.createElement("div", {
            className: (0, $gMc0m.default)([
                $86481dd22f22993b$var$styles.linkStyles
            ])
        }, /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
            testId: `${testId}-open-embed`,
            onClick: handlePreviewOpen,
            xcss: $86481dd22f22993b$var$styles.openIssueInJiraStyles
        }, (0, $dh538.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), (0, $afp1H.messages).open_issue_in_jiraIssueTermRefresh) : /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), (0, $afp1H.messages).open_issue_in_jira))) : null);
    }, [
        errorMessage,
        handlePreviewOpen,
        isPreviewAvailable,
        testId,
        dynamicCss
    ]);
    return /*#__PURE__*/ $42omo.createElement("span", {
        "data-testid": `${testId}-error-item-group`,
        className: (0, $gMc0m.default)([
            $86481dd22f22993b$var$styles.dropdownItemGroupStyles
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $ahaN7.default), null, /*#__PURE__*/ $42omo.createElement((0, $dAYOx.default), {
        testId: `${testId}-error`
    }, content)));
};
var $86481dd22f22993b$export$2e2bcd8739ae039 = $86481dd22f22993b$var$LozengeActionError;
module.exports["default"] = $86481dd22f22993b$export$2e2bcd8739ae039;

});

parcelRegister("bTJCs", function(module, exports) {

var $afp1H = parcelRequire("afp1H");

const $3b4344c10bfc2ba3$export$4f2e371a667ad688 = {
    noData: {
        descriptor: (0, $afp1H.messages)['status_change_permission_error']
    },
    noDataIssueTermRefresh: {
        descriptor: (0, $afp1H.messages)['status_change_permission_errorIssueTermRefresh']
    },
    unknown: {
        descriptor: (0, $afp1H.messages)['status_change_load_error']
    },
    updateFailed: {
        descriptor: (0, $afp1H.messages)['status_change_update_error']
    }
};
module.exports["LozengeActionErrorMessages"] = $3b4344c10bfc2ba3$export$4f2e371a667ad688;

});

parcelRegister("58trk", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $ahaN7 = parcelRequire("ahaN7");


var $k5ktp = parcelRequire("k5ktp");

const $7734c527fca28b11$var$dropdownItemGroupStyles = null;
const $7734c527fca28b11$var$LozengeActionItemsGroup = ({ items: items, testId: testId, onClick: onClick })=>/*#__PURE__*/ $42omo.createElement("span", {
        "data-testid": `${testId}-item-group`,
        className: (0, $gMc0m.default)([
            "_c71l1mjv _18m91wug _1pv01r31 _1m1b1r31 _qh55glyw _lt2aglyw _ph3k1o36 _1twe1o36 _1ll71dpa _qprf1dpa _n6y8usvi _109gusvi _z29h1x9r _wlxp1x9r _1gfl12x7 _yhjmutpp _1gqn12x7 _11lvutpp _d4lf1f4h _14hp1wdt _6pup1kw7"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $ahaN7.default), null, items.map((item, idx)=>/*#__PURE__*/ $42omo.createElement((0, $k5ktp.default), {
            ...item,
            key: idx,
            onClick: onClick,
            testId: `${testId}-item-${idx}`
        }))));
var $7734c527fca28b11$export$2e2bcd8739ae039 = $7734c527fca28b11$var$LozengeActionItemsGroup;
module.exports["default"] = $7734c527fca28b11$export$2e2bcd8739ae039;

});

parcelRegister("dXPIV", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1bHXt = parcelRequire("1bHXt");


var $8C5kA = parcelRequire("8C5kA");


var $ghftu = parcelRequire("ghftu");


var $5nBzc = parcelRequire("5nBzc");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $afp1H = parcelRequire("afp1H");

const $7e3c19665a3fd574$var$styles = {
    chevronDown: "_18u012x7 _1e0c1txw",
    lozengeContainer: "_kkk2n7od _2rko12b0 _1dqonqa1 _189ee4h9 _1h6d1j28 _bfhk1j28 _1e0c1txw _4cvr1h6o _4t3i7vkz",
    lozengeContainerSelected: "_1reo15vq _18m915vq _1h6d1v1w"
};
const $7e3c19665a3fd574$var$textStyles = null;
const $7e3c19665a3fd574$var$triggerLozengeStyles = null;
const $7e3c19665a3fd574$var$triggerButtonStyles = null;
const $7e3c19665a3fd574$var$LozengeActionTrigger = ({ appearance: appearance, isOpen: isOpen, maxWidth: maxWidth, testId: testId, text: text, triggerRef: triggerRef, ...props })=>{
    const intl = (0, $8C5kA.default)();
    const [isHovering, setIsHovering] = (0, $42omo.useState)(false);
    const [isPressing, setIsPressing] = (0, $42omo.useState)(false);
    const [lozengeBackgroundColor, setLozengeBackgroundColor] = (0, $42omo.useState)(undefined);
    const [lozengeForegroundColor, setLozengeForegroundColor] = (0, $42omo.useState)(undefined);
    const onMouseEnter = (0, $42omo.useCallback)(()=>setIsHovering(true), []);
    const onMouseLeave = (0, $42omo.useCallback)(()=>setIsHovering(false), []);
    const onMouseOrKeyDown = (0, $42omo.useCallback)(()=>setIsPressing(true), []);
    const onMouseOrKeyUp = (0, $42omo.useCallback)(()=>setIsPressing(false), []);
    (0, $42omo.useEffect)(()=>{
        if (isPressing) {
            setLozengeBackgroundColor("var(--ds-background-selected-pressed, #8FB8F6)");
            setLozengeForegroundColor("var(--ds-text-selected, #1868DB)");
        } else if (isOpen) {
            if (isHovering) setLozengeBackgroundColor("var(--ds-background-selected-hovered, #CFE1FD)");
            else setLozengeBackgroundColor("var(--ds-background-selected, #E9F2FE)");
            setLozengeForegroundColor("var(--ds-text-selected, #1868DB)");
        } else {
            setLozengeBackgroundColor(undefined);
            setLozengeForegroundColor(undefined);
        }
    }, [
        isPressing,
        isOpen,
        isHovering
    ]);
    const lozenge = (0, $42omo.useMemo)(()=>{
        return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: (0, $1bHXt.cx)($7e3c19665a3fd574$var$styles.lozengeContainer, (isOpen || isPressing) && $7e3c19665a3fd574$var$styles.lozengeContainerSelected),
            as: "span"
        }, /*#__PURE__*/ $42omo.createElement((0, $5nBzc.default), {
            appearance: appearance,
            isBold: (0, $dh538.fg)('platform-component-visual-refresh') ? true : isHovering,
            ...(0, $dh538.fg)('platform_navx_sl_lozenge_max_width') ? {
                maxWidth: maxWidth
            } : undefined,
            style: {
                backgroundColor: lozengeBackgroundColor,
                color: lozengeForegroundColor
            }
        }, /*#__PURE__*/ $42omo.createElement("span", {
            className: (0, $gMc0m.default)([
                "_4cvr1h6o _1e0c1txw"
            ])
        }, /*#__PURE__*/ $42omo.createElement("span", {
            className: (0, $gMc0m.default)([
                (0, $dh538.fg)('platform_navx_sl_lozenge_max_width') && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
            ])
        }, text), /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            as: "span",
            xcss: $7e3c19665a3fd574$var$styles.chevronDown
        }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            color: "currentColor",
            label: "options",
            size: "small",
            "aria-hidden": true
        })))));
    }, [
        appearance,
        isHovering,
        isPressing,
        text,
        isOpen,
        lozengeBackgroundColor,
        lozengeForegroundColor,
        maxWidth
    ]);
    return /*#__PURE__*/ $42omo.createElement("button", {
        type: "button",
        ...props,
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        style: {
            maxWidth: (0, $dh538.fg)('platform_navx_sl_lozenge_max_width') ? maxWidth : undefined
        },
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseDown: onMouseOrKeyDown,
        onMouseUp: onMouseOrKeyUp,
        onKeyDown: onMouseOrKeyDown,
        onKeyUp: onMouseOrKeyUp,
        ref: triggerRef,
        "aria-label": (0, $dh538.fg)('platform_navx_flex_card_status_dropdown_a11y_fix') ? intl.formatMessage((0, $afp1H.messages).change_status, {
            status: text
        }) : undefined,
        className: (0, $gMc0m.default)([
            "_kkk2n7od _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _15vhn7od _1dqonqa1 _189e1dm9 _1h6d1j28 _bfhk1j28 _syazn7od _80omtlke _ect4n7od _1wybn7od _zg8ln7od _k48pn7od _vwz4idpf _1p1dn7od _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _mizu1r31 _1guj1r31 _p8tl1r31 _ra3xglyw _pbhaglyw _1q2vglyw _128m1o36 _11ow1o36 _j8b81o36 _1bas1qi0 _19h61qi0 _1d391qi0 _1ejj1y54 _1u6l1y54 _6ssh1y54"
        ])
    }, lozenge);
};
var $7e3c19665a3fd574$export$2e2bcd8739ae039 = $7e3c19665a3fd574$var$LozengeActionTrigger;
module.exports["default"] = $7e3c19665a3fd574$export$2e2bcd8739ae039;

});

parcelRegister("2OB54", function(module, exports) {

var $ccQw1 = parcelRequire("ccQw1");


var $5TXU5 = parcelRequire("5TXU5");

/**
 * Computes the relevant icon for a document type.
 *
 * @remark Note that document icons can vary based on the provider. E.g., a
 * provider may choose to re-use one of these document types in their domain,
 * but offer a different SVG icon on the frontend (to map to this type in their
 * domain). See `schema:digitalDocument` for an example of this behaviour. This
 * mechanism will be superseded by backend-driven icon URLs as part of
 * go/j/MODES-5864. Do not add more!
 *
 * @param documentType JSON-LD document type
 * @param label human-readable label to be displayed on the icon
 * @param providerId JSON-LD provider (generator ID)
 * @returns an icon descriptor representing the document type
 */ const $43d4ba8ed352f0e6$var$extractDocumentTypeIcon = (documentType, label, providerId)=>{
    switch(documentType){
        case 'schema:BlogPosting':
            return {
                icon: (0, $5TXU5.IconType).Blog,
                label: label
            };
        case 'schema:DigitalDocument':
            if (providerId && (0, $ccQw1.isConfluenceGenerator)(providerId)) return {
                icon: (0, $5TXU5.IconType).LiveDocument,
                label: label
            };
            else return {
                icon: (0, $5TXU5.IconType).File,
                label: label
            };
        case 'schema:TextDigitalDocument':
            return {
                icon: (0, $5TXU5.IconType).Document,
                label: label
            };
        case 'schema:PresentationDigitalDocument':
            return {
                icon: (0, $5TXU5.IconType).Presentation,
                label: label
            };
        case 'schema:SpreadsheetDigitalDocument':
            return {
                icon: (0, $5TXU5.IconType).Spreadsheet,
                label: label
            };
        case 'atlassian:Template':
            return {
                icon: (0, $5TXU5.IconType).Template,
                label: label
            };
        case 'atlassian:UndefinedLink':
            return {
                icon: (0, $5TXU5.IconType).Document,
                label: label
            };
        default:
            return undefined;
    }
};
var $43d4ba8ed352f0e6$export$2e2bcd8739ae039 = $43d4ba8ed352f0e6$var$extractDocumentTypeIcon;
module.exports["default"] = $43d4ba8ed352f0e6$export$2e2bcd8739ae039;

});

parcelRegister("8fQ4N", function(module, exports) {

var $5TXU5 = parcelRequire("5TXU5");

const $3057ac52417f53cb$var$extractJiraTaskIcon = (taskType, label = 'Task')=>{
    switch(taskType){
        case 'JiraBug':
            return {
                icon: (0, $5TXU5.IconType).Bug,
                label: label
            };
        case 'JiraChange':
            return {
                icon: (0, $5TXU5.IconType).Change,
                label: label
            };
        case 'JiraEpic':
            return {
                icon: (0, $5TXU5.IconType).Epic,
                label: label
            };
        case 'JiraIncident':
            return {
                icon: (0, $5TXU5.IconType).Incident,
                label: label
            };
        case 'JiraProblem':
            return {
                icon: (0, $5TXU5.IconType).Problem,
                label: label
            };
        case 'JiraServiceRequest':
            return {
                icon: (0, $5TXU5.IconType).ServiceRequest,
                label: label
            };
        case 'JiraStory':
            return {
                icon: (0, $5TXU5.IconType).Story,
                label: label
            };
        case 'JiraSubTask':
            return {
                icon: (0, $5TXU5.IconType).SubTask,
                label: label
            };
        case 'JiraTask':
        default:
            return {
                icon: (0, $5TXU5.IconType).Task,
                label: label
            };
    }
};
var $3057ac52417f53cb$export$2e2bcd8739ae039 = $3057ac52417f53cb$var$extractJiraTaskIcon;
module.exports["default"] = $3057ac52417f53cb$export$2e2bcd8739ae039;

});

parcelRegister("dVnIN", function(module, exports) {

var $8hlRK = parcelRequire("8hlRK");

/**
 * Extracts the URL icon from the given icon or link object.
 *
 * @param icon - The icon or link object from which to extract the URL icon.
 * @param label - The label for the URL icon.
 * @returns IconDescriptor, which will contain label and url, or undefined
 */ const $1af37185996e64e9$var$extractUrlIcon = (icon, label)=>{
    const url = icon && (0, $8hlRK.extractUrlFromIconJsonLd)(icon);
    return url ? {
        label: label,
        url: url
    } : undefined;
};
var $1af37185996e64e9$export$2e2bcd8739ae039 = $1af37185996e64e9$var$extractUrlIcon;
module.exports["default"] = $1af37185996e64e9$export$2e2bcd8739ae039;

});

parcelRegister("cbl6V", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $dQl1W = parcelRequire("dQl1W");


var $dDhJe = parcelRequire("dDhJe");


var $5Y0oB = parcelRequire("5Y0oB");


var $iPRQp = parcelRequire("iPRQp");


var $eDy2J = parcelRequire("eDy2J");

const $b962d377d695bb74$var$CONVO_AI_ENDPOINT = 'assist/api/ai/v2/ai-feature/smartlinksummary/stream';
class $b962d377d695bb74$export$73e4b807d5bd74b6 {
    async summariseUrl() {
        this.state = {
            status: 'loading',
            content: ''
        };
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
        try {
            this.onStart?.(id);
            const stream = await this.fetchStream();
            let bufferContent = '';
            for await (const chunk of stream){
                if (chunk.type === 'ANSWER_PART') {
                    bufferContent += chunk.message.content;
                    for (const subscriber of this.subscribedStateSetters)subscriber({
                        ...this.state,
                        content: bufferContent
                    });
                }
                //if AI Mate service returns cached summary we get the summary text in one piece as the last message
                if (chunk.type === 'FINAL_RESPONSE') bufferContent = chunk.message.content;
                if (chunk.type === 'ERROR') throw new (0, $iPRQp.ChunkProcessingError)(chunk?.message?.message_template);
            }
            this.onSuccess?.(id);
            this.state = {
                status: 'done',
                content: bufferContent
            };
        } catch (err) {
            let message = err instanceof (0, $iPRQp.ChunkProcessingError) ? err.message : 'UNEXPECTED';
            this.onError?.(id, message);
            this.state = {
                status: 'error',
                content: '',
                error: message
            };
        }
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        return this.state;
    }
    subscribe(stateSetter) {
        this.subscribedStateSetters.add(stateSetter);
        return ()=>{
            this.subscribedStateSetters.delete(stateSetter);
        };
    }
    constructor(props){
        this.state = {
            content: '',
            status: 'ready'
        };
        this.config = void 0;
        this.url = void 0;
        this.ari = void 0;
        this.locale = void 0;
        this.subscribedStateSetters = new Set();
        this.onStart = void 0;
        this.onSuccess = void 0;
        this.onError = void 0;
        this.getRequestUrl = (envKey, baseUrlOverride)=>{
            if (baseUrlOverride || envKey) {
                const baseUrl = baseUrlOverride || (0, $dDhJe.getBaseUrl)(envKey);
                return (0, $eDy2J.addPath)(baseUrl, $b962d377d695bb74$var$CONVO_AI_ENDPOINT);
            }
            return (0, $eDy2J.addPath)('/gateway/api/', $b962d377d695bb74$var$CONVO_AI_ENDPOINT);
        };
        this.fetchStream = async ()=>{
            const payload = {
                recipient_agent_named_id: 'smartlink_summary_agent',
                agent_input_context: {
                    content_url: this.url,
                    content_ari: this.ari,
                    prompt_id: 'smart_links',
                    summary_output_mimetype: 'text/markdown',
                    locale: this.locale
                },
                ai_feature_input: {
                    content_url: this.url,
                    content_ari: this.ari,
                    locale: this.locale
                }
            };
            const options = {
                method: 'POST',
                headers: this.config.headers,
                body: JSON.stringify(payload),
                credentials: 'include'
            };
            const response = await fetch(this.config.requestUrl, options);
            if (!response.ok || response.status >= 400) throw new Error(`Status: ${response.status}\n URL: ${this.url}\n StatusText ${response.statusText}`);
            else return (0, $5Y0oB.readStream)(response);
        };
        this.config = {
            requestUrl: this.getRequestUrl(props.envKey, props.baseUrl),
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'x-experience-id': 'smart-link',
                'x-product': (0, $eDy2J.getXProductHeaderValue)(props.product)?.toLowerCase() || 'confluence'
            }
        };
        this.url = props.url;
        this.ari = props.ari;
        this.locale = props.locale;
        this.onStart = props.onStart;
        this.onSuccess = props.onSuccess;
        this.onError = props.onError;
    }
}
module.exports["AISummaryService"] = $b962d377d695bb74$export$73e4b807d5bd74b6;

});

parcelRegister("geR8p", function(module, exports) {

var $9trs7 = parcelRequire("9trs7");

const $ae7dbc37116e63f9$var$AI_SUMMARY_CACHE_SIZE = 100;
const $ae7dbc37116e63f9$export$6979339b6d41707e = new (0, $9trs7.LRUMap)($ae7dbc37116e63f9$var$AI_SUMMARY_CACHE_SIZE);
module.exports["AISummariesStore"] = $ae7dbc37116e63f9$export$6979339b6d41707e;

});

parcelRegister("k5ktp", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dAYOx = parcelRequire("dAYOx");


var $5nBzc = parcelRequire("5nBzc");


var $dh538 = parcelRequire("dh538");

const $c9439470310c10a2$var$LozengeActionItem = ({ appearance: appearance, id: id, onClick: onClick, testId: testId, text: text })=>{
    const handleClick = (0, $42omo.useCallback)((e)=>{
        // Prevent dropdown to close on select item.
        // We want to show loading screen.
        e.stopPropagation();
        if (onClick) onClick(id, text, appearance);
    }, [
        appearance,
        id,
        onClick,
        text
    ]);
    const handleMouseEnter = (0, $42omo.useCallback)((e)=>{
        e.currentTarget?.firstElementChild?.focus();
    }, []);
    return(// eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        onMouseEnter: handleMouseEnter,
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        onClick: handleClick,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: appearance,
        ...(0, $dh538.fg)('platform-component-visual-refresh') ? {
            isBold: true
        } : undefined
    }, text))));
};
var $c9439470310c10a2$export$2e2bcd8739ae039 = $c9439470310c10a2$var$LozengeActionItem;
module.exports["default"] = $c9439470310c10a2$export$2e2bcd8739ae039;

});

parcelRegister("5Y0oB", function(module, exports) {

var $eDy2J = parcelRequire("eDy2J");

async function* $ac7ab9469e66450d$export$e45226161c660403(response) {
    const reader = (0, $eDy2J.getBufferReader)(response);
    let doneStreaming = false;
    let chunkBuffer = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const processedChunks = `${chunkBuffer}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            chunkBuffer = '';
            for (let chunk of processedChunks)try {
                const jsonChunk = JSON.parse(chunk);
                if (jsonChunk.type === 'ERROR') reader.cancel();
                yield jsonChunk;
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                chunkBuffer = chunk;
            }
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else {
            reader.cancel();
            throw e;
        }
    }
    while (!doneStreaming);
    if (chunkBuffer) {
        const error = new Error(`Not all the data was processed: ${chunkBuffer}`);
        throw error;
    }
}
module.exports["readStream"] = $ac7ab9469e66450d$export$e45226161c660403;

});

parcelRegister("iPRQp", function(module, exports) {
class $518e18325393707f$export$fcec967a4b7ebd84 extends Error {
    constructor(error){
        super(error);
    }
}
const $518e18325393707f$export$d8bd0967cb58683 = [
    'NETWORK_ERROR',
    'NO_ANSWER',
    'RATE_LIMIT',
    'NO_AGENT',
    'PLUGIN_ERRORED',
    'OPENAI_RATE_LIMIT_USER_ABUSE',
    'ACCEPTABLE_USE_VIOLATIONS',
    'AI_DISABLED',
    'UNEXPECTED',
    'HIPAA_CONTENT_DETECTED',
    'EXCEEDING_CONTEXT_LENGTH_ERROR'
];
module.exports["ChunkProcessingError"] = $518e18325393707f$export$fcec967a4b7ebd84;

});

parcelRegister("eDy2J", function(module, exports) {
const $80037b55255ba382$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};
const $80037b55255ba382$export$4c25481b843feb0b = (baseUrl, path)=>{
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
/**
 * Subset of a map of Jira `ProductTypes` to AI Mate expected values
 * See for more info: https://atlassian.slack.com/archives/C066UP0G0G3/p1716341647677829?thread_ts=1716338063.255939&cid=C066UP0G0G3
 */ const $80037b55255ba382$var$AiMateJiraXProduct = {
    JSM: 'JSM',
    JSW: 'JIRA-SOFTWARE',
    JWM: 'JIRA-CORE',
    JPD: 'JPD'
};
/**
 * Checks if `product` is a Jira related product.
 */ const $80037b55255ba382$var$isJiraProduct = (product)=>{
    const JIRA_PRODUCTS = [
        'JPD',
        'JSM',
        'JSW',
        'JWM'
    ];
    return product !== undefined && JIRA_PRODUCTS.includes(product);
};
const $80037b55255ba382$export$ff2962de2b2c930f = (product)=>{
    if ($80037b55255ba382$var$isJiraProduct(product)) return $80037b55255ba382$var$AiMateJiraXProduct[product];
    return product;
};
module.exports["getBufferReader"] = $80037b55255ba382$export$f6383c3ea1307da9;
module.exports["addPath"] = $80037b55255ba382$export$4c25481b843feb0b;
module.exports["getXProductHeaderValue"] = $80037b55255ba382$export$ff2962de2b2c930f;

});


$parcel$global.rlb("iVgrO")
//# sourceMappingURL=RelatedLinksModal.ade36fda.js.map
